/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _regeneratorRuntime = __webpack_require__(62);
	
	var _regeneratorRuntime2 = _interopRequireDefault(_regeneratorRuntime);
	
	__webpack_require__(69);
	
	__webpack_require__(68);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(1);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _preactRouter = __webpack_require__(12);
	
	var _preactRouter2 = _interopRequireDefault(_preactRouter);
	
	var _account = __webpack_require__(15);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _utils = __webpack_require__(23);
	
	var _userInterfaceHelper = __webpack_require__(19);
	
	var _userInterfaceHelper2 = _interopRequireDefault(_userInterfaceHelper);
	
	var _appStore = __webpack_require__(13);
	
	var _appStore2 = _interopRequireDefault(_appStore);
	
	var _mozactivityManager = __webpack_require__(34);
	
	var _deviceUtils = __webpack_require__(16);
	
	var _lib = __webpack_require__(17);
	
	var _lib2 = _interopRequireDefault(_lib);
	
	var _lib3 = __webpack_require__(44);
	
	var _lib4 = _interopRequireDefault(_lib3);
	
	var _lib5 = __webpack_require__(45);
	
	var _lib6 = _interopRequireDefault(_lib5);
	
	var _messageReceiver = __webpack_require__(87);
	
	var _webMessageHelper = __webpack_require__(5);
	
	var _commands = __webpack_require__(3);
	
	var _models = __webpack_require__(14);
	
	var _paymentHelper = __webpack_require__(22);
	
	var _paymentHelper2 = _interopRequireDefault(_paymentHelper);
	
	var _constants = __webpack_require__(2);
	
	var _constant = __webpack_require__(9);
	
	__webpack_require__(90);
	
	var _reactSoftKey = __webpack_require__(61);
	
	var _reactSoftKey2 = _interopRequireDefault(_reactSoftKey);
	
	var _Loading = __webpack_require__(74);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _Page = __webpack_require__(75);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Appspanel = __webpack_require__(70);
	
	var _Appspanel2 = _interopRequireDefault(_Appspanel);
	
	var _Settingsview = __webpack_require__(76);
	
	var _Settingsview2 = _interopRequireDefault(_Settingsview);
	
	var _reactDialog = __webpack_require__(21);
	
	var _reactDialog2 = _interopRequireDefault(_reactDialog);
	
	__webpack_require__(94);
	
	__webpack_require__(104);
	
	__webpack_require__(108);
	
	__webpack_require__(112);
	
	__webpack_require__(113);
	
	__webpack_require__(111);
	
	__webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// Shared Libs
	
	// Libs
	
	
	// Component
	
	
	// CSS
	
	
	var KEY_SERVER_TIME_OFFSET = 'hawk-request-server-time-offset';
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this));
	
	    _this.fetchDataAndGenerateUI = function () {
	      _this.resetState();
	      // show loading panel.
	      (0, _preactRouter.route)(_constant.PATH.LOADING.URL());
	      // show no network UI and early return here.
	      if (!navigator.onLine) {
	        // reset state to make sure UI works correctly.
	        _this.setMsg('no-internet');
	        console.error('no network');
	        return;
	      }
	      // Start to request things from server,
	      // such as token, app-list, categories and service worker.
	      _this.startRemoteServices();
	    };
	
	    _this.keydownHandler = function (event) {
	      var key = event.key;
	
	
	      switch (key) {
	        case 'BrowserBack':
	        case 'Backspace':
	        case 'Escape':
	          event.preventDefault();
	          _webMessageHelper.MessageSender.send(new _commands.RequestExitCommand());
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.showRestartDialog = function () {
	      var restartDialogOptions = {
	        header: 'no-price-header',
	        type: 'alert',
	        ok: 'ok',
	        content: 'restart-phone-msg',
	        onOk: _this.hideDialog
	      };
	      _this.showDialog(restartDialogOptions);
	    };
	
	    _this.handleHawkOffsetChange = function (event) {
	      var offset = event.detail.current;
	      window.serverTimeOffset = offset;
	      asyncStorage.setItem(KEY_SERVER_TIME_OFFSET, offset);
	    };
	
	    _this.showNotFoundDialog = function () {
	      var notFoundDialogOptions = {
	        header: 'not-found-header',
	        type: 'alert',
	        ok: 'ok',
	        content: 'not-found-msg',
	        onOk: _this.hideDialog
	      };
	      _this.showDialog(notFoundDialogOptions);
	    };
	
	    _this.hideDialog = function (callback) {
	      _this.setState({
	        dialog: false,
	        dialogOptions: {}
	      }, function () {
	        if (callback) {
	          callback();
	        }
	      });
	    };
	
	    _this.ensureDialogDisplay = function () {
	      _this.showNextDialog();
	    };
	
	    _this.restActivity = function () {
	      _this.setState({
	        activity: {
	          disposition: 'window', // inline or window, default window
	          donwloadType: 'maunal' // maunal or auto, default is maunal
	        }
	      });
	    };
	
	    _this.onRouteChange = function (event) {
	      if (_this.entryURL === null) {
	        _this.entryURL = event.url;
	      }
	      _this.currentRoute = event.url;
	
	      _this.setState({ isViewingSetting: event.url === _constant.PATH.SETTING.MATCH });
	    };
	
	    _utils.utils.remoteStartTime = new Date().getTime();
	    performance.mark('REMOTE_STORE');
	    performance.mark('REMOTE_PAGE_RENDERING_START');
	    console.warn('start to render remote page at ', _utils.utils.remoteStartTime);
	    _this.entryURL = null;
	    _this.currentRoute = null;
	
	    _webMessageHelper.MessageSender.remoteReady = true;
	    _this.dialogQueue = [];
	    // get default state.
	    _this.state = _this.getInitialState();
	    // save token information.
	    _this.tokenInfo = {
	      assertion: null,
	      type: _constants.tokenType.RESTRICTED,
	      status: false
	    };
	    _this.refs = {};
	    // init KaiOS account
	    _account2.default.init();
	    _this.startMessengers();
	
	    performance.mark('REQUEST_DEVICE_START');
	    _deviceUtils.deviceUtils.requestInfo().then(function () {
	      performance.mark('REQUEST_DEVICE_END');
	      _this.boot();
	    });
	    return _this;
	  }
	
	  _createClass(App, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      var initialState = {
	        noAvailableAPP: false,
	        dialog: false,
	        dialogOptions: {},
	        plusInfo: {
	          version: '2.4' // default
	        },
	        readyToRoute: false, // true when all prerequisites have finished
	        isViewingSetting: false
	      };
	      return initialState;
	    }
	  }, {
	    key: 'resetState',
	    value: function resetState() {
	      this.prepareDownload = _appStore2.default.preparedDownloadApp;
	      _appStore2.default.init();
	      this.setState(this.getInitialState());
	    }
	  }, {
	    key: 'boot',
	    value: function boot(event) {
	      var _this2 = this;
	
	      var isReboot = !(typeof event === 'undefined');
	      if (isReboot) {
	        // resetState
	        this.resetState();
	        (0, _preactRouter.route)(_constant.PATH.LOADING.URL());
	        // reset appStore.
	        _appStore2.default.resetStore();
	        _deviceUtils.deviceUtils.requestInfo().then(function () {
	          _this2.startRemoteServices();
	        });
	      } else {
	        this.initPreparation();
	      }
	    }
	  }, {
	    key: 'initPreparation',
	    value: function initPreparation() {
	      var _this3 = this;
	
	      // Listen relative events
	      this.startEventListener();
	
	      // Get the time offset from indexedDB if it exists
	      asyncStorage.getItem(KEY_SERVER_TIME_OFFSET, function (result) {
	        window.serverTimeOffset = result;
	      });
	
	      // hide the fake SSR and switch to the real loading page.
	      (0, _userInterfaceHelper.hideFakeSSR)();
	      // prepare price
	      this.paymentHelper = new _paymentHelper2.default();
	      this.paymentHelper.getProfile().then(function (result) {
	        window.unitPrice = result.unitPrice;
	      }).catch(function () {
	        window.unitPrice = null;
	      }).then(function () {
	        _this3.fetchDataAndGenerateUI();
	      });
	    }
	  }, {
	    key: 'startRemoteServices',
	    value: function startRemoteServices() {
	      var _this4 = this;
	
	      // Pass device info and IMEI to dynamicCategory.
	      _lib6.default.init({
	        deviceInfo: window.deviceInfos,
	        imei: window.IMEI,
	        commsInfo: _deviceUtils.deviceUtils.information.connection,
	        serverTimeOffset: window.serverTimeOffset,
	        useCustomConnectionType: true
	      });
	      performance.mark('REQUEST_TOKEN_START');
	      _account2.default.requestToken().then(function (detail) {
	        var token = detail.token,
	            type = detail.type;
	
	        _this4.tokenInfo = {
	          assertion: token,
	          type: type,
	          status: true
	        };
	        _lib2.default.setToken(token.kid, token.macKey);
	        _lib2.default.setCustomConnectionType(_deviceUtils.deviceUtils.information.connection.type);
	        performance.mark('REQUEST_TOKEN_END');
	        _this4.fetchAppsAndCategories();
	      });
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.stopEventListener();
	    }
	  }, {
	    key: 'startMessengers',
	    value: function startMessengers() {
	      _webMessageHelper.MessageSender.validMessageOrigins = [_constant.APP_ORIGIN];
	      _webMessageHelper.MessageSender.targetOrigin = _constant.APP_ORIGIN;
	      _webMessageHelper.MessageSender.start();
	      _webMessageHelper.MessageListener.start(_messageReceiver.receiveMessage);
	    }
	  }, {
	    key: 'startEventListener',
	    value: function startEventListener() {
	      window.addEventListener('keydown', this.keydownHandler);
	      window.addEventListener('online', this.fetchDataAndGenerateUI);
	      window.addEventListener('offline', this.fetchDataAndGenerateUI);
	      window.addEventListener('account:login', this.fetchDataAndGenerateUI);
	      window.addEventListener('account:logout', this.fetchDataAndGenerateUI);
	      window.addEventListener('reboot-needed', this.boot);
	
	      window.addEventListener('hawkrequester:offsetchange', this.handleHawkOffsetChange);
	
	      _userInterfaceHelper2.default.startListeners();
	    }
	  }, {
	    key: 'showNoPriceDialog',
	    value: function showNoPriceDialog() {
	      var _this5 = this;
	
	      var paymentHelper = new _paymentHelper2.default();
	      /**
	       * If KaiPay version has been v2.3.1+, it is able to get price. If
	       * not, it means KaiPay has been updated but not reloaded yet. So we
	       * popup a dialog and inform users to restart the device.
	       **/
	      var kaipayVersion = paymentHelper.getKaipayVersion();
	      var isNoProvider = paymentHelper.noProvider;
	      var canGetPrice = paymentHelper.isSupportPrice(kaipayVersion);
	      var noPriceDialogOptions = {
	        header: 'no-price-header',
	        type: 'alert',
	        ok: 'ok',
	        content: 'no-price-msg',
	        onOk: function onOk() {
	          _this5.hideDialog(function () {
	            isNoProvider && canGetPrice && _this5.showRestartDialog();
	          });
	        }
	      };
	      this.showDialog(noPriceDialogOptions);
	    }
	  }, {
	    key: 'fetchAppsAndCategories',
	    value: function fetchAppsAndCategories() {
	      var _this6 = this;
	
	      // fetch latest app list
	      performance.mark('FETCH_APPS_CAT_START');
	      var assertion = this.tokenInfo.assertion;
	      if (assertion) {
	        var applistHelper = new _lib4.default({
	          deviceInfos: window.deviceInfos,
	          simInfo: _deviceUtils.deviceUtils.information.connection,
	          IMEI: window.IMEI,
	          serverTimeOffset: window.serverTimeOffset,
	          useCustomConnectionType: true
	        });
	        var isPaymentAvailable = window.unitPrice !== null;
	        Promise.all([applistHelper.fetchAppList(isPaymentAvailable), _lib6.default.getCategories()]).then(function (result) {
	          performance.mark('FETCH_APPS_CAT_END');
	          var applistResult = result[0];
	          var categoriesResult = result[1];
	          _appStore2.default.initRemoteApps(applistResult.apps);
	          _appStore2.default.hasPaidApp = applistResult.hasPaidApp;
	          _appStore2.default.categories = categoriesResult;
	          _this6.prepareApps();
	        }).catch(function (error) {
	          _this6.serverError(error);
	        });
	      } else {
	        console.error('No restricted token for fetching app list.');
	      }
	    }
	  }, {
	    key: 'setMsg',
	    value: function setMsg(messageL10nId) {
	      var messageL10nArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (document.visibilityState === 'hidden') {
	        //Avoid to show toast when app is in background.
	        return;
	      }
	      var command = new _commands.ShowToastCommand({
	        detail: new _models.Toast({
	          messageL10nId: messageL10nId,
	          messageL10nArgs: messageL10nArgs
	        })
	      });
	      _webMessageHelper.MessageSender.send(command);
	    }
	  }, {
	    key: 'redirectAppPage',
	    value: function redirectAppPage(manifestURL) {
	      var activeApp = null;
	
	      if (manifestURL) {
	        activeApp = _appStore2.default.findAppByManifest(manifestURL);
	        if (activeApp) {
	          (0, _preactRouter.route)(_constant.PATH.PAGE.URL({ id: activeApp.id, autoDownload: true }));
	        } else {
	          this.handleAppNotFound();
	        }
	      }
	    }
	  }, {
	    key: 'prepareApps',
	    value: function prepareApps() {
	      var _this7 = this;
	
	      // In order to reduce render times, so fetch setting here.
	      var isSupportedSettingsPanel = window.deviceInfos.get('apps.serviceCenter.settingsEnabled');
	      performance.mark('REQUEST_INSTALLED_START');
	      _webMessageHelper.MessageSender.send(new _commands.RequestInstalledAppsCommand(), function (success, detail) {
	        if (success) {
	          var installedApps = detail;
	          _appStore2.default.syncInstalledApps(installedApps);
	          _appStore2.default.syncBookmarks().then(function (result) {
	            _deviceUtils.deviceUtils.featureset = {
	              bookmarkDBSupported: result.bookmarkDBSupported,
	              settingsPanelSupported: isSupportedSettingsPanel
	            };
	            _appStore2.default.syncPurchasedApps();
	
	            _this7.requestLaunchList();
	            // add eventListener after app list is ready
	            // to avoid app is not found
	            window.addEventListener('task-queue-updated', function () {
	              var mozActivityTask = _mozactivityManager.mozActivityManager.task;
	              if (mozActivityTask) {
	                _this7.handleActivityTask(mozActivityTask);
	              }
	            });
	          });
	          performance.mark('REQUEST_INSTALLED_END');
	        }
	      });
	    }
	  }, {
	    key: 'handleActivityTask',
	    value: function handleActivityTask(task) {
	      var activeApp = void 0;
	      var activityType = task.data.type;
	      var adId = task.data.adId ? task.data.adId : null;
	      var autoDownload = false;
	      var disposition = 'window';
	
	      // Support finding app via manifestURL and name;
	      if (activityType === 'name') {
	        var targetName = task.data.name;
	        activeApp = _appStore2.default.findAppByName(targetName);
	      } else if (activityType === 'url') {
	        var activeManifestURL = task.data.url;
	        activeApp = _appStore2.default.findAppByManifest(activeManifestURL);
	      } else if (activityType === 'push-app') {
	        var pushAppManifestURL = task.data.url;
	        activeApp = _appStore2.default.findAppByManifest(pushAppManifestURL);
	        autoDownload = true;
	      }
	
	      switch (task.name) {
	        case 'inline-open-page':
	        case 'inline-open-by-name':
	          disposition = 'inline';
	          break;
	        default:
	          break;
	      }
	
	      if (activeApp) {
	        (0, _preactRouter.route)(_constant.PATH.PAGE.URL({
	          id: activeApp.id,
	          adId: adId,
	          autoDownload: autoDownload,
	          disposition: disposition
	        }));
	      } else {
	        this.handleAppNotFound();
	      }
	    }
	  }, {
	    key: 'handleAppNotFound',
	    value: function handleAppNotFound() {
	      // Launch app list first and then launch alert to notice user
	      // can't find app.
	      this.showNotFoundDialog();
	    }
	  }, {
	    key: 'serverError',
	    value: function serverError(error) {
	      var msg = error.errorMsgId;
	      if (msg) {
	        if (msg === 'no-app-available') {
	          this.setState({ noAvailableAPP: true });
	        } else {
	          this.setMsg(msg);
	        }
	      }
	    }
	  }, {
	    key: 'stopEventListener',
	    value: function stopEventListener() {
	      //TODO
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.dialog !== this.state.dialog) {
	        if (this.state.dialog) {
	          this.onDialogInShowState();
	        } else {
	          this.onDialogInHideState();
	        }
	      }
	
	      if (prevState.readyToRoute === false && this.state.readyToRoute === true) {
	        if (this.prepareDownload) {
	          this.redirectAppPage(this.prepareDownload);
	        } else {
	          (0, _preactRouter.route)(this.entryURL);
	          if (_appStore2.default.kaipayUpdated) {
	            this.showRestartDialog();
	          } else if (window.unitPrice === null && _appStore2.default.hasPaidApp) {
	            this.showNoPriceDialog();
	          }
	        }
	      }
	
	      if (prevState.isViewingSetting !== this.state.isViewingSetting) {
	        (0, _userInterfaceHelper.setThemeColor)(this.state.isViewingSetting);
	      }
	    }
	  }, {
	    key: 'requestLaunchList',
	    value: function requestLaunchList() {
	      this.setState({ readyToRoute: true });
	    }
	  }, {
	    key: 'showDialog',
	    value: function showDialog(options) {
	      if (this.state.dialog === true || this.currentRoute === _constant.PATH.LOADING.URL()) {
	        this.dialogQueue.push(options);
	      } else {
	        this.setState({
	          dialog: true,
	          dialogOptions: options
	        });
	      }
	    }
	  }, {
	    key: 'showNextDialog',
	    value: function showNextDialog() {
	      var nextDialog = this.dialogQueue.shift();
	      if (nextDialog) {
	        this.showDialog(nextDialog);
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'onDialogInShowState',
	    value: function onDialogInShowState() {
	      var _this8 = this;
	
	      var lastActive = document.activeElement;
	
	      this.refs.dialog.show();
	      this.refs.dialog.on('closed', function () {
	        if (_this8.state.dialog) {
	          // close by endKey
	          _this8.hideDialog();
	        }
	        if (_this8.showNextDialog() === false) {
	          lastActive.focus();
	        }
	      });
	    }
	  }, {
	    key: 'onDialogInHideState',
	    value: function onDialogInHideState() {
	      this.refs.dialog.hide();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'App ' + (this.state.isViewingSetting ? 'settings ' : 'bright ') + (navigator.largeTextEnabled ? 'large-text' : ' '),
	          id: 'app',
	          tabIndex: '-1'
	        },
	        _react2.default.createElement(
	          _preactRouter2.default,
	          { onChange: this.onRouteChange },
	          _react2.default.createElement(_Loading2.default, {
	            path: _constant.PATH.LOADING.MATCH,
	            noAvailableAPP: this.state.noAvailableAPP
	          }),
	          this.state.readyToRoute && _react2.default.createElement(_Appspanel2.default, {
	            path: _constant.PATH.APPS.MATCH,
	            ensureDialogDisplay: this.ensureDialogDisplay,
	            'default': true
	          }),
	          _react2.default.createElement(_Settingsview2.default, { path: _constant.PATH.SETTING.MATCH }),
	          this.state.readyToRoute && _react2.default.createElement(_Page2.default, {
	            path: _constant.PATH.PAGE.MATCH,
	            onAppNotFound: this.showNotFoundDialog
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'soft-key-wrapper ' + (this.state.dialog ? 'default' : '')
	          },
	          _react2.default.createElement(_reactSoftKey2.default, null)
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'main-dialog', className: this.state.dialog ? '' : 'hidden' },
	          _react2.default.createElement(_reactDialog2.default, _extends({
	            ref: function ref(dialog) {
	              _this9.refs['dialog'] = dialog;
	            }
	          }, this.state.dialogOptions))
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	navigator.mozL10n.once(function () {
	  _reactDom2.default.render(_react2.default.createElement(App, null), document.getElementById('root'));
	});

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var n = __webpack_require__(56),
	    t = __webpack_require__(4);function e(n, t) {
	  for (var e in t) {
	    n[e] = t[e];
	  }return n;
	}function r(n, t) {
	  for (var e in n) {
	    if ("__source" !== e && !(e in t)) return !0;
	  }for (var r in t) {
	    if ("__source" !== r && n[r] !== t[r]) return !0;
	  }return !1;
	}var o = function (n) {
	  var t, e;function o(t) {
	    var e;return (e = n.call(this, t) || this).isPureReactComponent = !0, e;
	  }return e = n, (t = o).prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e, o.prototype.shouldComponentUpdate = function (n, t) {
	    return r(this.props, n) || r(this.state, t);
	  }, o;
	}(t.Component);function u(n, o) {
	  function u(n) {
	    var t = this.props.ref,
	        e = t == n.ref;return !e && t && (t.call ? t(null) : t.current = null), o ? !o(this.props, n) || !e : r(this.props, n);
	  }function i(r) {
	    return this.shouldComponentUpdate = u, t.createElement(n, e({}, r));
	  }return i.prototype.isReactComponent = !0, i.displayName = "Memo(" + (n.displayName || n.name) + ")", i.t = !0, i;
	}var i = t.options.vnode;function f(n) {
	  function t(t) {
	    var r = e({}, t);return delete r.ref, n(r, t.ref);
	  }return t.prototype.isReactComponent = !0, t.t = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
	}t.options.vnode = function (n) {
	  n.type && n.type.t && n.ref && (n.props.ref = n.ref, n.ref = null), i && i(n);
	};var c = function c(n, e) {
	  return n ? t.toChildArray(n).reduce(function (n, t) {
	    return n.concat(e(t));
	  }, []) : null;
	},
	    l = { map: c, forEach: c, count: function count(n) {
	    return n ? t.toChildArray(n).length : 0;
	  }, only: function only(n) {
	    if (1 !== (n = t.toChildArray(n)).length) throw new Error("Children.only() expects only one child.");return n[0];
	  }, toArray: t.toChildArray },
	    s = t.options.__e;function a(n) {
	  return n && ((n = e({}, n)).__c = null, n.__k = n.__k && n.__k.map(a)), n;
	}function p(n) {
	  this.__u = 0, this.o = null, this.__b = null;
	}function h(n) {
	  var t = n.__.__c;return t && t.u && t.u(n);
	}function v(n) {
	  var e, r, o;function u(u) {
	    if (e || (e = n()).then(function (n) {
	      r = n.default || n;
	    }, function (n) {
	      o = n;
	    }), o) throw o;if (!r) throw e;return t.createElement(r, u);
	  }return u.displayName = "Lazy", u.t = !0, u;
	}function d() {
	  this.i = null, this.l = null;
	}t.options.__e = function (n, t, e) {
	  if (n.then) for (var r, o = t; o = o.__;) {
	    if ((r = o.__c) && r.__c) return r.__c(n, t.__c);
	  }s(n, t, e);
	}, (p.prototype = new t.Component()).__c = function (n, t) {
	  var e = this;null == e.o && (e.o = []), e.o.push(t);var r = h(e.__v),
	      o = !1,
	      u = function u() {
	    o || (o = !0, r ? r(i) : i());
	  };t.__c = t.componentWillUnmount, t.componentWillUnmount = function () {
	    u(), t.__c && t.__c();
	  };var i = function i() {
	    var n;if (! --e.__u) for (e.__v.__k[0] = e.state.u, e.setState({ u: e.__b = null }); n = e.o.pop();) {
	      n.forceUpdate();
	    }
	  };e.__u++ || e.setState({ u: e.__b = e.__v.__k[0] }), n.then(u, u);
	}, p.prototype.render = function (n, e) {
	  return this.__b && (this.__v.__k[0] = a(this.__b), this.__b = null), [t.createElement(t.Component, null, e.u ? null : n.children), e.u && n.fallback];
	};var x = function x(n, t, e) {
	  if (++e[1] === e[0] && n.l.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.l.size)) for (e = n.i; e;) {
	    for (; e.length > 3;) {
	      e.pop()();
	    }if (e[1] < e[0]) break;n.i = e = e[2];
	  }
	};(d.prototype = new t.Component()).u = function (n) {
	  var t = this,
	      e = h(t.__v),
	      r = t.l.get(n);return r[0]++, function (o) {
	    var u = function u() {
	      t.props.revealOrder ? (r.push(o), x(t, n, r)) : o();
	    };e ? e(u) : u();
	  };
	}, d.prototype.render = function (n) {
	  this.i = null, this.l = new Map();var e = t.toChildArray(n.children);n.revealOrder && "b" === n.revealOrder[0] && e.reverse();for (var r = e.length; r--;) {
	    this.l.set(e[r], this.i = [1, 0, this.i]);
	  }return n.children;
	}, d.prototype.componentDidUpdate = d.prototype.componentDidMount = function () {
	  var n = this;n.l.forEach(function (t, e) {
	    x(n, e, t);
	  });
	};var m = function () {
	  function n() {}var t = n.prototype;return t.getChildContext = function () {
	    return this.props.context;
	  }, t.render = function (n) {
	    return n.children;
	  }, n;
	}();function y(n) {
	  var e = this,
	      r = n.container,
	      o = t.createElement(m, { context: e.context }, n.vnode);return e.s && e.s !== r && (e.p.parentNode && e.s.removeChild(e.p), t._e(e.h), e.v = !1), n.vnode ? e.v ? (r.__k = e.__k, t.render(o, r), e.__k = r.__k) : (e.p = document.createTextNode(""), t.hydrate("", r), r.appendChild(e.p), e.v = !0, e.s = r, t.render(o, r, e.p), e.__k = this.p.__k) : e.v && (e.p.parentNode && e.s.removeChild(e.p), t._e(e.h)), e.h = o, e.componentWillUnmount = function () {
	    e.p.parentNode && e.s.removeChild(e.p), t._e(e.h);
	  }, null;
	}function b(n, e) {
	  return t.createElement(y, { vnode: n, container: e });
	}var g = /^(?:accent|alignment|arabic|baseline|cap|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;t.Component.prototype.isReactComponent = {};var w = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103;function E(n, t, e) {
	  if (null == t.__k) for (; t.firstChild;) {
	    t.removeChild(t.firstChild);
	  }return _(n, t, e);
	}function _(n, e, r) {
	  return t.render(n, e), "function" == typeof r && r(), n ? n.__c : null;
	}var A = t.options.event;function S(n, t) {
	  n["UNSAFE_" + t] && !n[t] && Object.defineProperty(n, t, { configurable: !1, get: function get() {
	      return this["UNSAFE_" + t];
	    }, set: function set(n) {
	      this["UNSAFE_" + t] = n;
	    } });
	}t.options.event = function (n) {
	  return A && (n = A(n)), n.persist = function () {}, n.nativeEvent = n;
	};var C = { configurable: !0, get: function get() {
	    return this.class;
	  } },
	    k = t.options.vnode;function N(n) {
	  return t.createElement.bind(null, n);
	}function F(n) {
	  return !!n && n.$$typeof === w;
	}function R(n) {
	  return F(n) ? t.cloneElement.apply(null, arguments) : n;
	}function M(n) {
	  return !!n.__k && (t.render(null, n), !0);
	}function O(n) {
	  return n && (n.base || 1 === n.nodeType && n) || null;
	}t.options.vnode = function (n) {
	  n.$$typeof = w;var e = n.type,
	      r = n.props;if (r.class != r.className && (C.enumerable = "className" in r, null != r.className && (r.class = r.className), Object.defineProperty(r, "className", C)), "function" != typeof e) {
	    var o, u, i;for (i in r.defaultValue && (r.value || 0 === r.value || (r.value = r.defaultValue), delete r.defaultValue), Array.isArray(r.value) && r.multiple && "select" === e && (t.toChildArray(r.children).forEach(function (n) {
	      -1 != r.value.indexOf(n.props.value) && (n.props.selected = !0);
	    }), delete r.value), r) {
	      if (o = g.test(i)) break;
	    }if (o) for (i in u = n.props = {}, r) {
	      u[g.test(i) ? i.replace(/([A-Z0-9])/, "-$1").toLowerCase() : i] = r[i];
	    }
	  }!function (t) {
	    var e = n.type,
	        r = n.props;if (r && "string" == typeof e) {
	      var o = {};for (var u in r) {
	        /^on(Ani|Tra|Tou)/.test(u) && (r[u.toLowerCase()] = r[u], delete r[u]), o[u.toLowerCase()] = u;
	      }if (o.ondoubleclick && (r.ondblclick = r[o.ondoubleclick], delete r[o.ondoubleclick]), o.onbeforeinput && (r.onbeforeinput = r[o.onbeforeinput], delete r[o.onbeforeinput]), o.onchange && ("textarea" === e || "input" === e.toLowerCase() && !/^fil|che|ra/i.test(r.type))) {
	        var i = o.oninput || "oninput";r[i] || (r[i] = r[o.onchange], delete r[o.onchange]);
	      }
	    }
	  }(), "function" == typeof e && !e.m && e.prototype && (S(e.prototype, "componentWillMount"), S(e.prototype, "componentWillReceiveProps"), S(e.prototype, "componentWillUpdate"), e.m = !0), k && k(n);
	};var U = function U(n, t) {
	  return n(t);
	},
	    j = { useState: n.useState, useReducer: n.useReducer, useEffect: n.useEffect, useLayoutEffect: n.useLayoutEffect, useRef: n.useRef, useImperativeHandle: n.useImperativeHandle, useMemo: n.useMemo, useCallback: n.useCallback, useContext: n.useContext, useDebugValue: n.useDebugValue, version: "16.8.0", Children: l, render: E, hydrate: E, unmountComponentAtNode: M, createPortal: b, createElement: t.createElement, createContext: t.createContext, createFactory: N, cloneElement: R, createRef: t.createRef, Fragment: t.Fragment, isValidElement: F, findDOMNode: O, Component: t.Component, PureComponent: o, memo: u, forwardRef: f, unstable_batchedUpdates: U, Suspense: p, SuspenseList: d, lazy: v };Object.keys(n).forEach(function (t) {
	  exports[t] = n[t];
	}), exports.createElement = t.createElement, exports.createContext = t.createContext, exports.createRef = t.createRef, exports.Fragment = t.Fragment, exports.Component = t.Component, exports.version = "16.8.0", exports.Children = l, exports.render = E, exports.hydrate = _, exports.unmountComponentAtNode = M, exports.createPortal = b, exports.createFactory = N, exports.cloneElement = R, exports.isValidElement = F, exports.findDOMNode = O, exports.PureComponent = o, exports.memo = u, exports.forwardRef = f, exports.unstable_batchedUpdates = U, exports.Suspense = p, exports.SuspenseList = d, exports.lazy = v, exports.default = j;
	//# sourceMappingURL=compat.js.map

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _validSettingData;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var mozAppsEvents = exports.mozAppsEvents = {
	  INSTALL: 'install',
	  UNINSTALL: 'uninstall',
	  UPDATE: 'update'
	};
	
	var mozAppEvent = exports.mozAppEvent = {
	  ON_DOWNLOAD_APPLIED: 'ondownloadapplied',
	  ON_DOWNLOAD_ERROR: 'ondownloaderror',
	  ON_PROGRESS: 'onprogress',
	  ON_DOWNLOAD_AVAILABLE: 'ondownloadavailable',
	  ON_DOWNLOAD_SUCCESS: 'ondownloadsuccess'
	};
	
	var accountEvent = exports.accountEvent = {
	  ON_ACCOUNT_API_MISSING: 'missing',
	  ON_LOGIN: 'login',
	  ON_LOGOUT: 'logout',
	  ON_READY: 'ready',
	  ON_ERROR: 'error'
	};
	
	var tokenType = exports.tokenType = {
	  RESTRICTED: 0,
	  ACCOUNT: 1
	};
	
	var validSettingKey = exports.validSettingKey = {
	  AUTO_DOWNLOAD: 'app.update.auto-download',
	  RICH_CONTENT: 'store.richcontent.mode'
	};
	
	var validSettingData = exports.validSettingData = (_validSettingData = {}, _defineProperty(_validSettingData, validSettingKey.AUTO_DOWNLOAD, {
	  default: 'data-enable',
	  values: ['auto-update-off', 'data-enable', 'wifi-only']
	}), _defineProperty(_validSettingData, validSettingKey.RICH_CONTENT, {
	  default: 'wifi-only',
	  values: ['do-not-show', 'data-enable', 'wifi-only']
	}), _validSettingData);

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _App = __webpack_require__(49);
	
	Object.keys(_App).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _App[key];
	    }
	  });
	});
	
	var _Bookmark = __webpack_require__(51);
	
	Object.keys(_Bookmark).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Bookmark[key];
	    }
	  });
	});
	
	var _UI = __webpack_require__(55);
	
	Object.keys(_UI).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _UI[key];
	    }
	  });
	});
	
	var _Device = __webpack_require__(52);
	
	Object.keys(_Device).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Device[key];
	    }
	  });
	});
	
	var _Payment = __webpack_require__(53);
	
	Object.keys(_Payment).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Payment[key];
	    }
	  });
	});
	
	var _Task = __webpack_require__(54);
	
	Object.keys(_Task).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Task[key];
	    }
	  });
	});
	
	var _Auth = __webpack_require__(50);
	
	Object.keys(_Auth).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Auth[key];
	    }
	  });
	});

/***/ },
/* 4 */
/***/ function(module, exports) {

	"use strict";
	
	var n,
	    l,
	    u,
	    t,
	    i,
	    o,
	    r,
	    f = {},
	    e = [],
	    c = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord/i;function s(n, l) {
	  for (var u in l) {
	    n[u] = l[u];
	  }return n;
	}function a(n) {
	  var l = n.parentNode;l && l.removeChild(n);
	}function p(n, l, u) {
	  var t,
	      i = arguments,
	      o = {};for (t in l) {
	    "key" !== t && "ref" !== t && (o[t] = l[t]);
	  }if (arguments.length > 3) for (u = [u], t = 3; t < arguments.length; t++) {
	    u.push(i[t]);
	  }if (null != u && (o.children = u), "function" == typeof n && null != n.defaultProps) for (t in n.defaultProps) {
	    void 0 === o[t] && (o[t] = n.defaultProps[t]);
	  }return v(n, o, l && l.key, l && l.ref);
	}function v(l, u, t, i) {
	  var o = { type: l, props: u, key: t, ref: i, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, constructor: void 0 };return n.vnode && n.vnode(o), o;
	}function h(n) {
	  return n.children;
	}function d(n, l) {
	  this.props = n, this.context = l;
	}function y(n, l) {
	  if (null == l) return n.__ ? y(n.__, n.__.__k.indexOf(n) + 1) : null;for (var u; l < n.__k.length; l++) {
	    if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
	  }return "function" == typeof n.type ? y(n) : null;
	}function x(n) {
	  var l, u;if (null != (n = n.__) && null != n.__c) {
	    for (n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++) {
	      if (null != (u = n.__k[l]) && null != u.__e) {
	        n.__e = n.__c.base = u.__e;break;
	      }
	    }return x(n);
	  }
	}function m(l) {
	  (!l.__d && (l.__d = !0) && 1 === u.push(l) || i !== n.debounceRendering) && ((i = n.debounceRendering) || t)(w);
	}function w() {
	  var n, l, t, i, o, r, f;for (u.sort(function (n, l) {
	    return l.__v.__b - n.__v.__b;
	  }); n = u.pop();) {
	    n.__d && (t = void 0, i = void 0, r = (o = (l = n).__v).__e, (f = l.__P) && (t = [], i = N(f, o, s({}, o), l.__n, void 0 !== f.ownerSVGElement, null, t, null == r ? y(o) : r), z(t, o), i != r && x(o)));
	  }
	}function g(n, l, u, t, i, o, r, c, s) {
	  var p,
	      v,
	      h,
	      d,
	      x,
	      m,
	      w,
	      g = u && u.__k || e,
	      _ = g.length;if (c == f && (c = null != o ? o[0] : _ ? y(u, 0) : null), p = 0, l.__k = k(l.__k, function (u) {
	    if (null != u) {
	      if (u.__ = l, u.__b = l.__b + 1, null === (h = g[p]) || h && u.key == h.key && u.type === h.type) g[p] = void 0;else for (v = 0; v < _; v++) {
	        if ((h = g[v]) && u.key == h.key && u.type === h.type) {
	          g[v] = void 0;break;
	        }h = null;
	      }if (d = N(n, u, h = h || f, t, i, o, r, c, s), (v = u.ref) && h.ref != v && (w || (w = []), h.ref && w.push(h.ref, null, u), w.push(v, u.__c || d, u)), null != d) {
	        var e;if (null == m && (m = d), void 0 !== u.__d) e = u.__d, u.__d = void 0;else if (o == h || d != c || null == d.parentNode) {
	          n: if (null == c || c.parentNode !== n) n.appendChild(d), e = null;else {
	            for (x = c, v = 0; (x = x.nextSibling) && v < _; v += 2) {
	              if (x == d) break n;
	            }n.insertBefore(d, c), e = c;
	          }"option" == l.type && (n.value = "");
	        }c = void 0 !== e ? e : d.nextSibling, "function" == typeof l.type && (l.__d = c);
	      }
	    }return p++, u;
	  }), l.__e = m, null != o && "function" != typeof l.type) for (p = o.length; p--;) {
	    null != o[p] && a(o[p]);
	  }for (p = _; p--;) {
	    null != g[p] && j(g[p], g[p]);
	  }if (w) for (p = 0; p < w.length; p++) {
	    $(w[p], w[++p], w[++p]);
	  }
	}function k(n, l, u) {
	  if (null == u && (u = []), null == n || "boolean" == typeof n) l && u.push(l(null));else if (Array.isArray(n)) for (var t = 0; t < n.length; t++) {
	    k(n[t], l, u);
	  } else u.push(l ? l("string" == typeof n || "number" == typeof n ? v(null, n, null, null) : null != n.__e || null != n.__c ? v(n.type, n.props, n.key, null) : n) : n);return u;
	}function _(n, l, u, t, i) {
	  var o;for (o in u) {
	    o in l || P(n, o, null, u[o], t);
	  }for (o in l) {
	    i && "function" != typeof l[o] || "value" === o || "checked" === o || u[o] === l[o] || P(n, o, l[o], u[o], t);
	  }
	}function b(n, l, u) {
	  "-" === l[0] ? n.setProperty(l, u) : n[l] = "number" == typeof u && !1 === c.test(l) ? u + "px" : null == u ? "" : u;
	}function P(n, l, u, t, i) {
	  var o, r, f, e, c;if (i ? "className" === l && (l = "class") : "class" === l && (l = "className"), "key" === l || "children" === l) ;else if ("style" === l) {
	    if (o = n.style, "string" == typeof u) o.cssText = u;else {
	      if ("string" == typeof t && (o.cssText = "", t = null), t) for (r in t) {
	        u && r in u || b(o, r, "");
	      }if (u) for (f in u) {
	        t && u[f] === t[f] || b(o, f, u[f]);
	      }
	    }
	  } else "o" === l[0] && "n" === l[1] ? (e = l !== (l = l.replace(/Capture$/, "")), c = l.toLowerCase(), l = (c in n ? c : l).slice(2), u ? (t || n.addEventListener(l, C, e), (n.l || (n.l = {}))[l] = u) : n.removeEventListener(l, C, e)) : "list" !== l && "tagName" !== l && "form" !== l && "type" !== l && "size" !== l && !i && l in n ? n[l] = null == u ? "" : u : "function" != typeof u && "dangerouslySetInnerHTML" !== l && (l !== (l = l.replace(/^xlink:?/, "")) ? null == u || !1 === u ? n.removeAttributeNS("http://www.w3.org/1999/xlink", l.toLowerCase()) : n.setAttributeNS("http://www.w3.org/1999/xlink", l.toLowerCase(), u) : null == u || !1 === u ? n.removeAttribute(l) : n.setAttribute(l, u));
	}function C(l) {
	  this.l[l.type](n.event ? n.event(l) : l);
	}function N(l, u, t, i, o, r, f, e, c) {
	  var a,
	      p,
	      v,
	      y,
	      x,
	      m,
	      w,
	      k,
	      _,
	      b,
	      P = u.type;if (void 0 !== u.constructor) return null;(a = n.__b) && a(u);try {
	    n: if ("function" == typeof P) {
	      if (k = u.props, _ = (a = P.contextType) && i[a.__c], b = a ? _ ? _.props.value : a.__ : i, t.__c ? w = (p = u.__c = t.__c).__ = p.__E : ("prototype" in P && P.prototype.render ? u.__c = p = new P(k, b) : (u.__c = p = new d(k, b), p.constructor = P, p.render = A), _ && _.sub(p), p.props = k, p.state || (p.state = {}), p.context = b, p.__n = i, v = p.__d = !0, p.__h = []), null == p.__s && (p.__s = p.state), null != P.getDerivedStateFromProps && (p.__s == p.state && (p.__s = s({}, p.__s)), s(p.__s, P.getDerivedStateFromProps(k, p.__s))), y = p.props, x = p.state, v) null == P.getDerivedStateFromProps && null != p.componentWillMount && p.componentWillMount(), null != p.componentDidMount && p.__h.push(p.componentDidMount);else {
	        if (null == P.getDerivedStateFromProps && k !== y && null != p.componentWillReceiveProps && p.componentWillReceiveProps(k, b), !p.__e && null != p.shouldComponentUpdate && !1 === p.shouldComponentUpdate(k, p.__s, b)) {
	          for (p.props = k, p.state = p.__s, p.__d = !1, p.__v = u, u.__e = t.__e, u.__k = t.__k, p.__h.length && f.push(p), a = 0; a < u.__k.length; a++) {
	            u.__k[a] && (u.__k[a].__ = u);
	          }break n;
	        }null != p.componentWillUpdate && p.componentWillUpdate(k, p.__s, b), null != p.componentDidUpdate && p.__h.push(function () {
	          p.componentDidUpdate(y, x, m);
	        });
	      }p.context = b, p.props = k, p.state = p.__s, (a = n.__r) && a(u), p.__d = !1, p.__v = u, p.__P = l, a = p.render(p.props, p.state, p.context), u.__k = null != a && a.type == h && null == a.key ? a.props.children : a, null != p.getChildContext && (i = s(s({}, i), p.getChildContext())), v || null == p.getSnapshotBeforeUpdate || (m = p.getSnapshotBeforeUpdate(y, x)), g(l, u, t, i, o, r, f, e, c), p.base = u.__e, p.__h.length && f.push(p), w && (p.__E = p.__ = null), p.__e = !1;
	    } else u.__e = T(t.__e, u, t, i, o, r, f, c);(a = n.diffed) && a(u);
	  } catch (l) {
	    n.__e(l, u, t);
	  }return u.__e;
	}function z(l, u) {
	  n.__c && n.__c(u, l), l.some(function (u) {
	    try {
	      l = u.__h, u.__h = [], l.some(function (n) {
	        n.call(u);
	      });
	    } catch (l) {
	      n.__e(l, u.__v);
	    }
	  });
	}function T(n, l, u, t, i, o, r, c) {
	  var s,
	      a,
	      p,
	      v,
	      h,
	      d = u.props,
	      y = l.props;if (i = "svg" === l.type || i, null == n && null != o) for (s = 0; s < o.length; s++) {
	    if (null != (a = o[s]) && (null === l.type ? 3 === a.nodeType : a.localName === l.type)) {
	      n = a, o[s] = null;break;
	    }
	  }if (null == n) {
	    if (null === l.type) return document.createTextNode(y);n = i ? document.createElementNS("http://www.w3.org/2000/svg", l.type) : document.createElement(l.type, y.is && { is: y.is }), o = null;
	  }if (null === l.type) null != o && (o[o.indexOf(n)] = null), d !== y && n.data != y && (n.data = y);else if (l !== u) {
	    if (null != o && (o[o.indexOf(n)] = null, o = e.slice.call(n.childNodes)), p = (d = u.props || f).dangerouslySetInnerHTML, v = y.dangerouslySetInnerHTML, !c) {
	      if (d === f) for (d = {}, h = 0; h < n.attributes.length; h++) {
	        d[n.attributes[h].name] = n.attributes[h].value;
	      }(v || p) && (v && p && v.__html == p.__html || (n.innerHTML = v && v.__html || ""));
	    }_(n, y, d, i, c), l.__k = l.props.children, v || g(n, l, u, t, "foreignObject" !== l.type && i, o, r, f, c), c || ("value" in y && void 0 !== y.value && y.value !== n.value && (n.value = null == y.value ? "" : y.value), "checked" in y && void 0 !== y.checked && y.checked !== n.checked && (n.checked = y.checked));
	  }return n;
	}function $(l, u, t) {
	  try {
	    "function" == typeof l ? l(u) : l.current = u;
	  } catch (l) {
	    n.__e(l, t);
	  }
	}function j(l, u, t) {
	  var i, o, r;if (n.unmount && n.unmount(l), (i = l.ref) && (i.current && i.current !== l.__e || $(i, null, u)), t || "function" == typeof l.type || (t = null != (o = l.__e)), l.__e = l.__d = void 0, null != (i = l.__c)) {
	    if (i.componentWillUnmount) try {
	      i.componentWillUnmount();
	    } catch (l) {
	      n.__e(l, u);
	    }i.base = i.__P = null;
	  }if (i = l.__k) for (r = 0; r < i.length; r++) {
	    i[r] && j(i[r], u, t);
	  }null != o && a(o);
	}function A(n, l, u) {
	  return this.constructor(n, u);
	}function D(l, u, t) {
	  var i, r, c;n.__ && n.__(l, u), r = (i = t === o) ? null : t && t.__k || u.__k, l = p(h, null, [l]), c = [], N(u, (i ? u : t || u).__k = l, r || f, f, void 0 !== u.ownerSVGElement, t && !i ? [t] : r ? null : e.slice.call(u.childNodes), c, t || f, i), z(c, l);
	}n = { __e: function __e(n, l) {
	    for (var u, t; l = l.__;) {
	      if ((u = l.__c) && !u.__) try {
	        if (u.constructor && null != u.constructor.getDerivedStateFromError && (t = !0, u.setState(u.constructor.getDerivedStateFromError(n))), null != u.componentDidCatch && (t = !0, u.componentDidCatch(n)), t) return m(u.__E = u);
	      } catch (l) {
	        n = l;
	      }
	    }throw n;
	  } }, l = function l(n) {
	  return null != n && void 0 === n.constructor;
	}, d.prototype.setState = function (n, l) {
	  var u;u = this.__s !== this.state ? this.__s : this.__s = s({}, this.state), "function" == typeof n && (n = n(u, this.props)), n && s(u, n), null != n && this.__v && (l && this.__h.push(l), m(this));
	}, d.prototype.forceUpdate = function (n) {
	  this.__v && (this.__e = !0, n && this.__h.push(n), m(this));
	}, d.prototype.render = h, u = [], t = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, o = f, r = 0, exports.render = D, exports.hydrate = function (n, l) {
	  D(n, l, o);
	}, exports.createElement = p, exports.h = p, exports.Fragment = h, exports.createRef = function () {
	  return {};
	}, exports.isValidElement = l, exports.Component = d, exports.cloneElement = function (n, l) {
	  return l = s(s({}, n.props), l), arguments.length > 2 && (l.children = e.slice.call(arguments, 2)), v(n.type, l, l.key || n.key, l.ref || n.ref);
	}, exports.createContext = function (n) {
	  var l = {},
	      u = { __c: "__cC" + r++, __: n, Consumer: function Consumer(n, l) {
	      return n.children(l);
	    }, Provider: function Provider(n) {
	      var t,
	          i = this;return this.getChildContext || (t = [], this.getChildContext = function () {
	        return l[u.__c] = i, l;
	      }, this.shouldComponentUpdate = function (l) {
	        n.value !== l.value && t.some(function (n) {
	          n.context = l.value, m(n);
	        });
	      }, this.sub = function (n) {
	        t.push(n);var l = n.componentWillUnmount;n.componentWillUnmount = function () {
	          t.splice(t.indexOf(n), 1), l && l.call(n);
	        };
	      }), n.children;
	    } };return u.Consumer.contextType = u, u;
	}, exports.toChildArray = k, exports._e = j, exports.options = n;
	//# sourceMappingURL=preact.js.map

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.postMessageResponse = exports.MessageSender = exports.MessageListener = undefined;
	
	var _listener = __webpack_require__(66);
	
	var _listener2 = _interopRequireDefault(_listener);
	
	var _sender = __webpack_require__(67);
	
	var _sender2 = _interopRequireDefault(_sender);
	
	var _lib = __webpack_require__(65);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MessageListener = _listener2.default;
	exports.MessageSender = _sender2.default;
	exports.postMessageResponse = _lib.response;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _baseEmitter = __webpack_require__(36);
	
	var _baseEmitter2 = _interopRequireDefault(_baseEmitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SoftKeyStore = function (_BaseEmitter) {
	  _inherits(SoftKeyStore, _BaseEmitter);
	
	  function SoftKeyStore() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SoftKeyStore);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SoftKeyStore.__proto__ || Object.getPrototypeOf(SoftKeyStore)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'SoftKeyStore', _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SoftKeyStore, [{
	    key: 'start',
	    value: function start() {
	      this.currentKeys = {};
	      this.currentTheme = null;
	      this.registeredDOMMap = new Map();
	    }
	  }, {
	    key: 'register',
	    value: function register(keys, dom, theme) {
	      var currentInstance = this.registeredDOMMap.get(dom);
	      var self = this;
	      if (!currentInstance) {
	        currentInstance = {
	          start: function start() {
	            dom.addEventListener('focus', this, true);
	            this.theme = theme;
	            this.updateKeys(keys);
	          },
	          stop: function stop() {
	            dom.removeEventListener('focus', this, true);
	          },
	          handleEvent: function handleEvent() {
	            this.check();
	          },
	          check: function check() {
	            if (document.activeElement === dom || dom.contains(document.activeElement)) {
	              var result = self.recount();
	              self.store(result, this.theme);
	            }
	          },
	          updateKeys: function updateKeys(keys) {
	            this.keys = keys;
	            this.check();
	          }
	        };
	        this.registeredDOMMap.set(dom, currentInstance);
	        currentInstance.start();
	      } else {
	        currentInstance.updateKeys(keys);
	      }
	    }
	  }, {
	    key: 'generateKeysInfo',
	    value: function generateKeysInfo(keys) {
	      var keysInfo = [];
	      for (var key in keys) {
	        var info = {};
	        switch (key) {
	          case 'left':
	            info.code = 'SoftLeft';
	            break;
	          case 'center':
	            info.code = 'Enter';
	            break;
	          case 'right':
	            info.code = 'SoftRight';
	            break;
	        }
	        info.options = {
	          'name': keys[key]
	        };
	        keysInfo.push(info);
	      }
	      return keysInfo;
	    }
	  }, {
	    key: 'registerSoftkeys',
	    value: function registerSoftkeys(keys) {
	      var keysInfo = this.generateKeysInfo(keys);
	
	      if (!keysInfo.length) {
	        return;
	      }
	
	      // registerKeys via softkeyManager
	      if (navigator.softkeyManager) {
	        navigator.softkeyManager.registerKeys(keysInfo);
	      }
	    }
	  }, {
	    key: 'store',
	    value: function store(keys, theme) {
	      this.currentKeys = keys;
	      this.currentTheme = theme;
	      this.registerSoftkeys(keys);
	      this.emit('change');
	    }
	  }, {
	    key: 'recount',
	    value: function recount() {
	      var result = {};
	      var current = document.activeElement;
	      while (current !== document.body) {
	        var instance = this.registeredDOMMap.get(current);
	        if (instance) {
	          var keys = instance.keys;
	          for (var key in keys) {
	            if (!(key in result)) {
	              result[key] = keys[key];
	            }
	          }
	        }
	        current = current.parentNode;
	      }
	      return result;
	    }
	  }, {
	    key: 'unregister',
	    value: function unregister(dom) {
	      var instance = this.registeredDOMMap.get(dom);
	      if (!instance) {
	        return;
	      }
	      instance.stop();
	      this.registeredDOMMap.delete(dom);
	      this.store(this.recount());
	    }
	  }]);
	
	  return SoftKeyStore;
	}(_baseEmitter2.default);
	
	;
	
	var softKeyStoreInstance = new SoftKeyStore();
	softKeyStoreInstance.start();
	
	exports.default = softKeyStoreInstance;

/***/ },
/* 7 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var commandList = exports.commandList = {
	  INSTALL_APP: 'install_app',
	  UNINSTALL_APP: 'uninstall_app',
	  PIN_BOOKMARK: 'add_bookmark',
	  UNPIN_BOOKMARK: 'remove_bookmark',
	  REQUEST_DEVICE_INFO: 'request_device_info',
	  REQUEST_TOKEN: 'request_token',
	  SHOW_NOTIFICATION: 'show_notification',
	  REQUEST_PAYMENT_PROFILE: 'request_payment_profile',
	  REQUEST_INSTALLED_APPS: 'request_installed_apps',
	  REQUEST_BOOKMARKS: 'request_bookmarks',
	  REQUEST_SETTING: 'request_setting',
	  UPDATE_SETTING: 'update_setting',
	  MOZAPP_UPDATE: 'mozapp_update',
	  BOOKMARK_UPDATE: 'bookmark_update',
	  TASK_QUEUE_UPDATE: 'task_queue_update',
	  SHOW_TOAST: 'show_toast',
	  CANCEL_DOWNLOAD: 'cancel_download',
	  LAUNCH_APP: 'launch_app',
	  UPDATE_APP: 'update_app',
	  REQUEST_PAYMENT: 'request_payment',
	  CHECK_APP_UPDATE: 'check_app_update',
	  ACCOUNT_EVENT: 'account_event',
	  OPEN_ACCOUNT: 'open_account',
	  GET_ACCOUNT_VERSION: 'get_account_version',
	  CHANGE_THEME_COLOR: 'change_theme_color',
	  REQUEST_RELOAD: 'request_reload',
	  CHECK_REBOOT: 'check_reboot',
	  REQUEST_EXIT: 'request_exit',
	  FIRST_VIEW_DID_MOUNT: 'first_view_did_mount'
	};

/***/ },
/* 8 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Object$assign, _extend2, _extend3, _extend4;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// ObjectModel v4.1.0 - http://objectmodel.js.org
	// MIT License - Sylvain Pollet-Villard
	var ObjectProto = Object.prototype,
	    bettertypeof = function bettertypeof(x) {
		return ObjectProto.toString.call(x).match(/\s([a-zA-Z]+)/)[1];
	},
	    getProto = Object.getPrototypeOf,
	    setProto = Object.setPrototypeOf,
	    has = function has(o, prop) {
		return ObjectProto.hasOwnProperty.call(o, prop);
	},
	    is = function is(Constructor, obj) {
		return obj instanceof Constructor;
	},
	    isFunction = function isFunction(f) {
		return typeof f === "function";
	},
	    isObject = function isObject(o) {
		return o && (typeof o === "undefined" ? "undefined" : _typeof(o)) === "object";
	},
	    isString = function isString(s) {
		return typeof s === "string";
	},
	    isPlainObject = function isPlainObject(o) {
		return isObject(o) && getProto(o) === ObjectProto;
	},
	    isIterable = function isIterable(x) {
		return x && isFunction(x[Symbol.iterator]);
	},
	    proxify = function proxify(val, traps) {
		return new Proxy(val, traps);
	},
	    merge = function merge(target) {
		var src = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		for (var key in src) {
			if (isPlainObject(src[key])) {
				var o = {};
				merge(o, target[key]);
				merge(o, src[key]);
				target[key] = o;
			} else {
				target[key] = src[key];
			}
		}
		return target;
	},
	    define = function define(obj, key, value) {
		var enumerable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
		Object.defineProperty(obj, key, { value: value, enumerable: enumerable, writable: true, configurable: true });
	},
	    extend = function extend(child, parent, props) {
		child.prototype = Object.assign(Object.create(parent.prototype, {
			constructor: {
				value: child,
				writable: true,
				configurable: true
			}
		}), props);
		setProto(child, parent);
	};
	
	var _check = Symbol(),
	    _checked = Symbol(),
	    // used to skip validation at instanciation for perf
	_original = Symbol(),
	    // used to bypass proxy
	
	initModel = function initModel(def, constructor, parent, init, getTraps, useNew) {
		var model = function model() {
			var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : model.default;
			var mode = arguments[1];
	
			if (useNew && !is(model, this)) return new model(val);
			if (init) val = init(val, model, this);
	
			if (mode === _checked || check(model, val)) return getTraps ? proxify(val, getTraps(model)) : val;
		};
	
		if (parent) extend(model, parent);
		setProto(model, constructor.prototype);
		model.constructor = constructor;
		model.definition = def;
		model.assertions = [].concat(_toConsumableArray(model.assertions));
		define(model, "errors", []);
		delete model.name;
		return model;
	},
	    initObjectModel = function initObjectModel(obj, model, _this) {
		if (is(model, obj)) return obj;
	
		if (!isObject(obj) && !isFunction(obj) && obj !== undefined) {
			stackError(model.errors, Object, obj);
		}
	
		merge(_this, model.default);
		if (model.parentClass) merge(obj, new model.parentClass(obj));
		merge(_this, obj);
		return _this;
	},
	    extendModel = function extendModel(child, parent, newProps) {
		var _child$assertions;
	
		extend(child, parent, newProps);
		(_child$assertions = child.assertions).push.apply(_child$assertions, _toConsumableArray(parent.assertions));
		return child;
	},
	    stackError = function stackError(errors, expected, received, path, message) {
		errors.push({ expected: expected, received: received, path: path, message: message });
	},
	    unstackErrors = function unstackErrors(model) {
		var collector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : model.errorCollector;
	
		var nbErrors = model.errors.length;
		if (nbErrors > 0) {
			var errors = model.errors.map(function (err) {
				if (!err.message) {
					err.message = "expecting " + (err.path ? err.path + " to be " : "") + formatDefinition(err.expected) + ", got " + (err.received != null ? bettertypeof(err.received) + " " : "") + format(err.received);
				}
				return err;
			});
	
			model.errors.length = 0;
			collector.call(model, errors); // throw all errors collected
		}
		return nbErrors;
	},
	    isModelInstance = function isModelInstance(i) {
		return i && getProto(i) && is(Model, getProto(i).constructor);
	},
	    parseDefinition = function parseDefinition(def) {
		if (isPlainObject(def)) {
			for (var key in def) {
				def[key] = parseDefinition(def[key]);
			}
		} else if (!Array.isArray(def)) return [def];else if (def.length === 1) return [def[0], undefined, null];
	
		return def;
	},
	    formatDefinition = function formatDefinition(def, stack) {
		var parts = parseDefinition(def).map(function (d) {
			return format(d, stack);
		});
		return parts.length > 1 ? parts.join(" or ") : parts[0];
	},
	    formatAssertions = function formatAssertions(fns) {
		return fns.length ? "(" + fns.map(function (f) {
			return f.name || f.description || f;
		}) + ")" : "";
	},
	    extendDefinition = function extendDefinition(def) {
		var newParts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
		if (newParts.length > 0) {
			var _ref;
	
			def = (_ref = []).concat.apply(_ref, [def].concat(_toConsumableArray([].concat(newParts)))) // clone to lose ref
			.filter(function (value, index, self) {
				return self.indexOf(value) === index;
			}); // remove duplicates
		}
	
		return def;
	},
	    check = function check(model, obj) {
		model[_check](obj, null, model.errors, [], true);
		return !unstackErrors(model);
	},
	    checkDefinition = function checkDefinition(obj, def, path, errors, stack, shouldCast) {
		var indexFound = stack.indexOf(def);
		if (indexFound !== -1 && stack.indexOf(def, indexFound + 1) !== -1) return obj; // if found twice in call stack, cycle detected, skip validation
	
		if (Array.isArray(def) && def.length === 1 && obj != null) {
			def = def[0]; // shorten validation path for optionals
		}
	
		if (is(Model, def)) {
			if (shouldCast) obj = cast(obj, def);
			def[_check](obj, path, errors, stack.concat(def));
		} else if (isPlainObject(def)) {
			for (var key in def) {
				var val = obj ? obj[key] : undefined;
				checkDefinition(val, def[key], formatPath(path, key), errors, stack, shouldCast);
			}
		} else {
			var pdef = parseDefinition(def);
			if (pdef.some(function (part) {
				return checkDefinitionPart(obj, part, path, stack);
			})) {
				return shouldCast ? cast(obj, def) : obj;
			}
	
			stackError(errors, def, obj, path);
		}
	
		return obj;
	},
	    checkDefinitionPart = function checkDefinitionPart(obj, def, path, stack, shouldCast) {
		if (def === Any) return true;
		if (obj == null) return obj === def;
		if (isPlainObject(def) || is(Model, def)) {
			// object or model as part of union type
			var errors = [];
			checkDefinition(obj, def, path, errors, stack, shouldCast);
			return !errors.length;
		}
		if (is(RegExp, def)) return def.test(obj);
		if (def === Number || def === Date) return obj.constructor === def && !isNaN(obj);
		return obj === def || isFunction(def) && is(def, obj) || obj.constructor === def;
	},
	    checkAssertions = function checkAssertions(obj, model, path) {
		var errors = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : model.errors;
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;
	
		try {
			var _loop = function _loop() {
				var assertion = _step.value;
	
				var result = void 0;
				try {
					result = assertion.call(model, obj);
				} catch (err) {
					result = err;
				}
				if (result !== true) {
					var onFail = isFunction(assertion.description) ? assertion.description : function (assertionResult, value) {
						return "assertion \"" + assertion.description + "\" returned " + format(assertionResult) + " " + ("for " + (path ? path + " =" : "value") + " " + format(value));
					};
					stackError(errors, assertion, obj, path, onFail.call(model, result, obj, path));
				}
			};
	
			for (var _iterator = model.assertions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				_loop();
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	},
	    format = function format(obj) {
		var stack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
		if (stack.length > 15 || stack.includes(obj)) return "...";
		if (obj === null || obj === undefined) return String(obj);
		if (isString(obj)) return "\"" + obj + "\"";
		if (is(Model, obj)) return obj.toString(stack);
	
		stack.unshift(obj);
	
		if (isFunction(obj)) return obj.name || obj.toString();
		if (is(Map, obj) || is(Set, obj)) return format([].concat(_toConsumableArray(obj)));
		if (Array.isArray(obj)) return "[" + obj.map(function (item) {
			return format(item, stack);
		}).join(", ") + "]";
		if (obj.toString && obj.toString !== ObjectProto.toString) return obj.toString();
		if (isObject(obj)) {
			var props = Object.keys(obj),
			    indent = "\t".repeat(stack.length);
			return "{" + props.map(function (key) {
				return "\n" + (indent + key) + ": " + format(obj[key], [].concat(_toConsumableArray(stack)));
			}).join(", ") + " " + (props.length ? "\n" + indent.slice(1) : "") + "}";
		}
	
		return String(obj);
	},
	    formatPath = function formatPath(path, key) {
		return path ? path + "." + key : key;
	},
	    controlMutation = function controlMutation(model, def, path, o, key, privateAccess, applyMutation) {
		var newPath = formatPath(path, key),
		    isPrivate = model.conventionForPrivate(key),
		    isConstant = model.conventionForConstant(key),
		    isOwnProperty = has(o, key),
		    initialPropDescriptor = isOwnProperty && Object.getOwnPropertyDescriptor(o, key);
	
		if (key in def && (isPrivate && !privateAccess || isConstant && o[key] !== undefined)) cannot("modify " + (isPrivate ? "private" : "constant") + " property " + key, model);
	
		applyMutation();
		if (has(def, key)) checkDefinition(o[key], def[key], newPath, model.errors, []);
		checkAssertions(o, model, newPath);
	
		var nbErrors = model.errors.length;
		if (nbErrors) {
			if (isOwnProperty) Object.defineProperty(o, key, initialPropDescriptor);else delete o[key]; // back to the initial property defined in prototype chain
	
			unstackErrors(model);
		}
	
		return !nbErrors;
	},
	    cannot = function cannot(msg, model) {
		model.errors.push({ message: "cannot " + msg });
	},
	    cast = function cast(obj) {
		var defNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
		if (!obj || isPlainObject(defNode) || is(BasicModel, defNode) || isModelInstance(obj)) return obj; // no value or not leaf or already a model instance
	
		var def = parseDefinition(defNode),
		    suitableModels = [];
	
		var _iteratorNormalCompletion2 = true;
		var _didIteratorError2 = false;
		var _iteratorError2 = undefined;
	
		try {
			for (var _iterator2 = def[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
				var part = _step2.value;
	
				if (is(Model, part) && !is(BasicModel, part) && part.test(obj)) suitableModels.push(part);
			}
		} catch (err) {
			_didIteratorError2 = true;
			_iteratorError2 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion2 && _iterator2.return) {
					_iterator2.return();
				}
			} finally {
				if (_didIteratorError2) {
					throw _iteratorError2;
				}
			}
		}
	
		if (suitableModels.length === 1) {
			// automatically cast to suitable model when explicit (autocasting)
			return new suitableModels[0](obj, _checked);
		}
	
		if (suitableModels.length > 1) console.warn("Ambiguous model for value " + format(obj) + ", could be " + suitableModels.join(" or "));
	
		return obj;
	},
	    getProp = function getProp(val, model, def, path, privateAccess) {
		if (!isPlainObject(def)) return cast(val, def);
		return proxify(val, getTraps(model, def, path, privateAccess));
	},
	    getTraps = function getTraps(model, def, path, privateAccess) {
		var grantPrivateAccess = function grantPrivateAccess(f) {
			return proxify(f, {
				apply: function apply(fn, ctx, args) {
					privateAccess = true;
					var result = Reflect.apply(fn, ctx, args);
					privateAccess = false;
					return result;
				}
			});
		};
	
		return {
			get: function get(o, key) {
				if (key === _original) return o;
	
				if (!isString(key)) return Reflect.get(o, key);
	
				var newPath = formatPath(path, key);
				var inDef = has(def, key);
				var defPart = def[key];
	
				if (!privateAccess && inDef && model.conventionForPrivate(key)) {
					cannot("access to private property " + newPath, model);
					unstackErrors(model);
					return;
				}
	
				var value = o[key];
	
				if (inDef && value && has(o, key) && !isPlainObject(defPart) && !isModelInstance(value)) {
					Reflect.set(o, key, value = cast(value, defPart)); // cast nested models
				}
	
				if (isFunction(value) && key !== "constructor" && !privateAccess) {
					return grantPrivateAccess(value);
				}
	
				if (isPlainObject(defPart) && !value) {
					o[key] = value = {}; // null-safe traversal
				}
	
				return getProp(value, model, defPart, newPath, privateAccess);
			},
			set: function set(o, key, val) {
				return controlMutation(model, def, path, o, key, privateAccess, function () {
					return Reflect.set(o, key, cast(val, def[key]));
				});
			},
			deleteProperty: function deleteProperty(o, key) {
				return controlMutation(model, def, path, o, key, privateAccess, function () {
					return Reflect.deleteProperty(o, key);
				});
			},
			defineProperty: function defineProperty(o, key, args) {
				return controlMutation(model, def, path, o, key, privateAccess, function () {
					return Reflect.defineProperty(o, key, args);
				});
			},
			has: function has(o, key) {
				return Reflect.has(o, key) && Reflect.has(def, key) && !model.conventionForPrivate(key);
			},
			ownKeys: function ownKeys(o) {
				return Reflect.ownKeys(o).filter(function (key) {
					return Reflect.has(def, key) && !model.conventionForPrivate(key);
				});
			},
			getOwnPropertyDescriptor: function getOwnPropertyDescriptor(o, key) {
				var descriptor = void 0;
				if (!model.conventionForPrivate(key)) {
					descriptor = Object.getOwnPropertyDescriptor(def, key);
					if (descriptor !== undefined) descriptor.value = o[key];
				}
	
				return descriptor;
			}
		};
	};
	
	function Model(def, params) {
		return isPlainObject(def) ? new ObjectModel(def, params) : new BasicModel(def);
	}
	
	Object.assign(Model.prototype, (_Object$assign = {
		name: "Model",
		assertions: [],
	
		conventionForConstant: function conventionForConstant(key) {
			return key.toUpperCase() === key;
		},
		conventionForPrivate: function conventionForPrivate(key) {
			return key[0] === "_";
		},
	
		toString: function toString(stack) {
			return has(this, "name") ? this.name : formatDefinition(this.definition, stack) + formatAssertions(this.assertions);
		},
		as: function as(name) {
			define(this, "name", name);
			return this;
		},
		defaultTo: function defaultTo(val) {
			this.default = val;
			return this;
		}
	}, _defineProperty(_Object$assign, _check, function (obj, path, errors, stack) {
		checkDefinition(obj, this.definition, path, errors, stack);
		checkAssertions(obj, this, path, errors);
	}), _defineProperty(_Object$assign, "test", function test(obj, errorCollector) {
		var _this2 = this;
	
		var model = this;
		while (!has(model, "errorCollector")) {
			model = getProto(model);
		}
	
		var initialErrorCollector = model.errorCollector;
		var failed = void 0;
	
		model.errorCollector = function (errors) {
			failed = true;
			if (errorCollector) errorCollector.call(_this2, errors);
		};
	
		new this(obj); // may trigger errorCollector
	
		model.errorCollector = initialErrorCollector;
		return !failed;
	}), _defineProperty(_Object$assign, "errorCollector", function errorCollector(errors) {
		var e = new TypeError(errors.map(function (e) {
			return e.message;
		}).join("\n"));
		e.stack = e.stack.replace(/\n.*object-model(.|\n)*object-model.*/, ""); // blackbox objectmodel in stacktrace
		throw e;
	}), _defineProperty(_Object$assign, "assert", function assert(assertion) {
		var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : format(assertion);
	
		define(assertion, "description", description);
		this.assertions = this.assertions.concat(assertion);
		return this;
	}), _Object$assign));
	
	function BasicModel(def) {
		return initModel(def, BasicModel);
	}
	
	extend(BasicModel, Model, {
		extend: function extend() {
			for (var _len = arguments.length, newParts = Array(_len), _key = 0; _key < _len; _key++) {
				newParts[_key] = arguments[_key];
			}
	
			var child = extendModel(new BasicModel(extendDefinition(this.definition, newParts)), this);
			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;
	
			try {
				for (var _iterator3 = newParts[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var _child$assertions2;
	
					var part = _step3.value;
	
					if (is(BasicModel, part)) (_child$assertions2 = child.assertions).push.apply(_child$assertions2, _toConsumableArray(part.assertions));
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}
	
			return child;
		}
	});
	
	function ObjectModel(def) {
		return initModel(def, ObjectModel, Object, initObjectModel, function (model) {
			return getTraps(model, def);
		}, true);
	}
	
	extend(ObjectModel, Model, _defineProperty({
		defaultTo: function defaultTo(obj) {
			var def = this.definition;
			for (var key in obj) {
				if (has(def, key)) {
					obj[key] = checkDefinition(obj[key], def[key], key, this.errors, [], true);
				}
			}
			unstackErrors(this);
			this.default = obj;
			return this;
		},
		toString: function toString(stack) {
			return format(this.definition, stack);
		},
		extend: function extend() {
			var definition = _extends({}, this.definition);
			var proto = _extends({}, this.prototype);
			var defaults = _extends({}, this.default);
			var newAssertions = [];
	
			for (var _len2 = arguments.length, newParts = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				newParts[_key2] = arguments[_key2];
			}
	
			var _iteratorNormalCompletion4 = true;
			var _didIteratorError4 = false;
			var _iteratorError4 = undefined;
	
			try {
				for (var _iterator4 = newParts[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
					var part = _step4.value;
	
					if (is(Model, part)) {
						merge(definition, part.definition);
						merge(defaults, part.default);
						newAssertions.push.apply(newAssertions, _toConsumableArray(part.assertions));
					}
					if (isFunction(part)) merge(proto, part.prototype);
					if (isObject(part)) merge(definition, part);
				}
			} catch (err) {
				_didIteratorError4 = true;
				_iteratorError4 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion4 && _iterator4.return) {
						_iterator4.return();
					}
				} finally {
					if (_didIteratorError4) {
						throw _iteratorError4;
					}
				}
			}
	
			var submodel = extendModel(new ObjectModel(definition), this, proto).defaultTo(defaults);
			submodel.assertions = [].concat(_toConsumableArray(this.assertions), newAssertions);
	
			if (getProto(this) !== ObjectModel.prototype) {
				// extended class
				submodel.parentClass = this;
			}
	
			return submodel;
		}
	}, _check, function (obj, path, errors, stack, shouldCast) {
		if (isObject(obj)) {
			checkDefinition(obj[_original] || obj, this.definition, path, errors, stack, shouldCast);
		} else stackError(errors, this, obj, path);
	
		checkAssertions(obj, this, path, errors);
	}));
	
	var Any = proxify(BasicModel(), {
		apply: function apply(target, ctx, _ref2) {
			var _ref3 = _slicedToArray(_ref2, 1),
			    def = _ref3[0];
	
			var anyOf = Object.create(Any);
			anyOf.definition = def;
			return anyOf;
		}
	});
	Any.definition = Any;
	Any.toString = function () {
		return "Any";
	};
	
	Any.remaining = function (def) {
		this.definition = def;
	};
	extend(Any.remaining, Any, {
		toString: function toString() {
			return "..." + formatDefinition(this.definition);
		}
	});
	Any[Symbol.iterator] = /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return new Any.remaining(this.definition);
	
					case 2:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this);
	});
	
	var initListModel = function initListModel(base, constructor, def, init, clone, mutators, otherTraps) {
	
		return initModel(def, constructor, base, init, function (model) {
			return Object.assign({
				getPrototypeOf: function getPrototypeOf() {
					return model.prototype;
				},
				get: function get(l, key) {
					if (key === _original) return l;
	
					var val = l[key];
					return isFunction(val) ? proxify(val, {
						apply: function apply(fn, ctx, args) {
							if (has(mutators, key)) {
								// indexes of arguments to check def + cast
								var _mutators$key = _slicedToArray(mutators[key], 3),
								    begin = _mutators$key[0],
								    _mutators$key$ = _mutators$key[1],
								    end = _mutators$key$ === undefined ? args.length - 1 : _mutators$key$,
								    getArgDef = _mutators$key[2];
	
								for (var i = begin; i <= end; i++) {
									var argDef = getArgDef ? getArgDef(i) : model.definition;
									args[i] = checkDefinition(args[i], argDef, base.name + "." + key + " arguments[" + i + "]", model.errors, [], true);
								}
	
								if (model.assertions.length > 0) {
									var testingClone = clone(l);
									fn.apply(testingClone, args);
									checkAssertions(testingClone, model, "after " + key + " mutation");
								}
	
								unstackErrors(model);
							}
	
							return fn.apply(l, args);
						}
					}) : val;
				}
			}, otherTraps);
		});
	};
	
	function ArrayModel(initialDefinition) {
		var model = initListModel(Array, ArrayModel, initialDefinition, function (a) {
			return Array.isArray(a) ? a.map(function (arg) {
				return cast(arg, model.definition);
			}) : a;
		}, function (a) {
			return [].concat(_toConsumableArray(a));
		}, {
			"copyWithin": [],
			"fill": [0, 0],
			"pop": [],
			"push": [0],
			"reverse": [],
			"shift": [],
			"sort": [],
			"splice": [2],
			"unshift": [0]
		}, {
			set: function set(arr, key, val) {
				return controlMutation$1(model, arr, key, val, function (a, v) {
					return a[key] = v;
				}, true);
			},
			deleteProperty: function deleteProperty(arr, key) {
				return controlMutation$1(model, arr, key, undefined, function (a) {
					return delete a[key];
				});
			}
		});
	
		return model;
	}
	
	extend(ArrayModel, Model, (_extend2 = {
		toString: function toString(stack) {
			return "Array of " + formatDefinition(this.definition, stack);
		}
	}, _defineProperty(_extend2, _check, function (arr, path, errors, stack) {
		var _this3 = this;
	
		if (Array.isArray(arr)) (arr[_original] || arr).forEach(function (a, i) {
			return checkDefinition(a, _this3.definition, (path || "Array") + "[" + i + "]", errors, stack);
		});else stackError(errors, this, arr, path);
	
		checkAssertions(arr, this, path, errors);
	}), _defineProperty(_extend2, "extend", function extend() {
		for (var _len3 = arguments.length, newParts = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
			newParts[_key3] = arguments[_key3];
		}
	
		return extendModel(new ArrayModel(extendDefinition(this.definition, newParts)), this);
	}), _extend2));
	
	var controlMutation$1 = function controlMutation$1(model, array, key, value, applyMutation, canBeExtended) {
		var path = "Array[" + key + "]";
		var isInDef = +key >= 0 && (canBeExtended || key in array);
		if (isInDef) value = checkDefinition(value, model.definition, path, model.errors, [], true);
	
		var testArray = [].concat(_toConsumableArray(array));
		applyMutation(testArray);
		checkAssertions(testArray, model, path);
		var isSuccess = !unstackErrors(model);
		if (isSuccess) applyMutation(array, value);
		return isSuccess;
	};
	
	function SetModel(initialDefinition) {
		var model = initListModel(Set, SetModel, initialDefinition, function (it) {
			return isIterable(it) ? new Set([].concat(_toConsumableArray(it)).map(function (val) {
				return cast(val, model.definition);
			})) : it;
		}, function (set) {
			return new Set(set);
		}, {
			"add": [0, 0],
			"delete": [],
			"clear": []
		});
	
		return model;
	}
	
	extend(SetModel, Model, (_extend3 = {
		toString: function toString(stack) {
			return "Set of " + formatDefinition(this.definition, stack);
		}
	}, _defineProperty(_extend3, _check, function (set, path, errors, stack) {
		if (is(Set, set)) {
			var _iteratorNormalCompletion5 = true;
			var _didIteratorError5 = false;
			var _iteratorError5 = undefined;
	
			try {
				for (var _iterator5 = set.values()[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
					var item = _step5.value;
	
					checkDefinition(item, this.definition, (path || "Set") + " value", errors, stack);
				}
			} catch (err) {
				_didIteratorError5 = true;
				_iteratorError5 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion5 && _iterator5.return) {
						_iterator5.return();
					}
				} finally {
					if (_didIteratorError5) {
						throw _iteratorError5;
					}
				}
			}
		} else stackError(errors, this, set, path);
		checkAssertions(set, this, path, errors);
	}), _defineProperty(_extend3, "extend", function extend() {
		for (var _len4 = arguments.length, newParts = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
			newParts[_key4] = arguments[_key4];
		}
	
		return extendModel(new SetModel(extendDefinition(this.definition, newParts)), this);
	}), _extend3));
	
	function MapModel(initialKeyDefinition, initialValueDefinition) {
		var getDef = function getDef(i) {
			return i === 0 ? model.definition.key : model.definition.value;
		};
		var model = initListModel(Map, MapModel, { key: initialKeyDefinition, value: initialValueDefinition }, function (it) {
			return isIterable(it) ? new Map([].concat(_toConsumableArray(it)).map(function (pair) {
				return pair.map(function (x, i) {
					return cast(x, getDef(i));
				});
			})) : it;
		}, function (map) {
			return new Map(map);
		}, {
			"set": [0, 1, getDef],
			"delete": [],
			"clear": []
		});
	
		return model;
	}
	
	extend(MapModel, Model, (_extend4 = {
		toString: function toString(stack) {
			return "Map of " + formatDefinition(this.definition.key, stack) + " : " + formatDefinition(this.definition.value, stack);
		}
	}, _defineProperty(_extend4, _check, function (map, path, errors, stack) {
		if (is(Map, map)) {
			path = path || "Map";
			var _iteratorNormalCompletion6 = true;
			var _didIteratorError6 = false;
			var _iteratorError6 = undefined;
	
			try {
				for (var _iterator6 = map[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
					var _step6$value = _slicedToArray(_step6.value, 2),
					    key = _step6$value[0],
					    value = _step6$value[1];
	
					checkDefinition(key, this.definition.key, path + " key", errors, stack);
					checkDefinition(value, this.definition.value, path + "[" + format(key) + "]", errors, stack);
				}
			} catch (err) {
				_didIteratorError6 = true;
				_iteratorError6 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion6 && _iterator6.return) {
						_iterator6.return();
					}
				} finally {
					if (_didIteratorError6) {
						throw _iteratorError6;
					}
				}
			}
		} else stackError(errors, this, map, path);
	
		checkAssertions(map, this, path, errors);
	}), _defineProperty(_extend4, "extend", function extend(keyParts, valueParts) {
		return extendModel(new MapModel(extendDefinition(this.definition.key, keyParts), extendDefinition(this.definition.value, valueParts)), this);
	}), _extend4));
	
	function FunctionModel() {
		for (var _len5 = arguments.length, argsDef = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
			argsDef[_key5] = arguments[_key5];
		}
	
		return initModel({ arguments: argsDef }, FunctionModel, Function, null, function (model) {
			return {
				getPrototypeOf: function getPrototypeOf() {
					return model.prototype;
				},
	
				get: function get(fn, key) {
					return key === _original ? fn : fn[key];
				},
				apply: function apply(fn, ctx, args) {
					var def = model.definition;
					var remainingArgDef = def.arguments.find(function (argDef) {
						return is(Any.remaining, argDef);
					});
					var nbArgsToCheck = remainingArgDef ? Math.max(args.length, def.arguments.length - 1) : def.arguments.length;
	
					for (var i = 0; i < nbArgsToCheck; i++) {
						var argDef = remainingArgDef && i >= def.arguments.length - 1 ? remainingArgDef.definition : def.arguments[i];
						args[i] = checkDefinition(args[i], argDef, "arguments[" + i + "]", model.errors, [], true);
					}
	
					checkAssertions(args, model, "arguments");
	
					var result = void 0;
					if (!model.errors.length) {
						result = Reflect.apply(fn, ctx, args);
						if ("return" in def) result = checkDefinition(result, def.return, "return value", model.errors, [], true);
					}
					unstackErrors(model);
					return result;
				}
			};
		});
	}
	
	extend(FunctionModel, Model, _defineProperty({
		toString: function toString() {
			var stack = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
			var out = "Function(" + this.definition.arguments.map(function (argDef) {
				return formatDefinition(argDef, [].concat(_toConsumableArray(stack)));
			}).join(", ") + ")";
	
			if ("return" in this.definition) {
				out += " => " + formatDefinition(this.definition.return, stack);
			}
			return out;
		},
		return: function _return(def) {
			this.definition.return = def;
			return this;
		},
		extend: function extend(newArgs, newReturns) {
			var args = this.definition.arguments,
			    mixedArgs = newArgs.map(function (a, i) {
				return extendDefinition(i in args ? args[i] : [], newArgs[i]);
			}),
			    mixedReturns = extendDefinition(this.definition.return, newReturns);
			return extendModel(new (Function.prototype.bind.apply(FunctionModel, [null].concat(_toConsumableArray(mixedArgs))))().return(mixedReturns), this);
		}
	}, _check, function (f, path, errors) {
		if (!isFunction(f)) stackError(errors, "Function", f, path);
	}));
	
	var styles = {
		list: "list-style-type: none; padding: 0; margin: 0;",
		listItem: "padding: 0 0 0 1em;",
		model: "color: #3e999f;",
		instance: "color: #718c00; font-style: italic",
		function: "color: #4271AE",
		string: "color: #C41A16",
		number: "color: #1C00CF",
		boolean: "color: #AA0D91",
		property: "color: #8959a8",
		private: "color: #C19ED8",
		constant: "color: #8959a8; font-weight: bold",
		privateConstant: "color: #C19ED8; font-weight: bold",
		null: "color: #8e908c",
		undeclared: "color: #C0C0C0;",
		proto: "color: #B871BD; font-style: italic"
	};
	
	var getModel = function getModel(instance) {
		if (instance === undefined || instance === null) return null;
	
		var proto = getProto(instance);
		if (!proto || !proto.constructor || !is(Model, proto.constructor)) return null;
	
		return proto.constructor;
	};
	
	var span = function span(style) {
		for (var _len6 = arguments.length, children = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
			children[_key6 - 1] = arguments[_key6];
		}
	
		return ["span", { style: style }].concat(children);
	};
	
	var format$1 = function format$1(x) {
		var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		if (x === null || x === undefined) return span(styles.null, "" + x);
	
		if (typeof x === "boolean") return span(styles.boolean, x);
	
		if (typeof x === "number") return span(styles.number, x);
	
		if (typeof x === "string") return span(styles.string, "\"" + x + "\"");
	
		if (Array.isArray(x) && config.isModelDefinition) {
			var def = [];
			if (x.length === 1) x.push(undefined, null);
			for (var i = 0; i < x.length; i++) {
				def.push(format$1(x[i], config));
				if (i < x.length - 1) def.push(" or ");
			}
			return span.apply(undefined, [""].concat(def));
		}
	
		if (isPlainObject(x)) return formatObject(x, getModel(x), config);
	
		if (isFunction(x) && !is(Model, x) && config.isModelDefinition) return span(styles.function, x.name || x.toString());
	
		return ["object", { object: x, config: config }];
	};
	
	var formatObject = function formatObject(o, model, config) {
		return span("", "{", ["ol", { style: styles.list }].concat(_toConsumableArray(Object.keys(o).map(function (prop) {
			return ["li", { style: styles.listItem }, span(styles.property, prop), ": ", format$1(o[prop], config)];
		}))), "}");
	};
	
	var formatModel = function formatModel(model) {
		var parts = [],
		    cfg = { isModelDefinition: true },
		    def = model.definition,
		    formatList = function formatList(list, map) {
			return list.reduce(function (r, e) {
				return [].concat(_toConsumableArray(r), [map(e), ", "]);
			}, []).slice(0, 2 * list.length - 1);
		};
	
		if (is(BasicModel, model)) parts.push(format$1(def, cfg));
		if (is(ArrayModel, model)) parts.push("Array of ", format$1(def, cfg));
		if (is(SetModel, model)) parts.push("Set of ", format$1(def, cfg));
		if (is(MapModel, model)) parts.push("Map of ", format$1(def.key, cfg), " : ", format$1(def.value, cfg));
		if (is(FunctionModel, model)) {
			parts.push.apply(parts, ["Function("].concat(_toConsumableArray(formatList(def.arguments, function (arg) {
				return format$1(arg, cfg);
			})), [")"]));
			if ("return" in def) parts.push(" => ", format$1(def.return, cfg));
		}
	
		if (model.assertions.length > 0) {
			parts.push.apply(parts, ["\n(assertions: "].concat(_toConsumableArray(formatList(model.assertions, function (f) {
				return ["object", { object: f }];
			})), [")"]));
		}
	
		return span.apply(undefined, [styles.model].concat(parts));
	};
	
	var ModelFormatter = {
		header: function header(x) {
			var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
			if (x === Any) return span(styles.model, "Any");
	
			if (is(Any.remaining, x)) return span(styles.model, "...", format$1(x.definition, { isModelDefinition: true }));
	
			if (is(ObjectModel, x)) return span(styles.model, x.name);
	
			if (is(Model, x)) {
				return formatModel(x);
			}
	
			if (config.isModelDefinition && isPlainObject(x)) return format$1(x, config);
	
			return null;
		},
		hasBody: function hasBody(x) {
			return is(ObjectModel, x);
		},
		body: function body(model) {
			return span("", "{", ["ol", { style: styles.list }].concat(_toConsumableArray(Object.keys(model.definition).map(function (prop) {
				var isPrivate = model.conventionForPrivate(prop);
				var isConstant = model.conventionForConstant(prop);
				var hasDefault = model.default && has(model.default, prop);
				var style = styles.property;
	
				if (isPrivate) {
					style = isConstant ? styles.privateConstant : styles.private;
				} else if (isConstant) {
					style = styles.constant;
				}
	
				return ["li", { style: styles.listItem }, span(style, prop), ": ", format$1(model.definition[prop], { isModelDefinition: true }), hasDefault ? span(styles.proto, " = ", format$1(model.default[prop])) : ""];
			}))), "}");
		}
	};
	
	var ModelInstanceFormatter = {
		header: function header(x) {
			var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
			if (config.isInstanceProperty && isPlainObject(x)) {
				return format$1(x, config);
			}
	
			var model = getModel(x);
			if (is(Model, model)) {
				var parts = is(ObjectModel, model) ? [model.name] : [["object", { object: x[_original] }], " (" + model.name + ")"];
				return span.apply(undefined, [styles.instance].concat(parts));
			}
	
			return null;
		},
		hasBody: function hasBody(x) {
			return x && is(ObjectModel, getModel(x));
		},
		body: function body(x) {
			var model = getModel(x);
			var o = x[_original] || x;
			return span("", "{", ["ol", { style: styles.list }].concat(_toConsumableArray(Object.keys(o).map(function (prop) {
				var isPrivate = model.conventionForPrivate(prop);
				var isConstant = model.conventionForConstant(prop);
				var isDeclared = prop in model.definition;
				var style = styles.property;
	
				if (!isDeclared) {
					style = styles.undeclared;
				} else if (isPrivate) {
					style = isConstant ? styles.privateConstant : styles.private;
				} else if (isConstant) {
					style = styles.constant;
				}
	
				return ["li", { style: styles.listItem }, span(style, prop), ": ", format$1(o[prop], { isInstanceProperty: true })];
			})), [["li", { style: styles.listItem }, span(styles.proto, "__proto__", ": ", ["object", { object: getProto(x) }])]]), "}");
		}
	};
	
	if (typeof window !== "undefined") {
		window.devtoolsFormatters = (window.devtoolsFormatters || []).concat(ModelFormatter, ModelInstanceFormatter);
	}
	
	exports.Any = Any;
	exports.ArrayModel = ArrayModel;
	exports.BasicModel = BasicModel;
	exports.FunctionModel = FunctionModel;
	exports.MapModel = MapModel;
	exports.Model = Model;
	exports.ObjectModel = ObjectModel;
	exports.SetModel = SetModel;
	//# sourceMappingURL=object-model.js.map

/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var APP_ORIGIN = exports.APP_ORIGIN = 'app://kaios-plus.kaiostech.com';
	
	var PATH = exports.PATH = {
	  LOADING: {
	    MATCH: '/loading',
	    URL: function URL() {
	      return '/loading';
	    }
	  },
	  APPS: {
	    MATCH: '/',
	    URL: function URL() {
	      return '/';
	    }
	  },
	  SETTING: {
	    MATCH: '/setting',
	    URL: function URL() {
	      return '/setting';
	    }
	  },
	  PAGE: {
	    MATCH: '/app/:id?',
	    URL: function URL(_ref) {
	      var _ref$id = _ref.id,
	          id = _ref$id === undefined ? '' : _ref$id,
	          _ref$adId = _ref.adId,
	          adId = _ref$adId === undefined ? null : _ref$adId,
	          _ref$appOrder = _ref.appOrder,
	          appOrder = _ref$appOrder === undefined ? null : _ref$appOrder,
	          _ref$autoDownload = _ref.autoDownload,
	          autoDownload = _ref$autoDownload === undefined ? false : _ref$autoDownload,
	          _ref$disposition = _ref.disposition,
	          disposition = _ref$disposition === undefined ? 'window' : _ref$disposition,
	          _ref$manifest = _ref.manifest,
	          manifest = _ref$manifest === undefined ? null : _ref$manifest,
	          _ref$batchUpdating = _ref.batchUpdating,
	          batchUpdating = _ref$batchUpdating === undefined ? false : _ref$batchUpdating;
	
	      var params = new URLSearchParams();
	      var timestamp = new Date().getTime();
	
	      params.append('t', timestamp);
	      adId && params.append('adId', adId);
	      appOrder && params.append('appOrder', appOrder);
	      autoDownload && params.append('autoDownload', autoDownload);
	      disposition && params.append('disposition', disposition);
	      manifest && params.append('manifest', encodeURIComponent(manifest));
	      batchUpdating && params.append('batchUpdating', batchUpdating);
	
	      return '/app/' + id + '?' + params.toString();
	    }
	  }
	};
	
	var SUPPORTED_APP_TYPE = exports.SUPPORTED_APP_TYPE = ['bookmark', 'privileged', 'hosted', 'certified', 'web'];
	
	// uuid of
	// Payment = 'UgW01f5JflryQMM4H7SF'
	// KaiOS-Store for FIH(HMD) = 'mpEy1f2paIZOdwYMzzr6'
	// KaiOS-Store for All = ''daR-aFQOTlGk8DJePIQA''
	var INTERNAL_APP = exports.INTERNAL_APP = ['UgW01f5JflryQMM4H7SF', 'mpEy1f2paIZOdwYMzzr6', 'daR-aFQOTlGk8DJePIQA', 'qli0T1E695LxmxEqZer4'];
	
	// Google Assistant ='OSlAbgrhLArfT7grf4_N'
	var PRELOADED_APP = exports.PRELOADED_APP = ['OSlAbgrhLArfT7grf4_N'];

/***/ },
/* 10 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.generateID = generateID;
	exports.generateDefault = generateDefault;
	exports.hashCode = hashCode;
	function generateID(length) {
	  var result = '';
	  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz0123456789';
	  var charactersLength = characters.length;
	  for (var i = 0; i < length; i++) {
	    result += characters.charAt(Math.floor(Math.random() * charactersLength));
	  }
	  return result;
	}
	
	function generateDefault(data) {
	  return Object.assign({
	    id: generateID(5) + new Date().getTime() + hashCode(JSON.stringify(data))
	  }, data);
	}
	
	function hashCode(s) {
	  return s.split('').reduce(function (a, b) {
	    a = (a << 5) - a + b.charCodeAt(0);
	    return a & a;
	  }, 0);
	}

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Command = undefined;
	
	var _objectmodel = __webpack_require__(8);
	
	var Command = new _objectmodel.ObjectModel({
	  id: String,
	  action: String
	});
	
	exports.Command = Command;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	!function (t, e) {
	  "object" == ( false ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = e(__webpack_require__(4)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_FACTORY__ = (e), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : t.preactRouter = e(t.preact);
	}(undefined, function (t) {
	  function e(t, e) {
	    for (var n in e) {
	      t[n] = e[n];
	    }return t;
	  }function n(t, e, n) {
	    var r,
	        o = /(?:\?([^#]*))?(#.*)?$/,
	        u = t.match(o),
	        a = {};if (u && u[1]) for (var p = u[1].split("&"), c = 0; c < p.length; c++) {
	      var f = p[c].split("=");a[decodeURIComponent(f[0])] = decodeURIComponent(f.slice(1).join("="));
	    }t = i(t.replace(o, "")), e = i(e || "");for (var l = Math.max(t.length, e.length), s = 0; s < l; s++) {
	      if (e[s] && ":" === e[s].charAt(0)) {
	        var h = e[s].replace(/(^:|[+*?]+$)/g, ""),
	            d = (e[s].match(/[+*?]+$/) || C)[0] || "",
	            g = ~d.indexOf("+"),
	            y = ~d.indexOf("*"),
	            m = t[s] || "";if (!m && !y && (d.indexOf("?") < 0 || g)) {
	          r = !1;break;
	        }if (a[h] = decodeURIComponent(m), g || y) {
	          a[h] = t.slice(s).map(decodeURIComponent).join("/");break;
	        }
	      } else if (e[s] !== t[s]) {
	        r = !1;break;
	      }
	    }return (!0 === n.default || !1 !== r) && a;
	  }function r(t, e) {
	    return t.rank < e.rank ? 1 : t.rank > e.rank ? -1 : t.index - e.index;
	  }function o(t, e) {
	    return t.index = e, t.rank = p(t), t.props;
	  }function i(t) {
	    return t.replace(/(^\/+|\/+$)/g, "").split("/");
	  }function u(t) {
	    return ":" == t.charAt(0) ? 1 + "*+?".indexOf(t.charAt(t.length - 1)) || 4 : 5;
	  }function a(t) {
	    return i(t).map(u).join("");
	  }function p(t) {
	    return t.props.default ? 0 : a(t.props.path);
	  }function c(t, e) {
	    void 0 === e && (e = "push"), b && b[e] ? b[e](t) : "undefined" != typeof history && history[e + "State"] && history[e + "State"](null, null, t);
	  }function f() {
	    var t;return t = b && b.location ? b.location : b && b.getCurrentLocation ? b.getCurrentLocation() : "undefined" != typeof location ? location : x, "" + (t.pathname || "") + (t.search || "");
	  }function l(t, e) {
	    return void 0 === e && (e = !1), "string" != typeof t && t.url && (e = t.replace, t = t.url), s(t) && c(t, e ? "replace" : "push"), h(t);
	  }function s(t) {
	    for (var e = U.length; e--;) {
	      if (U[e].canRoute(t)) return !0;
	    }return !1;
	  }function h(t) {
	    for (var e = !1, n = 0; n < U.length; n++) {
	      !0 === U[n].routeTo(t) && (e = !0);
	    }for (var r = k.length; r--;) {
	      k[r](t);
	    }return e;
	  }function d(t) {
	    if (t && t.getAttribute) {
	      var e = t.getAttribute("href"),
	          n = t.getAttribute("target");if (e && e.match(/^\//g) && (!n || n.match(/^_?self$/i))) return l(e);
	    }
	  }function g(t) {
	    if (!(t.ctrlKey || t.metaKey || t.altKey || t.shiftKey || 0 !== t.button)) return d(t.currentTarget || t.target || this), y(t);
	  }function y(t) {
	    return t && (t.stopImmediatePropagation && t.stopImmediatePropagation(), t.stopPropagation && t.stopPropagation(), t.preventDefault()), !1;
	  }function m(t) {
	    if (!(t.ctrlKey || t.metaKey || t.altKey || t.shiftKey || 0 !== t.button)) {
	      var e = t.target;do {
	        if ("A" === (e.nodeName + "").toUpperCase() && e.getAttribute("href")) {
	          if (e.hasAttribute("native")) return;if (d(e)) return y(t);
	        }
	      } while (e = e.parentNode);
	    }
	  }function v() {
	    A || ("function" == typeof addEventListener && (b || addEventListener("popstate", function () {
	      h(f());
	    }), addEventListener("click", m)), A = !0);
	  }var C = {},
	      b = null,
	      U = [],
	      k = [],
	      x = {},
	      A = !1,
	      R = function (i) {
	    function u(t) {
	      i.call(this, t), t.history && (b = t.history), this.state = { url: t.url || f() }, v();
	    }return i && (u.__proto__ = i), u.prototype = Object.create(i && i.prototype), u.prototype.constructor = u, u.prototype.shouldComponentUpdate = function (t) {
	      return !0 !== t.static || t.url !== this.props.url || t.onChange !== this.props.onChange;
	    }, u.prototype.canRoute = function (e) {
	      return this.getMatchingChildren(t.toChildArray(this.props.children), e, !1).length > 0;
	    }, u.prototype.routeTo = function (t) {
	      this.setState({ url: t });var e = this.canRoute(t);return this.updating || this.forceUpdate(), e;
	    }, u.prototype.componentWillMount = function () {
	      U.push(this), this.updating = !0;
	    }, u.prototype.componentDidMount = function () {
	      var t = this;b && (this.unlisten = b.listen(function (e) {
	        t.routeTo("" + (e.pathname || "") + (e.search || ""));
	      })), this.updating = !1;
	    }, u.prototype.componentWillUnmount = function () {
	      "function" == typeof this.unlisten && this.unlisten(), U.splice(U.indexOf(this), 1);
	    }, u.prototype.componentWillUpdate = function () {
	      this.updating = !0;
	    }, u.prototype.componentDidUpdate = function () {
	      this.updating = !1;
	    }, u.prototype.getMatchingChildren = function (i, u, a) {
	      return i.filter(o).sort(r).map(function (r) {
	        var o = n(u, r.props.path, r.props);if (o) {
	          if (!1 !== a) {
	            var i = { url: u, matches: o };return e(i, o), delete i.ref, delete i.key, t.cloneElement(r, i);
	          }return r;
	        }
	      }).filter(Boolean);
	    }, u.prototype.render = function (e, n) {
	      var r = e.children,
	          o = e.onChange,
	          i = n.url,
	          u = this.getMatchingChildren(t.toChildArray(r), i, !0),
	          a = u[0] || null,
	          p = this.previousUrl;return i !== p && (this.previousUrl = i, "function" == typeof o && o({ router: this, url: i, previous: p, active: u, current: a })), a;
	    }, u;
	  }(t.Component),
	      K = function K(n) {
	    return t.createElement("a", e({ onClick: g }, n));
	  },
	      E = function E(e) {
	    return t.createElement(e.component, e);
	  };return R.subscribers = k, R.getCurrentUrl = f, R.route = l, R.Router = R, R.Route = E, R.Link = K, R.exec = n, R;
	});
	//# sourceMappingURL=preact-router.js.map

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _paymentHelper = __webpack_require__(22);
	
	var _paymentHelper2 = _interopRequireDefault(_paymentHelper);
	
	var _utils = __webpack_require__(23);
	
	var _commands = __webpack_require__(3);
	
	var _webMessageHelper = __webpack_require__(5);
	
	var _constant = __webpack_require__(9);
	
	var _preactRouter = __webpack_require__(12);
	
	var _Application = __webpack_require__(92);
	
	var _Application2 = _interopRequireDefault(_Application);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AppStore = function () {
	  function AppStore() {
	    var _this = this;
	
	    _classCallCheck(this, AppStore);
	
	    this.init = function () {
	      // Make KaiStore can go back APP detail page after user login.
	      _this.preparedDownloadApp = null;
	      _this.apps = [];
	
	      _this.kaipayUpdated = false;
	      _this._purchasedApps = new Map();
	      _this.categories = [];
	      _this.updatableApps = {
	        system: new Map(),
	        remote: new Map()
	      };
	      _this.updateAllInProcess = {
	        system: false,
	        remote: false
	      };
	      _this.hasPaidApp = false;
	    };
	
	    this.init();
	  }
	
	  _createClass(AppStore, [{
	    key: 'resetStore',
	    value: function resetStore() {
	      this.init();
	    }
	  }, {
	    key: 'initRemoteApps',
	    value: function initRemoteApps(remoteApps) {
	      var _this2 = this;
	
	      if (!remoteApps) {
	        return;
	      }
	      remoteApps.forEach(function (app) {
	        if (!app.manifest_url) {
	          console.warn('Malformed app ' + app.name + ' without manifest_url. Skip.');
	          return;
	        }
	        var application = new _Application2.default(app.manifest_url);
	        if (application.setRemoteInfo(app)) {
	          _this2.apps.push(application);
	        }
	      });
	    }
	  }, {
	    key: 'syncInstalledApps',
	    value: function syncInstalledApps(installedApps) {
	      var _this3 = this;
	
	      if (Object.keys(installedApps).length === 0) {
	        return;
	      }
	
	      Object.keys(installedApps).forEach(function (manifestURL) {
	        var mozAPP = installedApps[manifestURL];
	        var existedApplication = _this3.findAppByManifest(manifestURL);
	        var application = existedApplication || new _Application2.default(manifestURL);
	
	        application.mozAPP = mozAPP;
	        _this3.syncUpdatableApp(application);
	        application.checkUpdate();
	
	        if (!existedApplication) {
	          _this3.apps.push(application);
	        }
	
	        if (application.mozAPP.downloading) {
	          _this3.handleInstall(application.mozAPP);
	        }
	
	        if (application.isInternal) {
	          // XXX: possible problematic code since ondownloadsuccess cannot
	          // be catched in remote
	          // Payment App should be updated automatically
	          // !!! INTERNAL_APP[0] is the uuid of kaios-pay,
	          // !!! INTERNAL_APP[3] is the uuid of eventlogger.
	          switch (application.id) {
	            case _constant.INTERNAL_APP[0]:
	              if (application.mozAPP) {
	                // update KaiPay successfully and show the restart dialog.
	                application.mozAPP.ondownloadsuccess = function () {
	                  var paymentHelper = new _paymentHelper2.default();
	                  var isSupport = paymentHelper.isSupportPrice(mozAPP.manifest.version);
	                  if (isSupport && window.unitPrice === null) {
	                    _this3.kaipayUpdated = true;
	                  }
	                };
	              }
	              break;
	            default:
	              break;
	          }
	        }
	      });
	    }
	
	    // sync early updatable apps before waiting result from checkUpdate()
	    // to minizie the change that update tab flashing in
	
	  }, {
	    key: 'syncUpdatableApp',
	    value: function syncUpdatableApp(application) {
	      var mozAPP = application.mozAPP;
	      var hasUpdateManifest = mozAPP.updateManifest !== null;
	      if (!hasUpdateManifest || !(0, _utils.isVersionHigher)(mozAPP.manifest.version, mozAPP.updateManifest.version) || application.isInternal) {
	        return;
	      }
	      if (application.isNativeApp) {
	        this.updatableApps.system.set(mozAPP.manifestURL);
	      } else {
	        this.updatableApps.remote.set(mozAPP.manifestURL);
	      }
	      application.updateState({ updatable: true });
	    }
	  }, {
	    key: 'syncBookmarks',
	    value: function syncBookmarks() {
	      var _this4 = this;
	
	      return new Promise(function (resolve, reject) {
	        _webMessageHelper.MessageSender.send(new _commands.RequestBookmarksCommand(), function (success, detail) {
	          if (success) {
	            var bookmarksMap = new Map();
	            Object.keys(detail).forEach(function (key) {
	              bookmarksMap.set(key, detail[key]);
	            });
	            _this4.bookmarks.forEach(function (bookmark) {
	              var url = bookmark.info.url;
	              bookmark.state.pinned = bookmarksMap.has(url);
	            });
	
	            resolve({ bookmarkDBSupported: true });
	          } else {
	            resolve({ bookmarkDBSupported: false });
	          }
	        });
	      });
	    }
	
	    /**
	     * Fire appstore:change after sync purchased Apps completely, and
	     * update App bricks.
	     **/
	
	  }, {
	    key: 'syncPurchasedApps',
	    value: function syncPurchasedApps() {
	      var _this5 = this;
	
	      var paymentHelper = new _paymentHelper2.default();
	
	      paymentHelper.getAllPurchased().then(function (products) {
	        // Get apps from products only.
	        products = products.filter(function (product) {
	          return product.type === 1;
	        });
	        products.forEach(function (product) {
	          // related_good_id here is app ID.
	          _this5._purchasedApps.set(product.related_good_id, {
	            txId: product.transaction_id,
	            createDate: product.created_date
	          });
	        });
	        // start to sync remoteApps information
	        _this5.allRemoteApps.forEach(function (app) {
	          if (_this5._purchasedApps.has(app.id)) {
	            app.purchased = true;
	          }
	        });
	        _this5.publish('appstore:change');
	      }, function (error) {
	        console.error('Cannot get purchased Apps from server.', error);
	      });
	    }
	  }, {
	    key: 'updateAll',
	    value: function updateAll(type) {
	      var _this6 = this;
	
	      var enable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var apps = this.updatableApps[type];
	      if (apps && apps.size > 0) {
	        this.updateAllInProcess[type] = enable;
	        apps.forEach(function (value, manifest) {
	          var app = _this6.findAppByManifest(manifest);
	          app.updateState({ updatePending: enable });
	        });
	      }
	      if (type === 'system') {
	        var nextManifest = this.popNextUpdatePendingSystemApp;
	        if (nextManifest) {
	          (0, _preactRouter.route)(_constant.PATH.PAGE.URL({ manifest: nextManifest, batchUpdating: true }));
	        }
	      } else if (type == 'remote' && this.updatableApps.remote.size > 0) {
	        var _nextManifest = this.updatableApps.remote.keys().next().value;
	        var app = this.findAppByManifest(_nextManifest);
	        if (app) {
	          app.update();
	        }
	      }
	    }
	  }, {
	    key: 'handleUpdate',
	    value: function handleUpdate(manifest, mozAppEvent) {
	      switch (mozAppEvent) {
	        case _constants.mozAppEvent.ON_DOWNLOAD_APPLIED:
	        case _constants.mozAppEvent.ON_DOWNLOAD_SUCCESS:
	        case _constants.mozAppEvent.ON_DOWNLOAD_ERROR:
	          if (this.updateAllInProcess.remote) {
	            this.updatableApps.remote.delete(manifest);
	            var nextManifest = this.updatableApps.remote.keys().next().value;
	            var app = this.findAppByManifest(nextManifest);
	            if (app) {
	              app.update();
	            } else {
	              this.updateAllInProcess.remote = false;
	              this.publish('appstore:change');
	            }
	          }
	          break;
	      }
	    }
	  }, {
	    key: 'findAppByName',
	    value: function findAppByName(name) {
	      return this._findApps('name', name);
	    }
	  }, {
	    key: 'findAppById',
	    value: function findAppById(id) {
	      return this._findApps('id', id);
	    }
	  }, {
	    key: 'findItemById',
	    value: function findItemById(id) {
	      return this._findRemoteItem('id', id);
	    }
	  }, {
	    key: 'findAppByManifest',
	    value: function findAppByManifest(manifestURL) {
	      return this._findApps('manifestURL', manifestURL);
	    }
	  }, {
	    key: 'findBookmarkByUrl',
	    value: function findBookmarkByUrl(url) {
	      return this._findBookmarkInfo('url', url);
	    }
	  }, {
	    key: '_findApps',
	    value: function _findApps(key, value) {
	      return this.apps.find(function (app) {
	        return app[key] === value;
	      });
	    }
	  }, {
	    key: '_findBookmarkInfo',
	    value: function _findBookmarkInfo(key, value) {
	      var bookmarks = this.apps.filter(function (app) {
	        return app.isBookmark;
	      });
	      return bookmarks.find(function (bookmark) {
	        return bookmark.info[key] === value;
	      });
	    }
	  }, {
	    key: '_findRemoteItem',
	    value: function _findRemoteItem(key, value) {
	      return this.allRemoteItems.find(function (item) {
	        return item[key] === value;
	      });
	    }
	  }, {
	    key: 'publish',
	    value: function publish(eventname) {
	      var evt = new CustomEvent(eventname);
	      window.dispatchEvent(evt);
	    }
	  }, {
	    key: 'rebootIfNeeded',
	    value: function rebootIfNeeded() {
	      _webMessageHelper.MessageSender.send(new _commands.CheckRebootCommand());
	    }
	  }, {
	    key: 'allRemoteItems',
	    get: function get() {
	      return this.apps.filter(function (app) {
	        return app.isInRemoteList && !app.isInternal;
	      });
	    }
	  }, {
	    key: 'allRemoteApps',
	    get: function get() {
	      return this.apps.filter(function (app) {
	        return app.isInRemoteList && !app.isBookmark && !app.isInternal;
	      });
	    }
	  }, {
	    key: 'bookmarks',
	    get: function get() {
	      return this.apps.filter(function (app) {
	        return app.isBookmark;
	      });
	    }
	  }, {
	    key: 'apps',
	    get: function get() {
	      return this._apps;
	    },
	    set: function set(apps) {
	      this._apps = apps;
	    }
	  }, {
	    key: 'installedApps',
	    get: function get() {
	      return this.apps.filter(function (app) {
	        return app.isInstalled;
	      });
	    }
	  }, {
	    key: 'hasUpdatableApps',
	    get: function get() {
	      return this.updatableApps.system.size + this.updatableApps.remote.size > 0;
	    }
	  }, {
	    key: 'updateAllRebootNeeded',
	    get: function get() {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.updatableApps.system.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _step$value = _slicedToArray(_step.value, 1),
	              manifestURL = _step$value[0];
	
	          var application = this.findAppByManifest(manifestURL);
	          if (application.isRebootNeeded) {
	            return true;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: 'popNextUpdatePendingSystemApp',
	    get: function get() {
	      var manifest = this.updatableApps.system.keys().next().value;
	      if (!manifest) {
	        return false;
	      }
	      this.updatableApps.system.delete(manifest);
	      return manifest;
	    }
	  }, {
	    key: 'updatePendingRemoteApps',
	    get: function get() {
	      return this.apps.filter(function (app) {
	        return app.state.updatePending === true;
	      });
	    }
	  }]);
	
	  return AppStore;
	}();
	
	exports.default = AppStore = new AppStore();

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DeviceInfo = __webpack_require__(48);
	
	Object.defineProperty(exports, 'DeviceInfo', {
	  enumerable: true,
	  get: function get() {
	    return _DeviceInfo.DeviceInfo;
	  }
	});
	
	var _App = __webpack_require__(20);
	
	Object.defineProperty(exports, 'BookmarkApp', {
	  enumerable: true,
	  get: function get() {
	    return _App.BookmarkApp;
	  }
	});
	Object.defineProperty(exports, 'NormalApp', {
	  enumerable: true,
	  get: function get() {
	    return _App.NormalApp;
	  }
	});
	Object.defineProperty(exports, 'Bookmark', {
	  enumerable: true,
	  get: function get() {
	    return _App.Bookmark;
	  }
	});
	Object.defineProperty(exports, 'MozApp', {
	  enumerable: true,
	  get: function get() {
	    return _App.MozApp;
	  }
	});
	
	var _UI = __webpack_require__(28);
	
	Object.defineProperty(exports, 'Notification', {
	  enumerable: true,
	  get: function get() {
	    return _UI.Notification;
	  }
	});
	Object.defineProperty(exports, 'Toast', {
	  enumerable: true,
	  get: function get() {
	    return _UI.Toast;
	  }
	});
	
	var _Auth = __webpack_require__(47);
	
	Object.defineProperty(exports, 'Token', {
	  enumerable: true,
	  get: function get() {
	    return _Auth.Token;
	  }
	});
	
	var _Payment = __webpack_require__(25);
	
	Object.defineProperty(exports, 'PaymentDetail', {
	  enumerable: true,
	  get: function get() {
	    return _Payment.PaymentDetail;
	  }
	});
	Object.defineProperty(exports, 'PaymentProfile', {
	  enumerable: true,
	  get: function get() {
	    return _Payment.PaymentProfile;
	  }
	});
	
	var _Task = __webpack_require__(27);
	
	Object.defineProperty(exports, 'Task', {
	  enumerable: true,
	  get: function get() {
	    return _Task.Task;
	  }
	});
	
	var _Setting = __webpack_require__(26);
	
	Object.defineProperty(exports, 'Setting', {
	  enumerable: true,
	  get: function get() {
	    return _Setting.Setting;
	  }
	});

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(2);
	
	var _webMessageHelper = __webpack_require__(5);
	
	var _commands = __webpack_require__(3);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Account = function () {
	  function Account() {
	    _classCallCheck(this, Account);
	
	    this.version = null;
	    this.token = null;
	    this.onLoginLocked = false;
	  }
	
	  _createClass(Account, [{
	    key: 'init',
	    value: function init() {
	      this.getVersion();
	    }
	  }, {
	    key: 'handleEvent',
	    value: function handleEvent(type, detail) {
	      if (type === _constants.accountEvent.ON_ACCOUNT_API_MISSING) {
	        this.emit('account:missing');
	      } else if (type === _constants.accountEvent.ON_LOGIN) {
	        if (this.onLoginLocked) {
	          return;
	        }
	        var kid = detail.kid,
	            macKey = detail.macKey;
	
	        this.token = {
	          kid: kid,
	          macKey: macKey
	        };
	        this.emit('account:login', { detail: this.token });
	      } else if (type === _constants.accountEvent.ON_LOGOUT) {
	        this.token = null;
	        this.emit('account:logout');
	      } else if (type === _constants.accountEvent.ON_READY) {
	        this.emit('account:ready');
	      } else if (type === _constants.accountEvent.ON_ERROR) {
	        this.emit('account:error', { detail: detail });
	      }
	    }
	  }, {
	    key: 'emit',
	    value: function emit(name, detail) {
	      var accountEvent = new CustomEvent(name, detail);
	      window.dispatchEvent(accountEvent);
	    }
	
	    /**
	     * [section]
	     * - accounts: Open settings APP and switch to account tab.
	     * - fxa: Open KaiOS account entry page via settings APP.
	     **/
	
	  }, {
	    key: 'openAccount',
	    value: function openAccount() {
	      var _this = this;
	
	      var section = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'accounts';
	
	      return new Promise(function (resolve, reject) {
	        var command = new _commands.OpenAccountCommand({
	          detail: {
	            section: section
	          }
	        });
	        _webMessageHelper.MessageSender.send(command, function (success, result) {
	          if (success === true && _this.token) {
	            resolve(result);
	          } else {
	            reject(result);
	          }
	        });
	      });
	    }
	
	    /**
	     * Check KaiOS account version, the new KaiOS account will
	     * be appied in v3.0.0. More details please refer to
	     * https://bugzilla.kaiostech.com/show_bug.cgi?id=71284
	     **/
	
	  }, {
	    key: 'getVersion',
	    value: function getVersion() {
	      var _this2 = this;
	
	      _webMessageHelper.MessageSender.send(new _commands.GetAccountVersionCommand(), function (success, result) {
	        if (success === true) {
	          var version = result.version;
	
	          _this2.version = version;
	        } else {
	          _this2.version = null;
	        }
	      });
	    }
	  }, {
	    key: 'requestToken',
	    value: function requestToken() {
	      var _this3 = this;
	
	      return new Promise(function (resolve, reject) {
	        _webMessageHelper.MessageSender.send(new _commands.RequestTokenCommand(), function (success, detail) {
	          if (success) {
	            var kid = detail.kid,
	                macKey = detail.macKey,
	                type = detail.type;
	
	            var token = { kid: kid, macKey: macKey };
	            if (type === _constants.tokenType.ACCOUNT) {
	              _this3.token = token;
	            }
	            resolve({ token: token, type: type });
	          } else {
	            reject();
	          }
	        });
	      });
	    }
	  }]);
	
	  return Account;
	}();
	
	exports.default = Account = new Account();

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.deviceUtils = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _commands = __webpack_require__(3);
	
	var _webMessageHelper = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DeviceUtils = function () {
	  function DeviceUtils() {
	    _classCallCheck(this, DeviceUtils);
	
	    this.information = {};
	    this.startListeners();
	    this.featureset = {
	      bookmarkSupported: false,
	      settingsPanelSupported: false
	    };
	  }
	
	  _createClass(DeviceUtils, [{
	    key: 'startListeners',
	    value: function startListeners() {
	      var _this = this;
	
	      window.addEventListener('languagechange', function () {
	        _this.rebootRequest();
	      });
	    }
	  }, {
	    key: 'rebootRequest',
	    value: function rebootRequest() {
	      var rebootEvent = new CustomEvent('reboot-needed', {
	        detail: 'device-info-change'
	      });
	
	      window.dispatchEvent(rebootEvent);
	    }
	  }, {
	    key: 'connectionType',
	    value: function connectionType(simCard) {
	      if (navigator.mozWifiManager && navigator.mozWifiManager.connection.status === 'connected') {
	        return 'wifi';
	      } else {
	        var conns = window.navigator.mozMobileConnection || window.navigator.mozMobileConnections;
	        return conns[simCard].data.type;
	      }
	    }
	  }, {
	    key: 'getTimeZoneOffset',
	    value: function getTimeZoneOffset() {
	      var t = new Date();
	      var tzo = -t.getTimezoneOffset();
	      if (tzo !== 0) {
	        tzo = tzo / 60;
	      }
	      return tzo;
	    }
	  }, {
	    key: 'getTimeStamp',
	    value: function getTimeStamp() {
	      var t = new Date();
	      var tzo = -t.getTimezoneOffset();
	      var dif = tzo >= 0 ? '+' : '-';
	      return t.getFullYear() + '-' + (t.getMonth() + 1).toString().padStart(2, '0') + '-' + t.getDate().toString().padStart(2, '0') + 'T' + t.getHours().toString().padStart(2, '0') + ':' + t.getMinutes().toString().padStart(2, '0') + ':' + t.getSeconds().toString().padStart(2, '0') + dif + Math.abs(tzo / 60).toString().padStart(2, '0') + ':' + Math.abs(tzo % 60).toString().padStart(2, '0');
	    }
	  }, {
	    key: 'requestInfo',
	    value: function requestInfo() {
	      var _this2 = this;
	
	      return new Promise(function (resolve, reject) {
	        _webMessageHelper.MessageSender.send(new _commands.RequestDeviceInfoCommand(), function (success, detail) {
	          if (success) {
	            // make it as Map
	            detail.settings = new Map(Object.entries(detail.settings));
	            window.deviceInfos = detail.settings;
	            window.deviceInfos.set('ril.data.defaultServiceId', detail.connection.defaultServiceId);
	            _this2.information = detail;
	            resolve();
	          } else {
	            reject();
	          }
	        });
	      });
	    }
	  }]);
	
	  return DeviceUtils;
	}();
	
	var deviceUtils = exports.deviceUtils = new DeviceUtils();

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _hawkRequester = __webpack_require__(40);
	
	var _hawkRequester2 = _interopRequireDefault(_hawkRequester);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var KaiStoreHawkHelper = function () {
	  function KaiStoreHawkHelper() {
	    _classCallCheck(this, KaiStoreHawkHelper);
	
	    this._kid = null;
	    this._macKey = null;
	    this._customConnectionType = null;
	  }
	
	  _createClass(KaiStoreHawkHelper, [{
	    key: '_getDefaultConnectionType',
	    value: function _getDefaultConnectionType(deviceInfos) {
	      this._hasValidDeviceInfos({
	        deviceInfos: deviceInfos,
	        validateKeys: ['ril.data.defaultServiceId']
	      });
	      var defaultServiceId = deviceInfos.get('ril.data.defaultServiceId');
	
	      if (navigator.mozWifiManager && navigator.mozWifiManager.connection.status === 'connected') {
	        return 'wifi';
	      } else {
	        var conns = window.navigator.mozMobileConnection || window.navigator.mozMobileConnections;
	        return conns[defaultServiceId].data.type;
	      }
	    }
	  }, {
	    key: '_getConnectionType',
	    value: function _getConnectionType(_ref) {
	      var _ref$useCustom = _ref.useCustom,
	          useCustom = _ref$useCustom === undefined ? false : _ref$useCustom,
	          deviceInfos = _ref.deviceInfos;
	
	      if (useCustom) {
	        return this._customConnectionType;
	      } else {
	        return this._getDefaultConnectionType(deviceInfos);
	      }
	    }
	  }, {
	    key: '_getTimeZoneOffset',
	    value: function _getTimeZoneOffset() {
	      var t = new Date();
	      var tzo = t.getTimezoneOffset();
	      return tzo === 0 ? tzo : -(tzo / 60);
	    }
	  }, {
	    key: '_getTimeStamp',
	    value: function _getTimeStamp() {
	      var t = new Date();
	      var tzo = -t.getTimezoneOffset();
	      var dif = tzo >= 0 ? '+' : '-';
	      return t.getFullYear() + '-' + (this._formatedTime(t.getMonth() + 1) + '-') + (this._formatedTime(t.getDate()) + 'T') + (this._formatedTime(t.getHours()) + ':') + (this._formatedTime(t.getMinutes()) + ':') + (this._formatedTime(t.getSeconds()) + ':') + ('' + dif) + (this._formatedTime(Math.abs(tzo / 60)) + ':') + ('' + this._formatedTime(Math.abs(tzo % 60)));
	    }
	  }, {
	    key: '_formatedTime',
	    value: function _formatedTime(time) {
	      return time.toString().padStart(2, '0');
	    }
	  }, {
	    key: '_hasValidDeviceInfos',
	    value: function _hasValidDeviceInfos(_ref2) {
	      var deviceInfos = _ref2.deviceInfos,
	          validateKeys = _ref2.validateKeys;
	
	      if (!(deviceInfos instanceof Map) || !deviceInfos.size) {
	        // DeviceInfos not type of Map or deviceInfos Map is empty.
	        console.error('ArgumentError: Expected deviceInfos Map to not be empty');
	        return false;
	      }
	
	      if (typeof validateKeys === 'undefined' || validateKeys.length === 0) {
	        // No need to validate DeviceInfos keys.
	        return true;
	      }
	
	      // Start to validate DeviceInfos keys.
	      var missingKeys = [];
	
	      validateKeys.forEach(function (key) {
	        if (!deviceInfos.has(key)) {
	          missingKeys.push(key);
	        }
	      });
	
	      if (missingKeys.length > 0) {
	        console.error('ArgumentError: Expected Map to have keys [' + missingKeys.toString() + ']');
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'getRequester',
	    value: function getRequester(_ref3) {
	      var serverTimeOffset = _ref3.serverTimeOffset,
	          _ref3$setDeviceInfo = _ref3.setDeviceInfo,
	          setDeviceInfo = _ref3$setDeviceInfo === undefined ? true : _ref3$setDeviceInfo,
	          deviceInfos = _ref3.deviceInfos,
	          _ref3$useCustomConnec = _ref3.useCustomConnectionType,
	          useCustomConnectionType = _ref3$useCustomConnec === undefined ? false : _ref3$useCustomConnec;
	
	      if (!this.isTokenSet) {
	        return null;
	      }
	
	      if (setDeviceInfo) {
	        this._hasValidDeviceInfos({
	          deviceInfos: deviceInfos,
	          validateKeys: ['deviceinfo.platform_build_id', 'deviceinfo.build_number']
	        });
	      }
	
	      var requester = new _hawkRequester2.default();
	      requester.setHawkCredentials(this._kid, this._macKey);
	
	      if (serverTimeOffset) {
	        requester.serverTimeOffset = serverTimeOffset;
	      }
	
	      if (setDeviceInfo === true) {
	        var buildID = deviceInfos.get('deviceinfo.platform_build_id');
	        var buildNumber = deviceInfos.get('deviceinfo.build_number');
	
	        requester.setDeviceInfo({
	          ct: this._getConnectionType({
	            useCustom: useCustomConnectionType,
	            deviceInfos: deviceInfos
	          }),
	          utc: this._getTimeStamp(),
	          utcOff: this._getTimeZoneOffset(),
	          buildID: buildID,
	          buildNumber: buildNumber
	        });
	      }
	
	      return requester;
	    }
	  }, {
	    key: 'generateURL',
	    value: function generateURL(_ref4) {
	      var apiName = _ref4.apiName,
	          params = _ref4.params,
	          deviceInfos = _ref4.deviceInfos;
	
	      var apiURI = '';
	      if (this._hasValidDeviceInfos({
	        deviceInfos: deviceInfos,
	        validateKeys: ['apps.serviceCenterUrl']
	      })) {
	        apiURI = deviceInfos.get('apps.serviceCenterUrl') + '/';
	      }
	
	      var append = Object.entries(params).reduce(function (acc, _ref5) {
	        var _ref6 = _slicedToArray(_ref5, 2),
	            key = _ref6[0],
	            value = _ref6[1];
	
	        return acc.concat('&', key, '=', value);
	      }, '');
	
	      if (append.length > 0) {
	        append = '?' + append.slice(1);
	      }
	      return '' + apiURI + apiName + append;
	    }
	  }, {
	    key: 'setToken',
	    value: function setToken(kid, macKey) {
	      this._kid = kid;
	      this._macKey = macKey;
	    }
	  }, {
	    key: 'setCustomConnectionType',
	    value: function setCustomConnectionType(type) {
	      this._customConnectionType = type;
	    }
	  }, {
	    key: 'isTokenSet',
	    get: function get() {
	      return this.kid !== null && this._macKey !== null;
	    }
	  }]);
	
	  return KaiStoreHawkHelper;
	}();
	
	exports.default = KaiStoreHawkHelper = new KaiStoreHawkHelper();

/***/ },
/* 18 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function (module) {
		if (!module.webpackPolyfill) {
			module.deprecate = function () {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setThemeColor = exports.hideFakeSSR = exports.isOverflown = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _webMessageHelper = __webpack_require__(5);
	
	var _commands = __webpack_require__(3);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UserInterfaceHelper = function () {
	  function UserInterfaceHelper() {
	    _classCallCheck(this, UserInterfaceHelper);
	
	    this.handleVisibilityChange = function () {
	      if (document.visibilityState === 'hidden') {
	        window.close();
	        return;
	      }
	    };
	
	    this.lastAppsviewIndex = {
	      tabOrder: null,
	      appOrder: null
	    };
	    this.appsviewMounted = false;
	  }
	
	  _createClass(UserInterfaceHelper, [{
	    key: 'startListeners',
	    value: function startListeners() {
	      window.addEventListener('visibilitychange', this.handleVisibilityChange);
	    }
	  }]);
	
	  return UserInterfaceHelper;
	}();
	
	exports.default = UserInterfaceHelper = new UserInterfaceHelper();
	var isOverflown = exports.isOverflown = function isOverflown(element) {
	  if (!element) {
	    return false;
	  }
	  return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
	};
	
	var hideFakeSSR = exports.hideFakeSSR = function hideFakeSSR() {
	  var fakeSSR = document.getElementById('ssr');
	  fakeSSR.classList.add('hidden');
	};
	
	var setThemeColor = exports.setThemeColor = function setThemeColor(isViewingSetting) {
	  var detail = {
	    content: isViewingSetting ? 'rgb(50, 3, 116)' : 'rgb(255, 255, 255)'
	  };
	  _webMessageHelper.MessageSender.send(new _commands.ChangeThemeColorCommand({ detail: detail }));
	};

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MozApp = exports.Bookmark = exports.NormalApp = exports.BookmarkApp = undefined;
	
	var _objectmodel = __webpack_require__(8);
	
	var _App = new _objectmodel.ObjectModel({
	  category: Number,
	  default_locale: String,
	  description: String,
	  icons: Object,
	  id: String,
	  installed: Boolean,
	  locales: Object,
	  manifest_url: String,
	  name: String,
	  paid: Boolean,
	  version: String
	}).defaultTo({
	  default_locale: 'en-US'
	});
	
	var BookmarkApp = _App.extend({
	  type: ['bookmark'],
	  url: String
	}).defaultTo({
	  type: 'bookmark'
	});
	
	var NormalApp = _App.extend({
	  type: ['certified', 'hosted', 'privileged'],
	  downloading: Boolean,
	  installed: Boolean,
	  paid: Boolean,
	  progress: Number,
	  updatable: Boolean
	});
	
	var Bookmark = new _objectmodel.ObjectModel({
	  url: String,
	  icon: String,
	  name: String
	}).defaultTo({
	  type: 'bookmark'
	});
	
	var MozApp = new _objectmodel.ObjectModel({
	  allowedAutoDownload: Boolean,
	  downloadAvailable: Boolean,
	  downloadSize: Number,
	  downloading: Boolean,
	  enabled: Boolean,
	  installOrigin: String,
	  installState: String,
	  installTime: Number,
	  lastUpdateCheck: Number,
	  manifest: [Object],
	  manifestURL: String,
	  oldVersion: String,
	  origin: String,
	  progress: [Number],
	  readyToApplyDownload: Boolean,
	  receipts: [Array],
	  removable: Boolean,
	  role: [String],
	  updateManifest: [Object],
	  updateTime: [Number]
	});
	
	exports.BookmarkApp = BookmarkApp;
	exports.NormalApp = NormalApp;
	exports.Bookmark = Bookmark;
	exports.MozApp = MozApp;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	!function (e, t) {
	  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = t(__webpack_require__(4), __webpack_require__(6)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_FACTORY__ = (t), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.ReactDialog = t(require("preact"), require("soft-key-store")) : e.ReactDialog = t(e.preact, e["soft-key-store"]);
	}(window, function (e, t) {
	  return function (e) {
	    var t = {};function n(o) {
	      if (t[o]) return t[o].exports;var r = t[o] = { i: o, l: !1, exports: {} };return e[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
	    }return n.m = e, n.c = t, n.d = function (e, t, o) {
	      n.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: o });
	    }, n.r = function (e) {
	      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
	    }, n.t = function (e, t) {
	      if (1 & t && (e = n(e)), 8 & t) return e;if (4 & t && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && e && e.__esModule) return e;var o = Object.create(null);if (n.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e) for (var r in e) {
	        n.d(o, r, function (t) {
	          return e[t];
	        }.bind(null, r));
	      }return o;
	    }, n.n = function (e) {
	      var t = e && e.__esModule ? function () {
	        return e.default;
	      } : function () {
	        return e;
	      };return n.d(t, "a", t), t;
	    }, n.o = function (e, t) {
	      return Object.prototype.hasOwnProperty.call(e, t);
	    }, n.p = "", n(n.s = 8);
	  }([function (t, n) {
	    t.exports = e;
	  }, function (e, n) {
	    e.exports = t;
	  }, function (e, t, n) {
	    "use strict";
	    var o,
	        r = function r() {
	      return void 0 === o && (o = Boolean(window && document && document.all && !window.atob)), o;
	    },
	        i = function () {
	      var e = {};return function (t) {
	        if (void 0 === e[t]) {
	          var n = document.querySelector(t);if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
	            n = n.contentDocument.head;
	          } catch (e) {
	            n = null;
	          }e[t] = n;
	        }return e[t];
	      };
	    }(),
	        s = [];function a(e) {
	      for (var t = -1, n = 0; n < s.length; n++) {
	        if (s[n].identifier === e) {
	          t = n;break;
	        }
	      }return t;
	    }function c(e, t) {
	      for (var n = {}, o = [], r = 0; r < e.length; r++) {
	        var i = e[r],
	            c = t.base ? i[0] + t.base : i[0],
	            u = n[c] || 0,
	            l = "".concat(c, " ").concat(u);n[c] = u + 1;var p = a(l),
	            h = { css: i[1], media: i[2], sourceMap: i[3] };-1 !== p ? (s[p].references++, s[p].updater(h)) : s.push({ identifier: l, updater: m(h, t), references: 1 }), o.push(l);
	      }return o;
	    }function u(e) {
	      var t = document.createElement("style"),
	          o = e.attributes || {};if (void 0 === o.nonce) {
	        var r = n.nc;r && (o.nonce = r);
	      }if (Object.keys(o).forEach(function (e) {
	        t.setAttribute(e, o[e]);
	      }), "function" == typeof e.insert) e.insert(t);else {
	        var s = i(e.insert || "head");if (!s) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");s.appendChild(t);
	      }return t;
	    }var l,
	        p = (l = [], function (e, t) {
	      return l[e] = t, l.filter(Boolean).join("\n");
	    });function h(e, t, n, o) {
	      var r = n ? "" : o.media ? "@media ".concat(o.media, " {").concat(o.css, "}") : o.css;if (e.styleSheet) e.styleSheet.cssText = p(t, r);else {
	        var i = document.createTextNode(r),
	            s = e.childNodes;s[t] && e.removeChild(s[t]), s.length ? e.insertBefore(i, s[t]) : e.appendChild(i);
	      }
	    }function f(e, t, n) {
	      var o = n.css,
	          r = n.media,
	          i = n.sourceMap;if (r ? e.setAttribute("media", r) : e.removeAttribute("media"), i && btoa && (o += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i)))), " */")), e.styleSheet) e.styleSheet.cssText = o;else {
	        for (; e.firstChild;) {
	          e.removeChild(e.firstChild);
	        }e.appendChild(document.createTextNode(o));
	      }
	    }var d = null,
	        v = 0;function m(e, t) {
	      var n, o, r;if (t.singleton) {
	        var i = v++;n = d || (d = u(t)), o = h.bind(null, n, i, !1), r = h.bind(null, n, i, !0);
	      } else n = u(t), o = f.bind(null, n, t), r = function r() {
	        !function (e) {
	          if (null === e.parentNode) return !1;e.parentNode.removeChild(e);
	        }(n);
	      };return o(e), function (t) {
	        if (t) {
	          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;o(e = t);
	        } else r();
	      };
	    }e.exports = function (e, t) {
	      (t = t || {}).singleton || "boolean" == typeof t.singleton || (t.singleton = r());var n = c(e = e || [], t);return function (e) {
	        if (e = e || [], "[object Array]" === Object.prototype.toString.call(e)) {
	          for (var o = 0; o < n.length; o++) {
	            var r = a(n[o]);s[r].references--;
	          }for (var i = c(e, t), u = 0; u < n.length; u++) {
	            var l = a(n[u]);0 === s[l].references && (s[l].updater(), s.splice(l, 1));
	          }n = i;
	        }
	      };
	    };
	  }, function (e, t, n) {
	    "use strict";
	    e.exports = function (e) {
	      var t = [];return t.toString = function () {
	        return this.map(function (t) {
	          var n = function (e, t) {
	            var n = e[1] || "",
	                o = e[3];if (!o) return n;if (t && "function" == typeof btoa) {
	              var r = (s = o, a = btoa(unescape(encodeURIComponent(JSON.stringify(s)))), c = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(a), "/*# ".concat(c, " */")),
	                  i = o.sources.map(function (e) {
	                return "/*# sourceURL=".concat(o.sourceRoot || "").concat(e, " */");
	              });return [n].concat(i).concat([r]).join("\n");
	            }var s, a, c;return [n].join("\n");
	          }(t, e);return t[2] ? "@media ".concat(t[2], " {").concat(n, "}") : n;
	        }).join("");
	      }, t.i = function (e, n, o) {
	        "string" == typeof e && (e = [[null, e, ""]]);var r = {};if (o) for (var i = 0; i < this.length; i++) {
	          var s = this[i][0];null != s && (r[s] = !0);
	        }for (var a = 0; a < e.length; a++) {
	          var c = [].concat(e[a]);o && r[c[0]] || (n && (c[2] ? c[2] = "".concat(n, " and ").concat(c[2]) : c[2] = n), t.push(c));
	        }
	      }, t;
	    };
	  }, function (e, t, n) {
	    var o = n(2),
	        r = n(5);"string" == typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);var i = { insert: "head", singleton: !1 },
	        s = (o(r, i), r.locals ? r.locals : {});e.exports = s;
	  }, function (e, t, n) {
	    (t = n(3)(!1)).push([e.i, ".hidden{display:none !important}\n", ""]), e.exports = t;
	  }, function (e, t, n) {
	    var o = n(2),
	        r = n(7);"string" == typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);var i = { insert: "head", singleton: !1 },
	        s = (o(r, i), r.locals ? r.locals : {});e.exports = s;
	  }, function (e, t, n) {
	    (t = n(3)(!1)).push([e.i, ".dialog-container{z-index:9999;width:100%;height:100%;position:absolute;top:0;left:0;background-color:rgba(0,0,0,0.85)}.dialog-container .dialog{width:100%;position:absolute;bottom:0;left:0;max-height:calc(100% - 2rem - var(--statusbar-height));overflow-y:scroll;display:flex;flex-direction:column}.dialog-container .dialog>.header{padding:0.5rem 1rem;background-color:var(--color-gs20);color:var(--color-gs90)}.dialog-container .dialog>.content{height:auto;overflow-y:auto;word-wrap:break-word;white-space:pre-line;padding:1rem;background-color:var(--color-gs00);color:var(--color-gs90)}.dialog-container .dialog>.content input{display:block;width:100%;height:3.6rem;line-height:3.6rem;padding:0 1rem;box-sizing:border-box}.dialog-container .dialog>.content p{margin:0.4rem 0 0 0;color:var(--color-gs70)}.dialog-container .dialog>.content progress{width:100%;height:0.6rem;border:none;border-radius:0.5rem;background:var(--color-gs45)}.dialog-container .dialog>.content progress::-moz-progress-bar{background-color:var(--highlight-color, #f6529b);border-radius:0.5rem}\n", ""]), e.exports = t;
	  }, function (e, t, n) {
	    "use strict";
	    n.r(t);var o,
	        r,
	        i,
	        s = n(0),
	        a = [],
	        c = s.options.__r,
	        u = s.options.diffed,
	        l = s.options.__c,
	        p = s.options.unmount;function h(e) {
	      s.options.__h && s.options.__h(r);var t = r.__H || (r.__H = { t: [], u: [] });return e >= t.t.length && t.t.push({}), t.t[e];
	    }function f(e) {
	      return d(k, e);
	    }function d(e, t, n) {
	      var i = h(o++);return i.__c || (i.__c = r, i.i = [n ? n(t) : k(void 0, t), function (t) {
	        var n = e(i.i[0], t);i.i[0] !== n && (i.i[0] = n, i.__c.setState({}));
	      }]), i.i;
	    }function v(e, t) {
	      var n = h(o++);b(n.o, t) && (n.i = e, n.o = t, r.__h.push(n));
	    }function m(e, t) {
	      var n = h(o++);return b(n.o, t) ? (n.o = t, n.v = e, n.i = e()) : n.i;
	    }function y() {
	      a.some(function (e) {
	        if (e.__P) try {
	          e.__H.u.forEach(g), e.__H.u.forEach(_), e.__H.u = [];
	        } catch (t) {
	          return s.options.__e(t, e.m), !0;
	        }
	      }), a = [];
	    }function g(e) {
	      e.p && e.p();
	    }function _(e) {
	      var t = e.i();"function" == typeof t && (e.p = t);
	    }function b(e, t) {
	      return !e || t.some(function (t, n) {
	        return t !== e[n];
	      });
	    }function k(e, t) {
	      return "function" == typeof t ? t(e) : t;
	    }function E(e, t) {
	      for (var n in t) {
	        e[n] = t[n];
	      }return e;
	    }function w(e, t) {
	      for (var n in e) {
	        if ("__source" !== n && !(n in t)) return !0;
	      }for (var o in t) {
	        if ("__source" !== o && e[o] !== t[o]) return !0;
	      }return !1;
	    }s.options.__r = function (e) {
	      c && c(e), o = 0, (r = e.__c).__H && (r.__H.u.forEach(g), r.__H.u.forEach(_), r.__H.u = []);
	    }, s.options.diffed = function (e) {
	      u && u(e);var t = e.__c;if (t) {
	        var n = t.__H;n && n.u.length && (1 !== a.push(t) && i === s.options.requestAnimationFrame || ((i = s.options.requestAnimationFrame) || function (e) {
	          var t,
	              n = function n() {
	            clearTimeout(o), cancelAnimationFrame(t), setTimeout(e);
	          },
	              o = setTimeout(n, 100);"undefined" != typeof window && (t = requestAnimationFrame(n));
	        })(y));
	      }
	    }, s.options.__c = function (e, t) {
	      t.some(function (e) {
	        try {
	          e.__h.forEach(g), e.__h = e.__h.filter(function (e) {
	            return !e.i || _(e);
	          });
	        } catch (n) {
	          t.some(function (e) {
	            e.__h && (e.__h = []);
	          }), t = [], s.options.__e(n, e.m);
	        }
	      }), l && l(e, t);
	    }, s.options.unmount = function (e) {
	      p && p(e);var t = e.__c;if (t) {
	        var n = t.__H;if (n) try {
	          n.t.forEach(function (e) {
	            return e.p && e.p();
	          });
	        } catch (e) {
	          s.options.__e(e, t.m);
	        }
	      }
	    };var C = function (e) {
	      var t, n;function o(t) {
	        var n;return (n = e.call(this, t) || this).isPureReactComponent = !0, n;
	      }return n = e, (t = o).prototype = Object.create(n.prototype), t.prototype.constructor = t, t.__proto__ = n, o.prototype.shouldComponentUpdate = function (e, t) {
	        return w(this.props, e) || w(this.state, t);
	      }, o;
	    }(s.Component);var O = s.options.vnode;s.options.vnode = function (e) {
	      e.type && e.type.t && e.ref && (e.props.ref = e.ref, e.ref = null), O && O(e);
	    };var x = function x(e, t) {
	      return e ? Object(s.toChildArray)(e).reduce(function (e, n) {
	        return e.concat(t(n));
	      }, []) : null;
	    },
	        S = { map: x, forEach: x, count: function count(e) {
	        return e ? Object(s.toChildArray)(e).length : 0;
	      }, only: function only(e) {
	        if (1 !== (e = Object(s.toChildArray)(e)).length) throw new Error("Children.only() expects only one child.");return e[0];
	      }, toArray: s.toChildArray },
	        j = s.options.__e;function P(e) {
	      return e && ((e = E({}, e)).__c = null, e.__k = e.__k && e.__k.map(P)), e;
	    }function N(e) {
	      this.__u = 0, this.o = null, this.__b = null;
	    }function B(e) {
	      var t = e.__.__c;return t && t.u && t.u(e);
	    }function A() {
	      this.i = null, this.l = null;
	    }s.options.__e = function (e, t, n) {
	      if (e.then) for (var o, r = t; r = r.__;) {
	        if ((o = r.__c) && o.s) return o.s(e, t.__c);
	      }j(e, t, n);
	    }, (N.prototype = new s.Component()).s = function (e, t) {
	      var n = this;null == n.o && (n.o = []), n.o.push(t);var o = B(n.__v),
	          r = !1,
	          i = function i() {
	        r || (r = !0, o ? o(s) : s());
	      };t.__c = t.componentWillUnmount, t.componentWillUnmount = function () {
	        i(), t.__c && t.__c();
	      };var s = function s() {
	        var e;if (! --n.__u) for (n.__v.__k[0] = n.state.u, n.setState({ u: n.__b = null }); e = n.o.pop();) {
	          e.forceUpdate();
	        }
	      };n.__u++ || n.setState({ u: n.__b = n.__v.__k[0] }), e.then(i, i);
	    }, N.prototype.render = function (e, t) {
	      return this.__b && (this.__v.__k[0] = P(this.__b), this.__b = null), [Object(s.createElement)(s.Component, null, t.u ? null : e.children), t.u && e.fallback];
	    };var M = function M(e, t, n) {
	      if (++n[1] === n[0] && e.l.delete(t), e.props.revealOrder && ("t" !== e.props.revealOrder[0] || !e.l.size)) for (n = e.i; n;) {
	        for (; n.length > 3;) {
	          n.pop()();
	        }if (n[1] < n[0]) break;e.i = n = n[2];
	      }
	    };(A.prototype = new s.Component()).u = function (e) {
	      var t = this,
	          n = B(t.__v),
	          o = t.l.get(e);return o[0]++, function (r) {
	        var i = function i() {
	          t.props.revealOrder ? (o.push(r), M(t, e, o)) : r();
	        };n ? n(i) : i();
	      };
	    }, A.prototype.render = function (e) {
	      this.i = null, this.l = new Map();var t = Object(s.toChildArray)(e.children);e.revealOrder && "b" === e.revealOrder[0] && t.reverse();for (var n = t.length; n--;) {
	        this.l.set(t[n], this.i = [1, 0, this.i]);
	      }return e.children;
	    }, A.prototype.componentDidUpdate = A.prototype.componentDidMount = function () {
	      var e = this;e.l.forEach(function (t, n) {
	        M(e, n, t);
	      });
	    };var T = function () {
	      function e() {}var t = e.prototype;return t.getChildContext = function () {
	        return this.props.context;
	      }, t.render = function (e) {
	        return e.children;
	      }, e;
	    }();function D(e) {
	      var t = this,
	          n = e.container,
	          o = Object(s.createElement)(T, { context: t.context }, e.vnode);return t.h && t.h !== n && (t.v.parentNode && t.h.removeChild(t.v), Object(s._unmount)(t.p), t.m = !1), e.vnode ? t.m ? (n.__k = t.__k, Object(s.render)(o, n), t.__k = n.__k) : (t.v = document.createTextNode(""), Object(s.hydrate)("", n), n.appendChild(t.v), t.m = !0, t.h = n, Object(s.render)(o, n, t.v), t.__k = this.v.__k) : t.m && (t.v.parentNode && t.h.removeChild(t.v), Object(s._unmount)(t.p)), t.p = o, t.componentWillUnmount = function () {
	        t.v.parentNode && t.h.removeChild(t.v), Object(s._unmount)(t.p);
	      }, null;
	    }var q = /^(?:accent|alignment|arabic|baseline|cap|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;s.Component.prototype.isReactComponent = {};var R = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103;function I(e, t, n) {
	      if (null == t.__k) for (; t.firstChild;) {
	        t.removeChild(t.firstChild);
	      }return function (e, t, n) {
	        return Object(s.render)(e, t), "function" == typeof n && n(), e ? e.__c : null;
	      }(e, t, n);
	    }var H = s.options.event;function U(e, t) {
	      e["UNSAFE_" + t] && !e[t] && Object.defineProperty(e, t, { configurable: !1, get: function get() {
	          return this["UNSAFE_" + t];
	        }, set: function set(e) {
	          this["UNSAFE_" + t] = e;
	        } });
	    }s.options.event = function (e) {
	      return H && (e = H(e)), e.persist = function () {}, e.nativeEvent = e;
	    };var L = { configurable: !0, get: function get() {
	        return this.class;
	      } },
	        V = s.options.vnode;s.options.vnode = function (e) {
	      e.$$typeof = R;var t = e.type,
	          n = e.props;if (n.class != n.className && (L.enumerable = "className" in n, n.className && (n.class = n.className), Object.defineProperty(n, "className", L)), "function" != typeof t) {
	        var o, r, i;for (i in n.defaultValue && (n.value || 0 === n.value || (n.value = n.defaultValue), delete n.defaultValue), Array.isArray(n.value) && n.multiple && "select" === t && (Object(s.toChildArray)(n.children).forEach(function (e) {
	          -1 != n.value.indexOf(e.props.value) && (e.props.selected = !0);
	        }), delete n.value), n) {
	          if (o = q.test(i)) break;
	        }if (o) for (i in r = e.props = {}, n) {
	          r[q.test(i) ? i.replace(/([A-Z0-9])/, "-$1").toLowerCase() : i] = n[i];
	        }
	      }!function (t) {
	        var n = e.type,
	            o = e.props;if (o && "string" == typeof n) {
	          var r = {};for (var i in o) {
	            /^on(Ani|Tra|Tou)/.test(i) && (o[i.toLowerCase()] = o[i], delete o[i]), r[i.toLowerCase()] = i;
	          }if (r.ondoubleclick && (o.ondblclick = o[r.ondoubleclick], delete o[r.ondoubleclick]), r.onbeforeinput && (o.onbeforeinput = o[r.onbeforeinput], delete o[r.onbeforeinput]), r.onchange && ("textarea" === n || "input" === n.toLowerCase() && !/^fil|che|ra/i.test(o.type))) {
	            var s = r.oninput || "oninput";o[s] || (o[s] = o[r.onchange], delete o[r.onchange]);
	          }
	        }
	      }(), "function" == typeof t && !t.g && t.prototype && (U(t.prototype, "componentWillMount"), U(t.prototype, "componentWillReceiveProps"), U(t.prototype, "componentWillUpdate"), t.g = !0), V && V(e);
	    };function F(e) {
	      return !!e && e.$$typeof === R;
	    }var W = { useState: f, useReducer: d, useEffect: function useEffect(e, t) {
	        var n = h(o++);b(n.o, t) && (n.i = e, n.o = t, r.__H.u.push(n));
	      }, useLayoutEffect: v, useRef: function useRef(e) {
	        return m(function () {
	          return { current: e };
	        }, []);
	      }, useImperativeHandle: function useImperativeHandle(e, t, n) {
	        v(function () {
	          "function" == typeof e ? e(t()) : e && (e.current = t());
	        }, null == n ? n : n.concat(e));
	      }, useMemo: m, useCallback: function useCallback(e, t) {
	        return m(function () {
	          return e;
	        }, t);
	      }, useContext: function useContext(e) {
	        var t = r.context[e.__c];if (!t) return e.__;var n = h(o++);return null == n.i && (n.i = !0, t.sub(r)), t.props.value;
	      }, useDebugValue: function useDebugValue(e, t) {
	        s.options.useDebugValue && s.options.useDebugValue(t ? t(e) : e);
	      }, version: "16.8.0", Children: S, render: I, hydrate: I, unmountComponentAtNode: function unmountComponentAtNode(e) {
	        return !!e.__k && (Object(s.render)(null, e), !0);
	      }, createPortal: function createPortal(e, t) {
	        return Object(s.createElement)(D, { vnode: e, container: t });
	      }, createElement: s.createElement, createContext: s.createContext, createFactory: function createFactory(e) {
	        return s.createElement.bind(null, e);
	      }, cloneElement: function cloneElement(e) {
	        return F(e) ? s.cloneElement.apply(null, arguments) : e;
	      }, createRef: s.createRef, Fragment: s.Fragment, isValidElement: F, findDOMNode: function findDOMNode(e) {
	        return e && (e.base || 1 === e.nodeType && e) || null;
	      }, Component: s.Component, PureComponent: C, memo: function memo(e, t) {
	        function n(e) {
	          var n = this.props.ref,
	              o = n == e.ref;return !o && n && (n.call ? n(null) : n.current = null), t ? !t(this.props, e) || !o : w(this.props, e);
	        }function o(t) {
	          return this.shouldComponentUpdate = n, Object(s.createElement)(e, E({}, t));
	        }return o.prototype.isReactComponent = !0, o.displayName = "Memo(" + (e.displayName || e.name) + ")", o.t = !0, o;
	      }, forwardRef: function forwardRef(e) {
	        function t(t) {
	          var n = E({}, t);return delete n.ref, e(n, t.ref);
	        }return t.prototype.isReactComponent = !0, t.t = !0, t.displayName = "ForwardRef(" + (e.displayName || e.name) + ")", t;
	      }, unstable_batchedUpdates: function unstable_batchedUpdates(e, t) {
	        return e(t);
	      }, Suspense: N, SuspenseList: A, lazy: function lazy(e) {
	        var t, n, o;function r(r) {
	          if (t || (t = e()).then(function (e) {
	            n = e.default || e;
	          }, function (e) {
	            o = e;
	          }), o) throw o;if (!n) throw t;return Object(s.createElement)(n, r);
	        }return r.displayName = "Lazy", r.t = !0, r;
	      } },
	        z = { _providers: new Map(), _services: new Map(), _requestsByService: new Map(), _requestsByProvider: new Map(), request: function request(e) {
	        var t = e.split(":"),
	            n = Array.prototype.slice.call(arguments, 1),
	            o = this;if (this.debug(t), t.length > 1) {
	          var r = t[0],
	              i = t[1];return this._providers.get(r) ? (this.debug("service: " + i + " is online, perform the request with " + n.concat()), Promise.resolve(this._providers.get(r)[i].apply(o._providers.get(r), n))) : new Promise(function (t, s) {
	            o.debug("service: " + e + " is offline, queue the task."), o._requestsByProvider.has(r) || o._requestsByProvider.set(r, []), o._requestsByProvider.get(r).push({ service: i, resolve: t, args: n });
	          });
	        }if (this._services.has(e)) {
	          var s = this._services.get(e);return this.debug("service [" + e + "] provider [" + s.name + "] is online, perform the task."), Promise.resolve(s[e].apply(s, n));
	        }this.debug("service: " + e + " is offline, queue the task.");var a = new Promise(function (t, r) {
	          o.debug("storing the requests..."), o._requestsByService.has(e) || o._requestsByService.set(e, []), o._requestsByService.get(e).push({ service: e, resolve: t, args: n });
	        });return a;
	      }, register: function register(e, t) {
	        var n = this;this._providers.has(t.name) || this._providers.set(t.name, t), this.debug((t.name || "(Anonymous)") + " is registering service: [" + e + "]"), this.debug("checking awaiting requests by server.."), this._requestsByProvider.has(t.name) && (this._requestsByProvider.get(t.name).forEach(function (e) {
	          n.debug("resolving..", t, t.name, e.service, e.args);var o = "function" == typeof t[e.service] ? t[e.service].apply(t, e.args) : t[e.service];e.resolve(o);
	        }), this._requestsByProvider.delete(t.name)), this._services.has(e) ? this.debug("the service [" + e + "] has already been registered by other server:", this._services.get(e).name) : (this._services.set(e, t), this.debug("checking awaiting requests by service.."), this._requestsByService.has(e) && (this._requestsByService.get(e).forEach(function (e) {
	          n.debug("resolving..", t, e.service);var o = t[e.service].apply(t, e.args);e.resolve(o);
	        }), this._requestsByService.delete(e)));
	      }, unregister: function unregister(e, t) {
	        this._providers.delete(t.name);var n = this._services.get(e);n && t === n && this._services.delete(e);
	      }, _states: new Map(), _statesByState: new Map(), registerState: function registerState(e, t) {
	        this._states.set(t.name, t), t.name || console.warn(t), this._statesByState.set(e, t);
	      }, unregisterState: function unregisterState(e, t) {
	        this._states.delete(t.name), this._statesByState.get(e) === t && this._statesByState.delete(e);
	      }, query: function query(e) {
	        this.debug(e);var t,
	            n,
	            o = e.split(".");if (o.length > 1 ? (n = this._states.get(o[0]), t = o[1]) : (t = o[0], n = this._statesByState.get(t)), n) {
	          if ("function" == typeof n[t]) {
	            var r = Array.prototype.slice.call(arguments, 1);return n[t].apply(n, r);
	          }return n[t];
	        }this.debug("Provider not ready, return undefined state.");
	      }, _start: new Date().getTime() / 1e3, currentTime: function currentTime() {
	        return (new Date().getTime() / 1e3 - this._start).toFixed(3);
	      }, debug: function debug() {
	        var e = !1;e && console.log("[Service][" + z.currentTime() + "]" + Array.slice(arguments).concat());
	      } },
	        K = z;n(4);function $(e) {
	      return ($ = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
	        return typeof e === "undefined" ? "undefined" : _typeof(e);
	      } : function (e) {
	        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeof(e);
	      })(e);
	    }function J(e, t) {
	      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
	    }function Z(e, t) {
	      for (var n = 0; n < t.length; n++) {
	        var o = t[n];o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
	      }
	    }function G(e, t) {
	      return !t || "object" !== $(t) && "function" != typeof t ? function (e) {
	        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e;
	      }(e) : t;
	    }function X(e) {
	      return (X = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
	        return e.__proto__ || Object.getPrototypeOf(e);
	      })(e);
	    }function Q(e, t) {
	      return (Q = Object.setPrototypeOf || function (e, t) {
	        return e.__proto__ = t, e;
	      })(e, t);
	    }function Y(e) {
	      if (!e || "string" != typeof e) throw new Error("Event name should be a valid non-empty string!");
	    }function ee(e) {
	      if ("function" != typeof e) throw new Error("Handler should be a function!");
	    }var te = function (e) {
	      function t() {
	        return J(this, t), G(this, X(t).apply(this, arguments));
	      }var n, o, r;return function (e, t) {
	        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Q(e, t);
	      }(t, e), n = t, (o = [{ key: "setHierarchy", value: function value(e) {
	          this.getElement() && e && this.getElement().focus();
	        } }, { key: "handleEvent", value: function value(e) {
	          if ("function" == typeof this._pre_handleEvent) {
	            if (!1 === this._pre_handleEvent(e)) return;
	          } else this.debug("no handle event pre found. skip");"function" == typeof this["_handle_" + e.type] && (this.debug("handling " + e.type), this["_handle_" + e.type](e)), "function" == typeof this._post_handleEvent && this._post_handleEvent(e);
	        } }, { key: "open", value: function value(e) {} }, { key: "close", value: function value(e) {} }, { key: "show", value: function value() {
	          this.getElement() && (this.getElement().classList.remove("hidden"), this.focus(), this.emit("opened"));
	        } }, { key: "hide", value: function value() {
	          this.getElement() && (this.getElement().classList.add("hidden"), this.emit("closed"));
	        } }, { key: "focus", value: function value() {
	          this.getElement() && this.getElement().focus();
	        } }, { key: "respondToHierarchyEvent", value: function value(e) {
	          return !this.isActive();
	        } }, { key: "_changeState", value: function value(e, t) {
	          this.getElement() && this.getElement().setAttribute(e + "-state", t.toString());
	        } }, { key: "isHidden", value: function value() {
	          return !this.getElement() || this.getElement().classList.contains("hidden");
	        } }, { key: "isActive", value: function value() {
	          return !!this.getElement() && !this.getElement().classList.contains("hidden");
	        } }, { key: "publish", value: function value(e, t, n) {
	          if (this.getElement()) {
	            this.broadcast(e, t);var o = new CustomEvent(n ? e : this.EVENT_PREFIX + e, { bubbles: !0, detail: t || this });this.debug("publishing external event: " + e + (t ? JSON.stringify(t) : "")), this.getElement().dispatchEvent(o);
	          }
	        } }, { key: "getElement", value: function value() {
	          return this.element || W.findDOMNode(this);
	        } }, { key: "broadcast", value: function value(e, t) {
	          if (this.getElement()) {
	            var n = new CustomEvent("_" + e, { bubbles: !1, detail: t || this });this.getElement().dispatchEvent(n);
	          }
	        } }, { key: "debug", value: function value() {
	          this.DEBUG && (console.log("[" + this.name + "][" + K.currentTime() + "] " + Array.prototype.slice.call(arguments).concat()), this.TRACE && console.trace());
	        } }, { key: "on", value: function value(e, t) {
	          Y(e), ee(t), this.listeners || (this.listeners = new Map());var n = this.listeners.get(e);n || (n = new Set(), this.listeners.set(e, n)), n.add(t);
	        } }, { key: "off", value: function value(e, t) {
	          Y(e), ee(t);var n = this.listeners.get(e);n && (n.delete(t), n.size || this.listeners.delete(e));
	        } }, { key: "offAll", value: function value(e) {
	          if (void 0 !== e) {
	            Y(e);var t = this.listeners.get(e);t && (t.clear(), this.listeners.delete(e));
	          } else this.listeners.clear();
	        } }, { key: "observe", value: function value(e, t) {
	          this._settings || (this._settings = {}), this._settings[e] = t, "function" == typeof this["_observe_" + e] && this["_observe_" + e](t);
	        } }, { key: "emit", value: function value(e) {
	          for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++) {
	            n[o - 1] = arguments[o];
	          }Y(e), this.listeners || (this.listeners = new Map());var r = this.listeners.get(e);r && r.forEach(function (e) {
	            try {
	              e.apply(null, n);
	            } catch (e) {
	              console.error(e);
	            }
	          });
	        } }]) && Z(n.prototype, o), r && Z(n, r), t;
	    }(W.Component),
	        ne = n(1),
	        oe = n.n(ne);n(6);function re(e) {
	      return (re = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
	        return typeof e === "undefined" ? "undefined" : _typeof(e);
	      } : function (e) {
	        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeof(e);
	      })(e);
	    }function ie(e, t) {
	      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
	    }function se(e, t) {
	      for (var n = 0; n < t.length; n++) {
	        var o = t[n];o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
	      }
	    }function ae(e, t) {
	      return !t || "object" !== re(t) && "function" != typeof t ? ce(e) : t;
	    }function ce(e) {
	      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e;
	    }function ue(e, t, n) {
	      return (ue = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, n) {
	        var o = function (e, t) {
	          for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = le(e));) {}return e;
	        }(e, t);if (o) {
	          var r = Object.getOwnPropertyDescriptor(o, t);return r.get ? r.get.call(n) : r.value;
	        }
	      })(e, t, n || e);
	    }function le(e) {
	      return (le = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
	        return e.__proto__ || Object.getPrototypeOf(e);
	      })(e);
	    }function pe(e, t) {
	      return (pe = Object.setPrototypeOf || function (e, t) {
	        return e.__proto__ = t, e;
	      })(e, t);
	    }function he(e, t, n) {
	      return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
	    }n.d(t, "default", function () {
	      return de;
	    });var fe = 0,
	        de = function (e) {
	      function t() {
	        var e, n;ie(this, t);for (var o = arguments.length, r = new Array(o), i = 0; i < o; i++) {
	          r[i] = arguments[i];
	        }return he(ce(n = ae(this, (e = le(t)).call.apply(e, [this].concat(r)))), "name", "Dialog"), he(ce(n), "setRef", function (e) {
	          n.element = e;
	        }), n;
	      }var n, o, r;return function (e, t) {
	        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && pe(e, t);
	      }(t, e), n = t, (o = [{ key: "componentDidUpdate", value: function value(e, t) {
	          "prompt" === this.props.type && (this.input.value = this.props.initialValue || "");
	        } }, { key: "componentDidMount", value: function value() {
	          this.content = this.element.querySelector(".content"), "prompt" === this.props.type && this.input.setAttribute("x-inputmode", this.props.inputMode), this.updateSoftKeys();
	        } }, { key: "scrollContent", value: function value(e) {
	          if (this.content) {
	            var t = this.content.scrollHeight - this.content.clientHeight;if (0 == this.content.scrollTop && e < 0 || this.content.scrollTop == t && e > 0) return !1;var n,
	                o = this.content.clientHeight - 41;return e > 0 ? n = this.content.scrollTop + o : e < 0 && (n = this.content.scrollTop - o), n < 0 ? n = 0 : n > t && (n = t), this.content.scrollTo(0, n), !0;
	          }
	        } }, { key: "updateSoftKeys", value: function value() {
	          if ("custom" !== this.props.type) {
	            if ("alert" === this.props.type) oe.a.register({ left: "", center: this.props.ok || "ok", right: "" }, this.element);else if ("progress" === this.props.type) oe.a.register({ left: this.props.hideCancel ? "" : this.props.cancel || "cancel", center: "", right: "" }, this.element);else {
	              var e = { left: this.props.cancel || "cancel", center: "", right: this.props.ok || "ok" };this.props.hideOkWhenNoInputValue && !this.input.value && (e.right = ""), oe.a.register(e, this.element);
	            }
	          } else {
	            var t = this.props.buttons;3 === t.length ? "alert" !== this.props.type ? oe.a.register({ left: t[0].message, center: t[1].message, right: t[2].message }, this.element) : oe.a.register({ left: "", center: "ok", right: "" }, this.element) : 2 === t.length ? (oe.a.register({ left: t[0].message, center: "", right: t[1].message }, this.element), this.checkbox && oe.a.register({ center: "check-on" === this.checkbox.dataset.icon ? "off" : "on" }, this.checkboxContainer)) : 1 === t.length && oe.a.register({ left: "", center: t[0].message, right: "" }, this.element);
	          }
	        } }, { key: "focus", value: function value() {
	          this.focusIfPossible(), this.updateSoftKeys();
	        } }, { key: "focusIfPossible", value: function value() {
	          this.isHidden() || ("custom" === this.props.type && this.checkboxContainer ? this.checkboxContainer.focus() : "prompt" === this.props.type ? this.input.focus() : this.props.noFocus || (this.content ? this.content.focus() : this.element.focus()));
	        } }, { key: "hide", value: function value() {
	          "prompt" === this.props.type && (this.input.value = this.props.initialValue || ""), ue(le(t.prototype), "hide", this).call(this), this.props.onHide && this.props.onHide();
	        } }, { key: "getInstanceID", value: function value() {
	          return this._id || (this._id = fe, fe++), this._id;
	        } }, { key: "componentWillUnmount", value: function value() {
	          oe.a.unregister(this.element);
	        } }, { key: "onKeyDown", value: function value(e) {
	          switch (e.key) {case "ArrowDown":
	              e.stopPropagation(), e.preventDefault(), this.scrollContent(1);break;case "ArrowUp":
	              e.stopPropagation(), e.preventDefault(), this.scrollContent(-1);break;case "Enter":
	              if (e.stopPropagation(), e.preventDefault(), "custom" === this.props.type) {
	                if (3 === this.props.buttons.length) {
	                  var t = { selectedButton: 1 };if (this.props.showCheckbox) {
	                    var n = this.checkbox.dataset.icon;t.checked = "check-on" === n;
	                  }this.props.onOk && this.props.onOk(t), this.props.noClose || this.hide();
	                } else if (this.props.showCheckbox && document.activeElement === this.checkboxContainer) {
	                  var o = this.checkbox.dataset.icon;this.checkbox.dataset.icon = "check-on" === o ? "check-off" : "check-on", this.updateSoftKeys();
	                }
	              } else "alert" === this.props.type && (this.props.onOk && this.props.onOk(), this.props.noClose || this.hide());break;case "F1":case "SoftLeft":
	              if (e.stopPropagation(), e.preventDefault(), "custom" === this.props.type) {
	                var r = { selectedButton: 0 };this.props.showCheckbox && (r.checked = "check-on" === this.checkbox.dataset.icon), this.props.onOk && this.props.onOk(r);
	              } else if ("alert" !== this.props.type) {
	                if (this.props.hideCancel) return;this.props.onCancel && this.props.onCancel();
	              }"alert" === this.props.type || this.props.noClose || this.hide();break;case "F2":case "SoftRight":
	              if (e.stopPropagation(), e.preventDefault(), this.props.hideCancel) return;if ("INPUT" === document.activeElement.tagName && !document.activeElement.value && this.props.hideOkWhenNoInputValue) return;if ("custom" === this.props.type) {
	                var i = { selectedButton: 3 === this.props.buttons.length ? 2 : 1 };this.props.showCheckbox && (i.checked = this.checkbox.checked), this.props.onOk && this.props.onOk(i);
	              } else "prompt" === this.props.type ? this.props.onOk && this.props.onOk(this.input.value) : "confirm" === this.props.type && this.props.onOk && this.props.onOk();this.props.noClose || "alert" === this.props.type || this.hide();break;case "BrowserBack":case "Backspace":case "EndCall":
	              if ("INPUT" === document.activeElement.tagName && document.activeElement.value) return;if (e.stopPropagation(), e.preventDefault(), this.props.hideCancel) return;this.props.onBack && this.props.onBack(), this.props.noClose || this.hide();}
	        } }, { key: "onBlur", value: function value() {
	          this.props.onBlur && this.props.onBlur();
	        } }, { key: "onPromptInputChange", value: function value() {
	          this.props.hideOkWhenNoInputValue && this.updateSoftKeys();
	        } }, { key: "render", value: function value() {
	          var e = this,
	              t = "";return this.props.header && (t = this.props.translated ? W.createElement("div", { className: "header h1", key: "no-translated-header", id: "dialog-header-" + this.getInstanceID() }, this.props.header) : W.createElement("div", { className: "header h1", key: "translated-header", "data-l10n-id": this.props.header, id: "dialog-header-" + this.getInstanceID() })), W.createElement("div", { ref: this.setRef, className: "dialog-container", tabIndex: "-1", onKeyDown: function onKeyDown(t) {
	              return e.onKeyDown(t);
	            }, onBlur: function onBlur() {
	              e.onBlur();
	            } }, W.createElement("div", { role: "heading", className: "dialog", "aria-labelledby": "dialog-header-" + this.getInstanceID() }, t, this.props.children || W.createElement("div", { className: "content p-ul", ref: function ref(t) {
	              return e.content = t;
	            }, tabIndex: "-1" }, this.props.translated ? this.props.content : W.createElement("div", { "data-l10n-id": this.props.content }), "prompt" === this.props.type ? W.createElement("input", { ref: function ref(t) {
	              return e.input = t;
	            }, type: this.props.inputType, className: "primary", placeholder: this.props.placeholder, defaultValue: this.props.initialValue, maxLength: this.props.maxLength, onChange: function onChange(t) {
	              return e.onPromptInputChange(t);
	            } }) : "", "custom" === this.props.type && this.props.showCheckbox ? W.createElement("div", { tabIndex: "-1", ref: function ref(t) {
	              return e.checkboxContainer = t;
	            } }, W.createElement("i", { ref: function ref(t) {
	              return e.checkbox = t;
	            }, "data-icon": this.props.checkboxCheckedByDefault ? "check-on" : "check-off" }), W.createElement("span", null, this.props.checkboxMessage)) : "", "progress" === this.props.type ? W.createElement("div", null, W.createElement("p", null, this.props.progressValue, "/", this.props.progressMax), W.createElement("progress", { value: this.props.progressValue, max: this.props.progressMax })) : ""), this.props.additionalContent && (this.props.translated ? W.createElement("div", { className: "additional-content" }, this.props.additionalContent) : W.createElement("div", { className: "additional-content", "data-l10n-id": this.props.additionalContent }))));
	        } }]) && se(n.prototype, o), r && se(n, r), t;
	    }(te);he(de, "defaultProps", { header: "", content: "", type: "confirm", inputType: "text", inputMode: "", ok: "", cancel: "", onOk: null, onBack: null, onCancel: null, onHide: null, onBlur: null, translated: !1, buttons: [], showCheckbox: !1, checkboxCheckedByDefault: !1, checkboxMessage: "", placeholder: "", initialValue: "", additionalContent: null, maxLength: 100, progressValue: "", progressMax: "", noClose: !1, noFocus: !1, hideCancel: !1, hideOkWhenNoInputValue: !1 });
	  }]);
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)(module)))

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lib = __webpack_require__(17);
	
	var _lib2 = _interopRequireDefault(_lib);
	
	var _account = __webpack_require__(15);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _models = __webpack_require__(14);
	
	var _commands = __webpack_require__(3);
	
	var _webMessageHelper = __webpack_require__(5);
	
	var _appStore = __webpack_require__(13);
	
	var _appStore2 = _interopRequireDefault(_appStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PaymentHelper = function () {
	  function PaymentHelper() {
	    var _this = this;
	
	    _classCallCheck(this, PaymentHelper);
	
	    this._apiPrefix = deviceInfos.get('apps.serviceCenterUrl');
	    this.noProvider = false;
	
	    // Change the value at all paymentHelper's instances.
	    window.addEventListener('kaypay:no-provider', function () {
	      _this.noProvider = true;
	    });
	  }
	
	  // Use 'profile' to get price & currency from KaiPay.
	  // Use 'payment' to enter KaiPay payment process.
	
	
	  _createClass(PaymentHelper, [{
	    key: 'request',
	    value: function request() {
	      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'profile';
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Object();
	
	      options.type = type;
	
	      if (type === 'payment' && !options.detail) {
	        console.error('No detail.id & detail.name in options object.');
	      } else if (options.detail) {
	        // Build up inter app communication with KaiPay.
	        options.detail.connectKeyword = 'kaipay-to-kaistore';
	      }
	
	      if (type === 'payment') {
	        _account2.default.onLoginLocked = true;
	        return this.pay(options.detail);
	      } else if (type === 'profile') {
	        return this.getProfile();
	      } else {
	        console.error('Unkown payment activity type');
	        return false;
	      }
	    }
	  }, {
	    key: 'sendHttpRequest',
	    value: function sendHttpRequest(url) {
	      var requester = _lib2.default.getRequester({
	        serverTimeOffset: window.serverTimeOffset,
	        deviceInfos: window.deviceInfos,
	        setDeviceInfo: true,
	        useCustomConnectionType: true
	      });
	
	      return new Promise(function (resolve, reject) {
	        requester.send({
	          url: url,
	          method: 'GET'
	        }).then(function (response) {
	          resolve(JSON.parse(response));
	        }, function (error) {
	          reject(error);
	        });
	      });
	    }
	  }, {
	    key: 'getAllPurchased',
	    value: function getAllPurchased() {
	      var _this2 = this;
	
	      var url = this._apiPrefix + '/products?purchased=true';
	
	      return new Promise(function (resolve, reject) {
	        _this2.sendHttpRequest(url).then(function (result) {
	          return resolve(result);
	        }, function (error) {
	          error.url = url;
	          reject(error);
	        });
	      });
	    }
	  }, {
	    key: 'getPurchasedByProductId',
	    value: function getPurchasedByProductId(productId) {
	      var _this3 = this;
	
	      var url = this._apiPrefix + '/products/' + productId + '?purchased=true';
	
	      return new Promise(function (resolve, reject) {
	        _this3.sendHttpRequest(url).then(function (result) {
	          return resolve(result);
	        }).catch(function (error) {
	          error.url = url;
	          reject(error);
	        });
	      });
	    }
	  }, {
	    key: 'getReceiptsByTransactionId',
	    value: function getReceiptsByTransactionId(transactionId) {
	      var _this4 = this;
	
	      var url = this._apiPrefix + '/purchases/' + transactionId + '/receipt';
	
	      return new Promise(function (resolve, reject) {
	        _this4.sendHttpRequest(url).then(function (result) {
	          return resolve(result);
	        }, function (error) {
	          error.url = url;
	          reject(error);
	        });
	      });
	    }
	  }, {
	    key: 'getProfile',
	    value: function getProfile() {
	      return new Promise(function (resolve, reject) {
	        _webMessageHelper.MessageSender.send(new _commands.RequestPaymentProfileCommand(), function (success, detail) {
	          if (success) {
	            var price = detail.price,
	                currency = detail.currency;
	
	            detail.unitPrice = currency + ' $' + price;
	            resolve(detail);
	          } else {
	            // 1. Show dialog with no price info @ Appspanel.js
	            // 2. Store without paid apps @ applications.js
	            console.warn('Failed to fetch price: ', detail);
	            reject(detail);
	          }
	        });
	      });
	    }
	  }, {
	    key: 'pay',
	    value: function pay(detail) {
	      return new Promise(function (resolve, reject) {
	        var id = detail.id,
	            name = detail.name;
	
	        var command = new _commands.RequestPaymentCommand({
	          detail: new _models.PaymentDetail({
	            id: id,
	            name: name
	          })
	        });
	        _webMessageHelper.MessageSender.send(command, function (success, detail) {
	          var receipt = detail.receipt,
	              error = detail.error;
	
	          if (success) {
	            resolve(receipt);
	          } else {
	            reject('Failed payment process: ', error);
	          }
	        });
	      });
	    }
	  }, {
	    key: 'isProductPurchased',
	    value: function isProductPurchased(productId) {
	      var _this5 = this;
	
	      return new Promise(function (resolve, reject) {
	        _this5.getPurchasedByProductId(productId).then(function (product) {
	          if (product && product.transaction_id) {
	            resolve();
	          } else {
	            reject();
	          }
	        }).catch(function () {
	          reject();
	        });
	      });
	    }
	  }, {
	    key: 'isSupportPrice',
	    value: function isSupportPrice(version) {
	      // KaiPay supports to get price after version 2.3.1+
	      var SUPPORT_VERSION = {
	        major: 2,
	        minor: 3,
	        build: 1
	      };
	      var versionAry = version.replace(/[^0-9^.]/g, '').split('.');
	      var major = parseInt(versionAry[0], 10);
	      var minor = parseInt(versionAry[1], 10);
	      var build = parseInt(versionAry[2], 10);
	
	      if (major > SUPPORT_VERSION['major']) {
	        return true;
	      } else if (major === SUPPORT_VERSION['major'] && minor > SUPPORT_VERSION['minor']) {
	        return true;
	      } else if (major === SUPPORT_VERSION['major'] && minor === SUPPORT_VERSION['minor'] && build >= SUPPORT_VERSION['build']) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'getKaipayVersion',
	    value: function getKaipayVersion() {
	      var KAIPAY_ID = 'UgW01f5JflryQMM4H7SF';
	      var apps = Object.values(_appStore2.default.installedApps);
	      var kaipay = apps.find(function (app) {
	        return app.id === KAIPAY_ID;
	      });
	      if (kaipay && kaipay.mozAPP.manifest && kaipay.mozAPP.manifest.version) {
	        return kaipay.mozAPP.manifest.version;
	      }
	      return null;
	    }
	  }, {
	    key: '_getAppId',
	    value: function _getAppId(manifestURL) {
	      var partitions = manifestURL.split('/');
	      var len = partitions.length;
	
	      return partitions[len - 1];
	    }
	  }]);
	
	  return PaymentHelper;
	}();
	
	exports.default = PaymentHelper;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isVersionHigher = exports.utils = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _deviceUtils = __webpack_require__(16);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Utils = function () {
	  function Utils() {
	    _classCallCheck(this, Utils);
	
	    this._cacheCommsInfo = JSON.stringify(_deviceUtils.deviceUtils.information.connection);
	  }
	
	  _createClass(Utils, [{
	    key: 'checkParameters',
	    value: function checkParameters() {
	      var newCommsInfo = JSON.stringify(_deviceUtils.deviceUtils.information.connection);
	      if (this._cacheCommsInfo !== newCommsInfo) {
	        this.rebootRequest();
	      }
	    }
	  }, {
	    key: 'rebootRequest',
	    value: function rebootRequest() {
	      var rebootEvent = new CustomEvent('reboot-needed', {
	        detail: 'device-info-change'
	      });
	
	      window.dispatchEvent(rebootEvent);
	    }
	  }, {
	    key: 'getUrlInfo',
	    value: function getUrlInfo(url) {
	      if (url) {
	        return new URL(url);
	      }
	    }
	  }, {
	    key: 'performanceMeasure',
	    value: function performanceMeasure(name) {
	      switch (name) {
	        case 'REMOTE_STORE':
	          performance.measure(name, name, name);
	          break;
	        default:
	          performance.measure(name, name + '_START', name + '_END');
	          break;
	      }
	    }
	  }, {
	    key: 'performanceLogs',
	    value: function performanceLogs() {
	      var _this = this;
	
	      var measures = ['REMOTE_STORE', 'REQUEST_DEVICE', 'REQUEST_TOKEN', 'FETCH_APPS_CAT', 'REQUEST_INSTALLED', 'REMOTE_PAGE_RENDERING'];
	      var dataArray = null;
	      var loadApps = null;
	      var loadCategories = null;
	      var startTime = 0;
	      var timing = 0;
	      var duration = 0;
	      var findEntity = function findEntity(str) {
	        var resources = performance.getEntriesByType('resource');
	        return resources.find(function (element) {
	          return element.name.indexOf(str) > 0;
	        });
	      };
	
	      measures.forEach(function (key) {
	        return _this.performanceMeasure(key);
	      });
	      dataArray = performance.getEntriesByType('measure');
	
	      loadApps = findEntity('/apps?');
	      loadApps && dataArray.push(loadApps);
	      loadCategories = findEntity('/categories?');
	      loadCategories && dataArray.push(loadCategories);
	
	      // print the logs
	      console.warn('******** [Remote] Performance Testing ********');
	      dataArray.forEach(function (data) {
	        if (data.name === 'REMOTE_STORE') {
	          startTime = data.startTime;
	        }
	        timing = (data.startTime - startTime).toFixed(2);
	        duration = data.duration.toFixed(2);
	        if (data.name === 'REMOTE_STORE') {
	          console.warn('[' + data.name + '] start: ' + timing + ' ms, duration: ' + duration + ', timestamp: ' + _this.remoteStartTime);
	        } else {
	          console.warn('[' + data.name.split('?')[0] + '] start: ' + timing + ' ms, duration: ' + duration);
	        }
	      });
	      console.warn('******** [Remote] End ********');
	    }
	  }]);
	
	  return Utils;
	}();
	
	var utils = exports.utils = new Utils();
	
	var isVersionHigher = exports.isVersionHigher = function isVersionHigher(oldVersion, newVersion) {
	  var oldVerDigits = oldVersion.split('.').map(function (digit) {
	    return parseInt(digit, 10);
	  });
	  var newVerDigits = newVersion.split('.').map(function (digit) {
	    return parseInt(digit, 10);
	  });
	
	  // filling 0 if number of the digits are not the same
	  var missingDigit = Math.abs(oldVerDigits.length - newVerDigits.length);
	  if (missingDigit > 0) {
	    if (oldVerDigits.length > newVerDigits.length) {
	      newVerDigits = newVerDigits.concat(Array(missingDigit).fill(0));
	    } else {
	      oldVerDigits = oldVerDigits.concat(Array(missingDigit).fill(0));
	    }
	  }
	
	  for (var i = 0; i < oldVerDigits.length; i++) {
	    var oldDigit = oldVerDigits[i];
	    var newDigit = newVerDigits[i];
	    if (newDigit > oldDigit) {
	      return true;
	    } else if (oldDigit > newDigit) {
	      return false;
	    }
	  }
	  return false;
	};

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict';
	
	var base64 = __webpack_require__(37);
	var ieee754 = __webpack_require__(42);
	var isArray = __webpack_require__(43);
	
	exports.Buffer = Buffer;
	exports.SlowBuffer = SlowBuffer;
	exports.INSPECT_MAX_BYTES = 50;
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength();
	
	function typedArraySupport() {
	  try {
	    var arr = new Uint8Array(1);
	    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function foo() {
	        return 42;
	      } };
	    return arr.foo() === 42 && // typed array instances can be augmented
	    typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	    arr.subarray(1, 1).byteLength === 0; // ie10 has broken `subarray`
	  } catch (e) {
	    return false;
	  }
	}
	
	function kMaxLength() {
	  return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
	}
	
	function createBuffer(that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length');
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length);
	    that.__proto__ = Buffer.prototype;
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length);
	    }
	    that.length = length;
	  }
	
	  return that;
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer(arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length);
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error('If encoding is specified then the first argument must be a string');
	    }
	    return allocUnsafe(this, arg);
	  }
	  return from(this, arg, encodingOrOffset, length);
	}
	
	Buffer.poolSize = 8192; // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype;
	  return arr;
	};
	
	function from(that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number');
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length);
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset);
	  }
	
	  return fromObject(that, value);
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length);
	};
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype;
	  Buffer.__proto__ = Uint8Array;
	  if (typeof Symbol !== 'undefined' && Symbol.species && Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    });
	  }
	}
	
	function assertSize(size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number');
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative');
	  }
	}
	
	function alloc(that, size, fill, encoding) {
	  assertSize(size);
	  if (size <= 0) {
	    return createBuffer(that, size);
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string' ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
	  }
	  return createBuffer(that, size);
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding);
	};
	
	function allocUnsafe(that, size) {
	  assertSize(size);
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0;
	    }
	  }
	  return that;
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size);
	};
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size);
	};
	
	function fromString(that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8';
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding');
	  }
	
	  var length = byteLength(string, encoding) | 0;
	  that = createBuffer(that, length);
	
	  var actual = that.write(string, encoding);
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual);
	  }
	
	  return that;
	}
	
	function fromArrayLike(that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0;
	  that = createBuffer(that, length);
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255;
	  }
	  return that;
	}
	
	function fromArrayBuffer(that, array, byteOffset, length) {
	  array.byteLength; // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds');
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds');
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array);
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset);
	  } else {
	    array = new Uint8Array(array, byteOffset, length);
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array;
	    that.__proto__ = Buffer.prototype;
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array);
	  }
	  return that;
	}
	
	function fromObject(that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0;
	    that = createBuffer(that, len);
	
	    if (that.length === 0) {
	      return that;
	    }
	
	    obj.copy(that, 0, 0, len);
	    return that;
	  }
	
	  if (obj) {
	    if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0);
	      }
	      return fromArrayLike(that, obj);
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data);
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
	}
	
	function checked(length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + kMaxLength().toString(16) + ' bytes');
	  }
	  return length | 0;
	}
	
	function SlowBuffer(length) {
	  if (+length != length) {
	    // eslint-disable-line eqeqeq
	    length = 0;
	  }
	  return Buffer.alloc(+length);
	}
	
	Buffer.isBuffer = function isBuffer(b) {
	  return !!(b != null && b._isBuffer);
	};
	
	Buffer.compare = function compare(a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers');
	  }
	
	  if (a === b) return 0;
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) return -1;
	  if (y < x) return 1;
	  return 0;
	};
	
	Buffer.isEncoding = function isEncoding(encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true;
	    default:
	      return false;
	  }
	};
	
	Buffer.concat = function concat(list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers');
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0);
	  }
	
	  var i;
	  if (length === undefined) {
	    length = 0;
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length;
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length);
	  var pos = 0;
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i];
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers');
	    }
	    buf.copy(buffer, pos);
	    pos += buf.length;
	  }
	  return buffer;
	};
	
	function byteLength(string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length;
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength;
	  }
	  if (typeof string !== 'string') {
	    string = '' + string;
	  }
	
	  var len = string.length;
	  if (len === 0) return 0;
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false;
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len;
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length;
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2;
	      case 'hex':
	        return len >>> 1;
	      case 'base64':
	        return base64ToBytes(string).length;
	      default:
	        if (loweredCase) return utf8ToBytes(string).length; // assume utf8
	        encoding = ('' + encoding).toLowerCase();
	        loweredCase = true;
	    }
	  }
	}
	Buffer.byteLength = byteLength;
	
	function slowToString(encoding, start, end) {
	  var loweredCase = false;
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0;
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return '';
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length;
	  }
	
	  if (end <= 0) {
	    return '';
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0;
	  start >>>= 0;
	
	  if (end <= start) {
	    return '';
	  }
	
	  if (!encoding) encoding = 'utf8';
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end);
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end);
	
	      case 'ascii':
	        return asciiSlice(this, start, end);
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end);
	
	      case 'base64':
	        return base64Slice(this, start, end);
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end);
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
	        encoding = (encoding + '').toLowerCase();
	        loweredCase = true;
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true;
	
	function swap(b, n, m) {
	  var i = b[n];
	  b[n] = b[m];
	  b[m] = i;
	}
	
	Buffer.prototype.swap16 = function swap16() {
	  var len = this.length;
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits');
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1);
	  }
	  return this;
	};
	
	Buffer.prototype.swap32 = function swap32() {
	  var len = this.length;
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits');
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3);
	    swap(this, i + 1, i + 2);
	  }
	  return this;
	};
	
	Buffer.prototype.swap64 = function swap64() {
	  var len = this.length;
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits');
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7);
	    swap(this, i + 1, i + 6);
	    swap(this, i + 2, i + 5);
	    swap(this, i + 3, i + 4);
	  }
	  return this;
	};
	
	Buffer.prototype.toString = function toString() {
	  var length = this.length | 0;
	  if (length === 0) return '';
	  if (arguments.length === 0) return utf8Slice(this, 0, length);
	  return slowToString.apply(this, arguments);
	};
	
	Buffer.prototype.equals = function equals(b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
	  if (this === b) return true;
	  return Buffer.compare(this, b) === 0;
	};
	
	Buffer.prototype.inspect = function inspect() {
	  var str = '';
	  var max = exports.INSPECT_MAX_BYTES;
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
	    if (this.length > max) str += ' ... ';
	  }
	  return '<Buffer ' + str + '>';
	};
	
	Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer');
	  }
	
	  if (start === undefined) {
	    start = 0;
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0;
	  }
	  if (thisStart === undefined) {
	    thisStart = 0;
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length;
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index');
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0;
	  }
	  if (thisStart >= thisEnd) {
	    return -1;
	  }
	  if (start >= end) {
	    return 1;
	  }
	
	  start >>>= 0;
	  end >>>= 0;
	  thisStart >>>= 0;
	  thisEnd >>>= 0;
	
	  if (this === target) return 0;
	
	  var x = thisEnd - thisStart;
	  var y = end - start;
	  var len = Math.min(x, y);
	
	  var thisCopy = this.slice(thisStart, thisEnd);
	  var targetCopy = target.slice(start, end);
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i];
	      y = targetCopy[i];
	      break;
	    }
	  }
	
	  if (x < y) return -1;
	  if (y < x) return 1;
	  return 0;
	};
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1;
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset;
	    byteOffset = 0;
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff;
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000;
	  }
	  byteOffset = +byteOffset; // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : buffer.length - 1;
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1;else byteOffset = buffer.length - 1;
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0;else return -1;
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding);
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1;
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
	  } else if (typeof val === 'number') {
	    val = val & 0xFF; // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
	      }
	    }
	    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
	  }
	
	  throw new TypeError('val must be string, number or Buffer');
	}
	
	function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1;
	  var arrLength = arr.length;
	  var valLength = val.length;
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase();
	    if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1;
	      }
	      indexSize = 2;
	      arrLength /= 2;
	      valLength /= 2;
	      byteOffset /= 2;
	    }
	  }
	
	  function read(buf, i) {
	    if (indexSize === 1) {
	      return buf[i];
	    } else {
	      return buf.readUInt16BE(i * indexSize);
	    }
	  }
	
	  var i;
	  if (dir) {
	    var foundIndex = -1;
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i;
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex;
	        foundIndex = -1;
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true;
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false;
	          break;
	        }
	      }
	      if (found) return i;
	    }
	  }
	
	  return -1;
	}
	
	Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1;
	};
	
	Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
	};
	
	Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
	};
	
	function hexWrite(buf, string, offset, length) {
	  offset = Number(offset) || 0;
	  var remaining = buf.length - offset;
	  if (!length) {
	    length = remaining;
	  } else {
	    length = Number(length);
	    if (length > remaining) {
	      length = remaining;
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length;
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');
	
	  if (length > strLen / 2) {
	    length = strLen / 2;
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16);
	    if (isNaN(parsed)) return i;
	    buf[offset + i] = parsed;
	  }
	  return i;
	}
	
	function utf8Write(buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
	}
	
	function asciiWrite(buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length);
	}
	
	function latin1Write(buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length);
	}
	
	function base64Write(buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length);
	}
	
	function ucs2Write(buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
	}
	
	Buffer.prototype.write = function write(string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8';
	    length = this.length;
	    offset = 0;
	    // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset;
	    length = this.length;
	    offset = 0;
	    // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0;
	    if (isFinite(length)) {
	      length = length | 0;
	      if (encoding === undefined) encoding = 'utf8';
	    } else {
	      encoding = length;
	      length = undefined;
	    }
	    // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
	  }
	
	  var remaining = this.length - offset;
	  if (length === undefined || length > remaining) length = remaining;
	
	  if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds');
	  }
	
	  if (!encoding) encoding = 'utf8';
	
	  var loweredCase = false;
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length);
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length);
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length);
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length);
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length);
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length);
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
	        encoding = ('' + encoding).toLowerCase();
	        loweredCase = true;
	    }
	  }
	};
	
	Buffer.prototype.toJSON = function toJSON() {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  };
	};
	
	function base64Slice(buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf);
	  } else {
	    return base64.fromByteArray(buf.slice(start, end));
	  }
	}
	
	function utf8Slice(buf, start, end) {
	  end = Math.min(buf.length, end);
	  var res = [];
	
	  var i = start;
	  while (i < end) {
	    var firstByte = buf[i];
	    var codePoint = null;
	    var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint;
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte;
	          }
	          break;
	        case 2:
	          secondByte = buf[i + 1];
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint;
	            }
	          }
	          break;
	        case 3:
	          secondByte = buf[i + 1];
	          thirdByte = buf[i + 2];
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint;
	            }
	          }
	          break;
	        case 4:
	          secondByte = buf[i + 1];
	          thirdByte = buf[i + 2];
	          fourthByte = buf[i + 3];
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint;
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD;
	      bytesPerSequence = 1;
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000;
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
	      codePoint = 0xDC00 | codePoint & 0x3FF;
	    }
	
	    res.push(codePoint);
	    i += bytesPerSequence;
	  }
	
	  return decodeCodePointsArray(res);
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000;
	
	function decodeCodePointsArray(codePoints) {
	  var len = codePoints.length;
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = '';
	  var i = 0;
	  while (i < len) {
	    res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
	  }
	  return res;
	}
	
	function asciiSlice(buf, start, end) {
	  var ret = '';
	  end = Math.min(buf.length, end);
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F);
	  }
	  return ret;
	}
	
	function latin1Slice(buf, start, end) {
	  var ret = '';
	  end = Math.min(buf.length, end);
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i]);
	  }
	  return ret;
	}
	
	function hexSlice(buf, start, end) {
	  var len = buf.length;
	
	  if (!start || start < 0) start = 0;
	  if (!end || end < 0 || end > len) end = len;
	
	  var out = '';
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i]);
	  }
	  return out;
	}
	
	function utf16leSlice(buf, start, end) {
	  var bytes = buf.slice(start, end);
	  var res = '';
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
	  }
	  return res;
	}
	
	Buffer.prototype.slice = function slice(start, end) {
	  var len = this.length;
	  start = ~~start;
	  end = end === undefined ? len : ~~end;
	
	  if (start < 0) {
	    start += len;
	    if (start < 0) start = 0;
	  } else if (start > len) {
	    start = len;
	  }
	
	  if (end < 0) {
	    end += len;
	    if (end < 0) end = 0;
	  } else if (end > len) {
	    end = len;
	  }
	
	  if (end < start) end = start;
	
	  var newBuf;
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end);
	    newBuf.__proto__ = Buffer.prototype;
	  } else {
	    var sliceLen = end - start;
	    newBuf = new Buffer(sliceLen, undefined);
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start];
	    }
	  }
	
	  return newBuf;
	};
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset(offset, ext, length) {
	  if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) checkOffset(offset, byteLength, this.length);
	
	  var val = this[offset];
	  var mul = 1;
	  var i = 0;
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul;
	  }
	
	  return val;
	};
	
	Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length);
	  }
	
	  var val = this[offset + --byteLength];
	  var mul = 1;
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul;
	  }
	
	  return val;
	};
	
	Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length);
	  return this[offset];
	};
	
	Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  return this[offset] | this[offset + 1] << 8;
	};
	
	Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  return this[offset] << 8 | this[offset + 1];
	};
	
	Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
	};
	
	Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
	};
	
	Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) checkOffset(offset, byteLength, this.length);
	
	  var val = this[offset];
	  var mul = 1;
	  var i = 0;
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul;
	  }
	  mul *= 0x80;
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
	
	  return val;
	};
	
	Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) checkOffset(offset, byteLength, this.length);
	
	  var i = byteLength;
	  var mul = 1;
	  var val = this[offset + --i];
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul;
	  }
	  mul *= 0x80;
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
	
	  return val;
	};
	
	Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length);
	  if (!(this[offset] & 0x80)) return this[offset];
	  return (0xff - this[offset] + 1) * -1;
	};
	
	Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  var val = this[offset] | this[offset + 1] << 8;
	  return val & 0x8000 ? val | 0xFFFF0000 : val;
	};
	
	Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  var val = this[offset + 1] | this[offset] << 8;
	  return val & 0x8000 ? val | 0xFFFF0000 : val;
	};
	
	Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
	};
	
	Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
	};
	
	Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	  return ieee754.read(this, offset, true, 23, 4);
	};
	
	Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	  return ieee754.read(this, offset, false, 23, 4);
	};
	
	Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length);
	  return ieee754.read(this, offset, true, 52, 8);
	};
	
	Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length);
	  return ieee754.read(this, offset, false, 52, 8);
	};
	
	function checkInt(buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
	  if (offset + ext > buf.length) throw new RangeError('Index out of range');
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
	    checkInt(this, value, offset, byteLength, maxBytes, 0);
	  }
	
	  var mul = 1;
	  var i = 0;
	  this[offset] = value & 0xFF;
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = value / mul & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
	    checkInt(this, value, offset, byteLength, maxBytes, 0);
	  }
	
	  var i = byteLength - 1;
	  var mul = 1;
	  this[offset + i] = value & 0xFF;
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = value / mul & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
	  this[offset] = value & 0xff;
	  return offset + 1;
	};
	
	function objectWriteUInt16(buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1;
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value & 0xff;
	    this[offset + 1] = value >>> 8;
	  } else {
	    objectWriteUInt16(this, value, offset, true);
	  }
	  return offset + 2;
	};
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value >>> 8;
	    this[offset + 1] = value & 0xff;
	  } else {
	    objectWriteUInt16(this, value, offset, false);
	  }
	  return offset + 2;
	};
	
	function objectWriteUInt32(buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1;
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = value >>> 24;
	    this[offset + 2] = value >>> 16;
	    this[offset + 1] = value >>> 8;
	    this[offset] = value & 0xff;
	  } else {
	    objectWriteUInt32(this, value, offset, true);
	  }
	  return offset + 4;
	};
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value >>> 24;
	    this[offset + 1] = value >>> 16;
	    this[offset + 2] = value >>> 8;
	    this[offset + 3] = value & 0xff;
	  } else {
	    objectWriteUInt32(this, value, offset, false);
	  }
	  return offset + 4;
	};
	
	Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1);
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit);
	  }
	
	  var i = 0;
	  var mul = 1;
	  var sub = 0;
	  this[offset] = value & 0xFF;
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1;
	    }
	    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1);
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit);
	  }
	
	  var i = byteLength - 1;
	  var mul = 1;
	  var sub = 0;
	  this[offset + i] = value & 0xFF;
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1;
	    }
	    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
	  if (value < 0) value = 0xff + value + 1;
	  this[offset] = value & 0xff;
	  return offset + 1;
	};
	
	Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value & 0xff;
	    this[offset + 1] = value >>> 8;
	  } else {
	    objectWriteUInt16(this, value, offset, true);
	  }
	  return offset + 2;
	};
	
	Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value >>> 8;
	    this[offset + 1] = value & 0xff;
	  } else {
	    objectWriteUInt16(this, value, offset, false);
	  }
	  return offset + 2;
	};
	
	Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value & 0xff;
	    this[offset + 1] = value >>> 8;
	    this[offset + 2] = value >>> 16;
	    this[offset + 3] = value >>> 24;
	  } else {
	    objectWriteUInt32(this, value, offset, true);
	  }
	  return offset + 4;
	};
	
	Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
	  if (value < 0) value = 0xffffffff + value + 1;
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value >>> 24;
	    this[offset + 1] = value >>> 16;
	    this[offset + 2] = value >>> 8;
	    this[offset + 3] = value & 0xff;
	  } else {
	    objectWriteUInt32(this, value, offset, false);
	  }
	  return offset + 4;
	};
	
	function checkIEEE754(buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range');
	  if (offset < 0) throw new RangeError('Index out of range');
	}
	
	function writeFloat(buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4);
	  return offset + 4;
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert);
	};
	
	Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert);
	};
	
	function writeDouble(buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8);
	  return offset + 8;
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert);
	};
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert);
	};
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy(target, targetStart, start, end) {
	  if (!start) start = 0;
	  if (!end && end !== 0) end = this.length;
	  if (targetStart >= target.length) targetStart = target.length;
	  if (!targetStart) targetStart = 0;
	  if (end > 0 && end < start) end = start;
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0;
	  if (target.length === 0 || this.length === 0) return 0;
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds');
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
	  if (end < 0) throw new RangeError('sourceEnd out of bounds');
	
	  // Are we oob?
	  if (end > this.length) end = this.length;
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start;
	  }
	
	  var len = end - start;
	  var i;
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start];
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start];
	    }
	  } else {
	    Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
	  }
	
	  return len;
	};
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill(val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start;
	      start = 0;
	      end = this.length;
	    } else if (typeof end === 'string') {
	      encoding = end;
	      end = this.length;
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0);
	      if (code < 256) {
	        val = code;
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string');
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding);
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255;
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index');
	  }
	
	  if (end <= start) {
	    return this;
	  }
	
	  start = start >>> 0;
	  end = end === undefined ? this.length : end >>> 0;
	
	  if (!val) val = 0;
	
	  var i;
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val;
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
	    var len = bytes.length;
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len];
	    }
	  }
	
	  return this;
	};
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
	
	function base64clean(str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '');
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return '';
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '=';
	  }
	  return str;
	}
	
	function stringtrim(str) {
	  if (str.trim) return str.trim();
	  return str.replace(/^\s+|\s+$/g, '');
	}
	
	function toHex(n) {
	  if (n < 16) return '0' + n.toString(16);
	  return n.toString(16);
	}
	
	function utf8ToBytes(string, units) {
	  units = units || Infinity;
	  var codePoint;
	  var length = string.length;
	  var leadSurrogate = null;
	  var bytes = [];
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i);
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	          continue;
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	          continue;
	        }
	
	        // valid lead
	        leadSurrogate = codePoint;
	
	        continue;
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	        leadSurrogate = codePoint;
	        continue;
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	    }
	
	    leadSurrogate = null;
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break;
	      bytes.push(codePoint);
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break;
	      bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break;
	      bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break;
	      bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
	    } else {
	      throw new Error('Invalid code point');
	    }
	  }
	
	  return bytes;
	}
	
	function asciiToBytes(str) {
	  var byteArray = [];
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF);
	  }
	  return byteArray;
	}
	
	function utf16leToBytes(str, units) {
	  var c, hi, lo;
	  var byteArray = [];
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break;
	
	    c = str.charCodeAt(i);
	    hi = c >> 8;
	    lo = c % 256;
	    byteArray.push(lo);
	    byteArray.push(hi);
	  }
	
	  return byteArray;
	}
	
	function base64ToBytes(str) {
	  return base64.toByteArray(base64clean(str));
	}
	
	function blitBuffer(src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if (i + offset >= dst.length || i >= src.length) break;
	    dst[i + offset] = src[i];
	  }
	  return i;
	}
	
	function isnan(val) {
	  return val !== val; // eslint-disable-line no-self-compare
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer, (function() { return this; }())))

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PaymentDetail = exports.PaymentProfile = undefined;
	
	var _objectmodel = __webpack_require__(8);
	
	var PaymentProfile = new _objectmodel.ObjectModel({
	  price: Number,
	  currency: String
	});
	
	var PaymentDetail = new _objectmodel.ObjectModel({
	  id: String,
	  name: String
	});
	
	exports.PaymentProfile = PaymentProfile;
	exports.PaymentDetail = PaymentDetail;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Setting = undefined;
	
	var _objectmodel = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	var Setting = new _objectmodel.ObjectModel({
	  key: Object.values(_constants.validSettingKey),
	  value: [Number, String, Boolean, Object]
	});
	
	exports.Setting = Setting;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Task = undefined;
	
	var _objectmodel = __webpack_require__(8);
	
	var Task = new _objectmodel.ObjectModel({
	  data: {
	    type: ['name', 'url', 'push-app'],
	    url: [String],
	    name: [String]
	  },
	  name: String,
	  origin: String,
	  getFilterResults: Boolean
	});
	
	exports.Task = Task;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Toast = exports.Notification = undefined;
	
	var _objectmodel = __webpack_require__(8);
	
	var Notification = new _objectmodel.ObjectModel({
	  title: String,
	  options: Object
	});
	
	var Toast = new _objectmodel.ObjectModel({
	  messageL10nId: [String],
	  message: [String],
	  messageL10nArgs: [Object],
	  titleL10nId: [String],
	  title: [String],
	  titleL10nArgs: [Object]
	});
	
	exports.Notification = Notification;
	exports.Toast = Toast;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(58);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProgressBar = function (_React$Component) {
	  _inherits(ProgressBar, _React$Component);
	
	  function ProgressBar(props) {
	    _classCallCheck(this, ProgressBar);
	
	    var _this = _possibleConstructorReturn(this, (ProgressBar.__proto__ || Object.getPrototypeOf(ProgressBar)).call(this, props));
	
	    _this.state = {
	      'isInfinite': props.infinite,
	      'currentPercentage': props.percentage || 0
	    };
	    return _this;
	  }
	
	  _createClass(ProgressBar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.props.infinite === true && nextProps.infinite === false) {
	        this.infiniteBar.addEventListener('animationiteration', function () {
	          if (_this2.props.infinite === false) {
	            _this2.setState({
	              'isInfinite': false,
	              'currentPercentage': 0
	            });
	          }
	        });
	      } else if (this.props.infinite === false && nextProps.infinite === true) {
	        this.setState({
	          'isInfinite': true
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _this3 = this;
	
	      // To ensure the bar with percentage 0 is drawn already to achieve smooth transition
	      if (this.state.currentPercentage !== this.props.percentage) {
	        setTimeout(function () {
	          window.requestAnimationFrame(function () {
	            _this3.setState({
	              'currentPercentage': _this3.props.percentage
	            });
	          });
	        }, 0);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var progressBarStyle = {
	        'height': this.props.height + 'rem'
	      };
	      var activeBarStyle = {
	        'backgroundColor': '' + this.props.activeColor
	      };
	      var finiteContainerStyle = {
	        'left': -100 + this.state.currentPercentage + '%'
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'progress-bar', style: progressBarStyle },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'container ' + (this.state.isInfinite ? 'infinite' : ''),
	            ref: function ref(e) {
	              _this4.infiniteBar = e;
	            },
	            style: !this.state.isInfinite && finiteContainerStyle
	          },
	          _react2.default.createElement('div', { className: 'active', style: activeBarStyle }),
	          this.props.hasTip && _react2.default.createElement('div', { className: 'tip' })
	        )
	      );
	    }
	  }]);
	
	  return ProgressBar;
	}(_react2.default.Component);
	
	exports.default = ProgressBar;
	
	
	ProgressBar.propTypes = {
	  infinite: _propTypes2.default.bool,
	  percentage: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  activeColor: _propTypes2.default.string,
	  hasTip: _propTypes2.default.bool
	};
	
	ProgressBar.defaultProps = {
	  infinite: true,
	  percentage: 0,
	  height: 0.4,
	  activeColor: "var(--color-gs00, #FFFFFF)",
	  hasTip: false
	};

/***/ },
/* 30 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.simpleObject = simpleObject;
	exports.hashCode = hashCode;
	function simpleObject(data) {
	  return JSON.parse(JSON.stringify(data));
	}
	
	function hashCode(s) {
	  return s.split('').reduce(function (a, b) {
	    a = (a << 5) - a + b.charCodeAt(0);
	    return a & a;
	  }, 0);
	}

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(95);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(1);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _progressBar = __webpack_require__(29);
	
	var _progressBar2 = _interopRequireDefault(_progressBar);
	
	var _Marquee = __webpack_require__(79);
	
	var _Marquee2 = _interopRequireDefault(_Marquee);
	
	var _userInterfaceHelper = __webpack_require__(19);
	
	var _deviceUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	* This is a magic number for fitting UX.
	* In gerenral case, network speed is stable and fast,
	* and average app's size is between 2MB ~ 5MB.
	* So first progress event from gceko might be smaller than 1%,
	* then next event will be finished event.
	* So we made `PROGRESS_BASE_LEVEL` as mock progress at first event.
	*/
	
	var PROGRESS_BASE_LEVEL = 13;
	
	var _ = navigator.mozL10n.get;
	
	var Appbrick = function (_Component) {
	  _inherits(Appbrick, _Component);
	
	  function Appbrick(props) {
	    _classCallCheck(this, Appbrick);
	
	    var _this = _possibleConstructorReturn(this, (Appbrick.__proto__ || Object.getPrototypeOf(Appbrick)).call(this, props));
	
	    _this.state = {
	      titleOverflow: false,
	      showProgressBar: false,
	      progressState: 0,
	      progressInfinite: true
	    };
	
	    _this.onFocus = function () {
	      _this.setTitleOverflow();
	      if (_this.props.focusHandler) {
	        _this.props.focusHandler();
	      }
	    };
	
	    _this.onBlur = function () {
	      if (!_this.props.isActivateAsPage) {
	        _this.setState({ titleOverflow: false });
	      }
	    };
	
	    _this.icon = null;
	    return _this;
	  }
	
	  _createClass(Appbrick, [{
	    key: 'generatePriceButton',
	    value: function generatePriceButton(app) {
	      var icon = void 0,
	          textId = void 0,
	          text = null;
	      if (app.isBookmark) {
	        if (app.state.pinned) {
	          icon = 'tick';
	        } else {
	          textId = 'pin';
	        }
	      } else {
	        if (app.isInstalled && app.state.updatable) {
	          textId = 'update';
	        } else if (app.isInstalled) {
	          icon = 'tick';
	        } else if (app.state.downloading) {
	          icon = 'download';
	        } else {
	          textId = app.purchased ? 'get' : app.info.paid ? 'price' : 'free';
	        }
	      }
	
	      this.icon = icon;
	
	      var extraAttrs = {};
	      if (icon) {
	        extraAttrs['data-icon'] = icon;
	      } else {
	        text = app.info.paid ? window.unitPrice : _(textId);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({
	          className: 'ads-button',
	          'data-status': icon ? icon : textId,
	          'data-pinable': _deviceUtils.deviceUtils.featureset.bookmarkDBSupported
	        }, extraAttrs),
	        text
	      );
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.element) {
	        // Remove the default icon if the real icon loaded successfully.
	        var iconDiv = this.element.querySelector('.icon-wrapper');
	        var iconImg = iconDiv.querySelector('img');
	
	        iconImg.onload = function () {
	          iconDiv.classList.remove('default');
	        };
	        // Handle progress bar
	        this.mountProgressBar();
	        requestAnimationFrame(function () {
	          _this2.setTitleOverflow();
	        });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var app = this.props.app;
	      var pinned = app.state.pinned;
	      var downloading = nextProps.app.state.downloading;
	      var _nextProps$app = nextProps.app,
	          purchased = _nextProps$app.purchased,
	          isInstalled = _nextProps$app.isInstalled;
	      var titleOverflow = nextState.titleOverflow,
	          showProgressBar = nextState.showProgressBar;
	      var isActivateAsPage = nextProps.isActivateAsPage,
	          mozAPP = nextProps.mozAPP;
	
	
	      if (app.isBookmark) {
	        // update elements when pin or unpin the bookmark
	        if (pinned !== nextProps.app.state.pinned) {
	          return true;
	        }
	      } else {
	        // update app's status which is purchased.
	        if (purchased !== this.props.app.purchased) {
	          return true;
	        }
	        // update elements when download started or download complete.
	        if (!this.state.showProgressBar && downloading || this.state.showProgressBar && !downloading) {
	          return true;
	        }
	
	        // If we get mozAPP, then update the elements.
	        if (mozAPP) {
	          return true;
	        }
	
	        if (isInstalled !== this.props.app.isInstalled) {
	          return true;
	        }
	      }
	
	      if (this.props.isActivateAsPage === false && isActivateAsPage === true) {
	        return true;
	      }
	
	      if (this.state.titleOverflow !== titleOverflow) {
	        return true;
	      }
	
	      if (this.state.showProgressBar !== showProgressBar) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var progressBarStateChanged = this.state.showProgressBar !== this.props.app.state.downloading;
	      var mozAPPLateBound = !prevProps.mozAPP && this.props.mozAPP;
	      if (progressBarStateChanged || mozAPPLateBound) {
	        this.mountProgressBar();
	      }
	
	      if (this.state.progressState === 100) {
	        this.switchProgress(false);
	      }
	
	      if (this.props.mozAPP && prevProps.mozAPP && this.props.app.state.downloading && this.props.mozAPP.progress !== prevProps.mozAPP.progress) {
	        this.monitorProgress();
	      }
	    }
	  }, {
	    key: 'mountProgressBar',
	    value: function mountProgressBar() {
	      var app = this.props.app;
	
	      if (app.isBookmark) {
	        // do something for bookmark without mount progress bar.
	      } else {
	        this.setupProgress();
	      }
	    }
	  }, {
	    key: 'setupProgress',
	    value: function setupProgress() {
	      var downloading = this.props.app.state.downloading;
	      // If app is downloading and never start to monitor progress, then do it.
	
	      if (downloading) {
	        this.monitorProgress();
	      } else {
	        this.stopMonitorProgress();
	      }
	    }
	  }, {
	    key: 'monitorProgress',
	    value: function monitorProgress() {
	      var mozAPP = this.props.mozAPP;
	
	      if (mozAPP) {
	        if (mozAPP.downloadSize === 0) {
	          this.progressAutoPlay(true);
	          return;
	        }
	        // reset autoplay
	        this.progressAutoPlay(false);
	
	        var progress = Math.floor(this.props.mozAPP.progress / this.props.mozAPP.downloadSize * 100);
	        var implicitProgressLevel = this.props.mozAPP.progress > 0 && progress < PROGRESS_BASE_LEVEL;
	        this.setState({
	          progressState: implicitProgressLevel ? PROGRESS_BASE_LEVEL : progress
	        });
	      } else {
	        // If it is a hosted APP, then mozAPP will be null.
	        this.progressAutoPlay(true);
	      }
	    }
	  }, {
	    key: 'stopMonitorProgress',
	    value: function stopMonitorProgress() {
	      var _props = this.props,
	          app = _props.app,
	          mozAPP = _props.mozAPP;
	      var updatable = app.state.updatable;
	      var showProgressBar = this.state.showProgressBar;
	
	
	      var downloadFailed = !mozAPP;
	      var updateFailed = showProgressBar && updatable;
	      var downloadSuccess = showProgressBar && app.isInstalled;
	
	      if (downloadFailed || updateFailed) {
	        this.switchProgress(false);
	        return;
	      }
	
	      if (downloadSuccess) {
	        this.setState({
	          progressState: 100
	        });
	      }
	    }
	  }, {
	    key: 'progressAutoPlay',
	    value: function progressAutoPlay(enable) {
	      this.setState({ showProgressBar: true, progressInfinite: enable });
	    }
	  }, {
	    key: 'switchProgress',
	    value: function switchProgress(enable) {
	      this.setState({ showProgressBar: enable });
	      if (enable === false) {
	        // reset to zero.
	        this.setState({ progressState: 0 });
	      }
	    }
	  }, {
	    key: 'generateIcon',
	    value: function generateIcon(app) {
	      var info = app.info;
	
	      var iconClasses = ['icon-wrapper'];
	      var iconElement = void 0,
	          icon = void 0;
	
	      // Set the default icon
	      iconClasses.push('default');
	
	      if (app.isBookmark) {
	        iconClasses.push('bookmark-icon');
	      }
	
	      iconElement = _react2.default.createElement(
	        'div',
	        { className: iconClasses.join(' ') },
	        _react2.default.createElement('img', { className: 'app-icon', src: info.icon, alt: '' })
	      );
	
	      return iconElement;
	    }
	  }, {
	    key: 'getAppPopularityInfo',
	    value: function getAppPopularityInfo(app) {
	      var inAppPage = this.props.isActivateAsPage;
	      var totalLikes = '2.3K'; // use real number when it's available
	      var popularityInfoElement = void 0,
	          iconClass = void 0;
	
	      if (app.isBookmark) {
	        return;
	      }
	
	      if (app.state.liked) {
	        iconClass = 'app-liked-icon';
	      } else if (inAppPage) {
	        iconClass = 'app-unliked-icon-detail-page';
	      } else {
	        iconClass = 'app-unliked-icon-list-page';
	      }
	
	      popularityInfoElement = _react2.default.createElement(
	        'div',
	        { className: 'app-popularity-wrapper' },
	        _react2.default.createElement('div', { className: iconClass }),
	        _react2.default.createElement(
	          'span',
	          null,
	          totalLikes
	        )
	      );
	
	      return popularityInfoElement;
	    }
	  }, {
	    key: 'setTitleOverflow',
	    value: function setTitleOverflow() {
	      if ((0, _userInterfaceHelper.isOverflown)(this.infoWrapper) && this.state.titleOverflow === false) {
	        this.setState({
	          titleOverflow: true
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          app = _props2.app,
	          isActivateAsPage = _props2.isActivateAsPage,
	          hasProgressBar = _props2.hasProgressBar,
	          isNativeApp = _props2.isNativeApp;
	      var _state = this.state,
	          titleOverflow = _state.titleOverflow,
	          showProgressBar = _state.showProgressBar;
	      var _app$info = app.info,
	          bg = _app$info.bg,
	          localized = _app$info.localized;
	      var name = localized.name,
	          subtitle = localized.subtitle;
	
	
	      var priceButton = this.generatePriceButton(app);
	      var iconElement = this.generateIcon(app);
	      // let popularityElement = this.getAppPopularityInfo(app); // enable it when the backend is ready.
	      var style = {
	        backgroundImage: bg && isActivateAsPage ? 'url(' + bg + ')' : null
	      };
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'brick ' + (isActivateAsPage && bg ? 'bg-loaded' : ''),
	          tabIndex: '1',
	          'data-id': app.id,
	          'data-bg-image': bg,
	          'data-type': app.type,
	          'data-app-order': this.props.appOrder,
	          ref: function ref(element) {
	            _this3.element = element;
	          },
	          onFocus: this.onFocus,
	          onBlur: this.onBlur,
	          style: style
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'info-box' },
	          iconElement,
	          _react2.default.createElement(
	            'section',
	            {
	              className: 'info ' + (isActivateAsPage ? '' : 'full'),
	              ref: function ref(element) {
	                _this3.infoWrapper = element;
	              }
	            },
	            titleOverflow ? _react2.default.createElement(_Marquee2.default, { name: name }) : _react2.default.createElement(
	              'h2',
	              null,
	              name
	            ),
	            (!hasProgressBar || !app.state.downloading) && !isActivateAsPage && _react2.default.createElement(
	              'p',
	              null,
	              app.isBookmark ? _('website') : subtitle
	            ),
	            hasProgressBar && _react2.default.createElement(
	              'div',
	              {
	                className: 'progress-box ' + (showProgressBar ? '' : 'hide')
	              },
	              _react2.default.createElement(_progressBar2.default, {
	                infinite: this.state.progressInfinite,
	                percentage: this.state.progressState
	              })
	            ),
	            isNativeApp && !hasProgressBar && _react2.default.createElement(
	              'div',
	              { className: 'size' },
	              app.info.size
	            )
	          )
	        ),
	        !isNativeApp && priceButton
	      );
	    }
	  }]);
	
	  return Appbrick;
	}(_react.Component);
	
	exports.default = Appbrick;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loggerHelper = exports.bookmarkEvent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _baseComponent = __webpack_require__(35);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var _lib = __webpack_require__(17);
	
	var _lib2 = _interopRequireDefault(_lib);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDownloadErrorsToLoggerStatus = {
	  NETWORK_ERROR: 0,
	  DOWNLOAD_ERROR: 101,
	  CHECK_DEPENDENCIES_ERROR: 108,
	  INSUFFICIENT_STORAGE: 104
	};
	
	var bookmarkEvent = exports.bookmarkEvent = {
	  OPEN: 'store_bm_open',
	  PIN: 'store_bm_pin'
	};
	
	var LoggerHelper = function (_BaseComponent) {
	  _inherits(LoggerHelper, _BaseComponent);
	
	  function LoggerHelper() {
	    _classCallCheck(this, LoggerHelper);
	
	    var _this = _possibleConstructorReturn(this, (LoggerHelper.__proto__ || Object.getPrototypeOf(LoggerHelper)).call(this));
	
	    _this.apiName = 'events';
	    return _this;
	  }
	
	  _createClass(LoggerHelper, [{
	    key: 'postData',
	    value: function postData(data) {
	      var apiUri = deviceInfos.get('apps.serviceCenterUrl');
	      var url = apiUri + '/' + this.apiName;
	      return new Promise(function (resolve, reject) {
	        var requester = _lib2.default.getRequester({
	          serverTimeOffset: window.serverTimeOffset,
	          deviceInfos: window.deviceInfos,
	          setDeviceInfo: true,
	          useCustomConnectionType: true
	        });
	        requester.send({
	          url: url,
	          method: 'POST',
	          params: data
	        }).then(function (response) {
	          resolve(JSON.parse(response));
	        }, function (error) {
	          console.error('logger:' + error.statusText);
	          reject();
	        });
	      });
	    }
	  }, {
	    key: 'postAppInstallData',
	    value: function postAppInstallData(appsInfo) {
	      var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      var logsInfo = {
	        event_type: 'store_app_install'
	      };
	      logsInfo = Object.assign(appsInfo, logsInfo);
	      if (error === null) {
	        logsInfo.status_code = 1;
	      } else {
	        logsInfo.status_code = this._getInstallErrorStatus(error);
	      }
	      this.postData(logsInfo);
	    }
	  }, {
	    key: 'postAppViewData',
	    value: function postAppViewData(activeApp) {
	      var appOrder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var adId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      var logsInfo = {
	        event_type: 'store_app_view',
	        app_id: activeApp.id,
	        app_version: activeApp.info.version,
	        app_name: activeApp.info.localized.name,
	        tab_code: activeApp.remoteInfo.category.toString()
	      };
	      if (appOrder !== null) {
	        logsInfo.app_order = parseInt(appOrder, 10);
	      }
	      if (adId !== null) {
	        logsInfo.ad_id = adId;
	      }
	      this.postData(logsInfo);
	    }
	  }, {
	    key: 'postBookmarkData',
	    value: function postBookmarkData(eventType, id, info) {
	      var localized = info.localized,
	          version = info.version;
	
	      var data = {
	        event_type: eventType,
	        app_version: version,
	        app_id: id,
	        app_name: localized.name
	      };
	      this.postData(data);
	    }
	  }, {
	    key: '_getInstallErrorStatus',
	    value: function _getInstallErrorStatus(message) {
	      var status = mapDownloadErrorsToLoggerStatus[message];
	      if (typeof status !== 'undefined') {
	        return status;
	      } else {
	        return 101;
	      }
	    }
	  }]);
	
	  return LoggerHelper;
	}(_baseComponent2.default);
	
	var loggerHelper = exports.loggerHelper = new LoggerHelper();

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _deviceUtils = __webpack_require__(16);
	
	var _constants = __webpack_require__(2);
	
	var _webMessageHelper = __webpack_require__(5);
	
	var _commands = __webpack_require__(3);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RichContentHelper = function () {
	  function RichContentHelper() {
	    _classCallCheck(this, RichContentHelper);
	
	    this._enable = false;
	    this._settingValue = null;
	  }
	
	  _createClass(RichContentHelper, [{
	    key: '_checkEnable',
	    value: function _checkEnable(settingValue) {
	      var enable = false;
	      switch (settingValue) {
	        case 'wifi-only':
	          enable = _deviceUtils.deviceUtils.information.connection.type === 'wifi';
	          break;
	        case 'data-enable':
	          enable = true;
	          break;
	        default:
	          enable = false;
	      }
	      return enable;
	    }
	  }, {
	    key: 'settingValue',
	    set: function set(value) {
	      this._settingValue = value;
	    }
	  }, {
	    key: 'enable',
	    get: function get() {
	      var _this = this;
	
	      if (this._settingValue === null) {
	        var key = _constants.validSettingKey.RICH_CONTENT;
	        _webMessageHelper.MessageSender.send(new _commands.RequestSettingCommand({
	          detail: {
	            key: key
	          }
	        }), function (success, result) {
	          _this.settingValue = success && result.value ? result.value : _constants.validSettingData[key].default;
	          return _this._checkEnable(_this._settingValue);
	        });
	      } else {
	        return this._checkEnable(this._settingValue);
	      }
	    }
	  }]);
	
	  return RichContentHelper;
	}();
	
	exports.default = RichContentHelper = new RichContentHelper();

/***/ },
/* 34 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MozActivityManager = function () {
	  function MozActivityManager() {
	    _classCallCheck(this, MozActivityManager);
	
	    this.iac_kaipay = 'kaipay-to-kaistore';
	    this.taskQueue = [];
	  }
	
	  _createClass(MozActivityManager, [{
	    key: 'handleActivity',
	    value: function handleActivity(activityRequest) {
	      var option = activityRequest.source;
	      switch (option.name) {
	        case 'open-page':
	        case 'open-by-name':
	        case 'inline-open-page':
	        case 'inline-open-by-name':
	          this.saveToQueue(option);
	          break;
	        default:
	          break;
	      }
	    }
	
	    // XXX: In the future, we will use these order info to recover the intermittent orders.
	    // If the order has been completed, we will remove it after download success.
	
	  }, {
	    key: 'handleIAC',
	    value: function handleIAC(iacRequest) {
	      // Inter APP Communication with KaiPay
	      if (iacRequest.keyword === this.iac_kaipay) {
	        var port = iacRequest.port;
	        port.onmessage = function onReceivedMessage(evt) {
	          var eventData = evt.data;
	          var productId = eventData.productID;
	          var orderData = eventData.data;
	          var orderId = orderData.orderId;
	
	          if (productId && orderId) {
	            // add update time to data
	            eventData.updateTime = evt.timeStamp;
	            // insert or update the order info into indexDB (use "kaipay-{productId}" to be the key)
	            asyncStorage.setItem(this.iac_kaipay + '-' + productId, eventData);
	          }
	        }.bind(this);
	      }
	    }
	  }, {
	    key: 'saveToQueue',
	    value: function saveToQueue(option) {
	      if (!option) {
	        return;
	      }
	      this.taskQueue.push(option);
	      window.dispatchEvent(new CustomEvent('task-queue-updated'));
	    }
	  }, {
	    key: 'task',
	    get: function get() {
	      if (this.taskQueue.length === 0) {
	        return false;
	      } else {
	        return this.taskQueue.pop();
	      }
	    }
	  }]);
	
	  return MozActivityManager;
	}();
	
	var mozActivityManager = exports.mozActivityManager = new MozActivityManager();

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	!function (e, t) {
	  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = t(__webpack_require__(4)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_FACTORY__ = (t), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.BaseComponent = t(require("preact")) : e.BaseComponent = t(e.preact);
	}(window, function (e) {
	  return function (e) {
	    var t = {};function n(i) {
	      if (t[i]) return t[i].exports;var r = t[i] = { i: i, l: !1, exports: {} };return e[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
	    }return n.m = e, n.c = t, n.d = function (e, t, i) {
	      n.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: i });
	    }, n.r = function (e) {
	      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
	    }, n.t = function (e, t) {
	      if (1 & t && (e = n(e)), 8 & t) return e;if (4 & t && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && e && e.__esModule) return e;var i = Object.create(null);if (n.r(i), Object.defineProperty(i, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e) for (var r in e) {
	        n.d(i, r, function (t) {
	          return e[t];
	        }.bind(null, r));
	      }return i;
	    }, n.n = function (e) {
	      var t = e && e.__esModule ? function () {
	        return e.default;
	      } : function () {
	        return e;
	      };return n.d(t, "a", t), t;
	    }, n.o = function (e, t) {
	      return Object.prototype.hasOwnProperty.call(e, t);
	    }, n.p = "", n(n.s = 1);
	  }([function (t, n) {
	    t.exports = e;
	  }, function (e, t, n) {
	    "use strict";
	    n.r(t), n.d(t, "default", function () {
	      return s;
	    });var i = n(0);n(2);function r(e) {
	      if (!e || "string" != typeof e) throw new Error("Event name should be a valid non-empty string!");
	    }function o(e) {
	      if ("function" != typeof e) throw new Error("Handler should be a function!");
	    }
	    var s = function (_i$Component) {
	      _inherits(s, _i$Component);
	
	      function s() {
	        _classCallCheck(this, s);
	
	        return _possibleConstructorReturn(this, (s.__proto__ || Object.getPrototypeOf(s)).apply(this, arguments));
	      }
	
	      _createClass(s, [{
	        key: "setHierarchy",
	        value: function setHierarchy(e) {
	          this.getElement() && e && this.getElement().focus();
	        }
	      }, {
	        key: "handleEvent",
	        value: function handleEvent(e) {
	          if ("function" == typeof this._pre_handleEvent) {
	            if (!1 === this._pre_handleEvent(e)) return;
	          } else this.debug("no handle event pre found. skip");"function" == typeof this["_handle_" + e.type] && (this.debug("handling " + e.type), this["_handle_" + e.type](e)), "function" == typeof this._post_handleEvent && this._post_handleEvent(e);
	        }
	      }, {
	        key: "show",
	        value: function show() {
	          this.getElement() && (this.getElement().classList.remove("hidden"), this.focus(), this.emit("opened"));
	        }
	      }, {
	        key: "hide",
	        value: function hide() {
	          this.getElement() && (this.getElement().classList.add("hidden"), this.emit("closed"));
	        }
	      }, {
	        key: "focus",
	        value: function focus() {
	          this.getElement() && this.getElement().focus();
	        }
	      }, {
	        key: "respondToHierarchyEvent",
	        value: function respondToHierarchyEvent(e) {
	          return !this.isActive();
	        }
	      }, {
	        key: "_changeState",
	        value: function _changeState(e, t) {
	          this.getElement() && this.getElement().setAttribute(e + "-state", t.toString());
	        }
	      }, {
	        key: "isHidden",
	        value: function isHidden() {
	          return !this.getElement() || this.getElement().classList.contains("hidden");
	        }
	      }, {
	        key: "isActive",
	        value: function isActive() {
	          return !!this.getElement() && !this.getElement().classList.contains("hidden");
	        }
	      }, {
	        key: "publish",
	        value: function publish(e, t, n) {
	          if (this.getElement()) {
	            this.broadcast(e, t);var i = new CustomEvent(n ? e : this.EVENT_PREFIX + e, { bubbles: !0, detail: t || this });this.debug("publishing external event: " + e + (t ? JSON.stringify(t) : "")), this.getElement().dispatchEvent(i);
	          }
	        }
	      }, {
	        key: "getElement",
	        value: function getElement() {
	          return this.element || console.warn("BaseComponent couldn't get this.element correctly, please setup refs in your component first"), this.element;
	        }
	      }, {
	        key: "broadcast",
	        value: function broadcast(e, t) {
	          if (this.getElement()) {
	            var n = new CustomEvent("_" + e, { bubbles: !1, detail: t || this });this.getElement().dispatchEvent(n);
	          }
	        }
	      }, {
	        key: "currentTime",
	        value: function currentTime() {
	          return (new Date().getTime() / 1e3 - this._start).toFixed(3);
	        }
	      }, {
	        key: "debug",
	        value: function debug() {
	          this.DEBUG && (console.log("[" + this.name + "] [" + this.currentTime() + "] " + Array.prototype.slice.call(arguments).concat()), this.TRACE && console.trace());
	        }
	      }, {
	        key: "on",
	        value: function on(e, t) {
	          r(e), o(t), this.listeners || (this.listeners = new Map());var n = this.listeners.get(e);n || (n = new Set(), this.listeners.set(e, n)), n.add(t);
	        }
	      }, {
	        key: "off",
	        value: function off(e, t) {
	          r(e), o(t);var n = this.listeners.get(e);n && (n.delete(t), n.size || this.listeners.delete(e));
	        }
	      }, {
	        key: "offAll",
	        value: function offAll(e) {
	          if (void 0 !== e) {
	            r(e);var t = this.listeners.get(e);t && (t.clear(), this.listeners.delete(e));
	          } else this.listeners.clear();
	        }
	      }, {
	        key: "observe",
	        value: function observe(e, t) {
	          this._settings || (this._settings = {}), this._settings[e] = t, "function" == typeof this["_observe_" + e] && this["_observe_" + e](t);
	        }
	      }, {
	        key: "emit",
	        value: function emit(e) {
	          for (var _len = arguments.length, t = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	            t[_key - 1] = arguments[_key];
	          }
	
	          r(e), this.listeners || (this.listeners = new Map());var n = this.listeners.get(e);n && n.forEach(function (e) {
	            try {
	              e.apply(null, t);
	            } catch (e) {
	              console.error(e);
	            }
	          });
	        }
	      }]);
	
	      return s;
	    }(i.Component);
	  }, function (e, t, n) {
	    var i = n(3),
	        r = n(4);"string" == typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);var o = { insert: "head", singleton: !1 },
	        s = (i(r, o), r.locals ? r.locals : {});e.exports = s;
	  }, function (e, t, n) {
	    "use strict";
	    var i,
	        r = function r() {
	      return void 0 === i && (i = Boolean(window && document && document.all && !window.atob)), i;
	    },
	        o = function () {
	      var e = {};return function (t) {
	        if (void 0 === e[t]) {
	          var n = document.querySelector(t);if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
	            n = n.contentDocument.head;
	          } catch (e) {
	            n = null;
	          }e[t] = n;
	        }return e[t];
	      };
	    }(),
	        s = [];function a(e) {
	      for (var t = -1, n = 0; n < s.length; n++) {
	        if (s[n].identifier === e) {
	          t = n;break;
	        }
	      }return t;
	    }function c(e, t) {
	      for (var n = {}, i = [], r = 0; r < e.length; r++) {
	        var o = e[r],
	            c = t.base ? o[0] + t.base : o[0],
	            l = n[c] || 0,
	            u = "".concat(c, " ").concat(l);n[c] = l + 1;var f = a(u),
	            d = { css: o[1], media: o[2], sourceMap: o[3] };-1 !== f ? (s[f].references++, s[f].updater(d)) : s.push({ identifier: u, updater: v(d, t), references: 1 }), i.push(u);
	      }return i;
	    }function l(e) {
	      var t = document.createElement("style"),
	          i = e.attributes || {};if (void 0 === i.nonce) {
	        var r = n.nc;r && (i.nonce = r);
	      }if (Object.keys(i).forEach(function (e) {
	        t.setAttribute(e, i[e]);
	      }), "function" == typeof e.insert) e.insert(t);else {
	        var s = o(e.insert || "head");if (!s) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");s.appendChild(t);
	      }return t;
	    }var u,
	        f = (u = [], function (e, t) {
	      return u[e] = t, u.filter(Boolean).join("\n");
	    });function d(e, t, n, i) {
	      var r = n ? "" : i.media ? "@media ".concat(i.media, " {").concat(i.css, "}") : i.css;if (e.styleSheet) e.styleSheet.cssText = f(t, r);else {
	        var o = document.createTextNode(r),
	            s = e.childNodes;s[t] && e.removeChild(s[t]), s.length ? e.insertBefore(o, s[t]) : e.appendChild(o);
	      }
	    }function h(e, t, n) {
	      var i = n.css,
	          r = n.media,
	          o = n.sourceMap;if (r ? e.setAttribute("media", r) : e.removeAttribute("media"), o && btoa && (i += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o)))), " */")), e.styleSheet) e.styleSheet.cssText = i;else {
	        for (; e.firstChild;) {
	          e.removeChild(e.firstChild);
	        }e.appendChild(document.createTextNode(i));
	      }
	    }var p = null,
	        m = 0;function v(e, t) {
	      var n, i, r;if (t.singleton) {
	        var o = m++;n = p || (p = l(t)), i = d.bind(null, n, o, !1), r = d.bind(null, n, o, !0);
	      } else n = l(t), i = h.bind(null, n, t), r = function r() {
	        !function (e) {
	          if (null === e.parentNode) return !1;e.parentNode.removeChild(e);
	        }(n);
	      };return i(e), function (t) {
	        if (t) {
	          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;i(e = t);
	        } else r();
	      };
	    }e.exports = function (e, t) {
	      (t = t || {}).singleton || "boolean" == typeof t.singleton || (t.singleton = r());var n = c(e = e || [], t);return function (e) {
	        if (e = e || [], "[object Array]" === Object.prototype.toString.call(e)) {
	          for (var i = 0; i < n.length; i++) {
	            var r = a(n[i]);s[r].references--;
	          }for (var o = c(e, t), l = 0; l < n.length; l++) {
	            var u = a(n[l]);0 === s[u].references && (s[u].updater(), s.splice(u, 1));
	          }n = o;
	        }
	      };
	    };
	  }, function (e, t, n) {
	    (t = n(5)(!1)).push([e.i, ".hidden{display:none !important}\n", ""]), e.exports = t;
	  }, function (e, t, n) {
	    "use strict";
	    e.exports = function (e) {
	      var t = [];return t.toString = function () {
	        return this.map(function (t) {
	          var n = function (e, t) {
	            var n = e[1] || "",
	                i = e[3];if (!i) return n;if (t && "function" == typeof btoa) {
	              var r = (s = i, a = btoa(unescape(encodeURIComponent(JSON.stringify(s)))), c = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(a), "/*# ".concat(c, " */")),
	                  o = i.sources.map(function (e) {
	                return "/*# sourceURL=".concat(i.sourceRoot || "").concat(e, " */");
	              });return [n].concat(o).concat([r]).join("\n");
	            }var s, a, c;return [n].join("\n");
	          }(t, e);return t[2] ? "@media ".concat(t[2], " {").concat(n, "}") : n;
	        }).join("");
	      }, t.i = function (e, n, i) {
	        "string" == typeof e && (e = [[null, e, ""]]);var r = {};if (i) for (var o = 0; o < this.length; o++) {
	          var s = this[o][0];null != s && (r[s] = !0);
	        }for (var a = 0; a < e.length; a++) {
	          var c = [].concat(e[a]);i && r[c[0]] || (n && (c[2] ? c[2] = "".concat(n, " and ").concat(c[2]) : c[2] = n), t.push(c));
	        }
	      }, t;
	    };
	  }]);
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)(module)))

/***/ },
/* 36 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function ensureValidEventName(eventName) {
	  if (!eventName || typeof eventName !== 'string') {
	    throw new Error('Event name should be a valid non-empty string!');
	  }
	}
	
	function ensureValidHandler(handler) {
	  if (typeof handler !== 'function') {
	    throw new Error('Handler should be a function!');
	  }
	}
	
	// Implements publish/subscribe behaviour that can be applied to any object,
	// so that object can be listened for custom events. "this" context is the
	// object with Map "listeners" property used to store handlers.
	
	var BaseEmitter = function () {
	  function BaseEmitter() {
	    _classCallCheck(this, BaseEmitter);
	
	    this.listeners = new Map();
	  }
	
	  _createClass(BaseEmitter, [{
	    key: 'on',
	
	
	    /**
	     * Registers listener function to be executed once event occurs.
	     * @param {string} eventName Name of the event to listen for.
	     * @param {function} handler Handler to be executed once event occurs.
	     */
	    value: function on(eventName, handler) {
	      ensureValidEventName(eventName);
	      ensureValidHandler(handler);
	
	      var handlers = this.listeners.get(eventName);
	
	      if (!handlers) {
	        handlers = new Set();
	        this.listeners.set(eventName, handlers);
	      }
	
	      // Set.add ignores handler if it has been already registered
	      handlers.add(handler);
	    }
	  }, {
	    key: 'off',
	
	
	    /**
	     * Removes registered listener for the specified event.
	     * @param {string} eventName Name of the event to remove listener for.
	     * @param {function} handler Handler to remove, so it won't be executed
	     * next time event occurs.
	     */
	    value: function off(eventName, handler) {
	      ensureValidEventName(eventName);
	      ensureValidHandler(handler);
	
	      var handlers = this.listeners.get(eventName);
	
	      if (!handlers) {
	        return;
	      }
	
	      handlers.delete(handler);
	
	      if (!handlers.size) {
	        this.listeners.delete(eventName);
	      }
	    }
	  }, {
	    key: 'offAll',
	
	
	    /**
	     * Removes all registered listeners for the specified event.
	     * @param {string} eventName Name of the event to remove all listeners for.
	     */
	    value: function offAll(eventName) {
	      if (typeof eventName === 'undefined') {
	        this.listeners.clear();
	        return;
	      }
	
	      ensureValidEventName(eventName);
	
	      var handlers = this.listeners.get(eventName);
	
	      if (!handlers) {
	        return;
	      }
	
	      handlers.clear();
	
	      this.listeners.delete(eventName);
	    }
	  }, {
	    key: 'emit',
	
	
	    /**
	     * Emits specified event so that all registered handlers will be called
	     * with the specified parameters.
	     * @param {string} eventName Name of the event to call handlers for.
	     * @param {Object} parameters Optional parameters that will be passed to
	     * every registered handler.
	     */
	    value: function emit(eventName) {
	      for (var _len = arguments.length, parameters = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        parameters[_key - 1] = arguments[_key];
	      }
	
	      ensureValidEventName(eventName);
	
	      var handlers = this.listeners.get(eventName);
	
	      if (!handlers) {
	        return;
	      }
	
	      handlers.forEach(function (handler) {
	        try {
	          handler.apply(null, parameters);
	        } catch (e) {
	          console.error(e);
	        }
	      });
	    }
	  }]);
	
	  return BaseEmitter;
	}();
	
	exports.default = BaseEmitter;

/***/ },
/* 37 */
/***/ function(module, exports) {

	'use strict';
	
	exports.byteLength = byteLength;
	exports.toByteArray = toByteArray;
	exports.fromByteArray = fromByteArray;
	
	var lookup = [];
	var revLookup = [];
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i];
	  revLookup[code.charCodeAt(i)] = i;
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62;
	revLookup['_'.charCodeAt(0)] = 63;
	
	function getLens(b64) {
	  var len = b64.length;
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4');
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=');
	  if (validLen === -1) validLen = len;
	
	  var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
	
	  return [validLen, placeHoldersLen];
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength(b64) {
	  var lens = getLens(b64);
	  var validLen = lens[0];
	  var placeHoldersLen = lens[1];
	  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
	}
	
	function _byteLength(b64, validLen, placeHoldersLen) {
	  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
	}
	
	function toByteArray(b64) {
	  var tmp;
	  var lens = getLens(b64);
	  var validLen = lens[0];
	  var placeHoldersLen = lens[1];
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
	
	  var curByte = 0;
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
	
	  for (var i = 0; i < len; i += 4) {
	    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
	    arr[curByte++] = tmp >> 16 & 0xFF;
	    arr[curByte++] = tmp >> 8 & 0xFF;
	    arr[curByte++] = tmp & 0xFF;
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
	    arr[curByte++] = tmp & 0xFF;
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
	    arr[curByte++] = tmp >> 8 & 0xFF;
	    arr[curByte++] = tmp & 0xFF;
	  }
	
	  return arr;
	}
	
	function tripletToBase64(num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
	}
	
	function encodeChunk(uint8, start, end) {
	  var tmp;
	  var output = [];
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
	    output.push(tripletToBase64(tmp));
	  }
	  return output.join('');
	}
	
	function fromByteArray(uint8) {
	  var tmp;
	  var len = uint8.length;
	  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
	  var parts = [];
	  var maxChunkLength = 16383; // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1];
	    parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
	    parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
	  }
	
	  return parts.join('');
	}

/***/ },
/* 38 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _hawk = __webpack_require__(41);
	
	var _hawk2 = _interopRequireDefault(_hawk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var XHR_TIMEOUT_MS = 60000;
	
	var Requester = function () {
	  function Requester() {
	    var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : XHR_TIMEOUT_MS;
	
	    _classCallCheck(this, Requester);
	
	    this._timeout = timeout;
	    this._hawkCredentials = null;
	    this._deviceInfo = null;
	    this._timeOffset = null;
	    this.hawk = _hawk2.default;
	  }
	
	  _createClass(Requester, [{
	    key: 'setDeviceInfo',
	    value: function setDeviceInfo(deviceInfo) {
	      //ct=(wifi|3g|4g|5g)
	      //dev_utc=1541197041  Device time in UTC
	      //dev_utc_off="-8"
	      //dev_build_id
	      //dev_build_number
	
	      this._deviceInfo = {
	        'ct': deviceInfo.ct,
	        'dev_utc': deviceInfo.utc,
	        'dev_utc_off': deviceInfo.utcOff,
	        'dev_build_id': deviceInfo.buildID,
	        'dev_build_number': deviceInfo.buildNumber ? deviceInfo.buildNumber : null
	      };
	    }
	  }, {
	    key: '_caculateOffset',
	    value: function _caculateOffset(dateGMTStr) {
	      var offset = 0;
	
	      if (dateGMTStr) {
	        var serverGMTMillisTime = Date.parse(this._getUTCTime(dateGMTStr));
	        var localUTCMillisTime = Date.parse(new Date().toUTCString());
	
	        offset = serverGMTMillisTime - localUTCMillisTime;
	      }
	      return offset;
	    }
	  }, {
	    key: '_getUTCTime',
	    value: function _getUTCTime(dateStr) {
	      return new Date(Date.parse(dateStr)).toUTCString();
	    }
	
	    // Notify APPs: The time offset has been changed
	
	  }, {
	    key: '_broadcast',
	    value: function _broadcast(prevOffest, nowOffset) {
	      var event = new CustomEvent("hawkrequester:offsetchange", {
	        detail: {
	          msg: 'this._timeOffset in hawk-requester has been changed!',
	          previous: prevOffest,
	          current: nowOffset
	        }
	      });
	
	      window.dispatchEvent(event);
	    }
	
	    // Send a hawk request
	
	  }, {
	    key: '_send',
	    value: function _send(options) {
	      var _this = this;
	
	      return new Promise(function (resolve, reject) {
	        var params = JSON.stringify(options.params);
	        var url = options.url;
	        var method = options.method;
	        var authorization = options.authorization;
	
	        var xhr = new XMLHttpRequest({ mozSystem: true });
	        xhr.open(method, url, true);
	        xhr.timeout = _this._timeout;
	        xhr.setRequestHeader('Content-Type', 'application/json');
	        xhr.withCredentials = true;
	        xhr.responseType = '';
	
	        if (authorization) {
	          xhr.setRequestHeader('Authorization', authorization);
	        } else if (_this._hawkCredentials) {
	          var hawkHeader = _this.getHawkHeader(params, url, method);
	          xhr.setRequestHeader('Authorization', hawkHeader.field);
	        }
	
	        if (_this._deviceInfo) {
	          var deviceInfo = _this._deviceInfo;
	          Object.keys(deviceInfo).forEach(function (key) {
	            var val = deviceInfo[key];
	            xhr.setRequestHeader(key, val);
	          });
	        }
	
	        xhr.onload = function fmdr_xhr_onload() {
	          if (xhr.status >= 200 && xhr.status < 300) {
	            resolve(xhr.response);
	          } else {
	            reject({
	              status: xhr.status,
	              statusText: xhr.statusText,
	              responseText: xhr.responseText,
	              date: xhr.getResponseHeader('date')
	            });
	          }
	        };
	
	        xhr.onerror = function fmd_xhr_onerror() {
	          reject({
	            status: xhr.status,
	            statusText: xhr.statusText,
	            responseText: xhr.responseText,
	            date: xhr.getResponseHeader('date')
	          });
	        };
	
	        xhr.ontimeout = function fmd_xhr_ontimeout() {
	          xhr.onerror();
	        };
	
	        if (params) {
	          xhr.send(params);
	        } else {
	          xhr.send(null);
	        }
	      });
	    }
	  }, {
	    key: 'setHawkCredentials',
	    value: function setHawkCredentials(kid, macKey) {
	      this._hawkCredentials = {
	        id: kid,
	        key: convertKey(macKey),
	        algorithm: 'sha256'
	      };
	    }
	
	    // If hawk request is failed, set the timestamp and retry once.
	
	  }, {
	    key: 'send',
	    value: function send(options) {
	      var _this2 = this;
	
	      return new Promise(function (resolve, reject) {
	        _this2._send(options).then(function (result) {
	          resolve(result);
	        }, function (error) {
	          if (error.status === 401) {
	            var prevOffset = _this2._timeOffset;
	            // Get time offset from server
	            _this2._timeOffset = _this2._caculateOffset(error.date);
	            _this2._broadcast(prevOffset, _this2._timeOffset);
	
	            // Retry
	            _this2._send(options).then(function (result) {
	              resolve(result);
	            }, function (error) {
	              reject(error);
	            });
	          } else {
	            reject(error);
	          }
	        });
	      });
	    }
	  }, {
	    key: 'getHawkHeader',
	    value: function getHawkHeader(params, url, method) {
	      var credentials = {
	        credentials: this._hawkCredentials
	      };
	
	      // Add timestamp parameter into hawk header options
	      if (this._timeOffset) {
	        credentials['timestamp'] = Math.floor((Date.now() + this._timeOffset) / 1000);
	      }
	
	      if (params) {
	        credentials.payload = params;
	        credentials.contentType = 'application/json';
	      }
	      var hawkHeader = _hawk2.default.client.header(url, method, credentials);
	      return hawkHeader;
	    }
	  }, {
	    key: 'serverTimeOffset',
	    get: function get() {
	      return this._timeOffset;
	    },
	    set: function set(value) {
	      this._timeOffset = value;
	    }
	  }]);
	
	  return Requester;
	}();
	
	function convertKey(key) {
	  var key_bin = atob(key);
	  var key_array = new ArrayBuffer(key_bin.length);
	  var key_uint8 = new Uint8Array(key_array);
	  for (var i = 0; i < key_uint8.length; i++) {
	    key_uint8[i] = key_bin.charCodeAt(i);
	  }
	  return toHexString(key_uint8);
	}
	
	function toHexString(uint8arr) {
	  if (!uint8arr) {
	    return '';
	  }
	  var hexStr = '';
	  for (var i = 0; i < uint8arr.length; i++) {
	    var hex = (uint8arr[i] & 0xff).toString(16);
	    hex = hex.length === 1 ? '0' + hex : hex;
	    hexStr += hex;
	  }
	  return hexStr.toUpperCase();
	}
	
	function atob(str) {
	  return new Buffer(str, 'base64').toString('binary');
	}
	
	exports.default = Requester;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ },
/* 41 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*
	    HTTP Hawk Authentication Scheme
	    Copyright (c) 2012-2013, Eran Hammer <eran@hueniverse.com>
	    MIT Licensed
	*/
	// Declare namespace
	
	var hawk = {};
	
	// Export if used as a module
	
	if (typeof module !== "undefined" && module.exports) {
	    module.exports = hawk;
	}
	
	hawk.client = {
	
	    // Generate an Authorization header for a given request
	
	    /*
	        uri: 'http://example.com/resource?a=b'
	        method: HTTP verb (e.g. 'GET', 'POST')
	        options: {
	             // Required
	             credentials: {
	                id: 'dh37fgj492je',
	                key: 'aoijedoaijsdlaksjdl',
	                algorithm: 'sha256'                                 // 'sha1', 'sha256'
	            },
	             // Optional
	             ext: 'application-specific',                        // Application specific data sent via the ext attribute
	            timestamp: Date.now() / 1000,                       // A pre-calculated timestamp in seconds
	            nonce: '2334f34f',                                  // A pre-generated nonce
	            localtimeOffsetMsec: 400,                           // Time offset to sync with server time (ignored if timestamp provided)
	            payload: '{"some":"payload"}',                      // UTF-8 encoded string for body hash generation (ignored if hash provided)
	            contentType: 'application/json',                    // Payload content-type (ignored if hash provided)
	            hash: 'U4MKKSmiVxk37JCCrAVIjV=',                    // Pre-calculated payload hash
	            app: '24s23423f34dx',                               // Oz application id
	            dlg: '234sz34tww3sd'                                // Oz delegated-by application id
	        }
	    */
	
	    header: function header(uri, method, options) {
	
	        var result = {
	            field: '',
	            artifacts: {}
	        };
	
	        // Validate inputs
	
	        if (!uri || typeof uri !== 'string' && (typeof uri === 'undefined' ? 'undefined' : _typeof(uri)) !== 'object' || !method || typeof method !== 'string' || !options || (typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
	
	            result.err = 'Invalid argument type';
	            return result;
	        }
	
	        // Application time
	
	        var timestamp = options.timestamp || Math.floor((hawk.utils.now() + (options.localtimeOffsetMsec || 0)) / 1000);
	
	        // Validate credentials
	
	        var credentials = options.credentials;
	        if (!credentials || !credentials.id || !credentials.key || !credentials.algorithm) {
	
	            result.err = 'Invalid credential object';
	            return result;
	        }
	
	        if (hawk.crypto.algorithms.indexOf(credentials.algorithm) === -1) {
	            result.err = 'Unknown algorithm';
	            return result;
	        }
	
	        // Parse URI
	
	        if (typeof uri === 'string') {
	            uri = hawk.utils.parseUri(uri);
	        }
	
	        // Calculate signature
	
	        var artifacts = {
	            ts: timestamp,
	            nonce: options.nonce || hawk.utils.randomString(6),
	            method: method,
	            resource: uri.relative,
	            host: uri.hostname,
	            port: uri.port,
	            hash: options.hash,
	            ext: options.ext,
	            app: options.app,
	            dlg: options.dlg
	        };
	
	        result.artifacts = artifacts;
	
	        // Calculate payload hash
	
	        if (!artifacts.hash && options.hasOwnProperty('payload')) {
	
	            artifacts.hash = hawk.crypto.calculatePayloadHash(options.payload, credentials.algorithm, options.contentType);
	        }
	
	        var mac = hawk.crypto.calculateMac('header', credentials, artifacts);
	
	        // Construct header
	
	        var hasExt = artifacts.ext !== null && artifacts.ext !== undefined && artifacts.ext !== ''; // Other falsey values allowed
	        var header = 'Hawk id="' + credentials.id + '", ts="' + artifacts.ts + '", nonce="' + artifacts.nonce + (artifacts.hash ? '", hash="' + artifacts.hash : '') + (hasExt ? '", ext="' + hawk.utils.escapeHeaderAttribute(artifacts.ext) : '') + '", mac="' + mac + '"';
	
	        if (artifacts.app) {
	            header += ', app="' + artifacts.app + (artifacts.dlg ? '", dlg="' + artifacts.dlg : '') + '"';
	        }
	
	        result.field = header;
	
	        return result;
	    },
	
	    // Validate server response
	
	    /*
	        request:    object created via 'new XMLHttpRequest()' after response received
	        artifacts:  object recieved from header().artifacts
	        options: {
	            payload:    optional payload received
	            required:   specifies if a Server-Authorization header is required. Defaults to 'false'
	        }
	    */
	
	    authenticate: function authenticate(request, credentials, artifacts, options) {
	
	        options = options || {};
	
	        if (request.getResponseHeader('www-authenticate')) {
	
	            // Parse HTTP WWW-Authenticate header
	
	            var attributes = hawk.utils.parseAuthorizationHeader(request.getResponseHeader('www-authenticate'), ['ts', 'tsm', 'error']);
	            if (!attributes) {
	                return false;
	            }
	
	            if (attributes.ts) {
	                var tsm = hawk.crypto.calculateTsMac(attributes.ts, credentials);
	                if (tsm !== attributes.tsm) {
	                    return false;
	                }
	
	                hawk.utils.setNtpOffset(attributes.ts - Math.floor(new Date().getTime() / 1000)); // Keep offset at 1 second precision
	            }
	        }
	
	        // Parse HTTP Server-Authorization header
	
	        if (!request.getResponseHeader('server-authorization') && !options.required) {
	
	            return true;
	        }
	
	        var attributes = hawk.utils.parseAuthorizationHeader(request.getResponseHeader('server-authorization'), ['mac', 'ext', 'hash']);
	        if (!attributes) {
	            return false;
	        }
	
	        var modArtifacts = {
	            ts: artifacts.ts,
	            nonce: artifacts.nonce,
	            method: artifacts.method,
	            resource: artifacts.resource,
	            host: artifacts.host,
	            port: artifacts.port,
	            hash: attributes.hash,
	            ext: attributes.ext,
	            app: artifacts.app,
	            dlg: artifacts.dlg
	        };
	
	        var mac = hawk.crypto.calculateMac('response', credentials, modArtifacts);
	        if (mac !== attributes.mac) {
	            return false;
	        }
	
	        if (!options.hasOwnProperty('payload')) {
	            return true;
	        }
	
	        if (!attributes.hash) {
	            return false;
	        }
	
	        var calculatedHash = hawk.crypto.calculatePayloadHash(options.payload, credentials.algorithm, request.getResponseHeader('content-type'));
	        return calculatedHash === attributes.hash;
	    },
	
	    message: function message(host, port, _message, options) {
	
	        // Validate inputs
	
	        if (!host || typeof host !== 'string' || !port || typeof port !== 'number' || _message === null || _message === undefined || typeof _message !== 'string' || !options || (typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
	
	            return null;
	        }
	
	        // Application time
	
	        var timestamp = options.timestamp || Math.floor((hawk.utils.now() + (options.localtimeOffsetMsec || 0)) / 1000);
	
	        // Validate credentials
	
	        var credentials = options.credentials;
	        if (!credentials || !credentials.id || !credentials.key || !credentials.algorithm) {
	
	            // Invalid credential object
	            return null;
	        }
	
	        if (hawk.crypto.algorithms.indexOf(credentials.algorithm) === -1) {
	            return null;
	        }
	
	        // Calculate signature
	
	        var artifacts = {
	            ts: timestamp,
	            nonce: options.nonce || hawk.utils.randomString(6),
	            host: host,
	            port: port,
	            hash: hawk.crypto.calculatePayloadHash(_message, credentials.algorithm)
	        };
	
	        // Construct authorization
	
	        var result = {
	            id: credentials.id,
	            ts: artifacts.ts,
	            nonce: artifacts.nonce,
	            hash: artifacts.hash,
	            mac: hawk.crypto.calculateMac('message', credentials, artifacts)
	        };
	
	        return result;
	    },
	
	    authenticateTimestamp: function authenticateTimestamp(message, credentials, updateClock) {
	        // updateClock defaults to true
	
	        var tsm = hawk.crypto.calculateTsMac(message.ts, credentials);
	        if (tsm !== message.tsm) {
	            return false;
	        }
	
	        if (updateClock !== false) {
	            hawk.utils.setNtpOffset(message.ts - Math.floor(new Date().getTime() / 1000)); // Keep offset at 1 second precision
	        }
	
	        return true;
	    }
	};
	
	hawk.crypto = {
	
	    headerVersion: '1',
	
	    algorithms: ['sha1', 'sha256'],
	
	    calculateMac: function calculateMac(type, credentials, options) {
	
	        var normalized = hawk.crypto.generateNormalizedString(type, options);
	        var key = CryptoJS.enc.Hex.parse(credentials.key);
	
	        var hmac = CryptoJS['Hmac' + credentials.algorithm.toUpperCase()](normalized, key);
	        return hmac.toString(CryptoJS.enc.Base64);
	    },
	
	    generateNormalizedString: function generateNormalizedString(type, options) {
	
	        var normalized = 'hawk.' + hawk.crypto.headerVersion + '.' + type + '\n' + options.ts + '\n' + options.nonce + '\n' + (options.method || '').toUpperCase() + '\n' + (options.resource || '') + '\n' + options.host.toLowerCase() + '\n' + options.port + '\n' + (options.hash || '') + '\n';
	
	        if (options.ext) {
	            normalized += options.ext.replace('\\', '\\\\').replace('\n', '\\n');
	        }
	
	        normalized += '\n';
	
	        if (options.app) {
	            normalized += options.app + '\n' + (options.dlg || '') + '\n';
	        }
	
	        return normalized;
	    },
	
	    calculatePayloadHash: function calculatePayloadHash(payload, algorithm, contentType) {
	
	        var hash = CryptoJS.algo[algorithm.toUpperCase()].create();
	        hash.update('hawk.' + hawk.crypto.headerVersion + '.payload\n');
	        hash.update(hawk.utils.parseContentType(contentType) + '\n');
	        hash.update(payload || '');
	        hash.update('\n');
	        return hash.finalize().toString(CryptoJS.enc.Base64);
	    },
	
	    calculateTsMac: function calculateTsMac(ts, credentials) {
	
	        var hash = CryptoJS['Hmac' + credentials.algorithm.toUpperCase()]('hawk.' + hawk.crypto.headerVersion + '.ts\n' + ts + '\n', credentials.key);
	        return hash.toString(CryptoJS.enc.Base64);
	    }
	};
	
	hawk.utils = {
	
	    storage: { // localStorage compatible interface
	        _cache: {},
	        setItem: function setItem(key, value) {
	
	            hawk.utils.storage._cache[key] = value;
	        },
	        getItem: function getItem(key) {
	
	            return hawk.utils.storage._cache[key];
	        }
	    },
	
	    setStorage: function setStorage(storage) {
	
	        var ntpOffset = hawk.utils.getNtpOffset() || 0;
	        hawk.utils.storage = storage;
	        hawk.utils.setNtpOffset(ntpOffset);
	    },
	
	    setNtpOffset: function setNtpOffset(offset) {
	
	        try {
	            hawk.utils.storage.setItem('hawk_ntp_offset', offset);
	        } catch (err) {
	            console.error('[hawk] could not write to storage.');
	            console.error(err);
	        }
	    },
	
	    getNtpOffset: function getNtpOffset() {
	
	        return parseInt(hawk.utils.storage.getItem('hawk_ntp_offset') || '0', 10);
	    },
	
	    now: function now() {
	
	        return new Date().getTime() + hawk.utils.getNtpOffset();
	    },
	
	    escapeHeaderAttribute: function escapeHeaderAttribute(attribute) {
	
	        return attribute.replace(/\\/g, '\\\\').replace(/\"/g, '\\"');
	    },
	
	    parseContentType: function parseContentType(header) {
	
	        if (!header) {
	            return '';
	        }
	
	        return header.split(';')[0].replace(/^\s+|\s+$/g, '').toLowerCase();
	    },
	
	    parseAuthorizationHeader: function parseAuthorizationHeader(header, keys) {
	
	        if (!header) {
	            return null;
	        }
	
	        var headerParts = header.match(/^(\w+)(?:\s+(.*))?$/); // Header: scheme[ something]
	        if (!headerParts) {
	            return null;
	        }
	
	        var scheme = headerParts[1];
	        if (scheme.toLowerCase() !== 'hawk') {
	            return null;
	        }
	
	        var attributesString = headerParts[2];
	        if (!attributesString) {
	            return null;
	        }
	
	        var attributes = {};
	        var verify = attributesString.replace(/(\w+)="([^"\\]*)"\s*(?:,\s*|$)/g, function ($0, $1, $2) {
	
	            // Check valid attribute names
	
	            if (keys.indexOf($1) === -1) {
	                return;
	            }
	
	            // Allowed attribute value characters: !#$%&'()*+,-./:;<=>?@[]^_`{|}~ and space, a-z, A-Z, 0-9
	
	            if ($2.match(/^[ \w\!#\$%&'\(\)\*\+,\-\.\/\:;<\=>\?@\[\]\^`\{\|\}~]+$/) === null) {
	                return;
	            }
	
	            // Check for duplicates
	
	            if (attributes.hasOwnProperty($1)) {
	                return;
	            }
	
	            attributes[$1] = $2;
	            return '';
	        });
	
	        if (verify !== '') {
	            return null;
	        }
	
	        return attributes;
	    },
	
	    randomString: function randomString(size) {
	
	        var randomSource = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
	        var len = randomSource.length;
	
	        var result = [];
	        for (var i = 0; i < size; ++i) {
	            result[i] = randomSource[Math.floor(Math.random() * len)];
	        }
	
	        return result.join('');
	    },
	
	    parseUri: function parseUri(input) {
	
	        // Based on: parseURI 1.2.2
	        // http://blog.stevenlevithan.com/archives/parseuri
	        // (c) Steven Levithan <stevenlevithan.com>
	        // MIT License
	
	        var keys = ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'hostname', 'port', 'resource', 'relative', 'pathname', 'directory', 'file', 'query', 'fragment'];
	
	        var uriRegex = /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?(((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?)(?:#(.*))?)/;
	        var uriByNumber = uriRegex.exec(input);
	        var uri = {};
	
	        var i = 15;
	        while (i--) {
	            uri[keys[i]] = uriByNumber[i] || '';
	        }
	
	        if (uri.port === null || uri.port === '') {
	
	            uri.port = uri.protocol.toLowerCase() === 'http' ? '80' : uri.protocol.toLowerCase() === 'https' ? '443' : '';
	        }
	
	        return uri;
	    }
	};
	
	// Based on: Crypto-JS v3.1.2
	// Copyright (c) 2009-2013, Jeff Mott. All rights reserved.
	// http://code.google.com/p/crypto-js/
	// http://code.google.com/p/crypto-js/wiki/License
	
	var CryptoJS = CryptoJS || function (h, r) {
	    var k = {},
	        l = k.lib = {},
	        n = function n() {},
	        f = l.Base = { extend: function extend(a) {
	            n.prototype = this;var b = new n();a && b.mixIn(a);b.hasOwnProperty("init") || (b.init = function () {
	                b.$super.init.apply(this, arguments);
	            });b.init.prototype = b;b.$super = this;return b;
	        }, create: function create() {
	            var a = this.extend();a.init.apply(a, arguments);return a;
	        }, init: function init() {}, mixIn: function mixIn(a) {
	            for (var b in a) {
	                a.hasOwnProperty(b) && (this[b] = a[b]);
	            }a.hasOwnProperty("toString") && (this.toString = a.toString);
	        }, clone: function clone() {
	            return this.init.prototype.extend(this);
	        } },
	        j = l.WordArray = f.extend({ init: function init(a, b) {
	            a = this.words = a || [];this.sigBytes = b != r ? b : 4 * a.length;
	        }, toString: function toString(a) {
	            return (a || s).stringify(this);
	        }, concat: function concat(a) {
	            var b = this.words,
	                d = a.words,
	                c = this.sigBytes;a = a.sigBytes;this.clamp();if (c % 4) for (var e = 0; e < a; e++) {
	                b[c + e >>> 2] |= (d[e >>> 2] >>> 24 - 8 * (e % 4) & 255) << 24 - 8 * ((c + e) % 4);
	            } else if (65535 < d.length) for (e = 0; e < a; e += 4) {
	                b[c + e >>> 2] = d[e >>> 2];
	            } else b.push.apply(b, d);this.sigBytes += a;return this;
	        }, clamp: function clamp() {
	            var a = this.words,
	                b = this.sigBytes;a[b >>> 2] &= 4294967295 << 32 - 8 * (b % 4);a.length = h.ceil(b / 4);
	        }, clone: function clone() {
	            var a = f.clone.call(this);a.words = this.words.slice(0);return a;
	        }, random: function random(a) {
	            for (var b = [], d = 0; d < a; d += 4) {
	                b.push(4294967296 * h.random() | 0);
	            }return new j.init(b, a);
	        } }),
	        m = k.enc = {},
	        s = m.Hex = { stringify: function stringify(a) {
	            var b = a.words;a = a.sigBytes;for (var d = [], c = 0; c < a; c++) {
	                var e = b[c >>> 2] >>> 24 - 8 * (c % 4) & 255;d.push((e >>> 4).toString(16));d.push((e & 15).toString(16));
	            }return d.join("");
	        }, parse: function parse(a) {
	            for (var b = a.length, d = [], c = 0; c < b; c += 2) {
	                d[c >>> 3] |= parseInt(a.substr(c, 2), 16) << 24 - 4 * (c % 8);
	            }return new j.init(d, b / 2);
	        } },
	        p = m.Latin1 = { stringify: function stringify(a) {
	            var b = a.words;a = a.sigBytes;for (var d = [], c = 0; c < a; c++) {
	                d.push(String.fromCharCode(b[c >>> 2] >>> 24 - 8 * (c % 4) & 255));
	            }return d.join("");
	        }, parse: function parse(a) {
	            for (var b = a.length, d = [], c = 0; c < b; c++) {
	                d[c >>> 2] |= (a.charCodeAt(c) & 255) << 24 - 8 * (c % 4);
	            }return new j.init(d, b);
	        } },
	        t = m.Utf8 = { stringify: function stringify(a) {
	            try {
	                return decodeURIComponent(escape(p.stringify(a)));
	            } catch (b) {
	                throw Error("Malformed UTF-8 data");
	            }
	        }, parse: function parse(a) {
	            return p.parse(unescape(encodeURIComponent(a)));
	        } },
	        q = l.BufferedBlockAlgorithm = f.extend({ reset: function reset() {
	            this._data = new j.init();this._nDataBytes = 0;
	        }, _append: function _append(a) {
	            "string" == typeof a && (a = t.parse(a));this._data.concat(a);this._nDataBytes += a.sigBytes;
	        }, _process: function _process(a) {
	            var b = this._data,
	                d = b.words,
	                c = b.sigBytes,
	                e = this.blockSize,
	                f = c / (4 * e),
	                f = a ? h.ceil(f) : h.max((f | 0) - this._minBufferSize, 0);a = f * e;c = h.min(4 * a, c);if (a) {
	                for (var g = 0; g < a; g += e) {
	                    this._doProcessBlock(d, g);
	                }g = d.splice(0, a);b.sigBytes -= c;
	            }return new j.init(g, c);
	        }, clone: function clone() {
	            var a = f.clone.call(this);a._data = this._data.clone();return a;
	        }, _minBufferSize: 0 });l.Hasher = q.extend({ cfg: f.extend(), init: function init(a) {
	            this.cfg = this.cfg.extend(a);this.reset();
	        }, reset: function reset() {
	            q.reset.call(this);this._doReset();
	        }, update: function update(a) {
	            this._append(a);this._process();return this;
	        }, finalize: function finalize(a) {
	            a && this._append(a);return this._doFinalize();
	        }, blockSize: 16, _createHelper: function _createHelper(a) {
	            return function (b, d) {
	                return new a.init(d).finalize(b);
	            };
	        }, _createHmacHelper: function _createHmacHelper(a) {
	            return function (b, d) {
	                return new u.HMAC.init(a, d).finalize(b);
	            };
	        } });var u = k.algo = {};return k;
	}(Math);
	(function () {
	    var k = CryptoJS,
	        b = k.lib,
	        m = b.WordArray,
	        l = b.Hasher,
	        d = [],
	        b = k.algo.SHA1 = l.extend({ _doReset: function _doReset() {
	            this._hash = new m.init([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
	        }, _doProcessBlock: function _doProcessBlock(n, p) {
	            for (var a = this._hash.words, e = a[0], f = a[1], h = a[2], j = a[3], b = a[4], c = 0; 80 > c; c++) {
	                if (16 > c) d[c] = n[p + c] | 0;else {
	                    var g = d[c - 3] ^ d[c - 8] ^ d[c - 14] ^ d[c - 16];d[c] = g << 1 | g >>> 31;
	                }g = (e << 5 | e >>> 27) + b + d[c];g = 20 > c ? g + ((f & h | ~f & j) + 1518500249) : 40 > c ? g + ((f ^ h ^ j) + 1859775393) : 60 > c ? g + ((f & h | f & j | h & j) - 1894007588) : g + ((f ^ h ^ j) - 899497514);b = j;j = h;h = f << 30 | f >>> 2;f = e;e = g;
	            }a[0] = a[0] + e | 0;a[1] = a[1] + f | 0;a[2] = a[2] + h | 0;a[3] = a[3] + j | 0;a[4] = a[4] + b | 0;
	        }, _doFinalize: function _doFinalize() {
	            var b = this._data,
	                d = b.words,
	                a = 8 * this._nDataBytes,
	                e = 8 * b.sigBytes;d[e >>> 5] |= 128 << 24 - e % 32;d[(e + 64 >>> 9 << 4) + 14] = Math.floor(a / 4294967296);d[(e + 64 >>> 9 << 4) + 15] = a;b.sigBytes = 4 * d.length;this._process();return this._hash;
	        }, clone: function clone() {
	            var b = l.clone.call(this);b._hash = this._hash.clone();return b;
	        } });k.SHA1 = l._createHelper(b);k.HmacSHA1 = l._createHmacHelper(b);
	})();
	(function (k) {
	    for (var g = CryptoJS, h = g.lib, v = h.WordArray, j = h.Hasher, h = g.algo, s = [], t = [], u = function u(q) {
	        return 4294967296 * (q - (q | 0)) | 0;
	    }, l = 2, b = 0; 64 > b;) {
	        var d;a: {
	            d = l;for (var w = k.sqrt(d), r = 2; r <= w; r++) {
	                if (!(d % r)) {
	                    d = !1;break a;
	                }
	            }d = !0;
	        }d && (8 > b && (s[b] = u(k.pow(l, 0.5))), t[b] = u(k.pow(l, 1 / 3)), b++);l++;
	    }var n = [],
	        h = h.SHA256 = j.extend({ _doReset: function _doReset() {
	            this._hash = new v.init(s.slice(0));
	        }, _doProcessBlock: function _doProcessBlock(q, h) {
	            for (var a = this._hash.words, c = a[0], d = a[1], b = a[2], k = a[3], f = a[4], g = a[5], j = a[6], l = a[7], e = 0; 64 > e; e++) {
	                if (16 > e) n[e] = q[h + e] | 0;else {
	                    var m = n[e - 15],
	                        p = n[e - 2];n[e] = ((m << 25 | m >>> 7) ^ (m << 14 | m >>> 18) ^ m >>> 3) + n[e - 7] + ((p << 15 | p >>> 17) ^ (p << 13 | p >>> 19) ^ p >>> 10) + n[e - 16];
	                }m = l + ((f << 26 | f >>> 6) ^ (f << 21 | f >>> 11) ^ (f << 7 | f >>> 25)) + (f & g ^ ~f & j) + t[e] + n[e];p = ((c << 30 | c >>> 2) ^ (c << 19 | c >>> 13) ^ (c << 10 | c >>> 22)) + (c & d ^ c & b ^ d & b);l = j;j = g;g = f;f = k + m | 0;k = b;b = d;d = c;c = m + p | 0;
	            }a[0] = a[0] + c | 0;a[1] = a[1] + d | 0;a[2] = a[2] + b | 0;a[3] = a[3] + k | 0;a[4] = a[4] + f | 0;a[5] = a[5] + g | 0;a[6] = a[6] + j | 0;a[7] = a[7] + l | 0;
	        }, _doFinalize: function _doFinalize() {
	            var d = this._data,
	                b = d.words,
	                a = 8 * this._nDataBytes,
	                c = 8 * d.sigBytes;b[c >>> 5] |= 128 << 24 - c % 32;b[(c + 64 >>> 9 << 4) + 14] = k.floor(a / 4294967296);b[(c + 64 >>> 9 << 4) + 15] = a;d.sigBytes = 4 * b.length;this._process();return this._hash;
	        }, clone: function clone() {
	            var b = j.clone.call(this);b._hash = this._hash.clone();return b;
	        } });g.SHA256 = j._createHelper(h);g.HmacSHA256 = j._createHmacHelper(h);
	})(Math);
	(function () {
	    var c = CryptoJS,
	        k = c.enc.Utf8;c.algo.HMAC = c.lib.Base.extend({ init: function init(a, b) {
	            a = this._hasher = new a.init();"string" == typeof b && (b = k.parse(b));var c = a.blockSize,
	                e = 4 * c;b.sigBytes > e && (b = a.finalize(b));b.clamp();for (var f = this._oKey = b.clone(), g = this._iKey = b.clone(), h = f.words, j = g.words, d = 0; d < c; d++) {
	                h[d] ^= 1549556828, j[d] ^= 909522486;
	            }f.sigBytes = g.sigBytes = e;this.reset();
	        }, reset: function reset() {
	            var a = this._hasher;a.reset();a.update(this._iKey);
	        }, update: function update(a) {
	            this._hasher.update(a);return this;
	        }, finalize: function finalize(a) {
	            var b = this._hasher;a = b.finalize(a);b.reset();return b.finalize(this._oKey.clone().concat(a));
	        } });
	})();
	(function () {
	    var h = CryptoJS,
	        j = h.lib.WordArray;h.enc.Base64 = { stringify: function stringify(b) {
	            var e = b.words,
	                f = b.sigBytes,
	                c = this._map;b.clamp();b = [];for (var a = 0; a < f; a += 3) {
	                for (var d = (e[a >>> 2] >>> 24 - 8 * (a % 4) & 255) << 16 | (e[a + 1 >>> 2] >>> 24 - 8 * ((a + 1) % 4) & 255) << 8 | e[a + 2 >>> 2] >>> 24 - 8 * ((a + 2) % 4) & 255, g = 0; 4 > g && a + 0.75 * g < f; g++) {
	                    b.push(c.charAt(d >>> 6 * (3 - g) & 63));
	                }
	            }if (e = c.charAt(64)) for (; b.length % 4;) {
	                b.push(e);
	            }return b.join("");
	        }, parse: function parse(b) {
	            var e = b.length,
	                f = this._map,
	                c = f.charAt(64);c && (c = b.indexOf(c), -1 != c && (e = c));for (var c = [], a = 0, d = 0; d < e; d++) {
	                if (d % 4) {
	                    var g = f.indexOf(b.charAt(d - 1)) << 2 * (d % 4),
	                        h = f.indexOf(b.charAt(d)) >>> 6 - 2 * (d % 4);c[a >>> 2] |= (g | h) << 24 - 8 * (a % 4);a++;
	                }
	            }return j.create(c, a);
	        }, _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=" };
	})();

/***/ },
/* 42 */
/***/ function(module, exports) {

	"use strict";
	
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m;
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = -7;
	  var i = isLE ? nBytes - 1 : 0;
	  var d = isLE ? -1 : 1;
	  var s = buffer[offset + i];
	
	  i += d;
	
	  e = s & (1 << -nBits) - 1;
	  s >>= -nBits;
	  nBits += eLen;
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : (s ? -1 : 1) * Infinity;
	  } else {
	    m = m + Math.pow(2, mLen);
	    e = e - eBias;
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
	};
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c;
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
	  var i = isLE ? 0 : nBytes - 1;
	  var d = isLE ? 1 : -1;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	
	  value = Math.abs(value);
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0;
	    e = eMax;
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2);
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * Math.pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
	      e = 0;
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128;
	};

/***/ },
/* 43 */
/***/ function(module, exports) {

	'use strict';
	
	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lib = __webpack_require__(17);
	
	var _lib2 = _interopRequireDefault(_lib);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var KaistoreAppListHelper = function () {
	  function KaistoreAppListHelper(_ref) {
	    var deviceInfos = _ref.deviceInfos,
	        simInfo = _ref.simInfo,
	        _ref$IMEI = _ref.IMEI,
	        IMEI = _ref$IMEI === undefined ? '0123456789' : _ref$IMEI,
	        serverTimeOffset = _ref.serverTimeOffset,
	        _ref$useCustomConnect = _ref.useCustomConnectionType,
	        useCustomConnectionType = _ref$useCustomConnect === undefined ? false : _ref$useCustomConnect;
	
	    _classCallCheck(this, KaistoreAppListHelper);
	
	    this._deviceIMEI = IMEI;
	    this._deviceInfos = deviceInfos;
	    this._simInfo = simInfo;
	    this._requester = _lib2.default.getRequester({
	      serverTimeOffset: serverTimeOffset,
	      deviceInfos: deviceInfos,
	      useCustomConnectionType: useCustomConnectionType
	    });
	    this._apiName = 'apps';
	    this._apiURI = deviceInfos.get('apps.serviceCenterUrl');
	  }
	
	  // [name] => server:update or server:error
	
	
	  _createClass(KaistoreAppListHelper, [{
	    key: '_emit',
	    value: function _emit(name, details) {
	      var msg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	      var event = new CustomEvent(name, {
	        detail: details
	      });
	      window.dispatchEvent(event);
	
	      if (name === 'server:error') {
	        console.error(msg);
	      }
	    }
	
	    // Only support in v3.0.
	    // apiURI should be "https://example.com" or "https://example.com/v3.0"
	
	  }, {
	    key: '_isBookmarkSupported',
	    value: function _isBookmarkSupported() {
	      var URIArray = this._apiURI.split('/');
	      var apiVersion = URIArray[3];
	
	      if (apiVersion && apiVersion.indexOf('v3.0') >= 0) {
	        return true;
	      }
	      return false;
	    }
	
	    // Obtain the params for fetch app list.
	
	  }, {
	    key: '_getAppListParams',
	    value: function _getAppListParams() {
	      var bookmarkSupported = this._isBookmarkSupported();
	      var defaultServiceId = this._deviceInfos.get('ril.data.defaultServiceId');
	      var params = {
	        bookmark: bookmarkSupported,
	        defaultServiceId: defaultServiceId,
	        imei: this._deviceIMEI
	      };
	      var deviceParams = {};
	
	      this._deviceInfos.forEach(function (value, key) {
	        if (key.indexOf('deviceinfo') >= 0) {
	          var keyInfo = key.split('.');
	          var valueWithoutSpace = value.replace(/ /g, '_');
	
	          deviceParams[keyInfo[keyInfo.length - 1]] = valueWithoutSpace;
	        }
	      });
	
	      return Object.assign(params, this._simInfo, deviceParams);
	    }
	  }, {
	    key: '_hasPaidApp',
	    value: function _hasPaidApp(appAry) {
	      return appAry.some(function (app) {
	        return app.paid === true;
	      });
	    }
	  }, {
	    key: 'fetch',
	    value: function fetch() {
	      var _this = this;
	
	      return new Promise(function (resolve, reject) {
	        var params = _this._getAppListParams();
	
	        _this._requester.send({
	          url: _lib2.default.generateURL({
	            apiName: _this._apiName,
	            deviceInfos: _this._deviceInfos,
	            params: params
	          }),
	          method: 'GET'
	        }).then(function (result) {
	          resolve(JSON.parse(result));
	        }, function (error) {
	          reject(error);
	        });
	      });
	    }
	  }, {
	    key: 'fetchAppList',
	    value: function fetchAppList() {
	      var _this2 = this;
	
	      var isPaymentAvailable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      return new Promise(function (resolve, reject) {
	        _this2.fetch().then(function (result) {
	          var apps = result.apps;
	          if (apps.length === 0) {
	            reject({ errorMsgId: 'no-app-available' });
	            return;
	          }
	          var hasPaidApp = _this2._hasPaidApp(apps);
	          if (hasPaidApp && isPaymentAvailable === false) {
	            result.apps = apps.filter(function (app) {
	              return app.installed === true || app.paid === false;
	            });
	          }
	          result.hasPaidApp = hasPaidApp;
	          resolve(result);
	        }).catch(function (error) {
	          console.error('error in fetchAppList', error);
	          reject({ errorMsgId: 'connection-error' });
	        });
	      });
	    }
	  }]);
	
	  return KaistoreAppListHelper;
	}();
	
	exports.default = KaistoreAppListHelper;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lib = __webpack_require__(17);
	
	var _lib2 = _interopRequireDefault(_lib);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	 * ?cu=40440-2AAQUS0
	 *  &imei=123123123123123
	 *  &simMCC=null&simMNC=null&currentMCC=null&currentMNC=null
	 *
	 */
	var KaiStoreCategoriesHelper = function () {
	  function KaiStoreCategoriesHelper() {
	    _classCallCheck(this, KaiStoreCategoriesHelper);
	
	    this.apiName = 'categories';
	  }
	
	  _createClass(KaiStoreCategoriesHelper, [{
	    key: 'init',
	    value: function init(_ref) {
	      var deviceInfo = _ref.deviceInfo,
	          imei = _ref.imei,
	          commsInfo = _ref.commsInfo,
	          serverTimeOffset = _ref.serverTimeOffset,
	          _ref$useCustomConnect = _ref.useCustomConnectionType,
	          useCustomConnectionType = _ref$useCustomConnect === undefined ? false : _ref$useCustomConnect;
	
	      this.deviceInfo = deviceInfo;
	      this.imei = imei;
	      this.commsInfo = commsInfo;
	      this.serverTimeOffset = serverTimeOffset;
	      this.useCustomConnectionType = useCustomConnectionType;
	    }
	  }, {
	    key: '_getDeviceInfo',
	    value: function _getDeviceInfo(InfoList) {
	      var _this = this;
	
	      return InfoList.map(function (key) {
	        var deviceInfo = _this.deviceInfo.get(key);
	
	        if (!_this.deviceInfo.has(key)) {
	          console.error('ArgumentError: Expected deviceInfo Map to have keys [' + key + ']');
	        }
	
	        return deviceInfo;
	      });
	    }
	  }, {
	    key: 'getCategories',
	    value: function getCategories() {
	      var _this2 = this;
	
	      var _getDeviceInfo2 = this._getDeviceInfo(['deviceinfo.cu', 'ril.data.defaultServiceId']),
	          _getDeviceInfo3 = _slicedToArray(_getDeviceInfo2, 2),
	          cu = _getDeviceInfo3[0],
	          defaultServiceId = _getDeviceInfo3[1];
	
	      var params = Object.assign({}, {
	        cu: cu,
	        defaultServiceId: defaultServiceId,
	        imei: this.imei
	      }, this.commsInfo);
	
	      return new Promise(function (resolve, reject) {
	        var requester = _lib2.default.getRequester({
	          serverTimeOffset: _this2.serverTimeOffset,
	          deviceInfos: _this2.deviceInfo,
	          useCustomConnectionType: _this2.useCustomConnectionType
	        });
	
	        requester.send({
	          url: _lib2.default.generateURL({
	            apiName: _this2.apiName,
	            params: params,
	            deviceInfos: _this2.deviceInfo
	          }),
	          method: 'GET'
	        }).then(function (response) {
	          resolve(JSON.parse(response));
	        }, function (error) {
	          console.error('categories:' + error.statusText);
	          // pass empty array.
	          resolve([]);
	        });
	      });
	    }
	  }]);
	
	  return KaiStoreCategoriesHelper;
	}();
	
	exports.default = KaiStoreCategoriesHelper = new KaiStoreCategoriesHelper();

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _commandList = __webpack_require__(7);
	
	Object.defineProperty(exports, 'commandList', {
	  enumerable: true,
	  get: function get() {
	    return _commandList.commandList;
	  }
	});

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Token = undefined;
	
	var _objectmodel = __webpack_require__(8);
	
	var _constants = __webpack_require__(2);
	
	var Token = new _objectmodel.ObjectModel({
	  kid: String,
	  macKey: String,
	  type: Object.values(_constants.tokenType)
	}).defaultTo({
	  type: _constants.tokenType.RESTRICTED
	});
	
	exports.Token = Token;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DeviceInfo = undefined;
	
	var _objectmodel = __webpack_require__(8);
	
	var DeviceInfo = new _objectmodel.ObjectModel({
	  bookmarkSupported: Boolean,
	  connection: {
	    defaultServiceId: Number,
	    imei: String,
	    simMCC: [String, undefined, null],
	    simMNC: [String, undefined, null],
	    currentMCC: [String, undefined, null],
	    currentMNC: [String, undefined, null],
	    simMCC2: [String, undefined, null],
	    simMNC2: [String, undefined, null],
	    currentMCC2: [String, undefined, null],
	    currentMNC2: [String, undefined, null],
	    type: [String, undefined, null]
	  },
	  settings: {
	    'deviceinfo.hardware': String,
	    'deviceinfo.os': String,
	    'deviceinfo.product_model': String,
	    'deviceinfo.software': String,
	    'deviceinfo.cu': String,
	    'deviceinfo.platform_build_id': String,
	    'deviceinfo.build_number': String,
	    'deviceinfo.platform_version': String,
	    'apps.serviceCenterUrl': String,
	    'apps.serviceCenter.settingsEnabled': Boolean,
	    'store.banner.enable': Boolean
	  }
	}).defaultTo({
	  bookmarkSupported: false,
	  settings: {
	    'deviceinfo.hardware': 'unknown',
	    'deviceinfo.os': 'unknown',
	    'deviceinfo.product_model': 'unknown',
	    'deviceinfo.software': 'unknown',
	    'deviceinfo.cu': '4044O-2BAQUS1-R',
	    'deviceinfo.platform_build_id': '',
	    'deviceinfo.build_number': '',
	    'deviceinfo.platform_version': '',
	    'apps.serviceCenterUrl': 'https://api.kaiostech.com/v3.0',
	    'apps.serviceCenter.settingsEnabled': false,
	    'ril.data.defaultServiceId': '',
	    'store.banner.enable': false
	  }
	});
	
	exports.DeviceInfo = DeviceInfo;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CheckAppUpdateCommand = exports.MozAppUpdateCommand = exports.UpdateAppCommand = exports.LaunchAppCommand = exports.CancelDownloadCommand = exports.UninstallCommand = exports.InstallCommand = undefined;
	
	var _Command = __webpack_require__(11);
	
	var _utils = __webpack_require__(10);
	
	var _commandList = __webpack_require__(7);
	
	var _App = __webpack_require__(20);
	
	var _constants = __webpack_require__(2);
	
	var InstallCommand = _Command.Command.extend({
	  detail: {
	    isHosted: Boolean,
	    manifestURL: String,
	    jwt: [String]
	  }
	}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.INSTALL_APP
	}));
	
	var UninstallCommand = _Command.Command.extend({
	  detail: {
	    manifestURL: String
	  }
	}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.UNINSTALL_APP
	}));
	
	var CancelDownloadCommand = _Command.Command.extend({
	  detail: {
	    manifestURL: String
	  }
	}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.CANCEL_DOWNLOAD
	}));
	
	var LaunchAppCommand = _Command.Command.extend({
	  detail: {
	    manifestURL: String
	  }
	}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.LAUNCH_APP
	}));
	
	var UpdateAppCommand = _Command.Command.extend({
	  detail: {
	    manifestURL: String
	  }
	}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.UPDATE_APP
	}));
	
	var CheckAppUpdateCommand = _Command.Command.extend({
	  detail: {
	    manifestURL: String
	  }
	}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.CHECK_APP_UPDATE
	}));
	
	var MozAppUpdateCommand = _Command.Command.extend({
	  detail: {
	    manifestURL: String,
	    mozAppsEvent: Object.values(_constants.mozAppsEvents),
	    mozAppEvent: [String],
	    mozApp: _App.MozApp
	  }
	}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.MOZAPP_UPDATE
	}));
	
	exports.InstallCommand = InstallCommand;
	exports.UninstallCommand = UninstallCommand;
	exports.CancelDownloadCommand = CancelDownloadCommand;
	exports.LaunchAppCommand = LaunchAppCommand;
	exports.UpdateAppCommand = UpdateAppCommand;
	exports.MozAppUpdateCommand = MozAppUpdateCommand;
	exports.CheckAppUpdateCommand = CheckAppUpdateCommand;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GetAccountVersionCommand = exports.OpenAccountCommand = exports.AccountEventCommand = undefined;
	
	var _Command = __webpack_require__(11);
	
	var _utils = __webpack_require__(10);
	
	var _commandList = __webpack_require__(7);
	
	var _constants = __webpack_require__(2);
	
	var AccountEventCommand = _Command.Command.extend({
	  detail: {
	    event: Object.values(_constants.accountEvent),
	    data: [Object]
	  }
	}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.ACCOUNT_EVENT
	}));
	
	var OpenAccountCommand = _Command.Command.extend({
	  detail: {
	    section: String
	  }
	}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.OPEN_ACCOUNT
	}));
	
	var GetAccountVersionCommand = _Command.Command.extend({}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.GET_ACCOUNT_VERSION
	}));
	
	exports.AccountEventCommand = AccountEventCommand;
	exports.OpenAccountCommand = OpenAccountCommand;
	exports.GetAccountVersionCommand = GetAccountVersionCommand;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BookmarkUpdateCommand = exports.RequestBookmarksCommand = exports.UnPINBookmarkCommand = exports.PINBookmarkCommand = undefined;
	
	var _Command = __webpack_require__(11);
	
	var _utils = __webpack_require__(10);
	
	var _commandList = __webpack_require__(7);
	
	var _App = __webpack_require__(20);
	
	var RequestBookmarksCommand = _Command.Command.extend({}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.REQUEST_BOOKMARKS
	}));
	
	var PINBookmarkCommand = _Command.Command.extend({
	  detail: _App.Bookmark
	}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.PIN_BOOKMARK
	}));
	
	var UnPINBookmarkCommand = _Command.Command.extend({
	  detail: {
	    url: String
	  }
	}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.UNPIN_BOOKMARK
	}));
	
	var BookmarkUpdateCommand = _Command.Command.extend({
	  detail: {
	    url: String,
	    pin: Boolean
	  }
	}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.BOOKMARK_UPDATE
	}));
	
	exports.PINBookmarkCommand = PINBookmarkCommand;
	exports.UnPINBookmarkCommand = UnPINBookmarkCommand;
	exports.RequestBookmarksCommand = RequestBookmarksCommand;
	exports.BookmarkUpdateCommand = BookmarkUpdateCommand;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CheckRebootCommand = exports.RequestReloadCommand = exports.UpdateSettingCommand = exports.RequestSettingCommand = exports.RequestInstalledAppsCommand = exports.RequestTokenCommand = exports.RequestExitCommand = exports.RequestDeviceInfoCommand = undefined;
	
	var _Command = __webpack_require__(11);
	
	var _utils = __webpack_require__(10);
	
	var _commandList = __webpack_require__(7);
	
	var _constants = __webpack_require__(2);
	
	var _Setting = __webpack_require__(26);
	
	var RequestDeviceInfoCommand = _Command.Command.extend({}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.REQUEST_DEVICE_INFO
	}));
	
	var RequestExitCommand = _Command.Command.extend({}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.REQUEST_EXIT
	}));
	
	var RequestTokenCommand = _Command.Command.extend({}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.REQUEST_TOKEN
	}));
	
	var RequestInstalledAppsCommand = _Command.Command.extend({}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.REQUEST_INSTALLED_APPS
	}));
	
	var RequestSettingCommand = _Command.Command.extend({
	  detail: {
	    key: String
	  }
	}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.REQUEST_SETTING
	}));
	
	var UpdateSettingCommand = _Command.Command.extend({
	  detail: _Setting.Setting
	}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.UPDATE_SETTING
	}));
	
	var RequestReloadCommand = _Command.Command.extend({}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.REQUEST_RELOAD
	}));
	
	var CheckRebootCommand = _Command.Command.extend({}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.CHECK_REBOOT
	}));
	
	exports.RequestDeviceInfoCommand = RequestDeviceInfoCommand;
	exports.RequestExitCommand = RequestExitCommand;
	exports.RequestTokenCommand = RequestTokenCommand;
	exports.RequestInstalledAppsCommand = RequestInstalledAppsCommand;
	exports.RequestSettingCommand = RequestSettingCommand;
	exports.UpdateSettingCommand = UpdateSettingCommand;
	exports.RequestReloadCommand = RequestReloadCommand;
	exports.CheckRebootCommand = CheckRebootCommand;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RequestPaymentCommand = exports.RequestPaymentProfileCommand = undefined;
	
	var _Command = __webpack_require__(11);
	
	var _utils = __webpack_require__(10);
	
	var _commandList = __webpack_require__(7);
	
	var _Payment = __webpack_require__(25);
	
	var RequestPaymentProfileCommand = _Command.Command.extend({}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.REQUEST_PAYMENT_PROFILE
	}));
	
	var RequestPaymentCommand = _Command.Command.extend({
	  detail: _Payment.PaymentDetail
	}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.REQUEST_PAYMENT
	}));
	
	exports.RequestPaymentProfileCommand = RequestPaymentProfileCommand;
	exports.RequestPaymentCommand = RequestPaymentCommand;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TaskQueueUpdateCommand = undefined;
	
	var _Command = __webpack_require__(11);
	
	var _utils = __webpack_require__(10);
	
	var _commandList = __webpack_require__(7);
	
	var _Task = __webpack_require__(27);
	
	var TaskQueueUpdateCommand = _Command.Command.extend({
	  detail: _Task.Task
	}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.TASK_QUEUE_UPDATE
	}));
	
	exports.TaskQueueUpdateCommand = TaskQueueUpdateCommand;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FirstViewDidMountCommand = exports.ChangeThemeColorCommand = exports.ShowToastCommand = exports.ShowNotificationCommand = undefined;
	
	var _Command = __webpack_require__(11);
	
	var _UI = __webpack_require__(28);
	
	var _utils = __webpack_require__(10);
	
	var _commandList = __webpack_require__(7);
	
	var ShowNotificationCommand = _Command.Command.extend({
	  detail: _UI.Notification
	}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.SHOW_NOTIFICATION
	}));
	
	var ShowToastCommand = _Command.Command.extend({
	  detail: _UI.Toast
	}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.SHOW_TOAST
	}));
	
	var ChangeThemeColorCommand = _Command.Command.extend({
	  detail: {
	    content: String
	  }
	}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.CHANGE_THEME_COLOR
	}));
	
	// Remote to Client: Inform client that first view has rendered.
	var FirstViewDidMountCommand = _Command.Command.extend({
	  detail: {
	    timestamp: Number
	  }
	}).defaultTo((0, _utils.generateDefault)({
	  action: _commandList.commandList.FIRST_VIEW_DID_MOUNT
	}));
	
	exports.ShowNotificationCommand = ShowNotificationCommand;
	exports.ShowToastCommand = ShowToastCommand;
	exports.ChangeThemeColorCommand = ChangeThemeColorCommand;
	exports.FirstViewDidMountCommand = FirstViewDidMountCommand;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var n,
	    t,
	    r,
	    u = __webpack_require__(4),
	    o = [],
	    i = u.options.__r,
	    e = u.options.diffed,
	    c = u.options.__c,
	    f = u.options.unmount;function a(n) {
	  u.options.__h && u.options.__h(t);var r = t.__H || (t.__H = { __: [], __h: [] });return n >= r.__.length && r.__.push({}), r.__[n];
	}function v(n) {
	  return p(h, n);
	}function p(r, u, o) {
	  var i = a(n++);return i.__c || (i.__c = t, i.__ = [o ? o(u) : h(void 0, u), function (n) {
	    var t = r(i.__[0], n);i.__[0] !== t && (i.__[0] = t, i.__c.setState({}));
	  }]), i.__;
	}function s(r, u) {
	  var o = a(n++);d(o.__H, u) && (o.__ = r, o.__H = u, t.__h.push(o));
	}function x(t, r) {
	  var u = a(n++);return d(u.__H, r) ? (u.__H = r, u.__h = t, u.__ = t()) : u.__;
	}function l() {
	  o.some(function (n) {
	    if (n.__P) try {
	      n.__H.__h.forEach(m), n.__H.__h.forEach(y), n.__H.__h = [];
	    } catch (t) {
	      return u.options.__e(t, n.__v), !0;
	    }
	  }), o = [];
	}function m(n) {
	  n.t && n.t();
	}function y(n) {
	  var t = n.__();"function" == typeof t && (n.t = t);
	}function d(n, t) {
	  return !n || t.some(function (t, r) {
	    return t !== n[r];
	  });
	}function h(n, t) {
	  return "function" == typeof t ? t(n) : t;
	}u.options.__r = function (r) {
	  i && i(r), n = 0, (t = r.__c).__H && (t.__H.__h.forEach(m), t.__H.__h.forEach(y), t.__H.__h = []);
	}, u.options.diffed = function (n) {
	  e && e(n);var t = n.__c;if (t) {
	    var i = t.__H;i && i.__h.length && (1 !== o.push(t) && r === u.options.requestAnimationFrame || ((r = u.options.requestAnimationFrame) || function (n) {
	      var t,
	          r = function r() {
	        clearTimeout(u), cancelAnimationFrame(t), setTimeout(n);
	      },
	          u = setTimeout(r, 100);"undefined" != typeof window && (t = requestAnimationFrame(r));
	    })(l));
	  }
	}, u.options.__c = function (n, t) {
	  t.some(function (n) {
	    try {
	      n.__h.forEach(m), n.__h = n.__h.filter(function (n) {
	        return !n.__ || y(n);
	      });
	    } catch (r) {
	      t.some(function (n) {
	        n.__h && (n.__h = []);
	      }), t = [], u.options.__e(r, n.__v);
	    }
	  }), c && c(n, t);
	}, u.options.unmount = function (n) {
	  f && f(n);var t = n.__c;if (t) {
	    var r = t.__H;if (r) try {
	      r.__.forEach(function (n) {
	        return n.t && n.t();
	      });
	    } catch (n) {
	      u.options.__e(n, t.__v);
	    }
	  }
	}, exports.useState = v, exports.useReducer = p, exports.useEffect = function (r, u) {
	  var o = a(n++);d(o.__H, u) && (o.__ = r, o.__H = u, t.__H.__h.push(o));
	}, exports.useLayoutEffect = s, exports.useRef = function (n) {
	  return x(function () {
	    return { current: n };
	  }, []);
	}, exports.useImperativeHandle = function (n, t, r) {
	  s(function () {
	    "function" == typeof n ? n(t()) : n && (n.current = t());
	  }, null == r ? r : r.concat(n));
	}, exports.useMemo = x, exports.useCallback = function (n, t) {
	  return x(function () {
	    return n;
	  }, t);
	}, exports.useContext = function (r) {
	  var u = t.context[r.__c];if (!u) return r.__;var o = a(n++);return null == o.__ && (o.__ = !0, u.sub(t)), u.props.value;
	}, exports.useDebugValue = function (n, t) {
	  u.options.useDebugValue && u.options.useDebugValue(t ? t(n) : n);
	}, exports.useErrorBoundary = function (r) {
	  var u = a(n++),
	      o = v();return u.__ = r, t.componentDidCatch || (t.componentDidCatch = function (n) {
	    u.__ && u.__(n), o[1](n);
	  }), [o[0], function () {
	    o[1](void 0);
	  }];
	};
	//# sourceMappingURL=hooks.js.map

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(38);
	var invariant = __webpack_require__(39);
	var ReactPropTypesSecret = __webpack_require__(59);
	
	module.exports = function () {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;
	
	  var isValidElement = function isValidElement(object) {
	    return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(57)();
	}

/***/ },
/* 59 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	!function (e, t) {
	  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = t(__webpack_require__(4), __webpack_require__(6)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_FACTORY__ = (t), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.ReactOptionMenu = t(require("preact"), require("soft-key-store")) : e.ReactOptionMenu = t(e.preact, e["soft-key-store"]);
	}(window, function (e, t) {
	  return function (e) {
	    var t = {};function n(o) {
	      if (t[o]) return t[o].exports;var i = t[o] = { i: o, l: !1, exports: {} };return e[o].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
	    }return n.m = e, n.c = t, n.d = function (e, t, o) {
	      n.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: o });
	    }, n.r = function (e) {
	      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
	    }, n.t = function (e, t) {
	      if (1 & t && (e = n(e)), 8 & t) return e;if (4 & t && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && e && e.__esModule) return e;var o = Object.create(null);if (n.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e) for (var i in e) {
	        n.d(o, i, function (t) {
	          return e[t];
	        }.bind(null, i));
	      }return o;
	    }, n.n = function (e) {
	      var t = e && e.__esModule ? function () {
	        return e.default;
	      } : function () {
	        return e;
	      };return n.d(t, "a", t), t;
	    }, n.o = function (e, t) {
	      return Object.prototype.hasOwnProperty.call(e, t);
	    }, n.p = "", n(n.s = 8);
	  }([function (t, n) {
	    t.exports = e;
	  }, function (e, n) {
	    e.exports = t;
	  }, function (e, t, n) {
	    (function (e) {
	      var o, i, r, a;function c(e, t) {
	        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
	      }function s(e, t) {
	        for (var n = 0; n < t.length; n++) {
	          var o = t[n];o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
	        }
	      }function u(e, t) {
	        return !t || "object" !== h(t) && "function" != typeof t ? function (e) {
	          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e;
	        }(e) : t;
	      }function l(e) {
	        return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
	          return e.__proto__ || Object.getPrototypeOf(e);
	        })(e);
	      }function f(e, t) {
	        return (f = Object.setPrototypeOf || function (e, t) {
	          return e.__proto__ = t, e;
	        })(e, t);
	      }function h(e) {
	        return (h = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
	          return typeof e === "undefined" ? "undefined" : _typeof(e);
	        } : function (e) {
	          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeof(e);
	        })(e);
	      }window, a = function a(e) {
	        return function (e) {
	          var t = {};function n(o) {
	            if (t[o]) return t[o].exports;var i = t[o] = { i: o, l: !1, exports: {} };return e[o].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
	          }return n.m = e, n.c = t, n.d = function (e, t, o) {
	            n.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: o });
	          }, n.r = function (e) {
	            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
	          }, n.t = function (e, t) {
	            if (1 & t && (e = n(e)), 8 & t) return e;if (4 & t && "object" == h(e) && e && e.__esModule) return e;var o = Object.create(null);if (n.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e) for (var i in e) {
	              n.d(o, i, function (t) {
	                return e[t];
	              }.bind(null, i));
	            }return o;
	          }, n.n = function (e) {
	            var t = e && e.__esModule ? function () {
	              return e.default;
	            } : function () {
	              return e;
	            };return n.d(t, "a", t), t;
	          }, n.o = function (e, t) {
	            return Object.prototype.hasOwnProperty.call(e, t);
	          }, n.p = "", n(n.s = 1);
	        }([function (t, n) {
	          t.exports = e;
	        }, function (e, t, n) {
	          "use strict";
	          n.r(t), n.d(t, "default", function () {
	            return a;
	          });var o = n(0);function i(e) {
	            if (!e || "string" != typeof e) throw new Error("Event name should be a valid non-empty string!");
	          }function r(e) {
	            if ("function" != typeof e) throw new Error("Handler should be a function!");
	          }n(2);var a = function (e) {
	            function t() {
	              return c(this, t), u(this, l(t).apply(this, arguments));
	            }var n, o, a;return function (e, t) {
	              if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && f(e, t);
	            }(t, e), n = t, (o = [{ key: "setHierarchy", value: function value(e) {
	                this.getElement() && e && this.getElement().focus();
	              } }, { key: "handleEvent", value: function value(e) {
	                if ("function" == typeof this._pre_handleEvent) {
	                  if (!1 === this._pre_handleEvent(e)) return;
	                } else this.debug("no handle event pre found. skip");"function" == typeof this["_handle_".concat(e.type)] && (this.debug("handling ".concat(e.type)), this["_handle_".concat(e.type)](e)), "function" == typeof this._post_handleEvent && this._post_handleEvent(e);
	              } }, { key: "show", value: function value() {
	                this.getElement() && (this.getElement().classList.remove("hidden"), this.focus(), this.emit("opened"));
	              } }, { key: "hide", value: function value() {
	                this.getElement() && (this.getElement().classList.add("hidden"), this.emit("closed"));
	              } }, { key: "focus", value: function value() {
	                this.getElement() && this.getElement().focus();
	              } }, { key: "respondToHierarchyEvent", value: function value(e) {
	                return !this.isActive();
	              } }, { key: "_changeState", value: function value(e, t) {
	                this.getElement() && this.getElement().setAttribute("".concat(e, "-state"), t.toString());
	              } }, { key: "isHidden", value: function value() {
	                return !this.getElement() || this.getElement().classList.contains("hidden");
	              } }, { key: "isActive", value: function value() {
	                return !!this.getElement() && !this.getElement().classList.contains("hidden");
	              } }, { key: "publish", value: function value(e, t, n) {
	                if (this.getElement()) {
	                  this.broadcast(e, t);var o = new CustomEvent(n ? e : this.EVENT_PREFIX + e, { bubbles: !0, detail: t || this });this.debug("publishing external event: " + e + (t ? JSON.stringify(t) : "")), this.getElement().dispatchEvent(o);
	                }
	              } }, { key: "getElement", value: function value() {
	                return this.element || console.warn("BaseComponent couldn't get this.element correctly, please setup refs in your component first"), this.element;
	              } }, { key: "broadcast", value: function value(e, t) {
	                if (this.getElement()) {
	                  var n = new CustomEvent("_".concat(e), { bubbles: !1, detail: t || this });this.getElement().dispatchEvent(n);
	                }
	              } }, { key: "currentTime", value: function value() {
	                return (new Date().getTime() / 1e3 - this._start).toFixed(3);
	              } }, { key: "debug", value: function value() {
	                this.DEBUG && (console.log("[".concat(this.name, "] [").concat(this.currentTime(), "] ").concat(Array.prototype.slice.call(arguments).concat())), this.TRACE && console.trace());
	              } }, { key: "on", value: function value(e, t) {
	                i(e), r(t), this.listeners || (this.listeners = new Map());var n = this.listeners.get(e);n || (n = new Set(), this.listeners.set(e, n)), n.add(t);
	              } }, { key: "off", value: function value(e, t) {
	                i(e), r(t);var n = this.listeners.get(e);n && (n.delete(t), n.size || this.listeners.delete(e));
	              } }, { key: "offAll", value: function value(e) {
	                if (void 0 !== e) {
	                  i(e);var t = this.listeners.get(e);t && (t.clear(), this.listeners.delete(e));
	                } else this.listeners.clear();
	              } }, { key: "observe", value: function value(e, t) {
	                this._settings || (this._settings = {}), this._settings[e] = t, "function" == typeof this["_observe_".concat(e)] && this["_observe_".concat(e)](t);
	              } }, { key: "emit", value: function value(e) {
	                for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++) {
	                  n[o - 1] = arguments[o];
	                }i(e), this.listeners || (this.listeners = new Map());var r = this.listeners.get(e);r && r.forEach(function (e) {
	                  try {
	                    e.apply(null, n);
	                  } catch (e) {
	                    console.error(e);
	                  }
	                });
	              } }]) && s(n.prototype, o), a && s(n, a), t;
	          }(o.Component);
	        }, function (e, t, n) {
	          var o = n(3),
	              i = n(4);"string" == typeof (i = i.__esModule ? i.default : i) && (i = [[e.i, i, ""]]);var r = (o(i, { insert: "head", singleton: !1 }), i.locals ? i.locals : {});e.exports = r;
	        }, function (e, t, n) {
	          "use strict";
	          var o,
	              i = function () {
	            var e = {};return function (t) {
	              if (void 0 === e[t]) {
	                var n = document.querySelector(t);if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
	                  n = n.contentDocument.head;
	                } catch (e) {
	                  n = null;
	                }e[t] = n;
	              }return e[t];
	            };
	          }(),
	              r = [];function a(e) {
	            for (var t = -1, n = 0; n < r.length; n++) {
	              if (r[n].identifier === e) {
	                t = n;break;
	              }
	            }return t;
	          }function c(e, t) {
	            for (var n = {}, o = [], i = 0; i < e.length; i++) {
	              var c = e[i],
	                  s = t.base ? c[0] + t.base : c[0],
	                  u = n[s] || 0,
	                  l = "".concat(s, " ").concat(u);n[s] = u + 1;var f = a(l),
	                  h = { css: c[1], media: c[2], sourceMap: c[3] };-1 !== f ? (r[f].references++, r[f].updater(h)) : r.push({ identifier: l, updater: m(h, t), references: 1 }), o.push(l);
	            }return o;
	          }function s(e) {
	            var t = document.createElement("style"),
	                o = e.attributes || {};if (void 0 === o.nonce) {
	              var r = n.nc;r && (o.nonce = r);
	            }if (Object.keys(o).forEach(function (e) {
	              t.setAttribute(e, o[e]);
	            }), "function" == typeof e.insert) e.insert(t);else {
	              var a = i(e.insert || "head");if (!a) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");a.appendChild(t);
	            }return t;
	          }var u,
	              l = (u = [], function (e, t) {
	            return u[e] = t, u.filter(Boolean).join("\n");
	          });function f(e, t, n, o) {
	            var i = n ? "" : o.media ? "@media ".concat(o.media, " {").concat(o.css, "}") : o.css;if (e.styleSheet) e.styleSheet.cssText = l(t, i);else {
	              var r = document.createTextNode(i),
	                  a = e.childNodes;a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(r, a[t]) : e.appendChild(r);
	            }
	          }function h(e, t, n) {
	            var o = n.css,
	                i = n.media,
	                r = n.sourceMap;if (i ? e.setAttribute("media", i) : e.removeAttribute("media"), r && btoa && (o += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r)))), " */")), e.styleSheet) e.styleSheet.cssText = o;else {
	              for (; e.firstChild;) {
	                e.removeChild(e.firstChild);
	              }e.appendChild(document.createTextNode(o));
	            }
	          }var d = null,
	              p = 0;function m(e, t) {
	            var n, o, i;if (t.singleton) {
	              var r = p++;n = d || (d = s(t)), o = f.bind(null, n, r, !1), i = f.bind(null, n, r, !0);
	            } else n = s(t), o = h.bind(null, n, t), i = function i() {
	              !function (e) {
	                if (null === e.parentNode) return !1;e.parentNode.removeChild(e);
	              }(n);
	            };return o(e), function (t) {
	              if (t) {
	                if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;o(e = t);
	              } else i();
	            };
	          }e.exports = function (e, t) {
	            (t = t || {}).singleton || "boolean" == typeof t.singleton || (t.singleton = (void 0 === o && (o = Boolean(window && document && document.all && !window.atob)), o));var n = c(e = e || [], t);return function (e) {
	              if (e = e || [], "[object Array]" === Object.prototype.toString.call(e)) {
	                for (var o = 0; o < n.length; o++) {
	                  var i = a(n[o]);r[i].references--;
	                }for (var s = c(e, t), u = 0; u < n.length; u++) {
	                  var l = a(n[u]);0 === r[l].references && (r[l].updater(), r.splice(l, 1));
	                }n = s;
	              }
	            };
	          };
	        }, function (e, t, n) {
	          (t = n(5)(!1)).push([e.i, ".hidden{display:none !important}\n", ""]), e.exports = t;
	        }, function (e, t, n) {
	          "use strict";
	          e.exports = function (e) {
	            var t = [];return t.toString = function () {
	              return this.map(function (t) {
	                var n = function (e, t) {
	                  var n,
	                      o,
	                      i,
	                      r = e[1] || "",
	                      a = e[3];if (!a) return r;if (t && "function" == typeof btoa) {
	                    var c = (n = a, o = btoa(unescape(encodeURIComponent(JSON.stringify(n)))), i = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(o), "/*# ".concat(i, " */")),
	                        s = a.sources.map(function (e) {
	                      return "/*# sourceURL=".concat(a.sourceRoot || "").concat(e, " */");
	                    });return [r].concat(s).concat([c]).join("\n");
	                  }return [r].join("\n");
	                }(t, e);return t[2] ? "@media ".concat(t[2], " {").concat(n, "}") : n;
	              }).join("");
	            }, t.i = function (e, n, o) {
	              "string" == typeof e && (e = [[null, e, ""]]);var i = {};if (o) for (var r = 0; r < this.length; r++) {
	                var a = this[r][0];null != a && (i[a] = !0);
	              }for (var c = 0; c < e.length; c++) {
	                var s = [].concat(e[c]);o && i[s[0]] || (n && (s[2] ? s[2] = "".concat(n, " and ").concat(s[2]) : s[2] = n), t.push(s));
	              }
	            }, t;
	          };
	        }]);
	      }, "object" == h(t) && "object" == h(e) ? e.exports = a(n(0)) : (i = [n(0)], void 0 === (r = "function" == typeof (o = a) ? o.apply(t, i) : o) || (e.exports = r));
	    }).call(this, n(3)(e));
	  }, function (e, t) {
	    e.exports = function (e) {
	      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", { enumerable: !0, get: function get() {
	          return e.l;
	        } }), Object.defineProperty(e, "id", { enumerable: !0, get: function get() {
	          return e.i;
	        } }), e.webpackPolyfill = 1), e;
	    };
	  }, function (e, t, n) {
	    var o = n(5),
	        i = n(6);"string" == typeof (i = i.__esModule ? i.default : i) && (i = [[e.i, i, ""]]);var r = { insert: "head", singleton: !1 },
	        a = (o(i, r), i.locals ? i.locals : {});e.exports = a;
	  }, function (e, t, n) {
	    "use strict";
	    var o,
	        i = function i() {
	      return void 0 === o && (o = Boolean(window && document && document.all && !window.atob)), o;
	    },
	        r = function () {
	      var e = {};return function (t) {
	        if (void 0 === e[t]) {
	          var n = document.querySelector(t);if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
	            n = n.contentDocument.head;
	          } catch (e) {
	            n = null;
	          }e[t] = n;
	        }return e[t];
	      };
	    }(),
	        a = [];function c(e) {
	      for (var t = -1, n = 0; n < a.length; n++) {
	        if (a[n].identifier === e) {
	          t = n;break;
	        }
	      }return t;
	    }function s(e, t) {
	      for (var n = {}, o = [], i = 0; i < e.length; i++) {
	        var r = e[i],
	            s = t.base ? r[0] + t.base : r[0],
	            u = n[s] || 0,
	            l = "".concat(s, " ").concat(u);n[s] = u + 1;var f = c(l),
	            h = { css: r[1], media: r[2], sourceMap: r[3] };-1 !== f ? (a[f].references++, a[f].updater(h)) : a.push({ identifier: l, updater: v(h, t), references: 1 }), o.push(l);
	      }return o;
	    }function u(e) {
	      var t = document.createElement("style"),
	          o = e.attributes || {};if (void 0 === o.nonce) {
	        var i = n.nc;i && (o.nonce = i);
	      }if (Object.keys(o).forEach(function (e) {
	        t.setAttribute(e, o[e]);
	      }), "function" == typeof e.insert) e.insert(t);else {
	        var a = r(e.insert || "head");if (!a) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");a.appendChild(t);
	      }return t;
	    }var l,
	        f = (l = [], function (e, t) {
	      return l[e] = t, l.filter(Boolean).join("\n");
	    });function h(e, t, n, o) {
	      var i = n ? "" : o.media ? "@media ".concat(o.media, " {").concat(o.css, "}") : o.css;if (e.styleSheet) e.styleSheet.cssText = f(t, i);else {
	        var r = document.createTextNode(i),
	            a = e.childNodes;a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(r, a[t]) : e.appendChild(r);
	      }
	    }function d(e, t, n) {
	      var o = n.css,
	          i = n.media,
	          r = n.sourceMap;if (i ? e.setAttribute("media", i) : e.removeAttribute("media"), r && btoa && (o += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r)))), " */")), e.styleSheet) e.styleSheet.cssText = o;else {
	        for (; e.firstChild;) {
	          e.removeChild(e.firstChild);
	        }e.appendChild(document.createTextNode(o));
	      }
	    }var p = null,
	        m = 0;function v(e, t) {
	      var n, o, i;if (t.singleton) {
	        var r = m++;n = p || (p = u(t)), o = h.bind(null, n, r, !1), i = h.bind(null, n, r, !0);
	      } else n = u(t), o = d.bind(null, n, t), i = function i() {
	        !function (e) {
	          if (null === e.parentNode) return !1;e.parentNode.removeChild(e);
	        }(n);
	      };return o(e), function (t) {
	        if (t) {
	          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;o(e = t);
	        } else i();
	      };
	    }e.exports = function (e, t) {
	      (t = t || {}).singleton || "boolean" == typeof t.singleton || (t.singleton = i());var n = s(e = e || [], t);return function (e) {
	        if (e = e || [], "[object Array]" === Object.prototype.toString.call(e)) {
	          for (var o = 0; o < n.length; o++) {
	            var i = c(n[o]);a[i].references--;
	          }for (var r = s(e, t), u = 0; u < n.length; u++) {
	            var l = c(n[u]);0 === a[l].references && (a[l].updater(), a.splice(l, 1));
	          }n = r;
	        }
	      };
	    };
	  }, function (e, t, n) {
	    (t = n(7)(!1)).push([e.i, '.option-menu-container{z-index:9999;width:100%;position:absolute;top:0;bottom:var(--softkeybar-height, 3rem);left:0;border-top:var(--statusbar-height, 2.6rem) solid transparent;background-color:rgba(0,0,0,0.85)}.option-menu-container .option-menu{width:100%;display:flex;flex-direction:column;position:absolute;bottom:0;left:0;max-height:100%}.option-menu-container .option-menu .header{padding:0.5rem 1rem;background-color:var(--color-gs20);color:var(--color-gs90);text-align:center}.option-menu-container .option-menu .content{overflow-y:auto;background-color:var(--color-gs00);color:var(--color-gs90)}.option-menu-container .option-menu .content .menu-item{min-height:4.8rem;display:flex;align-items:center;padding-top:.5rem;padding-bottom:.5rem;box-sizing:border-box}.option-menu-container .option-menu .content .menu-item .icon{width:3.2rem;height:3.2rem}.option-menu-container .option-menu .content .menu-item .content{background-color:transparent;padding:0 1rem;overflow:unset}.option-menu-container .option-menu .content .menu-item [data-icon]:before{content:none}.option-menu-container .option-menu .content .menu-item [data-icon]:after{font-family:"gaia-icons";content:attr(data-icon);display:inline-block;font-weight:500;font-style:normal;text-decoration:inherit;text-transform:none;font-size:3.2rem;position:absolute;right:0;color:var(--color-gs45)}.option-menu-container .option-menu .content .menu-item .checked[data-icon]:after{color:var(--highlight-color)}.option-menu-container .option-menu .content .menu-item:focus{background-color:var(--highlight-color);color:white}.option-menu-container .option-menu .content .menu-item:focus .content,.option-menu-container .option-menu .content .menu-item:focus .checked[data-icon]:after{color:var(--color-gs00)}html[dir="rtl"] .option-menu-container .option-menu .content .menu-item [data-icon="radio-on"]:after{right:auto;left:0}html[dir="rtl"] .option-menu-container .option-menu .content .menu-item [data-icon="radio-off"]:after{right:auto;left:0}\n', ""]), e.exports = t;
	  }, function (e, t, n) {
	    "use strict";
	    e.exports = function (e) {
	      var t = [];return t.toString = function () {
	        return this.map(function (t) {
	          var n = function (e, t) {
	            var n = e[1] || "",
	                o = e[3];if (!o) return n;if (t && "function" == typeof btoa) {
	              var i = (a = o, c = btoa(unescape(encodeURIComponent(JSON.stringify(a)))), s = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(c), "/*# ".concat(s, " */")),
	                  r = o.sources.map(function (e) {
	                return "/*# sourceURL=".concat(o.sourceRoot || "").concat(e, " */");
	              });return [n].concat(r).concat([i]).join("\n");
	            }var a, c, s;return [n].join("\n");
	          }(t, e);return t[2] ? "@media ".concat(t[2], " {").concat(n, "}") : n;
	        }).join("");
	      }, t.i = function (e, n, o) {
	        "string" == typeof e && (e = [[null, e, ""]]);var i = {};if (o) for (var r = 0; r < this.length; r++) {
	          var a = this[r][0];null != a && (i[a] = !0);
	        }for (var c = 0; c < e.length; c++) {
	          var s = [].concat(e[c]);o && i[s[0]] || (n && (s[2] ? s[2] = "".concat(n, " and ").concat(s[2]) : s[2] = n), t.push(s));
	        }
	      }, t;
	    };
	  }, function (e, t, n) {
	    "use strict";
	    n.r(t);var o = n(0),
	        i = n(2),
	        r = n.n(i),
	        a = n(1),
	        c = n.n(a);function s(e, t) {
	      for (var n = 0; n < t.length; n++) {
	        var o = t[n];o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
	      }
	    }function u(e, t, n) {
	      return t && s(e.prototype, t), n && s(e, n), e;
	    }var l = function () {
	      function e(t, n, o, i) {
	        var r, a, c;!function (e, t) {
	          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
	        }(this, e), c = !0, (a = "loopable") in (r = this) ? Object.defineProperty(r, a, { value: c, enumerable: !0, configurable: !0, writable: !0 }) : r[a] = c, this.selector = t, this.element = n, this.scrollSelector = o, this.initialFocusIndex = i || 0, this.element.addEventListener("keydown", this), this.element.addEventListener("keyup", this), this.isHoldingArrowUp = !0, this.isHoldingArrowDown = !0, this._mutationObserver = new MutationObserver(this.refresh.bind(this)), this._mutationObserver.observe(this.element, { childList: !0, subtree: !0, attributes: !0 }), this.element.addEventListener("focus", this), this.refresh([]);
	      }return u(e, null, [{ key: "onBeforeKeyDown", value: function value() {} }]), u(e, [{ key: "onBeforeNavDown", value: function value() {} }, { key: "onBeforeNavUp", value: function value() {} }, { key: "setFocus", value: function value(e, t) {
	          this._currentFocus = e, this.element.activeElement = e, t || (this.scrollIntoView(e), this.element.contains(document.activeElement) && e.focus());
	        } }, { key: "destroy", value: function value() {
	          this.element.removeEventListener("keydown", this), this.element.removeEventListener("keyup", this), this.element.removeEventListener("focus", this), this._candidates = [], this._mutationObserver.disconnect(), this._currentFocus = null, this.element.activeElement = null, this.element = null;
	        } }, { key: "updateCandidates", value: function value() {
	          this._candidates = Array.from(this.element.querySelectorAll(this.selector));
	        } }, { key: "isAriaHiddenByAncestor", value: function value() {
	          for (var e = !1, t = this.element; t !== document.body;) {
	            if ("true" === t.getAttribute("aria-hidden")) {
	              e = !0;break;
	            }t = t.parentNode;
	          }return e;
	        } }, { key: "refresh", value: function value(e) {
	          var t = this,
	              n = !1,
	              o = this.initialFocusIndex,
	              i = !1;if (e.forEach(function (e) {
	            [].slice.call(e.removedNodes).forEach(function (e) {
	              e.contains(t._currentFocus) && (n = !0, o = t.getElementIndex(t._currentFocus));
	            }), e.addedNodes.length > 0 && (n = !0, i = !0);
	          }), this.updateCandidates(), i && (o = this.getElementIndex(this._currentFocus)), n || (!this._currentFocus || this._currentFocus === this.element) && this._candidates.length || this.element === document.activeElement) {
	            var r = o === this._candidates.length ? this._candidates[this.initialFocusIndex] : this._candidates[o];r ? (this._currentFocus = r, this.element.activeElement = r) : (this._currentFocus = this.element, this.element.activeElement = null);
	          }this.element.contains(document.activeElement) && (this._currentFocus !== document.activeElement || i) && (this.scrollIntoView(this._currentFocus), this._currentFocus.focus());
	        } }, { key: "handleEvent", value: function value(e) {
	          if ("keydown" === e.type) this.onKeyDown(e);else if ("keyup" === e.type) this.onKeyUp(e);else if ("focus" === e.type) {
	            if (this._currentFocus && this._currentFocus !== this.element) return this.scrollIntoView(this._currentFocus), void this._currentFocus.focus();var t = this.findNext();t ? (this.scrollIntoView(t), t.focus(), this._currentFocus = t, this.element.activeElement = t) : (this._currentFocus = this.element, this.element.activeElement = null);
	          }
	        } }, { key: "onKeyUp", value: function value(e) {
	          "ArrowUp" === e.key ? this.isHoldingArrowUp = !0 : "ArrowDown" === e.key && (this.isHoldingArrowDown = !0);
	        } }, { key: "onKeyDown", value: function value(e) {
	          this.constructor.onBeforeKeyDown(e);var t = null,
	              n = !1;switch (e.key) {case "ArrowDown":
	              n = !0, t = this.findNext(), !this.isHoldingArrowDown && this.element.activeElement && t.offsetTop < this.element.activeElement.offsetTop && (t = null), this.isHoldingArrowDown = !1;break;case "ArrowUp":
	              n = !0, t = this.findPrev(), !this.isHoldingArrowUp && this.element.activeElement && t.offsetTop > this.element.activeElement.offsetTop && (t = null), this.isHoldingArrowUp = !1;}t && (this.scrollIntoView(t), t.focus(), this._currentFocus = t, this.element.activeElement = t), n && (e.stopPropagation(), e.preventDefault());
	        } }, { key: "scrollIntoView", value: function value(e) {
	          if (this.scrollSelector) {
	            for (var t = e, n = !1; t !== document.body;) {
	              if (t.matches(this.scrollSelector)) {
	                n = !0, t.scrollIntoView(!1);break;
	              }t = t.parentNode;
	            }n || e.scrollIntoView(!1);
	          } else e.scrollIntoView(!1);
	        } }, { key: "getInitialFocus", value: function value() {
	          var e = this._candidates;return e.length ? e[this.initialFocusIndex] : null;
	        } }, { key: "getElementIndex", value: function value(e) {
	          var t = this._candidates;if (!t || !t.length || !e) return 0;var n = 0;return t.some(function (o, i) {
	            return o === e && (n = i % t.length, !0);
	          }), n;
	        } }, { key: "findNext", value: function value(e) {
	          this.onBeforeNavDown(), e = e || document.activeElement;var t = this._candidates;if (!t.length) return null;var n = 0;return t.some(function (o, i) {
	            return o === e && (n = (i + 1) % t.length, !0);
	          }), 0 !== n || this.loopable ? t[n] || t[this.initialFocusIndex] : null;
	        } }, { key: "findPrev", value: function value(e) {
	          this.onBeforeNavUp(), e = e || document.activeElement;var t = this._candidates;if (!t.length) return null;var n = null;return t.some(function (o, i) {
	            return o === e && (n = (t.length + i - 1) % t.length, !0);
	          }), t.length - 1 !== n || this.loopable ? t[n] || t[this.initialFocusIndex] : null;
	        } }]), e;
	    }();n(4);function f(e) {
	      return (f = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
	        return typeof e === "undefined" ? "undefined" : _typeof(e);
	      } : function (e) {
	        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeof(e);
	      })(e);
	    }function h(e, t) {
	      for (var n = 0; n < t.length; n++) {
	        var o = t[n];o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
	      }
	    }function d(e) {
	      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e;
	    }function p(e, t, n) {
	      return (p = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, n) {
	        var o = function (e, t) {
	          for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = m(e));) {}return e;
	        }(e, t);if (o) {
	          var i = Object.getOwnPropertyDescriptor(o, t);return i.get ? i.get.call(n) : i.value;
	        }
	      })(e, t, n || e);
	    }function m(e) {
	      return (m = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
	        return e.__proto__ || Object.getPrototypeOf(e);
	      })(e);
	    }function v(e, t) {
	      return (v = Object.setPrototypeOf || function (e, t) {
	        return e.__proto__ = t, e;
	      })(e, t);
	    }function y(e, t, n) {
	      return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
	    }n.d(t, "default", function () {
	      return b;
	    });var b = function (e) {
	      function t(e) {
	        var n, o, i;return function (e, t) {
	          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
	        }(this, t), o = this, n = !(i = m(t).call(this, e)) || "object" !== f(i) && "function" != typeof i ? d(o) : i, y(d(n), "name", "OptionMenu"), y(d(n), "FOCUS_SELECTOR", ".menu-item"), n.state = { header: "", options: [], onCancel: function onCancel() {} }, n;
	      }var n, i, r;return function (e, t) {
	        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && v(e, t);
	      }(t, e), n = t, (i = [{ key: "componentDidMount", value: function value() {
	          this.navigator = new l(this.FOCUS_SELECTOR, this.element), this.updateSoftKeys();
	        } }, { key: "componentWillUnmount", value: function value() {
	          this.navigator.destroy(), this.unregisterSoftKeys(), this.element = null;
	        } }, { key: "componentDidUpdate", value: function value() {
	          this.isActive() && document.activeElement === document.body && this.element.focus();
	        } }, { key: "componentWillUpdate", value: function value() {
	          var e = this.element.querySelector('[data-index="0"]');e && this.navigator.setFocus(e);
	        } }, { key: "unregisterSoftKeys", value: function value() {
	          c.a.unregister(this.element);
	        } }, { key: "toL10n", value: function value() {
	          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
	              t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};return "complete" === navigator.mozL10n.readyState && e ? (e += "", navigator.mozL10n.get(e, t) || e) : e;
	        } }, { key: "updateSoftKeys", value: function value() {
	          c.a.register({ left: this.state.hasCancel ? this.toL10n("cancel") : "", center: this.toL10n("select"), right: "" }, this.element);
	        } }, { key: "clear", value: function value() {
	          this.setState({ header: "", options: [], onCancel: function onCancel() {} });
	        } }, { key: "show", value: function value(e) {
	          var n = this;this.clear(), this.setState(e, function () {
	            n.updateSoftKeys();
	          }), p(m(t.prototype), "show", this).call(this);
	        } }, { key: "onKeyDown", value: function value(e) {
	          switch (e.key) {case "Enter":
	              e.stopPropagation(), e.preventDefault();var t = this.state.options[+e.target.dataset.index];t && t.callback && t.callback(), this.hide();break;case "ArrowUp":case "ArrowDown":
	              e.stopPropagation(), e.preventDefault();break;case "SoftLeft":
	              if (!this.state.hasCancel) break;case "BrowserBack":case "Backspace":
	              e.stopPropagation(), e.preventDefault(), this.state.onCancel && this.state.onCancel(), this.hide();}
	        } }, { key: "render", value: function value() {
	          var e = this,
	              t = [];this.state.options.forEach(function (e, n) {
	            var i = "";e.icon && (i = Object(o.h)("img", { src: e.icon, className: "icon" }));var r = "content" + (e.checked ? " checked" : "");t.push(Object(o.h)("div", { key: "option-" + n, tabIndex: "-1", "data-index": n, className: "menu-item p-pri" }, i, Object(o.h)("div", { className: r, "data-l10n-id": e.id || "", "data-l10n-args": e.l10nArgs || null, "data-icon": e.dataicon || "" }, e.label || "")));
	          });var n = "option-menu-container";return this.state.customClass && (n += " ".concat(n, "--").concat(this.state.customClass)), Object(o.h)("div", { tabIndex: "-1", role: "heading", "aria-labelledby": "option-menu-header", className: n, onKeyDown: function onKeyDown(t) {
	              return e.onKeyDown(t);
	            }, ref: function ref(t) {
	              e.element = t;
	            } }, Object(o.h)("div", { className: "option-menu" }, Object(o.h)("div", { id: "option-menu-header", className: "header h1", key: "translated-header" }, this.toL10n(this.state.header || "options")), Object(o.h)("div", { className: "content p-ul" }, this.props.children || t)));
	        } }]) && h(n.prototype, i), r && h(n, r), t;
	    }(r.a);
	  }]);
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)(module)))

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	!function (t, e) {
	  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = e(__webpack_require__(4), __webpack_require__(6)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_FACTORY__ = (e), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.ReactSoftKey = e(require("preact"), require("soft-key-store")) : t.ReactSoftKey = e(t.preact, t["soft-key-store"]);
	}(window, function (t, e) {
	  return function (t) {
	    var e = {};function n(o) {
	      if (e[o]) return e[o].exports;var r = e[o] = { i: o, l: !1, exports: {} };return t[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
	    }return n.m = t, n.c = e, n.d = function (t, e, o) {
	      n.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: o });
	    }, n.r = function (t) {
	      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
	    }, n.t = function (t, e) {
	      if (1 & e && (t = n(t)), 8 & e) return t;if (4 & e && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && t && t.__esModule) return t;var o = Object.create(null);if (n.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: t }), 2 & e && "string" != typeof t) for (var r in t) {
	        n.d(o, r, function (e) {
	          return t[e];
	        }.bind(null, r));
	      }return o;
	    }, n.n = function (t) {
	      var e = t && t.__esModule ? function () {
	        return t.default;
	      } : function () {
	        return t;
	      };return n.d(e, "a", e), e;
	    }, n.o = function (t, e) {
	      return Object.prototype.hasOwnProperty.call(t, e);
	    }, n.p = "", n(n.s = 6);
	  }([function (e, n) {
	    e.exports = t;
	  }, function (t, n) {
	    t.exports = e;
	  }, function (t, e, n) {
	    var o = n(3),
	        r = n(4);"string" == typeof (r = r.__esModule ? r.default : r) && (r = [[t.i, r, ""]]);var i = { insert: "head", singleton: !1 },
	        c = (o(r, i), r.locals ? r.locals : {});t.exports = c;
	  }, function (t, e, n) {
	    "use strict";
	    var o,
	        r = function r() {
	      return void 0 === o && (o = Boolean(window && document && document.all && !window.atob)), o;
	    },
	        i = function () {
	      var t = {};return function (e) {
	        if (void 0 === t[e]) {
	          var n = document.querySelector(e);if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
	            n = n.contentDocument.head;
	          } catch (t) {
	            n = null;
	          }t[e] = n;
	        }return t[e];
	      };
	    }(),
	        c = [];function a(t) {
	      for (var e = -1, n = 0; n < c.length; n++) {
	        if (c[n].identifier === t) {
	          e = n;break;
	        }
	      }return e;
	    }function u(t, e) {
	      for (var n = {}, o = [], r = 0; r < t.length; r++) {
	        var i = t[r],
	            u = e.base ? i[0] + e.base : i[0],
	            f = n[u] || 0,
	            s = "".concat(u, " ").concat(f);n[u] = f + 1;var l = a(s),
	            p = { css: i[1], media: i[2], sourceMap: i[3] };-1 !== l ? (c[l].references++, c[l].updater(p)) : c.push({ identifier: s, updater: v(p, e), references: 1 }), o.push(s);
	      }return o;
	    }function f(t) {
	      var e = document.createElement("style"),
	          o = t.attributes || {};if (void 0 === o.nonce) {
	        var r = n.nc;r && (o.nonce = r);
	      }if (Object.keys(o).forEach(function (t) {
	        e.setAttribute(t, o[t]);
	      }), "function" == typeof t.insert) t.insert(e);else {
	        var c = i(t.insert || "head");if (!c) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");c.appendChild(e);
	      }return e;
	    }var s,
	        l = (s = [], function (t, e) {
	      return s[t] = e, s.filter(Boolean).join("\n");
	    });function p(t, e, n, o) {
	      var r = n ? "" : o.media ? "@media ".concat(o.media, " {").concat(o.css, "}") : o.css;if (t.styleSheet) t.styleSheet.cssText = l(e, r);else {
	        var i = document.createTextNode(r),
	            c = t.childNodes;c[e] && t.removeChild(c[e]), c.length ? t.insertBefore(i, c[e]) : t.appendChild(i);
	      }
	    }function d(t, e, n) {
	      var o = n.css,
	          r = n.media,
	          i = n.sourceMap;if (r ? t.setAttribute("media", r) : t.removeAttribute("media"), i && btoa && (o += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i)))), " */")), t.styleSheet) t.styleSheet.cssText = o;else {
	        for (; t.firstChild;) {
	          t.removeChild(t.firstChild);
	        }t.appendChild(document.createTextNode(o));
	      }
	    }var _ = null,
	        h = 0;function v(t, e) {
	      var n, o, r;if (e.singleton) {
	        var i = h++;n = _ || (_ = f(e)), o = p.bind(null, n, i, !1), r = p.bind(null, n, i, !0);
	      } else n = f(e), o = d.bind(null, n, e), r = function r() {
	        !function (t) {
	          if (null === t.parentNode) return !1;t.parentNode.removeChild(t);
	        }(n);
	      };return o(t), function (e) {
	        if (e) {
	          if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;o(t = e);
	        } else r();
	      };
	    }t.exports = function (t, e) {
	      (e = e || {}).singleton || "boolean" == typeof e.singleton || (e.singleton = r());var n = u(t = t || [], e);return function (t) {
	        if (t = t || [], "[object Array]" === Object.prototype.toString.call(t)) {
	          for (var o = 0; o < n.length; o++) {
	            var r = a(n[o]);c[r].references--;
	          }for (var i = u(t, e), f = 0; f < n.length; f++) {
	            var s = a(n[f]);0 === c[s].references && (c[s].updater(), c.splice(s, 1));
	          }n = i;
	        }
	      };
	    };
	  }, function (t, e, n) {
	    (e = n(5)(!1)).push([t.i, ":root{--softkeybar-background-color: var(--color-gs20, #ccc);--softkey-color: var(--color-gs90, #323232);--softkey-color--icon: var(--color-gs70, #6a6a6a);--softkey-color--disabled: var(--color-eta, #c7c7c7);--softkey-background-color--active: #0ac;--softkey-font-size: 1.4rem;--softkey-icon-size: 2rem;--softkey-font-weight: 600}.skbar{position:fixed;left:0;right:0;bottom:0;z-index:var(--z-index--softkey, 99999);display:grid;grid-template-columns:1fr auto 1fr;outline:none;text-align:center;white-space:nowrap;color:var(--softkey-color);direction:ltr;background-color:var(--softkeybar-background-color)}.skbar:not(.visible){display:none}.skbar>*{min-width:1rem;padding-left:.5rem;padding-right:.5rem}.skbar>*:first-child{text-align:left}.skbar>*:nth-child(2){--softkey-font-size: 1.6rem;--softkey-font-weight: 700;flex-shrink:0;min-width:1rem;text-transform:uppercase}.skbar>*:last-child{text-align:right}.sk-button{display:block;max-width:100%;height:var(--softkeybar-height, 3rem);line-height:var(--softkeybar-height, 3rem);border:unset;overflow:hidden;text-overflow:ellipsis;text-align:inherit;font-size:var(--softkey-font-size);font-weight:var(--softkey-font-weight);color:var(--softkey-color);background:unset}.sk-button:-moz-dir(rtl){direction:rtl}.sk-button:active,.sk-button.active{background-color:var(--softkey-background-color--active)}.sk-button[disabled]{--softkey-color: var(--softkey-color--disabled);background-color:transparent;pointer-events:auto}.sk-button[data-icon]{--softkey-font-size: var(--softkey-icon-size)}.sk-button[data-icon]:empty{--softkey-color: var(--softkey-color--icon)}.sk-button[data-icon][data-icon=\"ok\"]{--softkey-icon-size: 2.4rem}.sk-button[data-icon]::before{content:unset}.sk-button[data-icon]::after{content:attr(data-icon);font-family:'gaia-icons';display:inline-block;font-weight:500;font-style:normal;text-decoration:inherit;text-transform:none;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased}\n", ""]), t.exports = e;
	  }, function (t, e, n) {
	    "use strict";
	    t.exports = function (t) {
	      var e = [];return e.toString = function () {
	        return this.map(function (e) {
	          var n = function (t, e) {
	            var n = t[1] || "",
	                o = t[3];if (!o) return n;if (e && "function" == typeof btoa) {
	              var r = (c = o, a = btoa(unescape(encodeURIComponent(JSON.stringify(c)))), u = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(a), "/*# ".concat(u, " */")),
	                  i = o.sources.map(function (t) {
	                return "/*# sourceURL=".concat(o.sourceRoot || "").concat(t, " */");
	              });return [n].concat(i).concat([r]).join("\n");
	            }var c, a, u;return [n].join("\n");
	          }(e, t);return e[2] ? "@media ".concat(e[2], " {").concat(n, "}") : n;
	        }).join("");
	      }, e.i = function (t, n, o) {
	        "string" == typeof t && (t = [[null, t, ""]]);var r = {};if (o) for (var i = 0; i < this.length; i++) {
	          var c = this[i][0];null != c && (r[c] = !0);
	        }for (var a = 0; a < t.length; a++) {
	          var u = [].concat(t[a]);o && r[u[0]] || (n && (u[2] ? u[2] = "".concat(n, " and ").concat(u[2]) : u[2] = n), e.push(u));
	        }
	      }, e;
	    };
	  }, function (t, e, n) {
	    "use strict";
	    n.r(e);var o,
	        r,
	        i,
	        c = n(0),
	        a = [],
	        u = c.options.__r,
	        f = c.options.diffed,
	        s = c.options.__c,
	        l = c.options.unmount;function p(t) {
	      c.options.__h && c.options.__h(r);var e = r.__H || (r.__H = { __: [], __h: [] });return t >= e.__.length && e.__.push({}), e.__[t];
	    }function d(t) {
	      return _(k, t);
	    }function _(t, e, n) {
	      var i = p(o++);return i.__c || (i.__c = r, i.__ = [n ? n(e) : k(void 0, e), function (e) {
	        var n = t(i.__[0], e);i.__[0] !== n && (i.__[0] = n, i.__c.setState({}));
	      }]), i.__;
	    }function h(t, e) {
	      var n = p(o++);g(n.__H, e) && (n.__ = t, n.__H = e, r.__h.push(n));
	    }function v(t, e) {
	      var n = p(o++);return g(n.__H, e) ? (n.__H = e, n.__h = t, n.__ = t()) : n.__;
	    }function m() {
	      a.some(function (t) {
	        if (t.__P) try {
	          t.__H.__h.forEach(y), t.__H.__h.forEach(b), t.__H.__h = [];
	        } catch (e) {
	          return c.options.__e(e, t.__v), !0;
	        }
	      }), a = [];
	    }function y(t) {
	      t.t && t.t();
	    }function b(t) {
	      var e = t.__();"function" == typeof e && (t.t = e);
	    }function g(t, e) {
	      return !t || e.some(function (e, n) {
	        return e !== t[n];
	      });
	    }function k(t, e) {
	      return "function" == typeof e ? e(t) : e;
	    }function C(t, e) {
	      for (var n in e) {
	        t[n] = e[n];
	      }return t;
	    }function w(t, e) {
	      for (var n in t) {
	        if ("__source" !== n && !(n in e)) return !0;
	      }for (var o in e) {
	        if ("__source" !== o && t[o] !== e[o]) return !0;
	      }return !1;
	    }c.options.__r = function (t) {
	      u && u(t), o = 0, (r = t.__c).__H && (r.__H.__h.forEach(y), r.__H.__h.forEach(b), r.__H.__h = []);
	    }, c.options.diffed = function (t) {
	      f && f(t);var e = t.__c;if (e) {
	        var n = e.__H;n && n.__h.length && (1 !== a.push(e) && i === c.options.requestAnimationFrame || ((i = c.options.requestAnimationFrame) || function (t) {
	          var e,
	              n = function n() {
	            clearTimeout(o), cancelAnimationFrame(e), setTimeout(t);
	          },
	              o = setTimeout(n, 100);"undefined" != typeof window && (e = requestAnimationFrame(n));
	        })(m));
	      }
	    }, c.options.__c = function (t, e) {
	      e.some(function (t) {
	        try {
	          t.__h.forEach(y), t.__h = t.__h.filter(function (t) {
	            return !t.__ || b(t);
	          });
	        } catch (n) {
	          e.some(function (t) {
	            t.__h && (t.__h = []);
	          }), e = [], c.options.__e(n, t.__v);
	        }
	      }), s && s(t, e);
	    }, c.options.unmount = function (t) {
	      l && l(t);var e = t.__c;if (e) {
	        var n = e.__H;if (n) try {
	          n.__.forEach(function (t) {
	            return t.t && t.t();
	          });
	        } catch (t) {
	          c.options.__e(t, e.__v);
	        }
	      }
	    };var O = function (t) {
	      var e, n;function o(e) {
	        var n;return (n = t.call(this, e) || this).isPureReactComponent = !0, n;
	      }return n = t, (e = o).prototype = Object.create(n.prototype), e.prototype.constructor = e, e.__proto__ = n, o.prototype.shouldComponentUpdate = function (t, e) {
	        return w(this.props, t) || w(this.state, e);
	      }, o;
	    }(c.Component);var x = c.options.vnode;c.options.vnode = function (t) {
	      t.type && t.type.t && t.ref && (t.props.ref = t.ref, t.ref = null), x && x(t);
	    };var j = function j(t, e) {
	      return t ? Object(c.toChildArray)(t).reduce(function (t, n) {
	        return t.concat(e(n));
	      }, []) : null;
	    },
	        E = { map: j, forEach: j, count: function count(t) {
	        return t ? Object(c.toChildArray)(t).length : 0;
	      }, only: function only(t) {
	        if (1 !== (t = Object(c.toChildArray)(t)).length) throw new Error("Children.only() expects only one child.");return t[0];
	      }, toArray: c.toChildArray },
	        S = c.options.__e;function N(t) {
	      return t && ((t = C({}, t)).__c = null, t.__k = t.__k && t.__k.map(N)), t;
	    }function A(t) {
	      this.__u = 0, this.o = null, this.__b = null;
	    }function R(t) {
	      var e = t.__.__c;return e && e.u && e.u(t);
	    }function H() {
	      this.i = null, this.l = null;
	    }c.options.__e = function (t, e, n) {
	      if (t.then) for (var o, r = e; r = r.__;) {
	        if ((o = r.__c) && o.__c) return o.__c(t, e.__c);
	      }S(t, e, n);
	    }, (A.prototype = new c.Component()).__c = function (t, e) {
	      var n = this;null == n.o && (n.o = []), n.o.push(e);var o = R(n.__v),
	          r = !1,
	          i = function i() {
	        r || (r = !0, o ? o(c) : c());
	      };e.__c = e.componentWillUnmount, e.componentWillUnmount = function () {
	        i(), e.__c && e.__c();
	      };var c = function c() {
	        var t;if (! --n.__u) for (n.__v.__k[0] = n.state.u, n.setState({ u: n.__b = null }); t = n.o.pop();) {
	          t.forceUpdate();
	        }
	      };n.__u++ || n.setState({ u: n.__b = n.__v.__k[0] }), t.then(i, i);
	    }, A.prototype.render = function (t, e) {
	      return this.__b && (this.__v.__k[0] = N(this.__b), this.__b = null), [Object(c.createElement)(c.Component, null, e.u ? null : t.children), e.u && t.fallback];
	    };var M = function M(t, e, n) {
	      if (++n[1] === n[0] && t.l.delete(e), t.props.revealOrder && ("t" !== t.props.revealOrder[0] || !t.l.size)) for (n = t.i; n;) {
	        for (; n.length > 3;) {
	          n.pop()();
	        }if (n[1] < n[0]) break;t.i = n = n[2];
	      }
	    };(H.prototype = new c.Component()).u = function (t) {
	      var e = this,
	          n = R(e.__v),
	          o = e.l.get(t);return o[0]++, function (r) {
	        var i = function i() {
	          e.props.revealOrder ? (o.push(r), M(e, t, o)) : r();
	        };n ? n(i) : i();
	      };
	    }, H.prototype.render = function (t) {
	      this.i = null, this.l = new Map();var e = Object(c.toChildArray)(t.children);t.revealOrder && "b" === t.revealOrder[0] && e.reverse();for (var n = e.length; n--;) {
	        this.l.set(e[n], this.i = [1, 0, this.i]);
	      }return t.children;
	    }, H.prototype.componentDidUpdate = H.prototype.componentDidMount = function () {
	      var t = this;t.l.forEach(function (e, n) {
	        M(t, n, e);
	      });
	    };var P = function () {
	      function t() {}var e = t.prototype;return e.getChildContext = function () {
	        return this.props.context;
	      }, e.render = function (t) {
	        return t.children;
	      }, t;
	    }();function T(t) {
	      var e = this,
	          n = t.container,
	          o = Object(c.createElement)(P, { context: e.context }, t.vnode);return e.s && e.s !== n && (e.h.parentNode && e.s.removeChild(e.h), Object(c._unmount)(e.v), e.p = !1), t.vnode ? e.p ? (n.__k = e.__k, Object(c.render)(o, n), e.__k = n.__k) : (e.h = document.createTextNode(""), Object(c.hydrate)("", n), n.appendChild(e.h), e.p = !0, e.s = n, Object(c.render)(o, n, e.h), e.__k = this.h.__k) : e.p && (e.h.parentNode && e.s.removeChild(e.h), Object(c._unmount)(e.v)), e.v = o, e.componentWillUnmount = function () {
	        e.h.parentNode && e.s.removeChild(e.h), Object(c._unmount)(e.v);
	      }, null;
	    }var U = /^(?:accent|alignment|arabic|baseline|cap|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;c.Component.prototype.isReactComponent = {};var z = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103;function F(t, e, n) {
	      if (null == e.__k) for (; e.firstChild;) {
	        e.removeChild(e.firstChild);
	      }return function (t, e, n) {
	        return Object(c.render)(t, e), "function" == typeof n && n(), t ? t.__c : null;
	      }(t, e, n);
	    }var L = c.options.event;function q(t, e) {
	      t["UNSAFE_" + e] && !t[e] && Object.defineProperty(t, e, { configurable: !1, get: function get() {
	          return this["UNSAFE_" + e];
	        }, set: function set(t) {
	          this["UNSAFE_" + e] = t;
	        } });
	    }c.options.event = function (t) {
	      return L && (t = L(t)), t.persist = function () {}, t.nativeEvent = t;
	    };var D = { configurable: !0, get: function get() {
	        return this.class;
	      } },
	        W = c.options.vnode;c.options.vnode = function (t) {
	      t.$$typeof = z;var e = t.type,
	          n = t.props;if (n.class != n.className && (D.enumerable = "className" in n, null != n.className && (n.class = n.className), Object.defineProperty(n, "className", D)), "function" != typeof e) {
	        var o, r, i;for (i in n.defaultValue && (n.value || 0 === n.value || (n.value = n.defaultValue), delete n.defaultValue), Array.isArray(n.value) && n.multiple && "select" === e && (Object(c.toChildArray)(n.children).forEach(function (t) {
	          -1 != n.value.indexOf(t.props.value) && (t.props.selected = !0);
	        }), delete n.value), n) {
	          if (o = U.test(i)) break;
	        }if (o) for (i in r = t.props = {}, n) {
	          r[U.test(i) ? i.replace(/([A-Z0-9])/, "-$1").toLowerCase() : i] = n[i];
	        }
	      }!function (e) {
	        var n = t.type,
	            o = t.props;if (o && "string" == typeof n) {
	          var r = {};for (var i in o) {
	            /^on(Ani|Tra|Tou)/.test(i) && (o[i.toLowerCase()] = o[i], delete o[i]), r[i.toLowerCase()] = i;
	          }if (r.ondoubleclick && (o.ondblclick = o[r.ondoubleclick], delete o[r.ondoubleclick]), r.onbeforeinput && (o.onbeforeinput = o[r.onbeforeinput], delete o[r.onbeforeinput]), r.onchange && ("textarea" === n || "input" === n.toLowerCase() && !/^fil|che|ra/i.test(o.type))) {
	            var c = r.oninput || "oninput";o[c] || (o[c] = o[r.onchange], delete o[r.onchange]);
	          }
	        }
	      }(), "function" == typeof e && !e.m && e.prototype && (q(e.prototype, "componentWillMount"), q(e.prototype, "componentWillReceiveProps"), q(e.prototype, "componentWillUpdate"), e.m = !0), W && W(t);
	    };function V(t) {
	      return !!t && t.$$typeof === z;
	    }var I = { useState: d, useReducer: _, useEffect: function useEffect(t, e) {
	        var n = p(o++);g(n.__H, e) && (n.__ = t, n.__H = e, r.__H.__h.push(n));
	      }, useLayoutEffect: h, useRef: function useRef(t) {
	        return v(function () {
	          return { current: t };
	        }, []);
	      }, useImperativeHandle: function useImperativeHandle(t, e, n) {
	        h(function () {
	          "function" == typeof t ? t(e()) : t && (t.current = e());
	        }, null == n ? n : n.concat(t));
	      }, useMemo: v, useCallback: function useCallback(t, e) {
	        return v(function () {
	          return t;
	        }, e);
	      }, useContext: function useContext(t) {
	        var e = r.context[t.__c];if (!e) return t.__;var n = p(o++);return null == n.__ && (n.__ = !0, e.sub(r)), e.props.value;
	      }, useDebugValue: function useDebugValue(t, e) {
	        c.options.useDebugValue && c.options.useDebugValue(e ? e(t) : t);
	      }, version: "16.8.0", Children: E, render: F, hydrate: F, unmountComponentAtNode: function unmountComponentAtNode(t) {
	        return !!t.__k && (Object(c.render)(null, t), !0);
	      }, createPortal: function createPortal(t, e) {
	        return Object(c.createElement)(T, { vnode: t, container: e });
	      }, createElement: c.createElement, createContext: c.createContext, createFactory: function createFactory(t) {
	        return c.createElement.bind(null, t);
	      }, cloneElement: function cloneElement(t) {
	        return V(t) ? c.cloneElement.apply(null, arguments) : t;
	      }, createRef: c.createRef, Fragment: c.Fragment, isValidElement: V, findDOMNode: function findDOMNode(t) {
	        return t && (t.base || 1 === t.nodeType && t) || null;
	      }, Component: c.Component, PureComponent: O, memo: function memo(t, e) {
	        function n(t) {
	          var n = this.props.ref,
	              o = n == t.ref;return !o && n && (n.call ? n(null) : n.current = null), e ? !e(this.props, t) || !o : w(this.props, t);
	        }function o(e) {
	          return this.shouldComponentUpdate = n, Object(c.createElement)(t, C({}, e));
	        }return o.prototype.isReactComponent = !0, o.displayName = "Memo(" + (t.displayName || t.name) + ")", o.t = !0, o;
	      }, forwardRef: function forwardRef(t) {
	        function e(e) {
	          var n = C({}, e);return delete n.ref, t(n, e.ref);
	        }return e.prototype.isReactComponent = !0, e.t = !0, e.displayName = "ForwardRef(" + (t.displayName || t.name) + ")", e;
	      }, unstable_batchedUpdates: function unstable_batchedUpdates(t, e) {
	        return t(e);
	      }, Suspense: A, SuspenseList: H, lazy: function lazy(t) {
	        var e, n, o;function r(r) {
	          if (e || (e = t()).then(function (t) {
	            n = t.default || t;
	          }, function (t) {
	            o = t;
	          }), o) throw o;if (!n) throw e;return Object(c.createElement)(n, r);
	        }return r.displayName = "Lazy", r.t = !0, r;
	      } },
	        $ = n(1),
	        B = n.n($);n(2);function K(t) {
	      return (K = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
	        return typeof t === "undefined" ? "undefined" : _typeof(t);
	      } : function (t) {
	        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : _typeof(t);
	      })(t);
	    }function J(t, e) {
	      for (var n = 0; n < e.length; n++) {
	        var o = e[n];o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
	      }
	    }function Z(t) {
	      return (Z = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
	        return t.__proto__ || Object.getPrototypeOf(t);
	      })(t);
	    }function G(t) {
	      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t;
	    }function Q(t, e) {
	      return (Q = Object.setPrototypeOf || function (t, e) {
	        return t.__proto__ = e, t;
	      })(t, e);
	    }function X() {
	      return (X = Object.assign || function (t) {
	        for (var e = 1; e < arguments.length; e++) {
	          var n = arguments[e];for (var o in n) {
	            Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
	          }
	        }return t;
	      }).apply(this, arguments);
	    }function Y(t) {
	      var e = t.content ? { "data-icon": t.content.icon, "data-l10n-id": t.content.text } : null;return I.createElement("button", X({ id: "software-keys-".concat(t.pos), className: "sk-button", "data-position": t.pos }, e));
	    }n.d(e, "default", function () {
	      return tt;
	    });var tt = function (t) {
	      function e(t) {
	        var n, o, r, i, c, a;return function (t, e) {
	          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
	        }(this, e), o = this, r = Z(e).call(this, t), n = !r || "object" !== K(r) && "function" != typeof r ? G(o) : r, i = G(n), a = function a(t) {
	          var e = n.props.getRef;n.element = t, e && e(t);
	        }, (c = "setRef") in i ? Object.defineProperty(i, c, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : i[c] = a, n.state = { left: t.left || "", center: t.center || "", right: t.right || "" }, n.softkeys = ["left", "right", "center"], n;
	      }var n, o, r;return function (t, e) {
	        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Q(t, e);
	      }(e, t), n = e, (o = [{ key: "componentDidMount", value: function value() {
	          var t = this;B.a.on("change", function () {
	            var e = B.a.currentKeys;t.softkeys.forEach(function (n) {
	              e[n] = t.uniformContent(e[n] || "");
	            }), t.setState(e);
	          });
	        } }, { key: "componentWillUpdate", value: function value(t, e) {
	          Array.from(this.element.getElementsByTagName("button")).forEach(function (t) {
	            e[t.dataset.position].text || (t.textContent = "");
	          });
	        } }, { key: "uniformContent", value: function value(t) {
	          return "string" == typeof t && (t = t.startsWith("icon=") ? { icon: t.replace("icon=", "") } : { text: t }), t;
	        } }, { key: "render", value: function value() {
	          return I.createElement("form", { className: "skbar none-paddings visible focused", id: "softkeyPanel", "data-type": "action", ref: this.setRef }, I.createElement(Y, { pos: "left", content: this.state.left }), I.createElement(Y, { pos: "center", content: this.state.center }), I.createElement(Y, { pos: "right", content: this.state.right }));
	        } }]) && J(n.prototype, o), r && J(n, r), e;
	    }(c.Component);
	  }]);
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)(module)))

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	var runtime = function (exports) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  exports.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function (method) {
	      prototype[method] = function (arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  exports.isGeneratorFunction = function (genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor ? ctor === GeneratorFunction ||
	    // For the native GeneratorFunction constructor, the best we can
	    // do is to check its .name property.
	    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
	  };
	
	  exports.mark = function (genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  exports.awrap = function (arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator, PromiseImpl) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && hasOwn.call(value, "__await")) {
	          return PromiseImpl.resolve(value.__await).then(function (value) {
	            invoke("next", value, resolve, reject);
	          }, function (err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return PromiseImpl.resolve(value).then(function (unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration.
	          result.value = unwrapped;
	          resolve(result);
	        }, function (error) {
	          // If a rejected Promise was yielded, throw the rejection back
	          // into the async generator function so it can be handled there.
	          return invoke("throw", error, resolve, reject);
	        });
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new PromiseImpl(function (resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	      // If enqueue has been called before, then we want to wait until
	      // all previous Promises have been resolved before calling invoke,
	      // so that results are always delivered in the correct order. If
	      // enqueue has not been called before, then it is important to
	      // call invoke immediately, without waiting on a callback to fire,
	      // so that the async generator function has the opportunity to do
	      // any necessary setup in a predictable way. This predictability
	      // is why the Promise constructor synchronously invokes its
	      // executor callback, and why async functions synchronously
	      // execute code before the first await. Since we implement simple
	      // async functions in terms of async generators, it is especially
	      // important to get this right, even though it requires care.
	      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
	      // Avoid propagating failures to Promises returned by later
	      // invocations of the iterator.
	      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  exports.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
	    if (PromiseImpl === void 0) PromiseImpl = Promise;
	
	    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
	
	    return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
	    : iter.next().then(function (result) {
	      return result.done ? result.value : iter.next();
	    });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done ? GenStateCompleted : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        // Note: ["return"] must be used for ES3 parsing compatibility.
	        if (delegate.iterator["return"]) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError("The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (!info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function () {
	    return this;
	  };
	
	  Gp.toString = function () {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  exports.keys = function (object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1,
	            next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  exports.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function reset(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function stop() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function dispatchException(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function abrupt(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function complete(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" || record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function finish(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function _catch(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	
	  // Regardless of whether this script is executing as a CommonJS module
	  // or not, return the runtime object so that we can declare the variable
	  // regeneratorRuntime in the outer scope, which allows this module to be
	  // injected easily by `bin/regenerator --include-runtime script.js`.
	  return exports;
	}(
	// If this script is executing as a CommonJS module, use module.exports
	// as the regeneratorRuntime namespace. Otherwise create a new empty
	// object. Either way, the resulting object will be used to initialize
	// the regeneratorRuntime variable at the top of this file.
	( false ? "undefined" : _typeof(module)) === "object" ? module.exports : {});
	
	try {
	  regeneratorRuntime = runtime;
	} catch (accidentalStrictMode) {
	  // This module should not be running in strict mode, so the above
	  // assignment should always work unless something is misconfigured. Just
	  // in case runtime.js accidentally runs in strict mode, we can escape
	  // strict mode using a global Function call. This could conceivably fail
	  // if a Content Security Policy forbids using Function, but in that case
	  // the proper solution is to fix the accidental strict mode problem. If
	  // you've misconfigured your bundler to force strict mode and applied a
	  // CSP to forbid Function, and you're not willing to fix either of those
	  // problems, please detail your unique predicament in a GitHub issue.
	  Function("r", "regeneratorRuntime = r")(runtime);
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)(module)))

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SimpleResult = undefined;
	
	var _objectmodel = __webpack_require__(64);
	
	var SimpleResult = new _objectmodel.ObjectModel({
	  id: String,
	  success: Boolean,
	  detail: [Object]
	});
	
	exports.SimpleResult = SimpleResult;

/***/ },
/* 64 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Object$assign, _extend2, _extend3, _extend4;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// ObjectModel v4.0.5 - http://objectmodel.js.org
	// MIT License - Sylvain Pollet-Villard
	var bettertypeof = function bettertypeof(x) {
		return Object.prototype.toString.call(x).match(/\s([a-zA-Z]+)/)[1];
	},
	    getProto = Object.getPrototypeOf,
	    setProto = Object.setPrototypeOf,
	    has = function has(o, prop) {
		return Object.prototype.hasOwnProperty.call(o, prop);
	},
	    is = function is(Constructor, obj) {
		return obj instanceof Constructor;
	},
	    isFunction = function isFunction(f) {
		return typeof f === "function";
	},
	    isObject = function isObject(o) {
		return o && (typeof o === "undefined" ? "undefined" : _typeof(o)) === "object";
	},
	    isPlainObject = function isPlainObject(o) {
		return isObject(o) && getProto(o) === Object.prototype;
	},
	    isIterable = function isIterable(x) {
		return x && isFunction(x[Symbol.iterator]);
	},
	    proxify = function proxify(val, traps) {
		return new Proxy(val, traps);
	},
	    merge = function merge(target) {
		var src = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		for (var key in src) {
			if (isPlainObject(src[key])) {
				var o = {};
				merge(o, target[key]);
				merge(o, src[key]);
				target[key] = o;
			} else {
				target[key] = src[key];
			}
		}
		return target;
	},
	    define = function define(obj, key, value) {
		var enumerable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
		Object.defineProperty(obj, key, { value: value, enumerable: enumerable, writable: true, configurable: true });
	},
	    extend = function extend(child, parent, props) {
		child.prototype = Object.assign(Object.create(parent.prototype, {
			constructor: {
				value: child,
				writable: true,
				configurable: true
			}
		}), props);
		setProto(child, parent);
	};
	
	var _check = Symbol(),
	    _checked = Symbol(),
	    // used to skip validation at instanciation for perf
	_original = Symbol(),
	    // used to bypass proxy
	
	initModel = function initModel(def, constructor, parent, init, getTraps, useNew) {
		var model = function model() {
			var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : model.default;
			var mode = arguments[1];
	
			if (useNew && !is(model, this)) return new model(val);
			if (init) val = init(val, model, this);
	
			if (mode === _checked || check(model, val)) return getTraps ? proxify(val, getTraps(model)) : val;
		};
	
		if (parent) extend(model, parent);
		setProto(model, constructor.prototype);
		model.constructor = constructor;
		model.definition = def;
		model.assertions = [].concat(_toConsumableArray(model.assertions));
		define(model, "errors", []);
		delete model.name;
		return model;
	},
	    initObjectModel = function initObjectModel(obj, model, _this) {
		if (is(model, obj)) return obj;
	
		if (!isObject(obj) && !isFunction(obj) && obj !== undefined) {
			stackError(model.errors, Object, obj);
		}
	
		merge(_this, model.default);
		if (model.parentClass) merge(obj, new model.parentClass(obj));
		merge(_this, obj);
		return _this;
	},
	    extendModel = function extendModel(child, parent, newProps) {
		var _child$assertions;
	
		extend(child, parent, newProps);
		(_child$assertions = child.assertions).push.apply(_child$assertions, _toConsumableArray(parent.assertions));
		return child;
	},
	    stackError = function stackError(errors, expected, received, path, message) {
		errors.push({ expected: expected, received: received, path: path, message: message });
	},
	    unstackErrors = function unstackErrors(model) {
		var collector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : model.errorCollector;
	
		var nbErrors = model.errors.length;
		if (nbErrors > 0) {
			var errors = model.errors.map(function (err) {
				if (!err.message) {
					err.message = "expecting " + (err.path ? err.path + " to be " : "") + formatDefinition(err.expected) + ", got " + (err.received != null ? bettertypeof(err.received) + " " : "") + format(err.received);
				}
				return err;
			});
	
			model.errors.length = 0;
			collector.call(model, errors); // throw all errors collected
		}
		return nbErrors;
	},
	    isModelInstance = function isModelInstance(i) {
		return i && getProto(i) && is(Model, getProto(i).constructor);
	},
	    parseDefinition = function parseDefinition(def) {
		if (isPlainObject(def)) {
			Object.keys(def).map(function (key) {
				def[key] = parseDefinition(def[key]);
			});
		} else if (!Array.isArray(def)) return [def];else if (def.length === 1) return [def[0], undefined, null];
	
		return def;
	},
	    formatDefinition = function formatDefinition(def, stack) {
		var parts = parseDefinition(def).map(function (d) {
			return format(d, stack);
		});
		return parts.length > 1 ? parts.join(" or ") : parts[0];
	},
	    formatAssertions = function formatAssertions(fns) {
		return fns.length ? "(" + fns.map(function (f) {
			return f.name || f.description || f;
		}) + ")" : "";
	},
	    extendDefinition = function extendDefinition(def) {
		var newParts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
		newParts = [].concat(newParts);
		if (newParts.length > 0) {
			def = newParts.reduce(function (def, ext) {
				return def.concat(ext);
			}, [].concat(def)) // clone to lose ref
			.filter(function (value, index, self) {
				return self.indexOf(value) === index;
			}); // remove duplicates
		}
	
		return def;
	},
	    check = function check(model, obj) {
		model[_check](obj, null, model.errors, [], true);
		return !unstackErrors(model);
	},
	    checkDefinition = function checkDefinition(obj, def, path, errors, stack, shouldCast) {
		var indexFound = stack.indexOf(def);
		if (indexFound !== -1 && stack.indexOf(def, indexFound + 1) !== -1) return obj; // if found twice in call stack, cycle detected, skip validation
	
		if (Array.isArray(def) && def.length === 1 && obj != null) {
			def = def[0]; // shorten validation path for optionals
		}
	
		if (is(Model, def)) {
			if (shouldCast) obj = cast(obj, def);
			def[_check](obj, path, errors, stack.concat(def));
		} else if (isPlainObject(def)) {
			Object.keys(def).map(function (key) {
				var val = obj ? obj[key] : undefined;
				checkDefinition(val, def[key], formatPath(path, key), errors, stack, shouldCast);
			});
		} else {
			var pdef = parseDefinition(def);
			if (pdef.some(function (part) {
				return checkDefinitionPart(obj, part, path, stack);
			})) {
				return shouldCast ? cast(obj, def) : obj;
			}
	
			stackError(errors, def, obj, path);
		}
	
		return obj;
	},
	    checkDefinitionPart = function checkDefinitionPart(obj, def, path, stack, shouldCast) {
		if (def === Any) return true;
		if (obj == null) return obj === def;
		if (isPlainObject(def) || is(Model, def)) {
			// object or model as part of union type
			var errors = [];
			checkDefinition(obj, def, path, errors, stack, shouldCast);
			return !errors.length;
		}
		if (is(RegExp, def)) return def.test(obj);
		if (def === Number || def === Date) return obj.constructor === def && !isNaN(obj);
		return obj === def || isFunction(def) && is(def, obj) || obj.constructor === def;
	},
	    checkAssertions = function checkAssertions(obj, model, path) {
		var errors = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : model.errors;
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;
	
		try {
			var _loop = function _loop() {
				var assertion = _step.value;
	
				var result = void 0;
				try {
					result = assertion.call(model, obj);
				} catch (err) {
					result = err;
				}
				if (result !== true) {
					var onFail = isFunction(assertion.description) ? assertion.description : function (assertionResult, value) {
						return "assertion \"" + assertion.description + "\" returned " + format(assertionResult) + " " + ("for " + (path ? path + " =" : "value") + " " + format(value));
					};
					stackError(errors, assertion, obj, path, onFail.call(model, result, obj, path));
				}
			};
	
			for (var _iterator = model.assertions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				_loop();
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	},
	    format = function format(obj) {
		var stack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
		if (stack.length > 15 || stack.includes(obj)) return "...";
		if (obj === null || obj === undefined) return String(obj);
		if (typeof obj === "string") return "\"" + obj + "\"";
		if (is(Model, obj)) return obj.toString(stack);
	
		stack.unshift(obj);
	
		if (isFunction(obj)) return obj.name || obj.toString();
		if (is(Map, obj) || is(Set, obj)) return format([].concat(_toConsumableArray(obj)));
		if (Array.isArray(obj)) return "[" + obj.map(function (item) {
			return format(item, stack);
		}).join(", ") + "]";
		if (obj.toString && obj.toString !== Object.prototype.toString) return obj.toString();
		if (isObject(obj)) {
			var props = Object.keys(obj),
			    indent = "\t".repeat(stack.length);
			return "{" + props.map(function (key) {
				return "\n" + (indent + key) + ": " + format(obj[key], [].concat(_toConsumableArray(stack)));
			}).join(", ") + " " + (props.length ? "\n" + indent.slice(1) : "") + "}";
		}
	
		return String(obj);
	},
	    formatPath = function formatPath(path, key) {
		return path ? path + "." + key : key;
	},
	    controlMutation = function controlMutation(model, def, path, o, key, privateAccess, applyMutation) {
		var newPath = formatPath(path, key),
		    isPrivate = model.conventionForPrivate(key),
		    isConstant = model.conventionForConstant(key),
		    isOwnProperty = has(o, key),
		    initialPropDescriptor = isOwnProperty && Object.getOwnPropertyDescriptor(o, key);
	
		if (key in def && (isPrivate && !privateAccess || isConstant && o[key] !== undefined)) cannot("modify " + (isPrivate ? "private" : "constant") + " property " + key, model);
	
		applyMutation(newPath);
		if (has(def, key)) checkDefinition(o[key], def[key], newPath, model.errors, []);
		checkAssertions(o, model, newPath);
	
		var nbErrors = model.errors.length;
		if (nbErrors) {
			if (isOwnProperty) Object.defineProperty(o, key, initialPropDescriptor);else delete o[key]; // back to the initial property defined in prototype chain
	
			unstackErrors(model);
		}
	
		return !nbErrors;
	},
	    cannot = function cannot(msg, model) {
		model.errors.push({ message: "cannot " + msg });
	},
	    cast = function cast(obj) {
		var defNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
		if (!obj || isPlainObject(defNode) || is(BasicModel, defNode) || isModelInstance(obj)) return obj; // no value or not leaf or already a model instance
	
		var def = parseDefinition(defNode),
		    suitableModels = [];
	
		var _iteratorNormalCompletion2 = true;
		var _didIteratorError2 = false;
		var _iteratorError2 = undefined;
	
		try {
			for (var _iterator2 = def[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
				var part = _step2.value;
	
				if (is(Model, part) && !is(BasicModel, part) && part.test(obj)) suitableModels.push(part);
			}
		} catch (err) {
			_didIteratorError2 = true;
			_iteratorError2 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion2 && _iterator2.return) {
					_iterator2.return();
				}
			} finally {
				if (_didIteratorError2) {
					throw _iteratorError2;
				}
			}
		}
	
		if (suitableModels.length === 1) {
			// automatically cast to suitable model when explicit (autocasting)
			return new suitableModels[0](obj, _checked);
		}
	
		if (suitableModels.length > 1) console.warn("Ambiguous model for value " + format(obj) + ", could be " + suitableModels.join(" or "));
	
		return obj;
	},
	    getProp = function getProp(val, model, def, path, privateAccess) {
		if (!isPlainObject(def)) return cast(val, def);
		return proxify(val, getTraps(model, def, path, privateAccess));
	},
	    getTraps = function getTraps(model, def, path, privateAccess) {
		var grantPrivateAccess = function grantPrivateAccess(f) {
			return proxify(f, {
				apply: function apply(fn, ctx, args) {
					privateAccess = true;
					var result = Reflect.apply(fn, ctx, args);
					privateAccess = false;
					return result;
				}
			});
		};
	
		return {
			getPrototypeOf: function getPrototypeOf(obj) {
				return path ? Object.prototype : getProto(obj);
			},
	
			get: function get(o, key) {
				if (key === _original) return o;
	
				if (typeof key !== "string") return Reflect.get(o, key);
	
				var newPath = formatPath(path, key),
				    defPart = def[key];
	
				if (!privateAccess && key in def && model.conventionForPrivate(key)) {
					cannot("access to private property " + newPath, model);
					unstackErrors(model);
					return;
				}
	
				if (o[key] && has(o, key) && !isPlainObject(defPart) && !isModelInstance(o[key])) {
					o[key] = cast(o[key], defPart); // cast nested models
				}
	
				if (isFunction(o[key]) && key !== "constructor" && !privateAccess) {
					return grantPrivateAccess(o[key]);
				}
	
				if (isPlainObject(defPart) && !o[key]) {
					o[key] = {}; // null-safe traversal
				}
	
				return getProp(o[key], model, defPart, newPath, privateAccess);
			},
			set: function set(o, key, val) {
				return controlMutation(model, def, path, o, key, privateAccess, function (newPath) {
					return Reflect.set(o, key, getProp(val, model, def[key], newPath));
				});
			},
			deleteProperty: function deleteProperty(o, key) {
				return controlMutation(model, def, path, o, key, privateAccess, function () {
					return Reflect.deleteProperty(o, key);
				});
			},
			defineProperty: function defineProperty(o, key, args) {
				return controlMutation(model, def, path, o, key, privateAccess, function () {
					return Reflect.defineProperty(o, key, args);
				});
			},
			has: function has(o, key) {
				return Reflect.has(o, key) && Reflect.has(def, key) && !model.conventionForPrivate(key);
			},
			ownKeys: function ownKeys(o) {
				return Reflect.ownKeys(o).filter(function (key) {
					return Reflect.has(def, key) && !model.conventionForPrivate(key);
				});
			},
			getOwnPropertyDescriptor: function getOwnPropertyDescriptor(o, key) {
				var descriptor = void 0;
				if (!model.conventionForPrivate(key)) {
					descriptor = Object.getOwnPropertyDescriptor(def, key);
					if (descriptor !== undefined) descriptor.value = o[key];
				}
	
				return descriptor;
			}
		};
	};
	
	function Model(def, params) {
		return isPlainObject(def) ? new ObjectModel(def, params) : new BasicModel(def);
	}
	
	Object.assign(Model.prototype, (_Object$assign = {
		name: "Model",
		assertions: [],
	
		conventionForConstant: function conventionForConstant(key) {
			return key.toUpperCase() === key;
		},
		conventionForPrivate: function conventionForPrivate(key) {
			return key[0] === "_";
		},
	
		toString: function toString(stack) {
			return has(this, "name") ? this.name : formatDefinition(this.definition, stack) + formatAssertions(this.assertions);
		},
		as: function as(name) {
			define(this, "name", name);
			return this;
		},
		defaultTo: function defaultTo(val) {
			this.default = val;
			return this;
		}
	}, _defineProperty(_Object$assign, _check, function (obj, path, errors, stack) {
		checkDefinition(obj, this.definition, path, errors, stack);
		checkAssertions(obj, this, path, errors);
	}), _defineProperty(_Object$assign, "test", function test(obj, errorCollector) {
		var _this2 = this;
	
		var model = this;
		while (!has(model, "errorCollector")) {
			model = getProto(model);
		}
	
		var initialErrorCollector = model.errorCollector,
		    failed = void 0;
	
		model.errorCollector = function (errors) {
			failed = true;
			if (errorCollector) errorCollector.call(_this2, errors);
		};
	
		new this(obj); // may trigger errorCollector
	
		model.errorCollector = initialErrorCollector;
		return !failed;
	}), _defineProperty(_Object$assign, "errorCollector", function errorCollector(errors) {
		var e = new TypeError(errors.map(function (e) {
			return e.message;
		}).join("\n"));
		e.stack = e.stack.replace(/\n.*object-model(.|\n)*object-model.*/, ""); // blackbox objectmodel in stacktrace
		throw e;
	}), _defineProperty(_Object$assign, "assert", function assert(assertion) {
		var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : format(assertion);
	
		define(assertion, "description", description);
		this.assertions = this.assertions.concat(assertion);
		return this;
	}), _Object$assign));
	
	function BasicModel(def) {
		return initModel(def, BasicModel);
	}
	
	extend(BasicModel, Model, {
		extend: function extend() {
			for (var _len = arguments.length, newParts = Array(_len), _key = 0; _key < _len; _key++) {
				newParts[_key] = arguments[_key];
			}
	
			var child = extendModel(new BasicModel(extendDefinition(this.definition, newParts)), this);
			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;
	
			try {
				for (var _iterator3 = newParts[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var _child$assertions2;
	
					var part = _step3.value;
	
					if (is(BasicModel, part)) (_child$assertions2 = child.assertions).push.apply(_child$assertions2, _toConsumableArray(part.assertions));
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}
	
			return child;
		}
	});
	
	function ObjectModel(def) {
		return initModel(def, ObjectModel, Object, initObjectModel, function (model) {
			return getTraps(model, def);
		}, true);
	}
	
	extend(ObjectModel, Model, _defineProperty({
		defaultTo: function defaultTo(obj) {
			var def = this.definition;
			for (var key in obj) {
				if (has(def, key)) {
					obj[key] = checkDefinition(obj[key], def[key], key, this.errors, [], true);
				}
			}
			unstackErrors(this);
			this.default = obj;
			return this;
		},
		toString: function toString(stack) {
			return format(this.definition, stack);
		},
		extend: function extend() {
			var definition = _extends({}, this.definition),
			    proto = _extends({}, this.prototype),
			    defaults = _extends({}, this.default),
			    newAssertions = [];
	
			for (var _len2 = arguments.length, newParts = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				newParts[_key2] = arguments[_key2];
			}
	
			var _iteratorNormalCompletion4 = true;
			var _didIteratorError4 = false;
			var _iteratorError4 = undefined;
	
			try {
				for (var _iterator4 = newParts[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
					var part = _step4.value;
	
					if (is(Model, part)) {
						merge(definition, part.definition);
						merge(defaults, part.default);
						newAssertions.push.apply(newAssertions, _toConsumableArray(part.assertions));
					}
					if (isFunction(part)) merge(proto, part.prototype);
					if (isObject(part)) merge(definition, part);
				}
			} catch (err) {
				_didIteratorError4 = true;
				_iteratorError4 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion4 && _iterator4.return) {
						_iterator4.return();
					}
				} finally {
					if (_didIteratorError4) {
						throw _iteratorError4;
					}
				}
			}
	
			var submodel = extendModel(new ObjectModel(definition), this, proto).defaultTo(defaults);
			submodel.assertions = [].concat(_toConsumableArray(this.assertions), newAssertions);
	
			if (getProto(this) !== ObjectModel.prototype) {
				// extended class
				submodel.parentClass = this;
			}
	
			return submodel;
		}
	}, _check, function (obj, path, errors, stack, shouldCast) {
		if (isObject(obj)) {
			var def = this.definition;
			checkDefinition(obj[_original] || obj, def, path, errors, stack, shouldCast);
		} else stackError(errors, this, obj, path);
	
		checkAssertions(obj, this, path, errors);
	}));
	
	var Any = proxify(BasicModel(), {
		apply: function apply(target, ctx, _ref) {
			var _ref2 = _slicedToArray(_ref, 1),
			    def = _ref2[0];
	
			return Object.assign(Object.create(Any), { definition: def });
		}
	});
	Any.definition = Any;
	Any.toString = function () {
		return "Any";
	};
	
	Any.remaining = function (def) {
		this.definition = def;
	};
	extend(Any.remaining, Any, {
		toString: function toString() {
			return "..." + formatDefinition(this.definition);
		}
	});
	Any[Symbol.iterator] = /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return new Any.remaining(this.definition);
	
					case 2:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this);
	});
	
	var initListModel = function initListModel(base, constructor, def, init, clone, mutators, otherTraps) {
	
		return initModel(def, constructor, base, init, function (model) {
			return Object.assign({
				getPrototypeOf: function getPrototypeOf() {
					return model.prototype;
				},
				get: function get(l, key) {
					if (key === _original) return l;
	
					var val = l[key];
					return isFunction(val) ? proxify(val, {
						apply: function apply(fn, ctx, args) {
							if (has(mutators, key)) {
								// indexes of arguments to check def + cast
								var _mutators$key = _slicedToArray(mutators[key], 3),
								    begin = _mutators$key[0],
								    _mutators$key$ = _mutators$key[1],
								    end = _mutators$key$ === undefined ? args.length - 1 : _mutators$key$,
								    getArgDef = _mutators$key[2];
	
								for (var i = begin; i <= end; i++) {
									var argDef = getArgDef ? getArgDef(i) : model.definition;
									args[i] = checkDefinition(args[i], argDef, base.name + "." + key + " arguments[" + i + "]", model.errors, [], true);
								}
	
								if (model.assertions.length > 0) {
									var testingClone = clone(l);
									fn.apply(testingClone, args);
									checkAssertions(testingClone, model, "after " + key + " mutation");
								}
	
								unstackErrors(model);
							}
	
							return fn.apply(l, args);
						}
					}) : val;
				}
			}, otherTraps);
		});
	};
	
	function ArrayModel(initialDefinition) {
		var model = initListModel(Array, ArrayModel, initialDefinition, function (a) {
			return Array.isArray(a) ? a.map(function (arg) {
				return cast(arg, model.definition);
			}) : a;
		}, function (a) {
			return [].concat(_toConsumableArray(a));
		}, {
			"copyWithin": [],
			"fill": [0, 0],
			"pop": [],
			"push": [0],
			"reverse": [],
			"shift": [],
			"sort": [],
			"splice": [2],
			"unshift": [0]
		}, {
			set: function set(arr, key, val) {
				return controlMutation$1(model, arr, key, val, function (a, v) {
					return a[key] = v;
				}, true);
			},
			deleteProperty: function deleteProperty(arr, key) {
				return controlMutation$1(model, arr, key, undefined, function (a) {
					return delete a[key];
				});
			}
		});
	
		return model;
	}
	
	extend(ArrayModel, Model, (_extend2 = {
		toString: function toString(stack) {
			return "Array of " + formatDefinition(this.definition, stack);
		}
	}, _defineProperty(_extend2, _check, function (arr, path, errors, stack) {
		var _this3 = this;
	
		if (Array.isArray(arr)) (arr[_original] || arr).forEach(function (a, i) {
			return checkDefinition(a, _this3.definition, (path || "Array") + "[" + i + "]", errors, stack);
		});else stackError(errors, this, arr, path);
	
		checkAssertions(arr, this, path, errors);
	}), _defineProperty(_extend2, "extend", function extend() {
		for (var _len3 = arguments.length, newParts = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
			newParts[_key3] = arguments[_key3];
		}
	
		return extendModel(new ArrayModel(extendDefinition(this.definition, newParts)), this);
	}), _extend2));
	
	var controlMutation$1 = function controlMutation$1(model, array, key, value, applyMutation, canBeExtended) {
		var path = "Array[" + key + "]";
		var isInDef = +key >= 0 && (canBeExtended || key in array);
		if (isInDef) value = checkDefinition(value, model.definition, path, model.errors, [], true);
	
		var testArray = [].concat(_toConsumableArray(array));
		applyMutation(testArray);
		checkAssertions(testArray, model, path);
		var isSuccess = !unstackErrors(model);
		if (isSuccess) applyMutation(array, value);
		return isSuccess;
	};
	
	function SetModel(initialDefinition) {
		var model = initListModel(Set, SetModel, initialDefinition, function (it) {
			return isIterable(it) ? new Set([].concat(_toConsumableArray(it)).map(function (val) {
				return cast(val, model.definition);
			})) : it;
		}, function (set) {
			return new Set(set);
		}, {
			"add": [0, 0],
			"delete": [],
			"clear": []
		});
	
		return model;
	}
	
	extend(SetModel, Model, (_extend3 = {
		toString: function toString(stack) {
			return "Set of " + formatDefinition(this.definition, stack);
		}
	}, _defineProperty(_extend3, _check, function (set, path, errors, stack) {
		if (is(Set, set)) {
			var _iteratorNormalCompletion5 = true;
			var _didIteratorError5 = false;
			var _iteratorError5 = undefined;
	
			try {
				for (var _iterator5 = set.values()[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
					var item = _step5.value;
	
					checkDefinition(item, this.definition, (path || "Set") + " value", errors, stack);
				}
			} catch (err) {
				_didIteratorError5 = true;
				_iteratorError5 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion5 && _iterator5.return) {
						_iterator5.return();
					}
				} finally {
					if (_didIteratorError5) {
						throw _iteratorError5;
					}
				}
			}
		} else stackError(errors, this, set, path);
		checkAssertions(set, this, path, errors);
	}), _defineProperty(_extend3, "extend", function extend() {
		for (var _len4 = arguments.length, newParts = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
			newParts[_key4] = arguments[_key4];
		}
	
		return extendModel(new SetModel(extendDefinition(this.definition, newParts)), this);
	}), _extend3));
	
	function MapModel(initialKeyDefinition, initialValueDefinition) {
		var getDef = function getDef(i) {
			return i === 0 ? model.definition.key : model.definition.value;
		},
		    model = initListModel(Map, MapModel, { key: initialKeyDefinition, value: initialValueDefinition }, function (it) {
			return isIterable(it) ? new Map([].concat(_toConsumableArray(it)).map(function (pair) {
				return pair.map(function (x, i) {
					return cast(x, getDef(i));
				});
			})) : it;
		}, function (map) {
			return new Map(map);
		}, {
			"set": [0, 1, getDef],
			"delete": [],
			"clear": []
		});
	
		return model;
	}
	
	extend(MapModel, Model, (_extend4 = {
		toString: function toString(stack) {
			return "Map of " + formatDefinition(this.definition.key, stack) + " : " + formatDefinition(this.definition.value, stack);
		}
	}, _defineProperty(_extend4, _check, function (map, path, errors, stack) {
		if (is(Map, map)) {
			path = path || "Map";
			var _iteratorNormalCompletion6 = true;
			var _didIteratorError6 = false;
			var _iteratorError6 = undefined;
	
			try {
				for (var _iterator6 = map[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
					var _step6$value = _slicedToArray(_step6.value, 2),
					    key = _step6$value[0],
					    value = _step6$value[1];
	
					checkDefinition(key, this.definition.key, path + " key", errors, stack);
					checkDefinition(value, this.definition.value, path + "[" + format(key) + "]", errors, stack);
				}
			} catch (err) {
				_didIteratorError6 = true;
				_iteratorError6 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion6 && _iterator6.return) {
						_iterator6.return();
					}
				} finally {
					if (_didIteratorError6) {
						throw _iteratorError6;
					}
				}
			}
		} else stackError(errors, this, map, path);
	
		checkAssertions(map, this, path, errors);
	}), _defineProperty(_extend4, "extend", function extend(keyParts, valueParts) {
		return extendModel(new MapModel(extendDefinition(this.definition.key, keyParts), extendDefinition(this.definition.value, valueParts)), this);
	}), _extend4));
	
	function FunctionModel() {
		for (var _len5 = arguments.length, argsDef = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
			argsDef[_key5] = arguments[_key5];
		}
	
		return initModel({ arguments: argsDef }, FunctionModel, Function, null, function (model) {
			return {
				getPrototypeOf: function getPrototypeOf() {
					return model.prototype;
				},
	
				get: function get(fn, key) {
					return key === _original ? fn : fn[key];
				},
				apply: function apply(fn, ctx, args) {
					var def = model.definition,
					    remainingArgDef = def.arguments.find(function (argDef) {
						return is(Any.remaining, argDef);
					}),
					    nbArgsToCheck = remainingArgDef ? Math.max(args.length, def.arguments.length - 1) : def.arguments.length;
	
					for (var i = 0; i < nbArgsToCheck; i++) {
						var argDef = remainingArgDef && i >= def.arguments.length - 1 ? remainingArgDef.definition : def.arguments[i];
						args[i] = checkDefinition(args[i], argDef, "arguments[" + i + "]", model.errors, [], true);
					}
	
					checkAssertions(args, model, "arguments");
	
					var result = void 0;
					if (!model.errors.length) {
						result = Reflect.apply(fn, ctx, args);
						if ("return" in def) result = checkDefinition(result, def.return, "return value", model.errors, [], true);
					}
					unstackErrors(model);
					return result;
				}
			};
		});
	}
	
	extend(FunctionModel, Model, _defineProperty({
		toString: function toString() {
			var stack = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
			var out = "Function(" + this.definition.arguments.map(function (argDef) {
				return formatDefinition(argDef, [].concat(_toConsumableArray(stack)));
			}).join(", ") + ")";
	
			if ("return" in this.definition) {
				out += " => " + formatDefinition(this.definition.return, stack);
			}
			return out;
		},
		return: function _return(def) {
			this.definition.return = def;
			return this;
		},
		extend: function extend(newArgs, newReturns) {
			var args = this.definition.arguments,
			    mixedArgs = newArgs.map(function (a, i) {
				return extendDefinition(i in args ? args[i] : [], newArgs[i]);
			}),
			    mixedReturns = extendDefinition(this.definition.return, newReturns);
			return extendModel(new (Function.prototype.bind.apply(FunctionModel, [null].concat(_toConsumableArray(mixedArgs))))().return(mixedReturns), this);
		}
	}, _check, function (f, path, errors) {
		if (!isFunction(f)) stackError(errors, "Function", f, path);
	}));
	
	var styles = {
		list: "list-style-type: none; padding: 0; margin: 0;",
		listItem: "padding: 0 0 0 1em;",
		model: "color: #3e999f;",
		instance: "color: #718c00; font-style: italic",
		function: "color: #4271AE",
		string: "color: #C41A16",
		number: "color: #1C00CF",
		boolean: "color: #AA0D91",
		property: "color: #8959a8",
		private: "color: #C19ED8",
		constant: "color: #8959a8; font-weight: bold",
		privateConstant: "color: #C19ED8; font-weight: bold",
		null: "color: #8e908c",
		undeclared: "color: #C0C0C0;",
		proto: "color: #B871BD; font-style: italic"
	};
	
	var getModel = function getModel(instance) {
		if (instance === undefined || instance === null) return null;
	
		var proto = getProto(instance);
		if (!proto || !proto.constructor || !is(Model, proto.constructor)) return null;
	
		return proto.constructor;
	};
	
	var span = function span(style) {
		for (var _len6 = arguments.length, children = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
			children[_key6 - 1] = arguments[_key6];
		}
	
		return ["span", { style: style }].concat(children);
	};
	
	var format$1 = function format$1(x) {
		var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		if (x === null || x === undefined) return span(styles.null, "" + x);
	
		if (typeof x === "boolean") return span(styles.boolean, x);
	
		if (typeof x === "number") return span(styles.number, x);
	
		if (typeof x === "string") return span(styles.string, "\"" + x + "\"");
	
		if (Array.isArray(x) && config.isModelDefinition) {
			var def = [];
			if (x.length === 1) x.push(undefined, null);
			for (var i = 0; i < x.length; i++) {
				def.push(format$1(x[i], config));
				if (i < x.length - 1) def.push(" or ");
			}
			return span.apply(undefined, [""].concat(def));
		}
	
		if (isPlainObject(x)) return formatObject(x, getModel(x), config);
	
		if (isFunction(x) && !is(Model, x) && config.isModelDefinition) return span(styles.function, x.name || x.toString());
	
		return ["object", { object: x, config: config }];
	};
	
	var formatObject = function formatObject(o, model, config) {
		return span("", "{", ["ol", { style: styles.list }].concat(_toConsumableArray(Object.keys(o).map(function (prop) {
			return ["li", { style: styles.listItem }, span(styles.property, prop), ": ", format$1(o[prop], config)];
		}))), "}");
	};
	
	var formatModel = function formatModel(model) {
		var parts = [],
		    cfg = { isModelDefinition: true },
		    def = model.definition,
		    formatList = function formatList(list, map) {
			return list.reduce(function (r, e) {
				return [].concat(_toConsumableArray(r), [map(e), ", "]);
			}, []).slice(0, 2 * list.length - 1);
		};
	
		if (is(BasicModel, model)) parts.push(format$1(def, cfg));
		if (is(ArrayModel, model)) parts.push("Array of ", format$1(def, cfg));
		if (is(SetModel, model)) parts.push("Set of ", format$1(def, cfg));
		if (is(MapModel, model)) parts.push("Map of ", format$1(def.key, cfg), " : ", format$1(def.value, cfg));
		if (is(FunctionModel, model)) {
			parts.push.apply(parts, ["Function("].concat(_toConsumableArray(formatList(def.arguments, function (arg) {
				return format$1(arg, cfg);
			})), [")"]));
			if ("return" in def) parts.push(" => ", format$1(def.return, cfg));
		}
	
		if (model.assertions.length > 0) {
			parts.push.apply(parts, ["\n(assertions: "].concat(_toConsumableArray(formatList(model.assertions, function (f) {
				return ["object", { object: f }];
			})), [")"]));
		}
	
		return span.apply(undefined, [styles.model].concat(parts));
	};
	
	var ModelFormatter = {
		header: function header(x) {
			var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
			if (x === Any) return span(styles.model, "Any");
	
			if (is(Any.remaining, x)) return span(styles.model, "...", format$1(x.definition, { isModelDefinition: true }));
	
			if (is(ObjectModel, x)) return span(styles.model, x.name);
	
			if (is(Model, x)) {
				return formatModel(x);
			}
	
			if (config.isModelDefinition && isPlainObject(x)) return format$1(x, config);
	
			return null;
		},
		hasBody: function hasBody(x) {
			return is(ObjectModel, x);
		},
		body: function body(model) {
			return span("", "{", ["ol", { style: styles.list }].concat(_toConsumableArray(Object.keys(model.definition).map(function (prop) {
				var isPrivate = model.conventionForPrivate(prop),
				    isConstant = model.conventionForConstant(prop),
				    hasDefault = model.default && has(model.default, prop),
				    style = styles.property;
	
				if (isPrivate) {
					style = isConstant ? styles.privateConstant : styles.private;
				} else if (isConstant) {
					style = styles.constant;
				}
	
				return ["li", { style: styles.listItem }, span(style, prop), ": ", format$1(model.definition[prop], { isModelDefinition: true }), hasDefault ? span(styles.proto, " = ", format$1(model.default[prop])) : ""];
			}))), "}");
		}
	};
	
	var ModelInstanceFormatter = {
		header: function header(x) {
			var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
			if (config.isInstanceProperty && isPlainObject(x)) {
				return format$1(x, config);
			}
	
			var model = getModel(x);
			if (is(Model, model)) {
				var parts = is(ObjectModel, model) ? [model.name] : [["object", { object: x[_original] }], " (" + model.name + ")"];
				return span.apply(undefined, [styles.instance].concat(parts));
			}
	
			return null;
		},
		hasBody: function hasBody(x) {
			return x && is(ObjectModel, getModel(x));
		},
		body: function body(x) {
			var model = getModel(x);
			var o = x[_original] || x;
			return span("", "{", ["ol", { style: styles.list }].concat(_toConsumableArray(Object.keys(o).map(function (prop) {
				var isPrivate = model.conventionForPrivate(prop),
				    isConstant = model.conventionForConstant(prop),
				    isDeclared = prop in model.definition,
				    style = styles.property;
	
				if (!isDeclared) {
					style = styles.undeclared;
				} else if (isPrivate) {
					style = isConstant ? styles.privateConstant : styles.private;
				} else if (isConstant) {
					style = styles.constant;
				}
	
				return ["li", { style: styles.listItem }, span(style, prop), ": ", format$1(o[prop], { isInstanceProperty: true })];
			})), [["li", { style: styles.listItem }, span(styles.proto, "__proto__", ": ", ["object", { object: getProto(x) }])]]), "}");
		}
	};
	
	if (typeof window !== "undefined") {
		window.devtoolsFormatters = (window.devtoolsFormatters || []).concat(ModelFormatter, ModelInstanceFormatter);
	}
	
	exports.Any = Any;
	exports.ArrayModel = ArrayModel;
	exports.BasicModel = BasicModel;
	exports.FunctionModel = FunctionModel;
	exports.MapModel = MapModel;
	exports.Model = Model;
	exports.ObjectModel = ObjectModel;
	exports.SetModel = SetModel;
	//# sourceMappingURL=object-model.js.map

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.response = response;
	
	var _Result = __webpack_require__(63);
	
	var _utils = __webpack_require__(30);
	
	function response(data, target) {
	  var flatten = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  var result = new _Result.SimpleResult(data);
	  if (flatten) {
	    result = (0, _utils.simpleObject)(result);
	  }
	  target.postMessage(result, '*');
	}

/***/ },
/* 66 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MessageListener = function () {
	  function MessageListener() {
	    _classCallCheck(this, MessageListener);
	
	    this.onReceiveMessage = null;
	  }
	
	  _createClass(MessageListener, [{
	    key: 'start',
	    value: function start(onReceiveMessage) {
	      this.onReceiveMessage = onReceiveMessage;
	      window.addEventListener('message:action', this.onReceiveMessage, false);
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      if (this.onReceiveMessage) {
	        window.removeEventListener('message:action', this.onReceiveMessage);
	      }
	    }
	  }]);
	
	  return MessageListener;
	}();
	
	exports.default = MessageListener = new MessageListener();

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(30);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MessageSender = function () {
	  function MessageSender() {
	    var _this = this;
	
	    _classCallCheck(this, MessageSender);
	
	    this.receiveMessage = function (event) {
	      var data = event.data,
	          source = event.source,
	          origin = event.origin;
	
	      var isOrginAllowed = _this.checkOriginPermission(origin);
	      if (isOrginAllowed === false) {
	        console.error('[receiveMessage] message received from unpermitted origin' + (' ' + origin + '. Abort.'));
	        return;
	      }
	      var id = data.id,
	          action = data.action,
	          detail = data.detail,
	          success = data.success;
	
	      if (action) {
	        // handle action
	        data.source = source;
	        var _event = new CustomEvent('message:action', {
	          detail: data
	        });
	        window.dispatchEvent(_event);
	      } else {
	        // response
	        if (_this.twoWayMessageCallbacks[id]) {
	          _this.twoWayMessageCallbacks[id](success, detail);
	          delete _this.twoWayMessageCallbacks[id];
	        }
	      }
	    };
	
	    this.target = window.parent;
	    this.twoWayMessageCallbacks = {}; // { id: callback }
	    this.messageQueue = [];
	    this.remoteReady = false;
	    this.targetOrigin = '*';
	    this.validMessageOrigins = '*';
	  }
	
	  _createClass(MessageSender, [{
	    key: 'start',
	    value: function start() {
	      window.addEventListener('message', this.receiveMessage, false);
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      window.removeEventListener('message', this.receiveMessage);
	    }
	  }, {
	    key: 'send',
	    value: function send(data, callback) {
	      if (typeof this.target === 'undefined') {
	        return false;
	      }
	      data.id = data.id + (0, _utils.hashCode)(JSON.stringify(data));
	      if (callback) {
	        this.twoWayMessageCallbacks[data.id] = callback;
	      }
	      var message = (0, _utils.simpleObject)(data);
	      if (this.remoteReady) {
	        this.target.postMessage(message, this.targetOrigin);
	      } else {
	        this.messageQueue.push(message);
	      }
	    }
	  }, {
	    key: 'postFullQueue',
	    value: function postFullQueue() {
	      while (this.messageQueue.length > 0) {
	        this.postNext();
	      }
	    }
	  }, {
	    key: 'postNext',
	    value: function postNext() {
	      var message = this.messageQueue.shift();
	      if (message) {
	        this.target.postMessage(message, this.targetOrigin);
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'checkOriginPermission',
	    value: function checkOriginPermission(origin) {
	      var validOrigins = this.validMessageOrigins;
	
	      if (validOrigins === '*') {
	        return true;
	      } else if (Array.isArray(validOrigins) && validOrigins.includes(origin)) {
	        return true;
	      } else if (typeof validOrigins === 'string' && validOrigins === origin) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }]);
	
	  return MessageSender;
	}();
	
	exports.default = MessageSender = new MessageSender();

/***/ },
/* 68 */
/***/ function(module, exports) {

	'use strict';
	
	/* globals indexedDB */
	/**
	 * This file defines an asynchronous version of the localStorage API, backed by
	 * an IndexedDB database.  It creates a global asyncStorage object that has
	 * methods like the localStorage object.
	 *
	 * To store a value use setItem:
	 *
	 *   asyncStorage.setItem('key', 'value');
	 *
	 * If you want confirmation that the value has been stored, pass a callback
	 * function as the third argument:
	 *
	 *  asyncStorage.setItem('key', 'newvalue', function() {
	 *    console.log('new value stored');
	 *  });
	 *
	 * To read a value, call getItem(), but note that you must supply a callback
	 * function that the value will be passed to asynchronously:
	 *
	 *  asyncStorage.getItem('key', function(value) {
	 *    console.log('The value of key is:', value);
	 *  });
	 *
	 * Note that unlike localStorage, asyncStorage does not allow you to store and
	 * retrieve values by setting and querying properties directly. You cannot just
	 * write asyncStorage.key; you have to explicitly call setItem() or getItem().
	 *
	 * removeItem(), clear(), length(), and key() are like the same-named methods of
	 * localStorage, but, like getItem() and setItem() they take a callback
	 * argument.
	 *
	 * The asynchronous nature of getItem() makes it tricky to retrieve multiple
	 * values. But unlike localStorage, asyncStorage does not require the values you
	 * store to be strings.  So if you need to save multiple values and want to
	 * retrieve them together, in a single asynchronous operation, just group the
	 * values into a single object. The properties of this object may not include
	 * DOM elements, but they may include things like Blobs and typed arrays.
	 *
	 * Unit tests are in apps/gallery/test/unit/asyncStorage_test.js
	 */
	
	window.asyncStorage = function () {
	  'use strict';
	
	  var DBNAME = 'asyncStorage';
	  var DBVERSION = localStorage.async_storage_db_ver || 1;
	  var STORENAME = 'keyvaluepairs';
	  var db = null;
	  var count = 3;
	
	  function withDatabase(f) {
	    if (db) {
	      f();
	    } else {
	      var openreq = indexedDB.open(DBNAME, DBVERSION);
	      openreq.onerror = function withStoreOnError() {
	        console.error("asyncStorage: can't open database:", openreq.error.name);
	        window.close();
	      };
	      openreq.onupgradeneeded = function withStoreOnUpgradeNeeded() {
	        // First time setup: create an empty object store
	        openreq.result.createObjectStore(STORENAME);
	      };
	      openreq.onsuccess = function withStoreOnSuccess() {
	        db = openreq.result;
	        // XXX, for bug 16915. There's case that when first enter
	        // some app, but quit (app killed) right between db file created
	        // and the asynchronous step to create related object store. Next time
	        // enter the app, we have a database with no object store which may
	        // lead to malfunctions. Here the workaround is to increase DB version
	        // to recreate object store again if not found.
	
	        // Not only asyncStorage, we may have same issue everywhere
	        // a new indexDB is created, but chances are rare.
	        if (db.objectStoreNames.contains(STORENAME)) {
	          localStorage.async_storage_db_ver = DBVERSION;
	          f();
	        } else {
	          if (count--) {
	            db.close();
	            db = null;
	            DBVERSION++;
	            withDatabase(f);
	          }
	        }
	      };
	    }
	  }
	
	  function withStore(type, callback, oncomplete) {
	    withDatabase(function () {
	      var transaction = db.transaction(STORENAME, type);
	      if (oncomplete) {
	        transaction.oncomplete = oncomplete;
	      }
	      callback(transaction.objectStore(STORENAME));
	    });
	  }
	
	  function getItem(key, callback) {
	    var req;
	    withStore('readonly', function getItemBody(store) {
	      req = store.get(key);
	      req.onerror = function getItemOnError() {
	        console.error('Error in asyncStorage.getItem(): ', req.error.name);
	      };
	    }, function onComplete() {
	      var value = req.result;
	      if (value === undefined) {
	        value = null;
	      }
	      callback(value);
	    });
	  }
	
	  function setItem(key, value, callback) {
	    withStore('readwrite', function setItemBody(store) {
	      var req = store.put(value, key);
	      req.onerror = function setItemOnError() {
	        console.error('Error in asyncStorage.setItem(): ', req.error.name);
	      };
	    }, callback);
	  }
	
	  function removeItem(key, callback) {
	    withStore('readwrite', function removeItemBody(store) {
	      var req = store.delete(key);
	      req.onerror = function removeItemOnError() {
	        console.error('Error in asyncStorage.removeItem(): ', req.error.name);
	      };
	    }, callback);
	  }
	
	  function clear(callback) {
	    withStore('readwrite', function clearBody(store) {
	      var req = store.clear();
	      req.onerror = function clearOnError() {
	        console.error('Error in asyncStorage.clear(): ', req.error.name);
	      };
	    }, callback);
	  }
	
	  function length(callback) {
	    var req;
	    withStore('readonly', function lengthBody(store) {
	      req = store.count();
	      req.onerror = function lengthOnError() {
	        console.error('Error in asyncStorage.length(): ', req.error.name);
	      };
	    }, function onComplete() {
	      callback(req.result);
	    });
	  }
	
	  function key(n, callback) {
	    if (n < 0) {
	      callback(null);
	      return;
	    }
	
	    var req;
	    withStore('readonly', function keyBody(store) {
	      var advanced = false;
	      req = store.openCursor();
	      req.onsuccess = function keyOnSuccess() {
	        var cursor = req.result;
	        if (!cursor) {
	          // this means there weren't enough keys
	          return;
	        }
	        if (n === 0 || advanced) {
	          // Either 1) we have the first key, return it if that's what they
	          // wanted, or 2) we've got the nth key.
	          return;
	        }
	
	        // Otherwise, ask the cursor to skip ahead n records
	        advanced = true;
	        cursor.advance(n);
	      };
	      req.onerror = function keyOnError() {
	        console.error('Error in asyncStorage.key(): ', req.error.name);
	      };
	    }, function onComplete() {
	      var cursor = req.result;
	      callback(cursor ? cursor.key : null);
	    });
	  }
	
	  return {
	    getItem: getItem,
	    setItem: setItem,
	    removeItem: removeItem,
	    clear: clear,
	    length: length,
	    key: key
	  };
	}();

/***/ },
/* 69 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function (window, undefined) {
	  'use strict';
	
	  function getLanguageFromURL() {
	    var paramObj = {};
	    var params = location.search.substr(1);
	    var paramsPairs = params.split('&');
	
	    paramsPairs.forEach(function (pair) {
	      var obj = pair.split('=');
	      paramObj[obj[0]] = obj[1];
	    });
	
	    return paramObj['locale'];
	  }
	
	  /* jshint validthis:true */
	  function L10nError(message, id, loc) {
	    this.name = 'L10nError';
	    this.message = message;
	    this.id = id;
	    this.loc = loc;
	  }
	  L10nError.prototype = Object.create(Error.prototype);
	  L10nError.prototype.constructor = L10nError;
	
	  /* jshint browser:true */
	
	  var io = {
	    _load: function _load(type, url, callback, sync) {
	      return new Promise(function (resolve) {
	        var xhr = new XMLHttpRequest();
	        var needParse;
	
	        if (xhr.overrideMimeType) {
	          xhr.overrideMimeType(type);
	        }
	
	        xhr.open('GET', url, !sync);
	
	        if (type === 'application/json') {
	          //  Gecko 11.0+ forbids the use of the responseType attribute when
	          //  performing sync requests (NS_ERROR_DOM_INVALID_ACCESS_ERR).
	          //  We'll need to JSON.parse manually.
	          if (sync) {
	            needParse = true;
	          } else {
	            xhr.responseType = 'json';
	          }
	        }
	
	        xhr.addEventListener('load', function io_onload(e) {
	          if (e.target.status === 200 || e.target.status === 0) {
	            // Sinon.JS's FakeXHR doesn't have the response property
	            var res = e.target.response || e.target.responseText;
	            callback(null, needParse ? JSON.parse(res) : res);
	            resolve();
	          } else {
	            callback(new L10nError('Not found: ' + url));
	            resolve('FILE_NOT_FOUND');
	          }
	        });
	        xhr.addEventListener('error', callback);
	        xhr.addEventListener('timeout', callback);
	
	        // the app: protocol throws on 404, see https://bugzil.la/827243
	        try {
	          xhr.send(null);
	        } catch (e) {
	          callback(new L10nError('Not found: ' + url));
	          resolve('FILE_NOT_FOUND');
	        }
	      });
	    },
	
	    load: function load(url, callback, sync) {
	      return io._load('text/plain', url, callback, sync);
	    },
	
	    loadJSON: function loadJSON(url, callback, sync) {
	      return io._load('application/json', url, callback, sync);
	    }
	  };
	
	  function EventEmitter() {}
	
	  EventEmitter.prototype.emit = function ee_emit() {
	    if (!this._listeners) {
	      return;
	    }
	
	    var args = Array.prototype.slice.call(arguments);
	    var type = args.shift();
	    if (!this._listeners[type]) {
	      return;
	    }
	
	    var typeListeners = this._listeners[type].slice();
	    for (var i = 0; i < typeListeners.length; i++) {
	      typeListeners[i].apply(this, args);
	    }
	  };
	
	  EventEmitter.prototype.addEventListener = function ee_add(type, listener) {
	    if (!this._listeners) {
	      this._listeners = {};
	    }
	    if (!(type in this._listeners)) {
	      this._listeners[type] = [];
	    }
	    this._listeners[type].push(listener);
	  };
	
	  EventEmitter.prototype.removeEventListener = function ee_rm(type, listener) {
	    if (!this._listeners) {
	      return;
	    }
	
	    var typeListeners = this._listeners[type];
	    var pos = typeListeners.indexOf(listener);
	    if (pos === -1) {
	      return;
	    }
	
	    typeListeners.splice(pos, 1);
	  };
	
	  function getPluralRule(lang) {
	    var locales2rules = {
	      af: 3,
	      ak: 4,
	      am: 4,
	      ar: 1,
	      asa: 3,
	      az: 0,
	      be: 11,
	      bem: 3,
	      bez: 3,
	      bg: 3,
	      bh: 4,
	      bm: 0,
	      bn: 3,
	      bo: 0,
	      br: 20,
	      brx: 3,
	      bs: 11,
	      ca: 3,
	      cgg: 3,
	      chr: 3,
	      cs: 12,
	      cy: 17,
	      da: 3,
	      de: 3,
	      dv: 3,
	      dz: 0,
	      ee: 3,
	      el: 3,
	      en: 3,
	      eo: 3,
	      es: 3,
	      et: 3,
	      eu: 3,
	      fa: 0,
	      ff: 5,
	      fi: 3,
	      fil: 4,
	      fo: 3,
	      fr: 5,
	      fur: 3,
	      fy: 3,
	      ga: 8,
	      gd: 24,
	      gl: 3,
	      gsw: 3,
	      gu: 3,
	      guw: 4,
	      gv: 23,
	      ha: 3,
	      haw: 3,
	      he: 2,
	      hi: 4,
	      hr: 11,
	      hu: 0,
	      id: 0,
	      ig: 0,
	      ii: 0,
	      is: 3,
	      it: 3,
	      iu: 7,
	      ja: 0,
	      jmc: 3,
	      jv: 0,
	      ka: 0,
	      kab: 5,
	      kaj: 3,
	      kcg: 3,
	      kde: 0,
	      kea: 0,
	      kk: 3,
	      kl: 3,
	      km: 0,
	      kn: 0,
	      ko: 0,
	      ksb: 3,
	      ksh: 21,
	      ku: 3,
	      kw: 7,
	      lag: 18,
	      lb: 3,
	      lg: 3,
	      ln: 4,
	      lo: 0,
	      lt: 10,
	      lv: 6,
	      mas: 3,
	      mg: 4,
	      mk: 16,
	      ml: 3,
	      mn: 3,
	      mo: 9,
	      mr: 3,
	      ms: 0,
	      mt: 15,
	      my: 0,
	      nah: 3,
	      naq: 7,
	      nb: 3,
	      nd: 3,
	      ne: 3,
	      nl: 3,
	      nn: 3,
	      no: 3,
	      nr: 3,
	      nso: 4,
	      ny: 3,
	      nyn: 3,
	      om: 3,
	      or: 3,
	      pa: 3,
	      pap: 3,
	      pl: 13,
	      ps: 3,
	      pt: 3,
	      rm: 3,
	      ro: 9,
	      rof: 3,
	      ru: 11,
	      rwk: 3,
	      sah: 0,
	      saq: 3,
	      se: 7,
	      seh: 3,
	      ses: 0,
	      sg: 0,
	      sh: 11,
	      shi: 19,
	      sk: 12,
	      sl: 14,
	      sma: 7,
	      smi: 7,
	      smj: 7,
	      smn: 7,
	      sms: 7,
	      sn: 3,
	      so: 3,
	      sq: 3,
	      sr: 11,
	      ss: 3,
	      ssy: 3,
	      st: 3,
	      sv: 3,
	      sw: 3,
	      syr: 3,
	      ta: 3,
	      te: 3,
	      teo: 3,
	      th: 0,
	      ti: 4,
	      tig: 3,
	      tk: 3,
	      tl: 4,
	      tn: 3,
	      to: 0,
	      tr: 0,
	      ts: 3,
	      tzm: 22,
	      uk: 11,
	      ur: 3,
	      ve: 3,
	      vi: 0,
	      vun: 3,
	      wa: 4,
	      wae: 3,
	      wo: 0,
	      xh: 3,
	      xog: 3,
	      yo: 0,
	      zh: 0,
	      zu: 3
	    };
	
	    // utility functions for plural rules methods
	    function isIn(n, list) {
	      return list.indexOf(n) !== -1;
	    }
	    function isBetween(n, start, end) {
	      return (typeof n === 'undefined' ? 'undefined' : _typeof(n)) === (typeof start === 'undefined' ? 'undefined' : _typeof(start)) && start <= n && n <= end;
	    }
	
	    // list of all plural rules methods:
	    // map an integer to the plural form name to use
	    var pluralRules = {
	      '0': function _() {
	        return 'other';
	      },
	      '1': function _(n) {
	        if (isBetween(n % 100, 3, 10)) {
	          return 'few';
	        }
	        if (n === 0) {
	          return 'zero';
	        }
	        if (isBetween(n % 100, 11, 99)) {
	          return 'many';
	        }
	        if (n === 2) {
	          return 'two';
	        }
	        if (n === 1) {
	          return 'one';
	        }
	        return 'other';
	      },
	      '2': function _(n) {
	        if (n !== 0 && n % 10 === 0) {
	          return 'many';
	        }
	        if (n === 2) {
	          return 'two';
	        }
	        if (n === 1) {
	          return 'one';
	        }
	        return 'other';
	      },
	      '3': function _(n) {
	        if (n === 1) {
	          return 'one';
	        }
	        return 'other';
	      },
	      '4': function _(n) {
	        if (isBetween(n, 0, 1)) {
	          return 'one';
	        }
	        return 'other';
	      },
	      '5': function _(n) {
	        if (isBetween(n, 0, 2) && n !== 2) {
	          return 'one';
	        }
	        return 'other';
	      },
	      '6': function _(n) {
	        if (n === 0) {
	          return 'zero';
	        }
	        if (n % 10 === 1 && n % 100 !== 11) {
	          return 'one';
	        }
	        return 'other';
	      },
	      '7': function _(n) {
	        if (n === 2) {
	          return 'two';
	        }
	        if (n === 1) {
	          return 'one';
	        }
	        return 'other';
	      },
	      '8': function _(n) {
	        if (isBetween(n, 3, 6)) {
	          return 'few';
	        }
	        if (isBetween(n, 7, 10)) {
	          return 'many';
	        }
	        if (n === 2) {
	          return 'two';
	        }
	        if (n === 1) {
	          return 'one';
	        }
	        return 'other';
	      },
	      '9': function _(n) {
	        if (n === 0 || n !== 1 && isBetween(n % 100, 1, 19)) {
	          return 'few';
	        }
	        if (n === 1) {
	          return 'one';
	        }
	        return 'other';
	      },
	      '10': function _(n) {
	        if (isBetween(n % 10, 2, 9) && !isBetween(n % 100, 11, 19)) {
	          return 'few';
	        }
	        if (n % 10 === 1 && !isBetween(n % 100, 11, 19)) {
	          return 'one';
	        }
	        return 'other';
	      },
	      '11': function _(n) {
	        if (isBetween(n % 10, 2, 4) && !isBetween(n % 100, 12, 14)) {
	          return 'few';
	        }
	        if (n % 10 === 0 || isBetween(n % 10, 5, 9) || isBetween(n % 100, 11, 14)) {
	          return 'many';
	        }
	        if (n % 10 === 1 && n % 100 !== 11) {
	          return 'one';
	        }
	        return 'other';
	      },
	      '12': function _(n) {
	        if (isBetween(n, 2, 4)) {
	          return 'few';
	        }
	        if (n === 1) {
	          return 'one';
	        }
	        return 'other';
	      },
	      '13': function _(n) {
	        if (isBetween(n % 10, 2, 4) && !isBetween(n % 100, 12, 14)) {
	          return 'few';
	        }
	        if (n !== 1 && isBetween(n % 10, 0, 1) || isBetween(n % 10, 5, 9) || isBetween(n % 100, 12, 14)) {
	          return 'many';
	        }
	        if (n === 1) {
	          return 'one';
	        }
	        return 'other';
	      },
	      '14': function _(n) {
	        if (isBetween(n % 100, 3, 4)) {
	          return 'few';
	        }
	        if (n % 100 === 2) {
	          return 'two';
	        }
	        if (n % 100 === 1) {
	          return 'one';
	        }
	        return 'other';
	      },
	      '15': function _(n) {
	        if (n === 0 || isBetween(n % 100, 2, 10)) {
	          return 'few';
	        }
	        if (isBetween(n % 100, 11, 19)) {
	          return 'many';
	        }
	        if (n === 1) {
	          return 'one';
	        }
	        return 'other';
	      },
	      '16': function _(n) {
	        if (n % 10 === 1 && n !== 11) {
	          return 'one';
	        }
	        return 'other';
	      },
	      '17': function _(n) {
	        if (n === 3) {
	          return 'few';
	        }
	        if (n === 0) {
	          return 'zero';
	        }
	        if (n === 6) {
	          return 'many';
	        }
	        if (n === 2) {
	          return 'two';
	        }
	        if (n === 1) {
	          return 'one';
	        }
	        return 'other';
	      },
	      '18': function _(n) {
	        if (n === 0) {
	          return 'zero';
	        }
	        if (isBetween(n, 0, 2) && n !== 0 && n !== 2) {
	          return 'one';
	        }
	        return 'other';
	      },
	      '19': function _(n) {
	        if (isBetween(n, 2, 10)) {
	          return 'few';
	        }
	        if (isBetween(n, 0, 1)) {
	          return 'one';
	        }
	        return 'other';
	      },
	      '20': function _(n) {
	        if ((isBetween(n % 10, 3, 4) || n % 10 === 9) && !(isBetween(n % 100, 10, 19) || isBetween(n % 100, 70, 79) || isBetween(n % 100, 90, 99))) {
	          return 'few';
	        }
	        if (n % 1000000 === 0 && n !== 0) {
	          return 'many';
	        }
	        if (n % 10 === 2 && !isIn(n % 100, [12, 72, 92])) {
	          return 'two';
	        }
	        if (n % 10 === 1 && !isIn(n % 100, [11, 71, 91])) {
	          return 'one';
	        }
	        return 'other';
	      },
	      '21': function _(n) {
	        if (n === 0) {
	          return 'zero';
	        }
	        if (n === 1) {
	          return 'one';
	        }
	        return 'other';
	      },
	      '22': function _(n) {
	        if (isBetween(n, 0, 1) || isBetween(n, 11, 99)) {
	          return 'one';
	        }
	        return 'other';
	      },
	      '23': function _(n) {
	        if (isBetween(n % 10, 1, 2) || n % 20 === 0) {
	          return 'one';
	        }
	        return 'other';
	      },
	      '24': function _(n) {
	        if (isBetween(n, 3, 10) || isBetween(n, 13, 19)) {
	          return 'few';
	        }
	        if (isIn(n, [2, 12])) {
	          return 'two';
	        }
	        if (isIn(n, [1, 11])) {
	          return 'one';
	        }
	        return 'other';
	      }
	    };
	
	    // return a function that gives the plural form name for a given integer
	    var index = locales2rules[lang.replace(/-.*$/, '')];
	    if (!(index in pluralRules)) {
	      return function () {
	        return 'other';
	      };
	    }
	    return pluralRules[index];
	  }
	
	  var MAX_PLACEABLES = 100;
	
	  var PropertiesParser = {
	    patterns: null,
	    entryIds: null,
	
	    init: function init() {
	      this.patterns = {
	        comment: /^\s*#|^\s*$/,
	        entity: /^([^=\s]+)\s*=\s*(.*)$/,
	        multiline: /[^\\]\\$/,
	        index: /\{\[\s*(\w+)(?:\(([^\)]*)\))?\s*\]\}/i,
	        unicode: /\\u([0-9a-fA-F]{1,4})/g,
	        entries: /[^\r\n]+/g,
	        controlChars: /\\([\\\n\r\t\b\f\{\}\"\'])/g,
	        placeables: /\{\{\s*([^\s]*?)\s*\}\}/
	      };
	    },
	
	    parse: function parse(ctx, source) {
	      if (!this.patterns) {
	        this.init();
	      }
	
	      var ast = [];
	      this.entryIds = Object.create(null);
	
	      var entries = source.match(this.patterns.entries);
	      if (!entries) {
	        return ast;
	      }
	      for (var i = 0; i < entries.length; i++) {
	        var line = entries[i];
	
	        if (this.patterns.comment.test(line)) {
	          continue;
	        }
	
	        while (this.patterns.multiline.test(line) && i < entries.length) {
	          line = line.slice(0, -1) + entries[++i].trim();
	        }
	
	        var entityMatch = line.match(this.patterns.entity);
	        if (entityMatch) {
	          try {
	            this.parseEntity(entityMatch[1], entityMatch[2], ast);
	          } catch (e) {
	            if (ctx) {
	              ctx._emitter.emit('parseerror', e);
	            } else {
	              throw e;
	            }
	          }
	        }
	      }
	      return ast;
	    },
	
	    parseEntity: function parseEntity(id, value, ast) {
	      var name, key;
	
	      var pos = id.indexOf('[');
	      if (pos !== -1) {
	        name = id.substr(0, pos);
	        key = id.substring(pos + 1, id.length - 1);
	      } else {
	        name = id;
	        key = null;
	      }
	
	      var nameElements = name.split('.');
	
	      if (nameElements.length > 2) {
	        throw new L10nError('Error in ID: "' + name + '".' + ' Nested attributes are not supported.');
	      }
	
	      var attr;
	      if (nameElements.length > 1) {
	        name = nameElements[0];
	        attr = nameElements[1];
	
	        if (attr[0] === '$') {
	          throw new L10nError('Attribute can\'t start with "$"', id);
	        }
	      } else {
	        attr = null;
	      }
	
	      this.setEntityValue(name, attr, key, this.unescapeString(value), ast);
	    },
	
	    setEntityValue: function setEntityValue(id, attr, key, rawValue, ast) {
	      var pos, v;
	
	      var value = rawValue.indexOf('{{') > -1 ? this.parseString(rawValue) : rawValue;
	
	      if (rawValue.indexOf('<') > -1 || rawValue.indexOf('&') > -1) {
	        value = { $o: value };
	      }
	
	      if (attr) {
	        pos = this.entryIds[id];
	        if (pos === undefined) {
	          v = { $i: id };
	          if (key) {
	            v[attr] = {};
	            v[attr][key] = value;
	          } else {
	            v[attr] = value;
	          }
	          ast.push(v);
	          this.entryIds[id] = ast.length - 1;
	          return;
	        }
	        if (key) {
	          if (typeof ast[pos][attr] === 'string') {
	            ast[pos][attr] = {
	              $x: this.parseIndex(ast[pos][attr]),
	              $v: {}
	            };
	          }
	          ast[pos][attr].$v[key] = value;
	          return;
	        }
	        ast[pos][attr] = value;
	        return;
	      }
	
	      // Hash value
	      if (key) {
	        pos = this.entryIds[id];
	        if (pos === undefined) {
	          v = {};
	          v[key] = value;
	          ast.push({ $i: id, $v: v });
	          this.entryIds[id] = ast.length - 1;
	          return;
	        }
	        if (typeof ast[pos].$v === 'string') {
	          ast[pos].$x = this.parseIndex(ast[pos].$v);
	          ast[pos].$v = {};
	        }
	        ast[pos].$v[key] = value;
	        return;
	      }
	
	      // simple value
	      ast.push({ $i: id, $v: value });
	      this.entryIds[id] = ast.length - 1;
	    },
	
	    parseString: function parseString(str) {
	      var chunks = str.split(this.patterns.placeables);
	      var complexStr = [];
	
	      var len = chunks.length;
	      var placeablesCount = (len - 1) / 2;
	
	      if (placeablesCount >= MAX_PLACEABLES) {
	        throw new L10nError('Too many placeables (' + placeablesCount + ', max allowed is ' + MAX_PLACEABLES + ')');
	      }
	
	      for (var i = 0; i < chunks.length; i++) {
	        if (chunks[i].length === 0) {
	          continue;
	        }
	        if (i % 2 === 1) {
	          complexStr.push({ t: 'idOrVar', v: chunks[i] });
	        } else {
	          complexStr.push(chunks[i]);
	        }
	      }
	      return complexStr;
	    },
	
	    unescapeString: function unescapeString(str) {
	      if (str.lastIndexOf('\\') !== -1) {
	        str = str.replace(this.patterns.controlChars, '$1');
	      }
	      return str.replace(this.patterns.unicode, function (match, token) {
	        return unescape('%u' + '0000'.slice(token.length) + token);
	      });
	    },
	
	    parseIndex: function parseIndex(str) {
	      var match = str.match(this.patterns.index);
	      if (!match) {
	        throw new L10nError('Malformed index');
	      }
	      if (match[2]) {
	        return [{ t: 'idOrVar', v: match[1] }, match[2]];
	      } else {
	        return [{ t: 'idOrVar', v: match[1] }];
	      }
	    }
	  };
	
	  var KNOWN_MACROS = ['plural'];
	
	  var MAX_PLACEABLE_LENGTH = 2500;
	  var rePlaceables = /\{\{\s*(.+?)\s*\}\}/g;
	
	  // Matches characters outside of the Latin-1 character set
	  var nonLatin1 = /[^\x01-\xFF]/;
	
	  // Unicode bidi isolation characters
	  var FSI = '\u2068';
	  var PDI = '\u2069';
	
	  function createEntry(node, env) {
	    var keys = Object.keys(node);
	
	    // the most common scenario: a simple string with no arguments
	    if (typeof node.$v === 'string' && keys.length === 2) {
	      return node.$v;
	    }
	
	    var attrs;
	
	    /* jshint -W084 */
	    for (var i = 0, key; key = keys[i]; i++) {
	      if (key[0] === '$') {
	        continue;
	      }
	
	      if (!attrs) {
	        attrs = Object.create(null);
	      }
	      attrs[key] = createAttribute(node[key], env, node.$i + '.' + key);
	    }
	
	    return {
	      id: node.$i,
	      value: node.$v !== undefined ? node.$v : null,
	      index: node.$x || null,
	      attrs: attrs || null,
	      env: env,
	      // the dirty guard prevents cyclic or recursive references
	      dirty: false
	    };
	  }
	
	  function createAttribute(node, env, id) {
	    if (typeof node === 'string') {
	      return node;
	    }
	
	    return {
	      id: id,
	      value: node.$v || (node !== undefined ? node : null),
	      index: node.$x || null,
	      env: env,
	      dirty: false
	    };
	  }
	
	  function format(args, entity) {
	    var locals = {
	      overlay: false
	    };
	
	    if (typeof entity === 'string') {
	      return [locals, entity];
	    }
	
	    if (entity.dirty) {
	      throw new L10nError('Cyclic reference detected: ' + entity.id);
	    }
	
	    entity.dirty = true;
	
	    var rv;
	
	    // if format fails, we want the exception to bubble up and stop the whole
	    // resolving process;  however, we still need to clean up the dirty flag
	    try {
	      rv = resolveValue(locals, args, entity.env, entity.value, entity.index);
	    } finally {
	      entity.dirty = false;
	    }
	    return rv;
	  }
	
	  function resolveIdentifier(args, env, id) {
	    if (KNOWN_MACROS.indexOf(id) > -1) {
	      return [{}, env['__' + id]];
	    }
	
	    if (args && args.hasOwnProperty(id)) {
	      if (typeof args[id] === 'string' || typeof args[id] === 'number' && !isNaN(args[id])) {
	        return [{}, args[id]];
	      } else {
	        throw new L10nError('Arg must be a string or a number: ' + id);
	      }
	    }
	
	    // XXX: special case for Node.js where still:
	    // '__proto__' in Object.create(null) => true
	    if (id in env && id !== '__proto__') {
	      return format(args, env[id]);
	    }
	
	    throw new L10nError('Unknown reference: ' + id);
	  }
	
	  function subPlaceable(locals, args, env, id) {
	    var res;
	
	    try {
	      res = resolveIdentifier(args, env, id);
	    } catch (err) {
	      return [{ error: err }, '{{ ' + id + ' }}'];
	    }
	
	    var value = res[1];
	
	    if (typeof value === 'number') {
	      return res;
	    }
	
	    if (typeof value === 'string') {
	      // prevent Billion Laughs attacks
	      if (value.length >= MAX_PLACEABLE_LENGTH) {
	        throw new L10nError('Too many characters in placeable (' + value.length + ', max allowed is ' + MAX_PLACEABLE_LENGTH + ')');
	      }
	
	      if (locals.contextIsNonLatin1 || value.match(nonLatin1)) {
	        // When dealing with non-Latin-1 text
	        // we wrap substitutions in bidi isolate characters
	        // to avoid bidi issues.
	        res[1] = FSI + value + PDI;
	      }
	
	      return res;
	    }
	
	    return [{}, '{{ ' + id + ' }}'];
	  }
	
	  function interpolate(locals, args, env, arr) {
	    return arr.reduce(function (prev, cur) {
	      if (typeof cur === 'string') {
	        return [prev[0], prev[1] + cur];
	      } else if (cur.t === 'idOrVar') {
	        var placeable = subPlaceable(locals, args, env, cur.v);
	        if (placeable[0].overlay) {
	          prev[0].overlay = true;
	        }
	        return [prev[0], prev[1] + placeable[1]];
	      }
	    }, [locals, '']);
	  }
	
	  function resolveSelector(args, env, expr, index) {
	    var selectorName = index[0].v;
	    var selector = resolveIdentifier(args, env, selectorName)[1];
	
	    if (typeof selector !== 'function') {
	      // selector is a simple reference to an entity or args
	      return selector;
	    }
	
	    var argValue = index[1] ? resolveIdentifier(args, env, index[1])[1] : undefined;
	
	    if (selector === env.__plural) {
	      // special cases for zero, one, two if they are defined on the hash
	      if (argValue === 0 && 'zero' in expr) {
	        return 'zero';
	      }
	      if (argValue === 1 && 'one' in expr) {
	        return 'one';
	      }
	      if (argValue === 2 && 'two' in expr) {
	        return 'two';
	      }
	    }
	
	    return selector(argValue);
	  }
	
	  function resolveValue(locals, args, env, expr, index) {
	    if (!expr) {
	      return [locals, expr];
	    }
	
	    if (expr.$o) {
	      expr = expr.$o;
	      locals.overlay = true;
	    }
	
	    if (typeof expr === 'string' || typeof expr === 'boolean' || typeof expr === 'number') {
	      return [locals, expr];
	    }
	
	    if (Array.isArray(expr)) {
	      locals.contextIsNonLatin1 = expr.some(function ($_) {
	        return typeof $_ === 'string' && $_.match(nonLatin1);
	      });
	      return interpolate(locals, args, env, expr);
	    }
	
	    // otherwise, it's a dict
	    if (index) {
	      // try to use the index in order to select the right dict member
	      var selector = resolveSelector(args, env, expr, index);
	      if (expr.hasOwnProperty(selector)) {
	        return resolveValue(locals, args, env, expr[selector]);
	      }
	    }
	
	    // if there was no index or no selector was found, try 'other'
	    if ('other' in expr) {
	      return resolveValue(locals, args, env, expr.other);
	    }
	
	    // XXX Specify entity id
	    throw new L10nError('Unresolvable value');
	  }
	
	  var Resolver = {
	    createEntry: createEntry,
	    format: format,
	    rePlaceables: rePlaceables
	  };
	
	  /* Utility functions */
	
	  // Recursively walk an AST node searching for content leaves
	  function walkContent(node, fn) {
	    if (typeof node === 'string') {
	      return fn(node);
	    }
	
	    if (node.t === 'idOrVar') {
	      return node;
	    }
	
	    var rv = Array.isArray(node) ? [] : {};
	    var keys = Object.keys(node);
	
	    /* jshint boss:true */
	    for (var i = 0, key; key = keys[i]; i++) {
	      // don't change identifier ($i) nor indices ($x)
	      if (key === '$i' || key === '$x') {
	        rv[key] = node[key];
	      } else {
	        rv[key] = walkContent(node[key], fn);
	      }
	    }
	    return rv;
	  }
	
	  /* Pseudolocalizations
	   *
	   * PSEUDO_STRATEGIES is a dict of strategies to be used to modify the English
	   * context in order to create pseudolocalizations.  These can be used by
	   * developers to test the localizability of their code without having to
	   * actually speak a foreign language.
	   *
	   * Currently, the following pseudolocales are supported:
	   *
	   *   qps-ploc - Ȧȧƈƈḗḗƞŧḗḗḓ Ḗḗƞɠŀīīşħ
	   *
	   *     In Accented English all English letters are replaced by accented
	   *     Unicode counterparts which don't impair the readability of the content.
	   *     This allows developers to quickly test if any given string is being
	   *     correctly displayed in its 'translated' form.  Additionally, simple
	   *     heuristics are used to make certain words longer to better simulate the
	   *     experience of international users.
	   *
	   *   qps-plocm - ɥsıʅƃuƎ pǝɹoɹɹıW
	   *
	   *     Mirrored English is a fake RTL locale.  All words are surrounded by
	   *     Unicode formatting marks forcing the RTL directionality of characters.
	   *     In addition, to make the reversed text easier to read, individual
	   *     letters are flipped.
	   *
	   *     Note: The name above is hardcoded to be RTL in case code editors have
	   *     trouble with the RLO and PDF Unicode marks.  In reality, it should be
	   *     surrounded by those marks as well.
	   *
	   * See https://bugzil.la/900182 for more information.
	   *
	   */
	
	  var reAlphas = /[a-zA-Z]/g;
	  var reVowels = /[aeiouAEIOU]/g;
	
	  // ȦƁƇḒḖƑƓĦĪĴĶĿḾȠǾƤɊŘŞŦŬṼẆẊẎẐ + [\\]^_` + ȧƀƈḓḗƒɠħīĵķŀḿƞǿƥɋřşŧŭṽẇẋẏẑ
	  var ACCENTED_MAP = '\u0226\u0181\u0187\u1E12\u1E16\u0191\u0193\u0126\u012A' + '\u0134\u0136\u013F\u1E3E\u0220\u01FE\u01A4\u024A\u0158' + '\u015E\u0166\u016C\u1E7C\u1E86\u1E8A\u1E8E\u1E90' + '[\\]^_`' + '\u0227\u0180\u0188\u1E13\u1E17\u0192\u0260\u0127\u012B' + '\u0135\u0137\u0140\u1E3F\u019E\u01FF\u01A5\u024B\u0159' + '\u015F\u0167\u016D\u1E7D\u1E87\u1E8B\u1E8F\u1E91';
	
	  // XXX Until https://bugzil.la/1007340 is fixed, ᗡℲ⅁⅂⅄ don't render correctly
	  // on the devices.  For now, use the following replacements: pɟפ˥ʎ
	  // ∀ԐↃpƎɟפHIſӼ˥WNOԀÒᴚS⊥∩ɅＭXʎZ + [\\]ᵥ_, + ɐqɔpǝɟƃɥıɾʞʅɯuodbɹsʇnʌʍxʎz
	  var FLIPPED_MAP = '\u2200\u0510\u2183p\u018E\u025F\u05E4HI\u017F' + '\u04FC\u02E5WNO\u0500\xD2\u1D1AS\u22A5\u2229\u0245' + '\uFF2DX\u028EZ' + '[\\]\u1D65_,' + '\u0250q\u0254p\u01DD\u025F\u0183\u0265\u0131\u027E' + '\u029E\u0285\u026Fuodb\u0279s\u0287n\u028C\u028Dx\u028Ez';
	
	  function makeLonger(val) {
	    return val.replace(reVowels, function (match) {
	      return match + match.toLowerCase();
	    });
	  }
	
	  function makeAccented(map, val) {
	    // Replace each Latin letter with a Unicode character from map
	    return val.replace(reAlphas, function (match) {
	      return map.charAt(match.charCodeAt(0) - 65);
	    });
	  }
	
	  var reWords = /[^\W0-9_]+/g;
	
	  function makeRTL(val) {
	    // Surround each word with Unicode formatting codes, RLO and PDF:
	    //   U+202E:   RIGHT-TO-LEFT OVERRIDE (RLO)
	    //   U+202C:   POP DIRECTIONAL FORMATTING (PDF)
	    // See http://www.w3.org/International/questions/qa-bidi-controls
	    return val.replace(reWords, function (match) {
	      return '\u202E' + match + '\u202C';
	    });
	  }
	
	  // strftime tokens (%a, %Eb) and template {vars}
	  var reExcluded = /(%[EO]?\w|\{\s*.+?\s*\})/;
	
	  function mapContent(fn, val) {
	    if (!val) {
	      return val;
	    }
	    var parts = val.split(reExcluded);
	    var modified = parts.map(function (part) {
	      if (reExcluded.test(part)) {
	        return part;
	      }
	      return fn(part);
	    });
	    return modified.join('');
	  }
	
	  function Pseudo(id, name, charMap, modFn) {
	    this.id = id;
	    this.translate = mapContent.bind(null, function (val) {
	      return makeAccented(charMap, modFn(val));
	    });
	    this.name = this.translate(name);
	  }
	
	  var PSEUDO_STRATEGIES = {
	    'qps-ploc': new Pseudo('qps-ploc', 'Accented English', ACCENTED_MAP, makeLonger),
	    'qps-plocm': new Pseudo('qps-plocm', 'Mirrored English', FLIPPED_MAP, makeRTL)
	  };
	
	  function Locale(id, ctx) {
	    this.id = id;
	    this.ctx = ctx;
	    this.isReady = false;
	    this.isPseudo = PSEUDO_STRATEGIES.hasOwnProperty(id);
	    this.entries = Object.create(null);
	    this.entries.__plural = getPluralRule(this.isPseudo ? this.ctx.defaultLocale : id);
	  }
	
	  var bindingsIO = {
	    extra: function extra(id, ver, path, type, callback, errback, sync) {
	      if (type === 'properties') {
	        type = 'text';
	      }
	      navigator.mozApps.getLocalizationResource(id, ver, path, type).then(callback.bind(null, null), errback);
	    },
	    app: function app(id, ver, path, type, callback, errback, sync) {
	      /**
	       * To reduce the request number, we load the specific xxx locale
	       * (via ?locale=xxx) first, if it's loaded fail, then load the
	       * default one.
	       */
	      switch (type) {
	        case 'properties':
	          io.load(path.userLocale, callback, sync).then(function (result) {
	            if (result === 'FILE_NOT_FOUND') {
	              io.load(path.defaultLocale, callback, sync);
	            }
	          }, function () {});
	          break;
	        case 'json':
	          io.loadJSON(path.userLocale, callback, sync).then(function (result) {
	            if (result === 'FILE_NOT_FOUND') {
	              io.loadJSON(path.defaultLocale, callback, sync);
	            }
	          }, function () {});
	          break;
	      }
	    }
	  };
	
	  Locale.prototype.build = function L_build(callback) {
	    var sync = !callback;
	    var ctx = this.ctx;
	    var self = this;
	
	    var l10nLoads = ctx.resLinks.length;
	
	    function onL10nLoaded(err) {
	      if (err) {
	        ctx._emitter.emit('fetcherror', err);
	      }
	      if (--l10nLoads <= 0) {
	        self.isReady = true;
	        if (callback) {
	          callback();
	        }
	      }
	    }
	
	    if (l10nLoads === 0) {
	      onL10nLoaded();
	      return;
	    }
	
	    function onJSONLoaded(err, json) {
	      if (!err && json) {
	        self.addAST(json);
	      }
	      onL10nLoaded(err);
	    }
	
	    function onPropLoaded(err, source) {
	      if (!err && source) {
	        var ast = PropertiesParser.parse(ctx, source);
	        self.addAST(ast);
	      }
	      onL10nLoaded(err);
	    }
	
	    /**
	     * Get the parameter "locale" from the URL, load the default locale file
	     * and the specific locale file.
	     */
	    var lang = getLanguageFromURL();
	    var idToFetch = this.isPseudo ? ctx.defaultLocale : lang;
	    var source = navigator.mozL10n._config.localeSources[lang] || 'app';
	    var appVersion = navigator.mozL10n._config.appVersion;
	
	    for (var i = 0; i < ctx.resLinks.length; i++) {
	      var resLink = decodeURI(ctx.resLinks[i]);
	      // the one user request
	      var userLocalePath = resLink.replace('{locale}', idToFetch);
	      // cannot find the request one, then fallback to the default one.
	      var defaultLocalePath = resLink.replace('{locale}', ctx.defaultLocale);
	      var type = defaultLocalePath.substr(defaultLocalePath.lastIndexOf('.') + 1);
	
	      var path = {
	        userLocale: userLocalePath,
	        defaultLocale: defaultLocalePath
	      };
	
	      var cb;
	      switch (type) {
	        case 'json':
	          cb = onJSONLoaded;
	          break;
	        case 'properties':
	          cb = onPropLoaded;
	          break;
	      }
	      bindingsIO[source](this.id, appVersion, path, type, cb, onL10nLoaded, sync);
	    }
	  };
	
	  function createPseudoEntry(node, entries) {
	    return Resolver.createEntry(walkContent(node, PSEUDO_STRATEGIES[this.id].translate), entries);
	  }
	
	  Locale.prototype.addAST = function (ast) {
	    /* jshint -W084 */
	
	    var createEntry = this.isPseudo ? createPseudoEntry.bind(this) : Resolver.createEntry;
	
	    for (var i = 0; i < ast.length; i++) {
	      this.entries[ast[i].$i] = createEntry(ast[i], this.entries);
	    }
	  };
	
	  function Context(id) {
	    this.id = id;
	    this.isReady = false;
	    this.isLoading = false;
	
	    this.defaultLocale = 'en-US';
	    this.availableLocales = [];
	    this.supportedLocales = [];
	
	    this.resLinks = [];
	    this.locales = {};
	
	    this._emitter = new EventEmitter();
	    this._ready = new Promise(this.once.bind(this));
	  }
	
	  // Getting translations
	
	  function reportMissing(id, err) {
	    this._emitter.emit('notfounderror', err);
	    return id;
	  }
	
	  function getWithFallback(id) {
	    /* jshint -W084 */
	    var cur = 0;
	    var loc;
	    var locale;
	    while (loc = this.supportedLocales[cur]) {
	      locale = this.getLocale(loc);
	      if (!locale.isReady) {
	        // build without callback, synchronously
	        locale.build(null);
	      }
	      var entry = locale.entries[id];
	      if (entry === undefined) {
	        cur++;
	        reportMissing.call(this, id, new L10nError('"' + id + '"' + ' not found in ' + loc + ' in ' + this.id, id, loc));
	        continue;
	      }
	      return entry;
	    }
	
	    throw new L10nError('"' + id + '"' + ' missing from all supported locales in ' + this.id, id);
	  }
	
	  function formatTuple(args, entity) {
	    try {
	      return Resolver.format(args, entity);
	    } catch (err) {
	      this._emitter.emit('resolveerror', err);
	      var locals = {
	        error: err
	      };
	      return [locals, entity.id];
	    }
	  }
	
	  function formatValue(args, entity) {
	    if (typeof entity === 'string') {
	      return entity;
	    }
	
	    // take the string value only
	    return formatTuple.call(this, args, entity)[1];
	  }
	
	  function formatEntity(args, entity) {
	    var rv = formatTuple.call(this, args, entity);
	    var locals = rv[0];
	    var value = rv[1];
	
	    var formatted = {
	      value: value,
	      attrs: null,
	      overlay: locals.overlay
	    };
	
	    if (entity.attrs) {
	      formatted.attrs = Object.create(null);
	    }
	
	    for (var key in entity.attrs) {
	      /* jshint -W089 */
	      formatted.attrs[key] = formatValue.call(this, args, entity.attrs[key]);
	    }
	
	    return formatted;
	  }
	
	  function formatAsync(fn, id, args) {
	    return this._ready.then(getWithFallback.bind(this, id)).then(fn.bind(this, args), reportMissing.bind(this, id));
	  }
	
	  Context.prototype.formatValue = function (id, args) {
	    return formatAsync.call(this, formatValue, id, args);
	  };
	
	  Context.prototype.formatEntity = function (id, args) {
	    return formatAsync.call(this, formatEntity, id, args);
	  };
	
	  function legacyGet(fn, id, args) {
	    if (!this.isReady) {
	      throw new L10nError('Context not ready');
	    }
	
	    var entry;
	    try {
	      entry = getWithFallback.call(this, id);
	    } catch (err) {
	      // Don't handle notfounderrors in individual locales in any special way
	      if (err.loc) {
	        throw err;
	      }
	      // For general notfounderrors, report them and return legacy fallback
	      reportMissing.call(this, id, err);
	      // XXX legacy compat;  some Gaia code checks if returned value is falsy or
	      // an empty string to know if a translation is available;  this is bad and
	      // will be fixed eventually in https://bugzil.la/1020138
	      return '';
	    }
	
	    // If translation is broken use regular fallback-on-id approach
	    return fn.call(this, args, entry);
	  }
	
	  Context.prototype.get = function (id, args) {
	    return legacyGet.call(this, formatValue, id, args);
	  };
	
	  Context.prototype.getEntity = function (id, args) {
	    return legacyGet.call(this, formatEntity, id, args);
	  };
	
	  Context.prototype.getLocale = function getLocale(code) {
	    /* jshint -W093 */
	
	    var locales = this.locales;
	    if (locales[code]) {
	      return locales[code];
	    }
	
	    return locales[code] = new Locale(code, this);
	  };
	
	  // Getting ready
	
	  function negotiate(available, requested, defaultLocale) {
	    if (available.indexOf(requested[0]) === -1 || requested[0] === defaultLocale) {
	      return [defaultLocale];
	    } else {
	      return [requested[0], defaultLocale];
	    }
	  }
	
	  function freeze(supported) {
	    var locale = this.getLocale(supported[0]);
	    if (locale.isReady) {
	      setReady.call(this, supported);
	    } else {
	      locale.build(setReady.bind(this, supported));
	    }
	  }
	
	  function setReady(supported) {
	    this.supportedLocales = supported;
	    this.isReady = true;
	    this._emitter.emit('ready');
	  }
	
	  Context.prototype.registerLocales = function (defLocale, available) {
	    if (defLocale) {
	      this.defaultLocale = defLocale;
	    }
	    /* jshint boss:true */
	    this.availableLocales = [this.defaultLocale];
	
	    if (available) {
	      for (var i = 0, loc; loc = available[i]; i++) {
	        if (this.availableLocales.indexOf(loc) === -1) {
	          this.availableLocales.push(loc);
	        }
	      }
	    }
	  };
	
	  Context.prototype.requestLocales = function requestLocales() {
	    if (this.isLoading && !this.isReady) {
	      throw new L10nError('Context not ready');
	    }
	
	    this.isLoading = true;
	    var requested = Array.prototype.slice.call(arguments);
	    if (requested.length === 0) {
	      throw new L10nError('No locales requested');
	    }
	
	    var reqPseudo = requested.filter(function (loc) {
	      return loc in PSEUDO_STRATEGIES;
	    });
	
	    var supported = negotiate(this.availableLocales.concat(reqPseudo), requested, this.defaultLocale);
	    freeze.call(this, supported);
	  };
	
	  // Events
	
	  Context.prototype.addEventListener = function (type, listener) {
	    this._emitter.addEventListener(type, listener);
	  };
	
	  Context.prototype.removeEventListener = function (type, listener) {
	    this._emitter.removeEventListener(type, listener);
	  };
	
	  Context.prototype.ready = function (callback) {
	    if (this.isReady) {
	      setTimeout(callback);
	      return;
	    }
	    this.addEventListener('ready', callback);
	  };
	
	  Context.prototype.once = function (callback) {
	    /* jshint -W068 */
	    if (this.isReady) {
	      setTimeout(callback);
	      return;
	    }
	
	    var callAndRemove = function () {
	      this.removeEventListener('ready', callAndRemove);
	      callback();
	    }.bind(this);
	    this.addEventListener('ready', callAndRemove);
	  };
	
	  var allowed = {
	    elements: ['a', 'em', 'strong', 'small', 's', 'cite', 'q', 'dfn', 'abbr', 'data', 'time', 'code', 'var', 'samp', 'kbd', 'sub', 'sup', 'i', 'b', 'u', 'mark', 'ruby', 'rt', 'rp', 'bdi', 'bdo', 'span', 'br', 'wbr'],
	    attributes: {
	      global: ['title', 'aria-label', 'aria-valuetext', 'aria-moz-hint'],
	      a: ['download'],
	      area: ['download', 'alt'],
	      // value is special-cased in isAttrAllowed
	      input: ['alt', 'placeholder'],
	      menuitem: ['label'],
	      menu: ['label'],
	      optgroup: ['label'],
	      option: ['label'],
	      track: ['label'],
	      img: ['alt'],
	      textarea: ['placeholder'],
	      th: ['abbr']
	    }
	  };
	
	  var DEBUG = true;
	  var isPretranslated = false;
	  var rtlList = ['ar-SA', 'he-IL', 'fa-IR', 'ps-AF', 'qps-plocm', 'ur-PK', 'ks-IN', 'ur-IN'];
	  var nodeObserver = null;
	  var pendingElements = null;
	
	  var moConfig = {
	    attributes: true,
	    characterData: false,
	    childList: true,
	    subtree: true,
	    attributeFilter: ['data-l10n-id', 'data-l10n-args']
	  };
	
	  // Public API
	
	  navigator.mozL10n = {
	    ctx: new Context(window.document ? document.URL : null),
	    get: function get(id, ctxdata) {
	      return navigator.mozL10n.ctx.get(id, ctxdata);
	    },
	    formatValue: function formatValue(id, ctxdata) {
	      return navigator.mozL10n.ctx.formatValue(id, ctxdata);
	    },
	    formatEntity: function formatEntity(id, ctxdata) {
	      return navigator.mozL10n.ctx.formatEntity(id, ctxdata);
	    },
	    translateFragment: function translateFragment(fragment) {
	      return _translateFragment.call(navigator.mozL10n, fragment);
	    },
	    setAttributes: setL10nAttributes,
	    getAttributes: getL10nAttributes,
	    ready: function ready(callback) {
	      return navigator.mozL10n.ctx.ready(callback);
	    },
	    once: function once(callback) {
	      return navigator.mozL10n.ctx.once(callback);
	    },
	    get readyState() {
	      return navigator.mozL10n.ctx.isReady ? 'complete' : 'loading';
	    },
	    language: {
	      set code(lang) {
	        navigator.mozL10n.ctx.requestLocales(lang);
	      },
	      get code() {
	        return navigator.mozL10n.ctx.supportedLocales[0];
	      },
	      get direction() {
	        return getDirection(navigator.mozL10n.ctx.supportedLocales[0]);
	      }
	    },
	    qps: PSEUDO_STRATEGIES,
	    _config: {
	      appVersion: null,
	      localeSources: Object.create(null)
	    },
	    _getInternalAPI: function _getInternalAPI() {
	      return {
	        Error: L10nError,
	        Context: Context,
	        Locale: Locale,
	        Resolver: Resolver,
	        getPluralRule: getPluralRule,
	        rePlaceables: rePlaceables,
	        translateDocument: translateDocument,
	        onMetaInjected: onMetaInjected,
	        PropertiesParser: PropertiesParser,
	        walkContent: walkContent,
	        buildLocaleList: buildLocaleList
	      };
	    }
	  };
	
	  navigator.mozL10n.ctx.ready(onReady.bind(navigator.mozL10n));
	
	  navigator.mozL10n.ctx.addEventListener('notfounderror', function reportMissingEntity(e) {
	    if (DEBUG || e.loc === 'en-US') {
	      console.warn(e.toString());
	    }
	  });
	
	  if (DEBUG) {
	    navigator.mozL10n.ctx.addEventListener('fetcherror', console.error.bind(console));
	    navigator.mozL10n.ctx.addEventListener('parseerror', console.error.bind(console));
	    navigator.mozL10n.ctx.addEventListener('resolveerror', console.error.bind(console));
	  }
	
	  function getDirection(lang) {
	    return rtlList.indexOf(lang) >= 0 ? 'rtl' : 'ltr';
	  }
	
	  var readyStates = {
	    loading: 0,
	    interactive: 1,
	    complete: 2
	  };
	
	  function waitFor(state, callback) {
	    state = readyStates[state];
	    if (readyStates[document.readyState] >= state) {
	      callback();
	      return;
	    }
	
	    document.addEventListener('readystatechange', function l10n_onrsc() {
	      if (readyStates[document.readyState] >= state) {
	        document.removeEventListener('readystatechange', l10n_onrsc);
	        callback();
	      }
	    });
	  }
	
	  if (window.document) {
	    isPretranslated = !PSEUDO_STRATEGIES.hasOwnProperty(navigator.language) && document.documentElement.lang === navigator.language;
	
	    // XXX always pretranslate if data-no-complete-bug is set;  this is
	    // a workaround for a netError page not firing some onreadystatechange
	    // events;  see https://bugzil.la/444165
	    var pretranslate = document.documentElement.dataset.noCompleteBug ? true : !isPretranslated;
	    waitFor('interactive', init.bind(navigator.mozL10n, pretranslate));
	  }
	
	  function initObserver() {
	    nodeObserver = new MutationObserver(onMutations.bind(navigator.mozL10n));
	    nodeObserver.observe(document, moConfig);
	  }
	
	  function init(pretranslate) {
	    if (pretranslate) {
	      initResources.call(navigator.mozL10n);
	    } else {
	      // if pretranslate is false, we want to initialize MO
	      // early, to collect nodes injected between now and when resources
	      // are loaded because we're not going to translate the whole
	      // document once l10n resources are ready.
	      initObserver();
	      window.setTimeout(initResources.bind(navigator.mozL10n));
	    }
	  }
	
	  function initResources() {
	    /* jshint boss:true */
	
	    var meta = {};
	    var nodes = document.head.querySelectorAll('link[rel="localization"],' + 'meta[name="availableLanguages"],' + 'meta[name="defaultLanguage"],' + 'meta[name="appVersion"],' + 'script[type="application/l10n"]');
	    for (var i = 0, node; node = nodes[i]; i++) {
	      var type = node.getAttribute('rel') || node.nodeName.toLowerCase();
	      switch (type) {
	        case 'localization':
	          this.ctx.resLinks.push(node.getAttribute('href'));
	          break;
	        case 'meta':
	          onMetaInjected.call(this, node, meta);
	          break;
	        case 'script':
	          onScriptInjected.call(this, node);
	          break;
	      }
	    }
	
	    var additionalLanguagesPromise;
	
	    if (navigator.mozApps && navigator.mozApps.getAdditionalLanguages) {
	      // if the environment supports langpacks, register extra languages…
	      additionalLanguagesPromise = navigator.mozApps.getAdditionalLanguages().catch(function (e) {
	        console.error('Error while loading getAdditionalLanguages', e);
	      });
	
	      // …and listen to langpacks being added and removed
	      document.addEventListener('additionallanguageschange', function (evt) {
	        registerLocales.call(this, meta, evt.detail);
	      }.bind(this));
	    } else {
	      additionalLanguagesPromise = Promise.resolve();
	    }
	
	    additionalLanguagesPromise.then(function (extraLangs) {
	      registerLocales.call(this, meta, extraLangs);
	      initLocale.call(this);
	    }.bind(this));
	  }
	
	  function registerLocales(meta, extraLangs) {
	    var locales = buildLocaleList.call(this, meta, extraLangs);
	    navigator.mozL10n._config.localeSources = locales[1];
	    this.ctx.registerLocales(locales[0], Object.keys(locales[1]));
	  }
	
	  function getMatchingLangpack(appVersion, langpacks) {
	    for (var i = 0, langpack; langpack = langpacks[i]; i++) {
	      if (langpack.target === appVersion) {
	        return langpack;
	      }
	    }
	    return null;
	  }
	
	  function buildLocaleList(meta, extraLangs) {
	    var loc, lp;
	    var localeSources = Object.create(null);
	    var defaultLocale = meta.defaultLocale || this.ctx.defaultLocale;
	
	    if (meta.availableLanguages) {
	      for (loc in meta.availableLanguages) {
	        localeSources[loc] = 'app';
	      }
	    }
	
	    if (extraLangs) {
	      for (loc in extraLangs) {
	        lp = getMatchingLangpack(this._config.appVersion, extraLangs[loc]);
	
	        if (!lp) {
	          continue;
	        }
	        if (!(loc in localeSources) || !meta.availableLanguages[loc] || parseInt(lp.revision) > meta.availableLanguages[loc]) {
	          localeSources[loc] = 'extra';
	        }
	      }
	    }
	
	    if (!(defaultLocale in localeSources)) {
	      localeSources[defaultLocale] = 'app';
	    }
	    return [defaultLocale, localeSources];
	  }
	
	  function splitAvailableLanguagesString(str) {
	    var langs = {};
	
	    str.split(',').forEach(function (lang) {
	      // code:revision
	      lang = lang.trim().split(':');
	      // if revision is missing, use NaN
	      langs[lang[0]] = parseInt(lang[1]);
	    });
	    return langs;
	  }
	
	  function onMetaInjected(node, meta) {
	    switch (node.getAttribute('name')) {
	      case 'availableLanguages':
	        var langs = getLanguageFromURL() + ', ' + this.ctx.defaultLocale;
	        meta.availableLanguages = splitAvailableLanguagesString(langs);
	        break;
	      case 'defaultLanguage':
	        meta.defaultLanguage = node.getAttribute('content');
	        break;
	      case 'appVersion':
	        navigator.mozL10n._config.appVersion = node.getAttribute('content');
	        break;
	    }
	  }
	
	  function onScriptInjected(node) {
	    var lang = node.getAttribute('lang');
	    var locale = this.ctx.getLocale(lang);
	    locale.addAST(JSON.parse(node.textContent));
	  }
	
	  function initLocale() {
	    this.ctx.requestLocales.apply(this.ctx, navigator.languages || [navigator.language]);
	    window.addEventListener('languagechange', function l10n_langchange() {
	      this.ctx.requestLocales.apply(this.ctx, navigator.languages || [navigator.language]);
	    }.bind(this));
	  }
	
	  function localizeMutations(mutations) {
	    var mutation;
	    var targets = new Set();
	
	    for (var i = 0; i < mutations.length; i++) {
	      mutation = mutations[i];
	      if (mutation.type === 'childList') {
	        var addedNode;
	
	        for (var j = 0; j < mutation.addedNodes.length; j++) {
	          addedNode = mutation.addedNodes[j];
	          if (addedNode.nodeType !== Node.ELEMENT_NODE) {
	            continue;
	          }
	          targets.add(addedNode);
	        }
	      }
	
	      if (mutation.type === 'attributes') {
	        targets.add(mutation.target);
	      }
	    }
	
	    targets.forEach(function (target) {
	      if (target.childElementCount) {
	        _translateFragment.call(this, target);
	      } else if (target.hasAttribute('data-l10n-id')) {
	        translateElement.call(this, target);
	      }
	    }, this);
	  }
	
	  function onMutations(mutations, self) {
	    self.disconnect();
	    localizeMutations.call(this, mutations);
	    self.observe(document, moConfig);
	  }
	
	  function onReady() {
	    if (!isPretranslated) {
	      translateDocument.call(this);
	    }
	    isPretranslated = false;
	
	    if (pendingElements) {
	      /* jshint boss:true */
	      for (var i = 0, element; element = pendingElements[i]; i++) {
	        translateElement.call(this, element);
	      }
	      pendingElements = null;
	    }
	
	    if (!nodeObserver) {
	      initObserver();
	    }
	    fireLocalizedEvent.call(this);
	  }
	
	  function fireLocalizedEvent() {
	    var event = new CustomEvent('localized', {
	      bubbles: false,
	      cancelable: false,
	      detail: {
	        language: this.ctx.supportedLocales[0]
	      }
	    });
	    window.dispatchEvent(event);
	  }
	
	  function translateDocument() {
	    document.documentElement.lang = this.language.code;
	    document.documentElement.dir = this.language.direction;
	    _translateFragment.call(this, document.documentElement);
	  }
	
	  function _translateFragment(element) {
	    if (element.hasAttribute('data-l10n-id')) {
	      translateElement.call(this, element);
	    }
	
	    var nodes = getTranslatableChildren(element);
	    for (var i = 0; i < nodes.length; i++) {
	      translateElement.call(this, nodes[i]);
	    }
	  }
	
	  function setL10nAttributes(element, id, args) {
	    element.setAttribute('data-l10n-id', id);
	    if (args) {
	      element.setAttribute('data-l10n-args', JSON.stringify(args));
	    }
	  }
	
	  function getL10nAttributes(element) {
	    return {
	      id: element.getAttribute('data-l10n-id'),
	      args: JSON.parse(element.getAttribute('data-l10n-args'))
	    };
	  }
	
	  function getTranslatableChildren(element) {
	    return element ? element.querySelectorAll('*[data-l10n-id]') : [];
	  }
	
	  function camelCaseToDashed(string) {
	    // XXX workaround for https://bugzil.la/1141934
	    if (string === 'ariaValueText') {
	      return 'aria-valuetext';
	    }
	
	    return string.replace(/[A-Z]/g, function (match) {
	      return '-' + match.toLowerCase();
	    }).replace(/^-/, '');
	  }
	
	  function translateElement(element) {
	    if (!this.ctx.isReady) {
	      if (!pendingElements) {
	        pendingElements = [];
	      }
	      pendingElements.push(element);
	      return;
	    }
	
	    var l10n = getL10nAttributes(element);
	
	    if (!l10n.id) {
	      return false;
	    }
	
	    var entity = this.ctx.getEntity(l10n.id, l10n.args);
	
	    if (typeof entity.value === 'string') {
	      if (!entity.overlay) {
	        element.textContent = entity.value;
	      } else {
	        // start with an inert template element and move its children into
	        // `element` but such that `element`'s own children are not replaced
	        var translation = element.ownerDocument.createElement('template');
	        translation.innerHTML = entity.value;
	        // overlay the node with the DocumentFragment
	        overlayElement(element, translation.content);
	      }
	    }
	
	    for (var key in entity.attrs) {
	      // XXX A temporary special-case for translations using the old method
	      // of declaring innerHTML.  To be removed in https://bugzil.la/1027117
	      if (key === 'innerHTML') {
	        element.innerHTML = entity.attrs[key];
	        continue;
	      }
	      var attrName = camelCaseToDashed(key);
	      if (isAttrAllowed({ name: attrName }, element)) {
	        element.setAttribute(attrName, entity.attrs[key]);
	      }
	    }
	  }
	
	  // The goal of overlayElement is to move the children of `translationElement`
	  // into `sourceElement` such that `sourceElement`'s own children are not
	  // replaced, but onle have their text nodes and their attributes modified.
	  //
	  // We want to make it possible for localizers to apply text-level semantics to
	  // the translations and make use of HTML entities. At the same time, we
	  // don't trust translations so we need to filter unsafe elements and
	  // attribtues out and we don't want to break the Web by replacing elements to
	  // which third-party code might have created references (e.g. two-way
	  // bindings in MVC frameworks).
	  function overlayElement(sourceElement, translationElement) {
	    var result = translationElement.ownerDocument.createDocumentFragment();
	    var k, attr;
	
	    // take one node from translationElement at a time and check it against
	    // the allowed list or try to match it with a corresponding element
	    // in the source
	    var childElement;
	    while (childElement = translationElement.childNodes[0]) {
	      translationElement.removeChild(childElement);
	
	      if (childElement.nodeType === Node.TEXT_NODE) {
	        result.appendChild(childElement);
	        continue;
	      }
	
	      var index = getIndexOfType(childElement);
	      var sourceChild = getNthElementOfType(sourceElement, childElement, index);
	      if (sourceChild) {
	        // there is a corresponding element in the source, let's use it
	        overlayElement(sourceChild, childElement);
	        result.appendChild(sourceChild);
	        continue;
	      }
	
	      if (isElementAllowed(childElement)) {
	        var sanitizedChild = childElement.ownerDocument.createElement(childElement.nodeName);
	        overlayElement(sanitizedChild, childElement);
	        result.appendChild(sanitizedChild);
	        continue;
	      }
	
	      // otherwise just take this child's textContent
	      result.appendChild(document.createTextNode(childElement.textContent));
	    }
	
	    // clear `sourceElement` and append `result` which by this time contains
	    // `sourceElement`'s original children, overlayed with translation
	    sourceElement.textContent = '';
	    sourceElement.appendChild(result);
	
	    // if we're overlaying a nested element, translate the allowed
	    // attributes; top-level attributes are handled in `translateElement`
	    // XXX attributes previously set here for another language should be
	    // cleared if a new language doesn't use them; https://bugzil.la/922577
	    if (translationElement.attributes) {
	      for (k = 0, attr; attr = translationElement.attributes[k]; k++) {
	        if (isAttrAllowed(attr, sourceElement)) {
	          sourceElement.setAttribute(attr.name, attr.value);
	        }
	      }
	    }
	  }
	
	  // XXX the allowed list should be amendable; https://bugzil.la/922573
	  function isElementAllowed(element) {
	    return allowed.elements.indexOf(element.tagName.toLowerCase()) !== -1;
	  }
	
	  function isAttrAllowed(attr, element) {
	    var attrName = attr.name.toLowerCase();
	    var tagName = element.tagName.toLowerCase();
	    // is it a globally safe attribute?
	    if (allowed.attributes.global.indexOf(attrName) !== -1) {
	      return true;
	    }
	    // are there no allowed attributes for this element?
	    if (!allowed.attributes[tagName]) {
	      return false;
	    }
	    // is it allowed on this element?
	    // XXX the allowed list should be amendable; https://bugzil.la/922573
	    if (allowed.attributes[tagName].indexOf(attrName) !== -1) {
	      return true;
	    }
	    // special case for value on inputs with type button, reset, submit
	    if (tagName === 'input' && attrName === 'value') {
	      var type = element.type.toLowerCase();
	      if (type === 'submit' || type === 'button' || type === 'reset') {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  // Get n-th immediate child of context that is of the same type as element.
	  // XXX Use querySelector(':scope > ELEMENT:nth-of-type(index)'), when:
	  // 1) :scope is widely supported in more browsers and 2) it works with
	  // DocumentFragments.
	  function getNthElementOfType(context, element, index) {
	    /* jshint boss:true */
	    var nthOfType = 0;
	    for (var i = 0, child; child = context.children[i]; i++) {
	      if (child.nodeType === Node.ELEMENT_NODE && child.tagName === element.tagName) {
	        if (nthOfType === index) {
	          return child;
	        }
	        nthOfType++;
	      }
	    }
	    return null;
	  }
	
	  // Get the index of the element among siblings of the same type.
	  function getIndexOfType(element) {
	    var index = 0;
	    var child;
	    while (child = element.previousElementSibling) {
	      if (child.tagName === element.tagName) {
	        index++;
	      }
	    }
	    return index;
	  }
	})(window);

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(96);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(1);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _preactRouter = __webpack_require__(12);
	
	var _account = __webpack_require__(15);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _Appsview = __webpack_require__(71);
	
	var _Appsview2 = _interopRequireDefault(_Appsview);
	
	var _Bannerbar = __webpack_require__(72);
	
	var _Bannerbar2 = _interopRequireDefault(_Bannerbar);
	
	var _softKeyStore = __webpack_require__(6);
	
	var _softKeyStore2 = _interopRequireDefault(_softKeyStore);
	
	var _reactOptionMenu = __webpack_require__(60);
	
	var _reactOptionMenu2 = _interopRequireDefault(_reactOptionMenu);
	
	var _deviceUtils = __webpack_require__(16);
	
	var _constant = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Appspanel = function (_Component) {
	  _inherits(Appspanel, _Component);
	
	  function Appspanel() {
	    _classCallCheck(this, Appspanel);
	
	    var _this = _possibleConstructorReturn(this, (Appspanel.__proto__ || Object.getPrototypeOf(Appspanel)).call(this));
	
	    _this.state = {
	      focusTarget: 'apps-view',
	      optionMenu: false
	    };
	
	    _this.bannerBlur = function () {
	      return _this.activePanel('apps-view');
	    };
	
	    _this.bannerQuantity = 3;
	    _this.initialized = false;
	    _this.refs = {};
	    _this.isBannerEnable = window.deviceInfos.get('store.banner.enable');
	    return _this;
	  }
	
	  _createClass(Appspanel, [{
	    key: 'handleKeydown',
	    value: function handleKeydown(e) {
	      switch (e.key) {
	        case 'Enter':
	          var target = e.target;
	          this.handleEnter(target);
	          break;
	        case 'SoftRight':
	          this.showOptionMenu();
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'showOptionMenu',
	    value: function showOptionMenu() {
	      var _this2 = this;
	
	      var urls = {
	        'privacy-policy': 'https://www.kaiostech.com/privacy-policy/',
	        'terms-and-services': 'https://www.kaiostech.com/kaistore-terms-of-service/',
	        'need-help': 'https://support.kaiostech.com/support/tickets/new'
	      };
	      var config = [];
	
	      // If settings is true. (Means supported.)
	      if (_deviceUtils.deviceUtils.featureset.settingsPanelSupported) {
	        config = [{
	          id: _account2.default.version ? 'settings-and-account' : 'settings',
	          callback: function callback() {
	            (0, _preactRouter.route)(_constant.PATH.SETTING.URL());
	          }
	        }];
	      }
	
	      var _loop = function _loop(item) {
	        config.push({
	          id: item,
	          callback: function callback() {
	            window.open(urls[item]);
	          }
	        });
	      };
	
	      for (var item in urls) {
	        _loop(item);
	      }
	
	      this.setState({ optionMenu: true }, function () {
	        _this2.menu.show({ options: config });
	        _this2.menu.on('closed', function () {
	          _this2.setState({ optionMenu: false });
	          _this2._focus();
	        });
	      });
	    }
	  }, {
	    key: 'handleEnter',
	    value: function handleEnter(target) {
	      var _target$dataset = target.dataset,
	          id = _target$dataset.id,
	          appOrder = _target$dataset.appOrder;
	
	      if (!id) {
	        return;
	      }
	      (0, _preactRouter.route)(_constant.PATH.PAGE.URL({ id: id, appOrder: parseInt(appOrder, 10) }));
	    }
	  }, {
	    key: '_updateSoftKey',
	    value: function _updateSoftKey(option) {
	      if (!option) {
	        return;
	      }
	      _softKeyStore2.default.register(option, _reactDom2.default.findDOMNode(this));
	    }
	  }, {
	    key: '_focus',
	    value: function _focus() {
	      var activateElement = this.state.focusTarget;
	      var focusElement = _reactDom2.default.findDOMNode(this.refs[activateElement]);
	      var option = {
	        left: '',
	        center: 'select',
	        right: 'options'
	      };
	
	      if (focusElement) {
	        focusElement.focus();
	        this._updateSoftKey(option);
	
	        if (!this.initialized) {
	          this.initialized = true;
	        }
	      }
	    }
	  }, {
	    key: 'activePanel',
	    value: function activePanel(panel) {
	      var _this3 = this;
	
	      if ((typeof panel === 'undefined' ? 'undefined' : _typeof(panel)) === undefined) {
	        return;
	      }
	      this.setState({ focusTarget: panel }, function () {
	        return _this3._focus();
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.element.addEventListener('keydown', this.handleKeydown.bind(this));
	      this._focus();
	      this.props.ensureDialogDisplay();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'Appspanel',
	          tabIndex: '1',
	          ref: function ref(element) {
	            _this4.element = element;
	          }
	        },
	        this.isBannerEnable && _react2.default.createElement(_Bannerbar2.default, {
	          'data-id': 'promotion-bar',
	          ref: function ref(banner) {
	            _this4.refs['banner'] = banner;
	          },
	          blur: this.bannerBlur,
	          itemNum: this.bannerQuantity
	        }),
	        _react2.default.createElement(_Appsview2.default, {
	          ref: function ref(appsview) {
	            _this4.refs['apps-view'] = appsview;
	          }
	        }),
	        _react2.default.createElement(
	          'div',
	          {
	            id: 'options-root',
	            className: this.state.optionMenu ? '' : 'hidden'
	          },
	          _react2.default.createElement(_reactOptionMenu2.default, {
	            ref: function ref(element) {
	              _this4.menu = element;
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return Appspanel;
	}(_react.Component);
	
	exports.default = Appspanel;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(97);
	
	var _Listview = __webpack_require__(73);
	
	var _Listview2 = _interopRequireDefault(_Listview);
	
	var _UpdateListview = __webpack_require__(77);
	
	var _UpdateListview2 = _interopRequireDefault(_UpdateListview);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(1);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _appStore = __webpack_require__(13);
	
	var _appStore2 = _interopRequireDefault(_appStore);
	
	var _userInterfaceHelper = __webpack_require__(19);
	
	var _userInterfaceHelper2 = _interopRequireDefault(_userInterfaceHelper);
	
	var _utils = __webpack_require__(23);
	
	var _webMessageHelper = __webpack_require__(5);
	
	var _commands = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CARRIER_CAT_START_AFTER = 100000;
	
	var Appsview = function (_Component) {
	  _inherits(Appsview, _Component);
	
	  function Appsview() {
	    _classCallCheck(this, Appsview);
	
	    var _this = _possibleConstructorReturn(this, (Appsview.__proto__ || Object.getPrototypeOf(Appsview)).call(this));
	
	    _this.state = {
	      categories: [],
	      currentTabIndex: 0,
	      apps: _appStore2.default.allRemoteItems
	    };
	
	    _this.handleStoreChange = function () {
	      _this.setState({
	        apps: _appStore2.default.allRemoteItems,
	        categories: _this.getCategories(_appStore2.default.allRemoteItems, _appStore2.default.categories)
	      });
	    };
	
	    window.addEventListener('appstore:change', _this.handleStoreChange);
	    return _this;
	  }
	
	  _createClass(Appsview, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var apps = this.state.apps;
	
	      this.setState({
	        categories: this.getCategories(apps, _appStore2.default.categories)
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('appstore:change', this.handleStoreChange);
	      _userInterfaceHelper2.default.lastAppsviewIndex.tabOrder = this.state.currentTabIndex;
	    }
	  }, {
	    key: 'getCategories',
	    value: function getCategories(apps, categories) {
	      var categoriesCode = [];
	
	      var categoriesForTabs = [];
	      var showRecommendedTab = false;
	      var carrierCategories = [];
	
	      categoriesCode = apps.map(function (item) {
	        if (!showRecommendedTab && item.remoteInfo.recommended_index > 0) {
	          showRecommendedTab = true;
	        }
	        return item.remoteInfo.category;
	      });
	      categoriesCode = [].concat(_toConsumableArray(new Set(categoriesCode)));
	
	      // For fixing app-list without any category.
	      if (categoriesCode.length === 0) {
	        categoriesCode.push('all');
	      }
	
	      if (categories.length !== 0) {
	        categories.forEach(function (cat) {
	          if (categoriesCode.indexOf(cat.code) !== -1) {
	            if (parseInt(cat.code) > CARRIER_CAT_START_AFTER) {
	              carrierCategories.push(cat);
	            } else {
	              categoriesForTabs.push(cat);
	            }
	          }
	        });
	        this.localizedCat(carrierCategories);
	        this.localizedCat(categoriesForTabs);
	      } else {
	        // For backward compatible.
	        var _ = navigator.mozL10n;
	        categoriesCode.forEach(function (code) {
	          var l10nId = 'CAT-' + code;
	          var catInfo = {
	            code: code,
	            displayName: _.get(l10nId)
	          };
	          if (parseInt(code) > CARRIER_CAT_START_AFTER) {
	            carrierCategories.push(catInfo);
	          } else {
	            categoriesForTabs.push(catInfo);
	          }
	        });
	        this.localizedCat(carrierCategories);
	      }
	
	      // append the recommended tab at the position after carrier tab
	      if (showRecommendedTab) {
	        var _2 = navigator.mozL10n;
	        var tabCode = 'recommended';
	        var l10nId = 'CAT-' + tabCode;
	
	        categoriesForTabs.unshift({
	          code: tabCode,
	          displayName: _2.get(l10nId)
	        });
	      }
	
	      if (carrierCategories.length > 0) {
	        categoriesForTabs = carrierCategories.concat(categoriesForTabs);
	      }
	
	      if (_appStore2.default.hasUpdatableApps) {
	        categoriesForTabs.unshift({ isUpdateTab: true });
	      }
	
	      return categoriesForTabs;
	    }
	  }, {
	    key: 'localizedCat',
	    value: function localizedCat(categories) {
	      if (categories.length === 0) {
	        return;
	      }
	      var lang = navigator.mozL10n.language.code || '';
	      categories.forEach(function (cat) {
	        var defaultName = cat.name;
	        if (cat.locales.hasOwnProperty(lang)) {
	          cat['displayName'] = cat.locales[lang];
	        } else {
	          cat['displayName'] = cat.name;
	        }
	      });
	    }
	  }, {
	    key: 'handleKeydown',
	    value: function handleKeydown(e) {
	      switch (e.key) {
	        case 'ArrowRight':
	          this._nav(1, e);
	          break;
	        case 'ArrowLeft':
	          this._nav(-1, e);
	          break;
	        case 'ArrowDown':
	        case 'ArrowUp':
	          this._blur();
	          break;
	        case 'Backspace':
	        case 'Enter':
	        case 'SoftRight':
	          // pass to parent.
	          break;
	        case 'BrowserBack':
	        case 'Accept':
	        default:
	          // do nothing.
	          e.stopPropagation();
	          break;
	      }
	    }
	  }, {
	    key: 'handleFocus',
	    value: function handleFocus(e) {
	      this._focus();
	    }
	  }, {
	    key: '_nav',
	    value: function _nav(move, e) {
	      this._resetActive();
	      var currentIndex = this.state.currentTabIndex;
	      var length = this.element.querySelectorAll('.tab').length;
	      if ('rtl' === document.dir) {
	        move = move * -1;
	      }
	      currentIndex += move;
	      if (currentIndex < -0) {
	        currentIndex = length - 1;
	      } else {
	        currentIndex %= length;
	      }
	      this.setState({ currentTabIndex: currentIndex });
	      e.preventDefault();
	    }
	  }, {
	    key: '_focus',
	    value: function _focus() {
	      var currentIndex = this.state.currentTabIndex;
	      this.activeList = this.element.querySelectorAll('.Listview')[currentIndex];
	      this.activeList.focus();
	    }
	  }, {
	    key: '_blur',
	    value: function _blur() {
	      this.element.blur();
	    }
	  }, {
	    key: '_activeTab',
	    value: function _activeTab() {
	      var offset;
	      var currentIndex = this.state.currentTabIndex;
	      this.activeList = this.element.querySelectorAll('.Listview')[currentIndex];
	      this.activeList.classList.add('active');
	
	      var tabs = this.element.querySelectorAll('.tab');
	      var lastIndex = tabs.length - 1;
	
	      // get activeTab
	      this.activeTab = tabs[currentIndex];
	
	      // fetch UL
	      var box = this.activeTab.parentElement;
	      var tabsWrapperWidth = box.offsetWidth;
	      var tabsWrapperLeft = box.offsetLeft;
	
	      var currTabLeft = this.activeTab.offsetLeft;
	      var currTabWidth = this.activeTab.offsetWidth;
	      var currTabRight = 0;
	
	      // last tabs
	      var lastTabLeft = tabs[lastIndex].offsetLeft;
	      var lastTabWidth = tabs[lastIndex].offsetWidth;
	      var lastTabRight = 0;
	
	      if ('rtl' === document.dir) {
	        // RTL (Right to Left)
	        // In RTL, offsetLeft will not be reverted to offsetRight.
	        // So first offsetLeft of tab will starts from
	        // (WrapperWidth -currTabWidth), eg. Each tab's width is 40px.
	        // its offsetLeft will be 160px, and 2nd tab will be 120, so on..
	        // But in LTR (Left to right), first offsetLeft will start from 0px.
	
	        if (currentIndex === 0) {
	          // First tab, translateX offset is 0.
	          offset = 0;
	        } else {
	          if (currTabLeft < 0) {
	            offset = tabsWrapperWidth / 2 - (currTabLeft + currTabWidth / 2);
	          } else {
	            offset = 0;
	          }
	        }
	      } else {
	        // LTR (Left to Right)
	        currTabRight = tabsWrapperWidth - (currTabLeft + currTabWidth);
	        lastTabRight = tabsWrapperWidth - (lastTabLeft + lastTabWidth);
	        if (currentIndex === 0) {
	          // First tab, translateX offset is 0.
	          offset = 0;
	        } else if (currentIndex === lastIndex) {
	          // Last tab, translateX offset is lastTabRight or 0.
	          if (lastTabRight > 0) {
	            offset = 0;
	          } else {
	            offset = (currTabLeft + currTabRight) / 2 - currTabLeft;
	          }
	        } else {
	          // Tab in the middle of somewhere
	
	          // Calcuate the average of current tab's offsetLeft and offsetRight
	          // as targetOffset and set translateX to put tab at the center.
	          var targetTabLeft = (currTabLeft + currTabRight) / 2;
	          var targetOffset = targetTabLeft - currTabLeft;
	          if (targetOffset > 0 || lastTabRight > 0) {
	            // Offset greater than 0, possibily at the first one or two tabs,
	            // or last tab is fully visible, so there's no need move.
	            offset = 0;
	          } else if (targetOffset < 0 && targetOffset > lastTabRight) {
	            // Normal case, simply set offset to targetOffset.
	            offset = targetOffset;
	          } else if (targetOffset < 0 && targetOffset < lastTabRight) {
	            // Offset less than lastTabRight,
	            // possibily at the last one or two tabs
	            // and can't move more than lastTabRight.
	            offset = lastTabRight;
	          }
	        }
	      }
	      // apply css.
	      box.style.transform = 'translateX(' + offset + 'px)';
	      this.activeTab.classList.add('selected');
	    }
	  }, {
	    key: '_resetActive',
	    value: function _resetActive() {
	      var currentIndex = this.state.currentTabIndex;
	      this.activeList = this.element.querySelectorAll('.Listview')[currentIndex];
	      this.activeList.classList.remove('active');
	
	      this.activeTab = this.element.querySelectorAll('.tab')[currentIndex];
	      this.activeTab.classList.remove('selected');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.element.addEventListener('keydown', this.handleKeydown.bind(this));
	      this.element.addEventListener('focus', this.handleFocus.bind(this));
	
	      var lastTabOrder = _userInterfaceHelper2.default.lastAppsviewIndex.tabOrder;
	      if (lastTabOrder) {
	        this.setState({
	          currentTabIndex: lastTabOrder
	        });
	      } else {
	        this._activeTab();
	      }
	
	      if (_userInterfaceHelper2.default.appsviewMounted) {
	        return;
	      }
	
	      _userInterfaceHelper2.default.appsviewMounted = true;
	      performance.mark('REMOTE_PAGE_RENDERING_END');
	      // Inform client store that first view is rendered completely.
	      var timestamp = new Date().getTime();
	      var command = new _commands.FirstViewDidMountCommand({
	        detail: {
	          timestamp: timestamp
	        }
	      });
	      _webMessageHelper.MessageSender.send(command);
	      console.warn('appsview first ready at', timestamp);
	      _utils.utils.performanceLogs();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.currentTabIndex !== this.state.currentTabIndex || prevState.categories.length !== this.state.categories.length) {
	        this._activeTab();
	        this._focus();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var apps = this.state.apps;
	
	      var tabs = this.state.categories;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'Appsview',
	          tabIndex: '1',
	          ref: function ref(target) {
	            _this2.element = target;
	          }
	        },
	        _react2.default.createElement(
	          'gaia-tabs',
	          { 'class': 'h3', underline: 'child', position: 'top' },
	          tabs.map(function (result, index) {
	            return result.isUpdateTab ? _react2.default.createElement(
	              'a',
	              { tabIndex: '1', className: 'tab' },
	              _react2.default.createElement('span', { 'data-l10n-id': 'update' })
	            ) : _react2.default.createElement(
	              'a',
	              { key: index, tabIndex: '1', className: 'tab' },
	              _react2.default.createElement(
	                'span',
	                { 'data-index': index, 'data-cat-id': result.code },
	                result.displayName
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ListviewBox' },
	          tabs.map(function (result, index) {
	            return result.isUpdateTab ? _react2.default.createElement(_UpdateListview2.default, {
	              isCurrentList: index === _this2.state.currentTabIndex
	            }) : _react2.default.createElement(_Listview2.default, {
	              apps: apps,
	              key: index,
	              category: result.code,
	              order: index,
	              isCurrentList: index === _this2.state.currentTabIndex
	            });
	          })
	        )
	      );
	    }
	  }]);
	
	  return Appsview;
	}(_react.Component);
	
	exports.default = Appsview;

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(98);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(1);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _preactRouter = __webpack_require__(12);
	
	var _constant = __webpack_require__(9);
	
	var _kaiadsMin = __webpack_require__(91);
	
	var _kaiadsMin2 = _interopRequireDefault(_kaiadsMin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BannerBar = function (_PureComponent) {
	  _inherits(BannerBar, _PureComponent);
	
	  function BannerBar(props) {
	    _classCallCheck(this, BannerBar);
	
	    var _this = _possibleConstructorReturn(this, (BannerBar.__proto__ || Object.getPrototypeOf(BannerBar)).call(this));
	
	    _this.state = {
	      currentIndex: 0,
	      isFocus: false
	    };
	
	    _this.publisher = '2dddcb68-d226-49a0-bb99-c65e141088e8';
	    _this.adNavCls = 'ad-nav';
	    _this.adSize = [210, 54];
	    return _this;
	  }
	
	  _createClass(BannerBar, [{
	    key: 'fetchOneKaiAd',
	
	
	    // Get a responsive Ad via KaiAds SDK
	    value: function fetchOneKaiAd(index) {
	      var _this2 = this;
	
	      return new Promise(function (resolve, reject) {
	        (0, _kaiadsMin2.default)({
	          publisher: _this2.publisher,
	          app: 'KaiStore',
	          slot: 'Banner Bar',
	          h: _this2.adSize[1],
	          w: _this2.adSize[0],
	          // 1 when testing the ad, 0 when in production
	          test: 0,
	          container: document.getElementById('ad-' + index),
	          onerror: function onerror(err) {
	            console.error('Custom catch:', err);
	            reject(err);
	          },
	          onready: function onready(ad) {
	            ad.call('display', {
	              tabindex: 1,
	              navClass: _this2.adNavCls,
	              display: 'inline-block'
	            });
	            resolve();
	          }
	        });
	      });
	    }
	  }, {
	    key: 'fetchManyKaiAds',
	    value: function fetchManyKaiAds() {
	      var _this3 = this;
	
	      var promises = [];
	
	      for (var i = 0; i < this.props.itemNum; i++) {
	        promises.push(this.fetchOneKaiAd(i));
	      }
	
	      Promise.all(promises).then(function () {
	        var _element$classList;
	
	        // All resovled: show the banner
	        (_element$classList = _this3.element.classList).remove.apply(_element$classList, _toConsumableArray(_this3.element.classList));
	      }, function () {
	        // Any rejected: remove all banner items
	        var indicators = _this3.element.querySelector('.indicator-bar');
	        var banners = _this3.element.querySelector('.banner-bar');
	        _this3.element.removeChild(indicators);
	        _this3.element.removeChild(banners);
	      });
	    }
	  }, {
	    key: 'getAppId',
	    value: function getAppId(manifestURL) {
	      var partitions = manifestURL.split('/');
	      var len = partitions.length;
	
	      return partitions[len - 1];
	    }
	  }, {
	    key: 'getAdInfo',
	    value: function getAdInfo(ad, key) {
	      return new Promise(function (resolve, reject) {
	        ad.on(key, function (value) {
	          ad.info[key] = value;
	          resolve();
	        });
	        ad.call(key);
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.element.addEventListener('keydown', this.handleKeydown.bind(this));
	      this.element.addEventListener('focus', this.handleFocus.bind(this));
	      // Fetch KaiAds and put them on banners.
	      this.fetchManyKaiAds();
	    }
	  }, {
	    key: 'handleKeydown',
	    value: function handleKeydown(e) {
	      switch (e.key) {
	        case 'ArrowDown':
	          // banner blur and focus on apps-view
	          this._blur();
	          this.props.blur();
	          break;
	        case 'ArrowRight':
	          this._nav(1, e);
	          break;
	        case 'ArrowLeft':
	          this._nav(-1, e);
	          break;
	        case 'Enter':
	        case 'ArrowUp':
	        case 'BrowserBack':
	        case 'Accept':
	        default:
	          // do nothing, pass to parent.
	          break;
	      }
	    }
	  }, {
	    key: '_nav',
	    value: function _nav(move, e) {
	      var _this4 = this;
	
	      var length = this.props.itemNum;
	      var currentIndex = this.state.currentIndex;
	
	      if ('rtl' === document.dir) {
	        move = move * -1;
	      }
	      currentIndex += move;
	      if (currentIndex < -0) {
	        currentIndex = length - 1;
	      } else {
	        currentIndex %= length;
	      }
	      // deactive the item
	      this._blur(true);
	      // change the current index, and active the selected item
	      this.setState({ currentIndex: currentIndex }, function () {
	        _this4._focus();
	      });
	
	      e.preventDefault();
	    }
	  }, {
	    key: 'handleFocus',
	    value: function handleFocus(e) {
	      this._focus();
	    }
	  }, {
	    key: '_focus',
	    value: function _focus() {
	      var idx = this.state.currentIndex;
	      var bar = this.element.querySelector('.banner-bar');
	      var containers = this.element.querySelectorAll('.ad-item');
	      var indicators = this.element.querySelector('.indicators');
	      var ads = this.element.querySelectorAll('.' + this.adNavCls);
	      var dots = this.element.querySelectorAll('.indicators > li');
	      var offset = -1 * ((210 + 7) * idx) + 11 - 4;
	
	      if (!this.state.isFocus) {
	        this.setState({ isFocus: true });
	      }
	
	      bar.style.transform = 'translateX(' + offset + 'px)';
	      containers[idx].classList.add('ad-item', 'active');
	      indicators.classList.add('indicators', 'active');
	      ads[idx].focus();
	      dots[idx].classList.add('active');
	    }
	  }, {
	    key: '_blur',
	    value: function _blur(isChangeBanner) {
	      var bar = this.element.querySelector('.banner-bar');
	      var container = this.element.querySelector('.ad-item.active');
	      var indicators = this.element.querySelector('.indicators.active');
	      var dot = this.element.querySelector('.indicators > li.active');
	      var offset = -1 * ((210 + 7) * this.state.currentIndex) + 11;
	
	      if (this.state.isFocus) {
	        this.setState({ isFocus: false });
	      }
	
	      bar.style.transform = 'translateX(' + offset + 'px)';
	      container.classList.add('ad-item');
	      indicators.classList.add('indicators');
	      if (isChangeBanner) {
	        var _dot$classList;
	
	        (_dot$classList = dot.classList).remove.apply(_dot$classList, _toConsumableArray(dot.classList));
	        indicators.classList.add('active');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var componentId = this.props['data-id'];
	      var PREFIX_AD = 'ad';
	      var PREFIX_INDICATE = 'dot';
	      var ads = [];
	      var dots = [];
	
	      for (var i = 0; i < this.props.itemNum; i++) {
	        ads.push(_react2.default.createElement(
	          'li',
	          { key: PREFIX_AD + '-' + i },
	          _react2.default.createElement('span', {
	            id: PREFIX_AD + '-' + i,
	            className: this.state.isFocus && i === this.state.currentIndex ? 'ad-item active' : 'ad-item'
	          })
	        ));
	        dots.push(_react2.default.createElement('li', {
	          key: PREFIX_INDICATE + '-' + i,
	          className: i === this.state.currentIndex ? 'active' : ''
	        }));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          id: componentId,
	          className: 'hidden',
	          tabIndex: '1',
	          ref: function ref(element) {
	            _this5.element = element;
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'indicator-bar' },
	          _react2.default.createElement(
	            'ol',
	            { className: 'indicators' },
	            dots
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'banner-bar', tabIndex: '1' },
	          _react2.default.createElement(
	            'ul',
	            null,
	            ads
	          )
	        )
	      );
	    }
	  }]);
	
	  return BannerBar;
	}(_react.PureComponent);
	
	exports.default = BannerBar;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(100);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(1);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Appbrick = __webpack_require__(31);
	
	var _Appbrick2 = _interopRequireDefault(_Appbrick);
	
	var _richcontentHelper = __webpack_require__(33);
	
	var _richcontentHelper2 = _interopRequireDefault(_richcontentHelper);
	
	var _imageLoader = __webpack_require__(86);
	
	var _userInterfaceHelper = __webpack_require__(19);
	
	var _userInterfaceHelper2 = _interopRequireDefault(_userInterfaceHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PREFIX = 'LISTVIEW';
	var LAZY_LOAD_NUM = 5;
	
	var Listview = function (_PureComponent) {
	  _inherits(Listview, _PureComponent);
	
	  function Listview(props) {
	    _classCallCheck(this, Listview);
	
	    var _this = _possibleConstructorReturn(this, (Listview.__proto__ || Object.getPrototypeOf(Listview)).call(this));
	
	    _this.handleKeydown = function (e) {
	      switch (e.key) {
	        case 'ArrowUp':
	          _this._nav(-1, e);
	          break;
	        case 'ArrowDown':
	          _this._nav(1, e);
	          break;
	        case 'ArrowRight':
	        case 'ArrowLeft':
	        case 'BrowserBack':
	        case 'Accept':
	        case 'Enter':
	        default:
	          // do nothing, pass to parent.
	          break;
	      }
	    };
	
	    _this.handleFocus = function (e) {
	      _this._focus();
	    };
	
	    _this.handleBrickFocus = function () {
	      if (_richcontentHelper2.default.enable) {
	        (0, _imageLoader.loadImage)(_this.element.querySelectorAll('.brick')[_this.state.currentBrickIndex], 'bg');
	      }
	    };
	
	    var _UserInterfaceHelper$ = _userInterfaceHelper2.default.lastAppsviewIndex,
	        tabOrder = _UserInterfaceHelper$.tabOrder,
	        appOrder = _UserInterfaceHelper$.appOrder;
	
	    var readLastIndex = appOrder && props.order === tabOrder;
	    _this.navDirection = 1;
	    _this.state = {
	      currentBrickIndex: readLastIndex ? appOrder : 0,
	      apps: [],
	      initialized: props.isCurrentList,
	      lastLoadedBrickIndex: readLastIndex ? appOrder : 0
	    };
	    return _this;
	  }
	
	  _createClass(Listview, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        apps: this.getApps()
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.isCurrentList) {
	        _userInterfaceHelper2.default.lastAppsviewIndex.appOrder = this.state.currentBrickIndex;
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var currentCategory = this.props.category;
	      if (prevProps.category !== currentCategory) {
	        this.setState({
	          apps: this.getApps()
	        });
	      }
	      if (prevState.currentBrickIndex !== this.state.currentBrickIndex) {
	        var promotion = document.getElementById('promotion-bar');
	        if (this.state.currentBrickIndex > this.state.lastLoadedBrickIndex) {
	          this.setState({ lastLoadedBrickIndex: this.state.currentBrickIndex });
	        }
	        if (this.state.currentBrickIndex === 0 && promotion) {
	          // if promotion banner exists, we should reset currentIndex.
	          promotion.focus();
	        } else {
	          this._focus();
	        }
	      }
	      if (this.props.isCurrentList && this.state.initialized === false) {
	        this.setState({
	          initialized: true
	        });
	      }
	      if (prevState.initialized === false && this.state.initialized === true) {
	        this._focus();
	      }
	    }
	  }, {
	    key: 'getApps',
	    value: function getApps() {
	      var category = this.props.category;
	      var allApps = this.props.apps;
	      if ((typeof category === 'undefined' ? 'undefined' : _typeof(category)) === undefined) {
	        return [];
	      }
	      if (category === 'all') {
	        return allApps;
	      }
	      if (category === 'recommended') {
	        // When recommended_index > 0, we will show this app in the recommendation tab,
	        // and the list will also be sorted by recommended_index.
	        return allApps.filter(function (app) {
	          return !!app.remoteInfo['recommended_index'];
	        }).sort(this._sortRecommendationApps);
	      }
	
	      return allApps.filter(function (app) {
	        return app.remoteInfo.category === category;
	      });
	    }
	  }, {
	    key: '_sortRecommendationApps',
	    value: function _sortRecommendationApps(app1, app2) {
	      return app1['recommended_index'] - app2['recommended_index'];
	    }
	  }, {
	    key: '_nav',
	    value: function _nav(move, e) {
	      var brickNumber = this.state.apps.length;
	      var nextIndex = parseInt(this.state.currentBrickIndex, 10) + move;
	      this.navDirection = move;
	
	      if (nextIndex < 0) {
	        this.setState({ currentBrickIndex: 0 });
	      } else if (nextIndex < brickNumber) {
	        nextIndex %= brickNumber;
	        this.setState({ currentBrickIndex: nextIndex });
	      }
	      e.stopPropagation();
	    }
	  }, {
	    key: '_focus',
	    value: function _focus() {
	      var currentIndex = this.state.currentBrickIndex;
	      var brick = this.element.querySelectorAll('.brick')[currentIndex];
	
	      if (brick) {
	        brick.focus();
	        brick.scrollIntoView({
	          // set vertical alignment to bottom when moving upwards and vice versa
	          // to ensure the component could be shown completely
	          block: this.navDirection > 0 ? 'end' : 'start'
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          apps = _state.apps,
	          lastLoadedBrickIndex = _state.lastLoadedBrickIndex;
	
	      var category = this.props.category;
	      var hasProgressBar = category !== 'recommended';
	      var renderApps = [];
	
	      if (this.state.initialized) {
	        renderApps = apps.slice(0, lastLoadedBrickIndex + LAZY_LOAD_NUM);
	      }
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'Listview',
	          tabIndex: '1',
	          onKeyDown: this.handleKeydown,
	          onFocus: this.handleFocus,
	          ref: function ref(target) {
	            _this2.element = target;
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          renderApps.map(function (result, index) {
	            return _react2.default.createElement(_Appbrick2.default, {
	              key: PREFIX + '-' + result.id,
	              'data-id': result.id,
	              appOrder: index,
	              app: result.brickInfo,
	              mozAPP: result.mozAPP,
	              hasProgressBar: hasProgressBar,
	              focusHandler: _this2.handleBrickFocus
	            });
	          })
	        )
	      );
	    }
	  }]);
	
	  return Listview;
	}(_react.PureComponent);
	
	exports.default = Listview;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(1);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _softKeyStore = __webpack_require__(6);
	
	var _softKeyStore2 = _interopRequireDefault(_softKeyStore);
	
	__webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Loading = function (_Component) {
	  _inherits(Loading, _Component);
	
	  function Loading() {
	    _classCallCheck(this, Loading);
	
	    return _possibleConstructorReturn(this, (Loading.__proto__ || Object.getPrototypeOf(Loading)).apply(this, arguments));
	  }
	
	  _createClass(Loading, [{
	    key: 'componentDidMount',
	
	    // constructor(props) {
	    //   super(props);
	    // }
	
	    value: function componentDidMount() {
	      this._focus();
	    }
	  }, {
	    key: '_focus',
	    value: function _focus() {
	      var option = {
	        center: '',
	        right: ''
	      };
	      _softKeyStore2.default.register(option, this.element);
	      this.element.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var noAvailableAPP = this.props.noAvailableAPP;
	
	      var statusID = navigator.onLine ? 'loading' : 'no-internet-with-tips';
	      var progressClasses = navigator.onLine ? 'loading-bar play' : 'loading-bar';
	
	      if (noAvailableAPP && navigator.onLine) {
	        statusID = 'no-available-app';
	        progressClasses = 'loading-bar';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'Loading',
	          tabIndex: '1',
	          ref: function ref(element) {
	            _this2.element = element;
	          }
	        },
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement('span', { 'data-l10n-id': 'store' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'loading-box' },
	          _react2.default.createElement('div', { className: progressClasses })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement('p', { 'data-l10n-id': statusID })
	        )
	      );
	    }
	  }]);
	
	  return Loading;
	}(_react.Component);
	
	exports.default = Loading;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _preactRouter = __webpack_require__(12);
	
	var _constant = __webpack_require__(9);
	
	var _Appbrick = __webpack_require__(31);
	
	var _Appbrick2 = _interopRequireDefault(_Appbrick);
	
	var _reactDialog = __webpack_require__(21);
	
	var _reactDialog2 = _interopRequireDefault(_reactDialog);
	
	var _softKeyStore = __webpack_require__(6);
	
	var _softKeyStore2 = _interopRequireDefault(_softKeyStore);
	
	var _account = __webpack_require__(15);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _iconConverter = __webpack_require__(89);
	
	var _iconConverter2 = _interopRequireDefault(_iconConverter);
	
	var _paymentHelper = __webpack_require__(22);
	
	var _paymentHelper2 = _interopRequireDefault(_paymentHelper);
	
	var _loggerHelper = __webpack_require__(32);
	
	var _LikeModal = __webpack_require__(78);
	
	var _LikeModal2 = _interopRequireDefault(_LikeModal);
	
	var _Desc = __webpack_require__(80);
	
	var _Desc2 = _interopRequireDefault(_Desc);
	
	var _appStore = __webpack_require__(13);
	
	var _appStore2 = _interopRequireDefault(_appStore);
	
	var _deviceUtils = __webpack_require__(16);
	
	var _bookmarkUtils = __webpack_require__(85);
	
	var _commands = __webpack_require__(3);
	
	var _models = __webpack_require__(14);
	
	var _webMessageHelper = __webpack_require__(5);
	
	__webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PREFIX = 'PAGE';
	var _ = navigator.mozL10n;
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handleStoreChange = function (event) {
	      // cannot get id from matches if the page is entered via activity
	      var manifestURL = _this.state.app.manifestURL;
	
	      if (event.detail && event.detail.manifestURL !== manifestURL) {
	        return;
	      }
	      _this.setState({
	        app: _appStore2.default.findAppByManifest(manifestURL)
	      });
	    };
	
	    _this.handleKeydown = function (e) {
	      if (_this.isNativeAppUpdating) {
	        e.preventDefault();
	        e.stopPropagation();
	        return;
	      }
	      var app = _this.state.app;
	
	      switch (e.key) {
	        case 'SoftRight':
	          if (app.isBookmark) {
	            _this.showUnPinDialog();
	          } else {
	            _this.showUnInstallDialog();
	          }
	          break;
	        case 'SoftLeft':
	          if (app.isBookmark) {
	            (0, _bookmarkUtils.pinWebsite)(app);
	          }
	          break;
	        case 'BrowserBack':
	        case 'Backspace':
	        case 'Escape':
	          e.stopPropagation();
	          _this.exitPage(e);
	          break;
	        case 'Accept':
	        case 'Enter':
	          if (app.isBookmark) {
	            (0, _bookmarkUtils.openWebsite)(app);
	          } else {
	            _this.handleCSK();
	          }
	          break;
	        default:
	          // do nothing.
	          break;
	      }
	    };
	
	    _this.handleAutoDownload = function () {
	      if (_this.isNativeAppUpdating) {
	        return;
	      }
	      var app = _this.state.app;
	      // bind to onFocus to ensure the user has navigated back from account page
	
	      if (_this.shouldHandleAutoDownload) {
	        _this.autoInstallHandled = true;
	        if (app.isBookmark) {
	          (0, _bookmarkUtils.openWebsite)(app);
	        } else {
	          _this.handleCSK();
	        }
	      }
	    };
	
	    _this.disableAPP = function () {
	      var app = _this.state.app;
	      var isInstalled = app.isInstalled,
	          mozAPP = app.mozAPP;
	
	
	      if (mozAPP === null) {
	        return;
	      }
	      // If removable is false, please don't remove it.
	      if (isInstalled && mozAPP.removable !== false) {
	        _this.isDisablingApp = true;
	        app.uninstall();
	      }
	    };
	
	    _this.hideDialog = function () {
	      _this.setState({
	        dialog: false
	      });
	    };
	
	    _this.appNotFound = false;
	    _this.autoInstallHandled = false;
	
	    _this.setCurrentApp(true);
	
	    if (_this.appNotFound) {
	      return _possibleConstructorReturn(_this);
	    }
	    _this.paymentHelper = new _paymentHelper2.default();
	    _this.iconConverter = _iconConverter2.default;
	    _this.refs = {};
	    _this.bookmarkSupported = _deviceUtils.deviceUtils.featureset.bookmarkDBSupported;
	    _this.isDisablingApp = false;
	    window.addEventListener('appstore:change', _this.handleStoreChange);
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'setCurrentApp',
	    value: function setCurrentApp() {
	      var initializing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var _props$matches = this.props.matches,
	          appOrder = _props$matches.appOrder,
	          adId = _props$matches.adId,
	          id = _props$matches.id,
	          manifest = _props$matches.manifest,
	          name = _props$matches.name;
	      // manifest or name only exist when the page is entered by mozActivity
	
	      var app = null;
	      if (id !== '') {
	        app = _appStore2.default.findItemById(id);
	      } else if (manifest) {
	        app = _appStore2.default.findAppByManifest(decodeURIComponent(manifest));
	      } else if (name) {
	        app = _appStore2.default.findAppByName(name);
	      }
	
	      if (app === null || typeof app === 'undefined') {
	        this.appNotFound = true;
	        (0, _preactRouter.route)(_constant.PATH.APPS.URL());
	        this.props.onAppNotFound();
	        return;
	      }
	
	      if (initializing) {
	        this.state = {
	          dialog: false,
	          dialogOptions: {},
	          app: app
	        };
	      } else {
	        this.setState({ app: app });
	      }
	
	      if (app.isInRemoteList) {
	        _loggerHelper.loggerHelper.postAppViewData(app, appOrder, adId);
	      }
	    }
	  }, {
	    key: 'exitPage',
	    value: function exitPage(e) {
	      var disposition = this.props.matches.disposition;
	
	      this.state.app.updateState({ nativeUpdated: false });
	      if (disposition !== 'inline') {
	        (0, _preactRouter.route)(_constant.PATH.APPS.URL());
	        e && e.preventDefault();
	      }
	    }
	  }, {
	    key: 'toggleLike',
	    value: function toggleLike() {
	      var app = this.state.app;
	      // app.updateState({ liked: !app.state.liked });
	    }
	  }, {
	    key: 'handleCSK',
	    value: function handleCSK() {
	      var _this2 = this;
	
	      var app = this.state.app;
	      var manifestURL = app.manifestURL,
	          isInstalled = app.isInstalled,
	          info = app.info;
	      var paid = info.paid,
	          productId = info.productId;
	      var _app$state = app.state,
	          updatable = _app$state.updatable,
	          downloading = _app$state.downloading,
	          nativeUpdated = _app$state.nativeUpdated;
	
	
	      if (nativeUpdated) {
	        this.exitPage();
	        return;
	      }
	
	      if (downloading) {
	        app.cancelDownload();
	        return;
	      }
	
	      if (isInstalled && !updatable) {
	        app.launch();
	      } else if (isInstalled && updatable) {
	        // XXX TODO: update App with purchased account.
	        app.update();
	      } else if (!isInstalled && !updatable) {
	        if (paid) {
	          // It's a paid APP
	          if (!productId) {
	            console.error('Paid App without productId');
	            return;
	          }
	
	          var loginRequired = _account2.default.version && _account2.default.token === null;
	          if (loginRequired) {
	            // Before enable APPs, users need to login their account first.
	            _appStore2.default.preparedDownloadApp = manifestURL;
	            _account2.default.openAccount('fxa').then(function () {
	              // If user closes settings activity and login success
	              if (_account2.default.token) {
	                _this2.handleCSK();
	              }
	            }).catch(function (evt) {
	              console.error(evt);
	            });
	            return;
	          }
	
	          this.paymentHelper.isProductPurchased(productId).then(function () {
	            // Skip the payment process and re-download the paid app.
	
	            // XXX: It's just a workaround here, not passing receipt token to Gecko.
	            // To fix Bug 63368, we will use PaymentHelper.getReceiptsByTransactionId()
	            // to get receipt_token if Gecko supports to pass the receipt token to backend.
	            _this2.state.app.purchased = true;
	            _this2.startDownload(app);
	          }).catch(function () {
	            // Enter payment process, pay the money to get receipt_token
	            return _this2.paymentHelper.request('payment', {
	              detail: {
	                id: productId,
	                name: info.localized.name
	              }
	            });
	          }).then(function (result) {
	            if (!result) {
	              return;
	            }
	            _this2.state.app.purchased = true;
	            _this2.startDownload(app, result.receiptToken);
	          }).catch(function (error) {
	            console.error('Failed payment process: ', error);
	          });
	        } else {
	          this.startDownload(app);
	        }
	      }
	    }
	  }, {
	    key: 'startDownload',
	    value: function startDownload(app) {
	      var _this3 = this;
	
	      var jwt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      var isHosted = app.isHosted;
	      app.install(jwt).then(function () {
	        if (isHosted) {
	          _this3.sendInstallHostedLog();
	        }
	      }).catch(function (error) {
	        _this3.handleDownloadFailed(app);
	        if (isHosted) {
	          _this3.sendInstallHostedLog(error);
	        }
	      });
	    }
	  }, {
	    key: 'handleDownloadFailed',
	    value: function handleDownloadFailed(app) {
	      // It's workaround for bug-53987: Store shouldn't be the notification sender.
	      var msg = 'device-issue-detail';
	      var msgBody = _.get(msg);
	      var options = {
	        icon: this.iconConverter.getBase64('download'),
	        body: msgBody
	      };
	      var title = 'device-issue-title';
	
	      app.handleDownloadError();
	      this.showNotification(title, options);
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.updateSoftKey();
	      this.descriptionElement.focus();
	    }
	  }, {
	    key: 'showNotification',
	    value: function showNotification(title, options) {
	      title = navigator.mozL10n.get(title);
	      var command = new _commands.ShowNotificationCommand({
	        detail: new _models.Notification({
	          title: title,
	          options: options
	        })
	      });
	      _webMessageHelper.MessageSender.send(command);
	    }
	  }, {
	    key: 'updateSoftKey',
	    value: function updateSoftKey() {
	      var app = this.state.app;
	
	      if (app.isBookmark) {
	        this.updateSoftKeyForWebsite();
	      } else {
	        this.updateSoftKeyForApp();
	      }
	    }
	  }, {
	    key: 'updateSoftKeyForWebsite',
	    value: function updateSoftKeyForWebsite() {
	      var pinned = this.state.app.state.pinned;
	
	      var option = {
	        left: 'pin',
	        center: 'open',
	        right: ''
	      };
	
	      if (!this.bookmarkSupported) {
	        option['left'] = '';
	        option['right'] = '';
	      } else if (pinned) {
	        option['left'] = '';
	        option['right'] = 'unpin';
	      }
	
	      _softKeyStore2.default.register(option, this.descriptionElement);
	    }
	  }, {
	    key: 'updateSoftKeyForApp',
	    value: function updateSoftKeyForApp() {
	      var app = this.state.app;
	      var isInstalled = app.isInstalled,
	          info = app.info,
	          state = app.state,
	          purchased = app.purchased,
	          mozAPP = app.mozAPP,
	          isNativeApp = app.isNativeApp;
	      var paid = info.paid;
	      var updatable = state.updatable,
	          downloading = state.downloading,
	          liked = state.liked,
	          nativeUpdated = state.nativeUpdated;
	
	
	      var option = {
	        left: '',
	        center: '',
	        right: ''
	      };
	
	      if (nativeUpdated) {
	        option['center'] = 'done';
	      } else if (this.isNativeAppUpdating) {
	        option['center'] = '';
	      } else if (downloading) {
	        option['center'] = 'stop';
	      } else if (paid && !isInstalled && !purchased) {
	        option['center'] = 'buy';
	      } else if (isInstalled && !updatable) {
	        option['center'] = 'go';
	      } else if (isInstalled && updatable) {
	        option['center'] = isNativeApp ? 'select' : 'update';
	      } else {
	        option['center'] = 'get';
	      }
	
	      if (isInstalled && !isNativeApp) {
	        // option['left'] = liked ? 'unlike' : 'like'; // enable it when the backend is ready.
	      }
	
	      if (isInstalled && mozAPP && mozAPP.removable === true && !this.isNativeAppUpdating && !this.state.app.state.nativeUpdated) {
	        option['right'] = 'uninstall'; // should be options.
	      }
	
	      _softKeyStore2.default.register(option, this.descriptionElement);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this4 = this;
	
	      if (this.appNotFound) {
	        return;
	      }
	      this.focus();
	      this.refs.dialog.on('closed', function () {
	        _this4.hideDialog();
	        // To avoid `Backspace` mess up softkey, set focus back to 'page'.
	        _this4.focus();
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.element) {
	        this.element = undefined;
	      }
	      window.removeEventListener('appstore:change', this.handleStoreChange);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.appNotFound) {
	        return;
	      }
	      if (this.props.matches.id !== prevProps.matches.id || this.props.matches.manifest !== prevProps.matches.manifest) {
	        this.autoInstallHandled = false;
	        this.setCurrentApp();
	      }
	
	      if (this.props.matches.id === prevProps.matches.id && this.props.matches.t !== prevProps.matches.t && this.props.matches.autoDownload === 'true') {
	        this.autoInstallHandled = false;
	      }
	
	      if (this.props.matches.t !== prevProps.matches.t) {
	        // another activity is called when user is still in Page
	        this.focus();
	      }
	
	      if (prevState.dialog !== this.state.dialog) {
	        if (this.state.dialog) {
	          this.refs.dialog.show();
	        } else {
	          this.refs.dialog.hide();
	        }
	      }
	
	      var batchUpdating = this.props.matches.batchUpdating;
	
	      var isNativeBatchUpdate = this.state.app.state.nativeUpdated && batchUpdating === 'true';
	      if (isNativeBatchUpdate) {
	        var nextManifest = _appStore2.default.popNextUpdatePendingSystemApp;
	        if (nextManifest) {
	          (0, _preactRouter.route)(_constant.PATH.PAGE.URL({ manifest: nextManifest, batchUpdating: true }));
	        } else {
	          // last native app from AppStore.updateAll
	          _appStore2.default.rebootIfNeeded();
	        }
	      }
	
	      if (!batchUpdating && this.state.app.state.nativeUpdated) {
	        _appStore2.default.rebootIfNeeded();
	      }
	
	      if (batchUpdating === 'true' && !this.state.app.state.nativeUpdated && !this.isNativeAppUpdating) {
	        this.handleAutoDownload();
	      }
	
	      if (this.isDisablingApp && !this.state.app.isInstalled) {
	        this.isDisablingApp = false;
	      }
	
	      this.updateSoftKey();
	    }
	  }, {
	    key: 'showUnInstallDialog',
	    value: function showUnInstallDialog() {
	      var app = this.state.app;
	      var mozAPP = app.mozAPP,
	          isInstalled = app.isInstalled,
	          info = app.info;
	
	      if (mozAPP === null || mozAPP.removable === false || !isInstalled || this.isDisablingApp) {
	        return;
	      }
	
	      var content = _.get('uninstall-msg-with-name', {
	        appName: info.localized.name
	      });
	
	      this.showDialog(content, 'uninstall', this.disableAPP);
	    }
	  }, {
	    key: 'showUnPinDialog',
	    value: function showUnPinDialog() {
	      var app = this.state.app;
	      var state = app.state,
	          info = app.info;
	      var pinned = state.pinned;
	
	      if (!pinned || !this.bookmarkSupported) {
	        return;
	      }
	
	      var content = _.get('unpin-msg-with-name', {
	        appName: info.localized.name
	      });
	
	      this.showDialog(content, 'unpin', function () {
	        (0, _bookmarkUtils.unPinWebsite)(app);
	      });
	    }
	  }, {
	    key: 'showDialog',
	    value: function showDialog(content, okl10nId, onOK) {
	      var dialogOptions = {
	        translated: true,
	        header: _.get('confirmation'),
	        type: 'confirm',
	        ok: okl10nId,
	        content: content,
	        onOk: onOK
	      };
	
	      this.setState({
	        dialog: true,
	        dialogOptions: dialogOptions
	      });
	    }
	  }, {
	    key: 'sendInstallHostedLog',
	    value: function sendInstallHostedLog() {
	      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var app = this.state.app;
	      var info = app.info;
	
	      var data = {
	        app_id: app.id,
	        app_name: info.localized.name
	      };
	      _loggerHelper.loggerHelper.postAppInstallData(data, error);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      if (this.appNotFound) {
	        return;
	      }
	      var app = this.state.app;
	      var info = app.info;
	      // const showModal = app.state.liked; // enable it when the backend is ready.
	
	      var desc = info.localized.description;
	      var url = app.isBookmark ? app.info.url || app.manifestURL : null;
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'Page active',
	          ref: function ref(element) {
	            _this5.element = element;
	          }
	        },
	        _react2.default.createElement(_Appbrick2.default, {
	          key: PREFIX + '-' + app.id,
	          'data-id': app.id,
	          'data-type': info.type,
	          app: app.brickInfo,
	          mozAPP: app.mozAPP,
	          isActivateAsPage: true,
	          hasProgressBar: app.isNativeApp && app.state.downloading || !app.isNativeApp,
	          isNativeApp: app.isNativeApp
	        }),
	        _react2.default.createElement(_Desc2.default, {
	          isUpdatableSysApp: app.isNativeApp && app.state.updatable,
	          isDownloading: app.state.downloading,
	          isNativeUpdated: app.state.nativeUpdated,
	          setRef: function setRef(element) {
	            _this5.descriptionElement = element;
	          },
	          onFocus: this.handleAutoDownload,
	          onKeyDown: this.handleKeydown,
	          url: url,
	          desc: desc,
	          version: info.version
	        }),
	        app.isNativeApp && app.state.updatable && !app.state.downloading && _react2.default.createElement(
	          'div',
	          { className: 'update-btn-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'btn' },
	            _react2.default.createElement('div', {
	              'data-l10n-id': app.isRebootNeeded ? 'update-and-restart' : 'update'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'dialog-root', className: this.state.dialog ? '' : 'hidden' },
	          _react2.default.createElement(_reactDialog2.default, _extends({
	            ref: function ref(dialog) {
	              _this5.refs['dialog'] = dialog;
	            }
	          }, this.state.dialogOptions))
	        )
	      );
	    }
	  }, {
	    key: 'shouldHandleAutoDownload',
	    get: function get() {
	      var paid = this.state.app.info.paid;
	      var _props$matches2 = this.props.matches,
	          autoDownload = _props$matches2.autoDownload,
	          batchUpdating = _props$matches2.batchUpdating;
	
	      return this.autoInstallHandled === false && paid === false && (autoDownload === 'true' || batchUpdating === 'true');
	    }
	  }, {
	    key: 'isNativeAppUpdating',
	    get: function get() {
	      var app = this.state.app;
	
	      return app.isNativeApp && app.state.updatable && app.state.downloading;
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(109);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(1);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _softKeyStore = __webpack_require__(6);
	
	var _softKeyStore2 = _interopRequireDefault(_softKeyStore);
	
	var _preactRouter = __webpack_require__(12);
	
	var _constant = __webpack_require__(9);
	
	var _account = __webpack_require__(15);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _constants = __webpack_require__(2);
	
	var _webMessageHelper = __webpack_require__(5);
	
	var _commands = __webpack_require__(3);
	
	var _models = __webpack_require__(14);
	
	var _richcontentHelper = __webpack_require__(33);
	
	var _richcontentHelper2 = _interopRequireDefault(_richcontentHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Settingsview = function (_Component) {
	  _inherits(Settingsview, _Component);
	
	  function Settingsview() {
	    var _this$state;
	
	    _classCallCheck(this, Settingsview);
	
	    var _this = _possibleConstructorReturn(this, (Settingsview.__proto__ || Object.getPrototypeOf(Settingsview)).call(this));
	
	    _this.state = (_this$state = {
	      currentIndex: 0
	    }, _defineProperty(_this$state, _constants.validSettingKey.AUTO_DOWNLOAD, null), _defineProperty(_this$state, _constants.validSettingKey.RICH_CONTENT, null), _this$state);
	
	    _this.settingKeys = [_constants.validSettingKey.AUTO_DOWNLOAD, _constants.validSettingKey.RICH_CONTENT];
	    return _this;
	  }
	
	  _createClass(Settingsview, [{
	    key: 'getDefaultSettings',
	    value: function getDefaultSettings() {
	      var _this2 = this;
	
	      var keys = this.settingKeys;
	
	      var _loop = function _loop(i) {
	        var key = keys[i];
	        var command = new _commands.RequestSettingCommand({
	          detail: {
	            key: key
	          }
	        });
	        _webMessageHelper.MessageSender.send(command, function (success, result) {
	          var value = _constants.validSettingData[key].default;
	          if (success) {
	            value = result.value;
	          }
	          _this2.updateMenuStatus(key, value);
	        });
	      };
	
	      for (var i = 0; i < keys.length; i++) {
	        _loop(i);
	      }
	    }
	  }, {
	    key: 'updateMenuStatus',
	    value: function updateMenuStatus(key, value) {
	      var updateLayoutOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      var dom = document.querySelector('select[data-setting="' + key + '"]');
	      dom.value = value;
	      this.setState(_defineProperty({}, key, value));
	
	      if (key === _constants.validSettingKey.RICH_CONTENT) {
	        _richcontentHelper2.default.settingValue = value;
	      }
	
	      if (updateLayoutOnly === false) {
	        var setting = new _models.Setting({
	          key: key,
	          value: value
	        });
	        _webMessageHelper.MessageSender.send(new _commands.UpdateSettingCommand({ detail: setting }));
	      }
	    }
	  }, {
	    key: '_nav',
	    value: function _nav(move, e) {
	      var items = this.element.querySelectorAll('.item');
	      var nextIndex = parseInt(this.state.currentIndex, 10) + move;
	      if (nextIndex < 0 || nextIndex >= items.length) {
	        e.stopPropagation();
	      } else {
	        nextIndex %= items.length;
	        this.setState({ currentIndex: nextIndex });
	        e.stopPropagation();
	      }
	    }
	  }, {
	    key: 'handleKeydown',
	    value: function handleKeydown(e) {
	      switch (e.key) {
	        case 'ArrowUp':
	          this._nav(-1, e);
	          break;
	        case 'ArrowDown':
	          this._nav(1, e);
	          break;
	        case 'Enter':
	          if (this.menu) {
	            this.menu.focus();
	          } else {
	            // Open Account
	            _account2.default.openAccount('accounts');
	          }
	          break;
	        case 'BrowserBack':
	        case 'Backspace':
	        case 'Escape':
	          (0, _preactRouter.route)(_constant.PATH.APPS.URL());
	          e.preventDefault();
	          e.stopPropagation();
	          break;
	        case 'ArrowRight':
	        case 'ArrowLeft':
	        case 'Accept':
	        default:
	          // do nothing, pass to parent.
	          break;
	      }
	    }
	  }, {
	    key: '_focus',
	    value: function _focus() {
	      var currentIndex = this.state.currentIndex;
	
	      var box = this.element.querySelector('.item-list');
	
	      var items = box.querySelectorAll('.item');
	      var lastIndex = items.length - 1;
	      var item = items[currentIndex];
	
	      var border = box.offsetTop + box.offsetHeight;
	
	      var targetBorder = box.offsetTop + item.offsetTop + item.offsetHeight;
	      var offset = 0;
	
	      if (currentIndex === 0) {
	        offset = 0;
	      } else {
	        if (border < targetBorder) {
	          offset = border - targetBorder;
	        }
	      }
	
	      box.style.transform = 'translateY(' + offset + 'px)';
	      this.menu = null;
	      if (item) {
	        item.focus();
	        this.menu = item.querySelector('.hidden-select');
	        this.menu && this.menu.addEventListener('blur', this.handleFocus.bind(this));
	      }
	
	      var option = {
	        left: '',
	        center: 'select',
	        right: ''
	      };
	      _softKeyStore2.default.register(option, this.element);
	    }
	  }, {
	    key: 'handleFocus',
	    value: function handleFocus(e) {
	      this._focus();
	    }
	  }, {
	    key: 'handleSettingsChange',
	    value: function handleSettingsChange(e) {
	      var target = e.target;
	      var key = target.dataset['setting'];
	      var value = target.value;
	      this.updateMenuStatus(key, value, false);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._focus();
	      this.element.addEventListener('keydown', this.handleKeydown.bind(this));
	      this.element.addEventListener('focus', this.handleFocus.bind(this));
	      this.getDefaultSettings();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.currentIndex !== this.state.currentIndex) {
	        this._focus();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var accountVersion = _account2.default.version;
	
	      var settingItem = function settingItem(key, titlel10n) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'item', tabIndex: '1', 'data-setting': key },
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement('p', { 'data-l10n-id': titlel10n }),
	            _react2.default.createElement('span', { className: 'current-status', 'data-l10n-id': _this3.state[key] })
	          ),
	          _react2.default.createElement(
	            'select',
	            {
	              className: 'hidden-select',
	              onChange: _this3.handleSettingsChange.bind(_this3),
	              'data-setting': key
	            },
	            _constants.validSettingData[key].values.map(function (value, index) {
	              return _react2.default.createElement('option', { value: value, 'data-l10n-id': value, key: index });
	            })
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'Settingsview',
	          tabIndex: '1',
	          ref: function ref(target) {
	            _this3.element = target;
	          }
	        },
	        _react2.default.createElement('h1', { className: 'header', 'data-l10n-id': 'settings' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'item-list' },
	          accountVersion && _react2.default.createElement(
	            'div',
	            { className: 'item', tabIndex: '1' },
	            _react2.default.createElement(
	              'div',
	              { className: 'content' },
	              _react2.default.createElement('p', { className: 'single-line-item', 'data-l10n-id': 'account' })
	            )
	          ),
	          settingItem(_constants.validSettingKey.AUTO_DOWNLOAD, 'auto-update'),
	          settingItem(_constants.validSettingKey.RICH_CONTENT, 'show-rich-content')
	        )
	      );
	    }
	  }]);
	
	  return Settingsview;
	}(_react.Component);
	
	exports.default = Settingsview;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _appStore = __webpack_require__(13);
	
	var _appStore2 = _interopRequireDefault(_appStore);
	
	var _preactRouter = __webpack_require__(12);
	
	var _constant = __webpack_require__(9);
	
	var _userInterfaceHelper = __webpack_require__(19);
	
	var _userInterfaceHelper2 = _interopRequireDefault(_userInterfaceHelper);
	
	var _reactDialog = __webpack_require__(21);
	
	var _reactDialog2 = _interopRequireDefault(_reactDialog);
	
	var _Divider = __webpack_require__(81);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _UpdateBrick = __webpack_require__(82);
	
	var _UpdateBrick2 = _interopRequireDefault(_UpdateBrick);
	
	var _UpdateButton = __webpack_require__(83);
	
	var _UpdateButton2 = _interopRequireDefault(_UpdateButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FOCUSABLE_SELECTOR = '.focusable';
	
	var UpdateListview = function (_Component) {
	  _inherits(UpdateListview, _Component);
	
	  function UpdateListview(props) {
	    _classCallCheck(this, UpdateListview);
	
	    var _this = _possibleConstructorReturn(this, (UpdateListview.__proto__ || Object.getPrototypeOf(UpdateListview)).call(this));
	
	    _initialiseProps.call(_this);
	
	    var updatableApps = _this.getUpdatableApps();
	    _this.state = {
	      updatableSystemApps: updatableApps.system,
	      updatableRemoteApps: updatableApps.remote,
	      isUpdatingAll: _appStore2.default.updateAllInProcess,
	      dialog: false,
	      dialogOptions: {},
	      currentNavIndex: _userInterfaceHelper2.default.lastAppsviewIndex.appOrder || 0
	    };
	    _this.element = null;
	    _this.refs = {};
	    return _this;
	  }
	
	  _createClass(UpdateListview, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.focus();
	      window.addEventListener('appstore:change', this.handleStoreChange);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.element = null;
	      window.removeEventListener('appstore:change', this.handleStoreChange);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.dialog !== this.state.dialog) {
	        if (this.state.dialog) {
	          this.onDialogInShowState();
	        } else {
	          this.onDialogInHideState();
	        }
	      }
	      if (prevState.currentNavIndex !== this.state.currentNavIndex || prevState.updatableRemoteApps.length !== this.state.updatableRemoteApps.length || prevState.updatableSystemApps.length !== this.state.updatableSystemApps.length) {
	        this.focus();
	      }
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (!this.element) {
	        return;
	      }
	      var index = this.state.currentNavIndex;
	      var focuables = this.element.querySelectorAll(FOCUSABLE_SELECTOR);
	      var element = index >= focuables.length ? focuables[focuables.length - 1] : focuables[index];
	      if (!element) {
	        return;
	      }
	      element.focus();
	    }
	  }, {
	    key: 'getUpdatableApps',
	    value: function getUpdatableApps() {
	      var result = {};
	      this.updatableMeta.forEach(function (item) {
	        var storeKey = item.storeKey;
	        var apps = [];
	        _appStore2.default.updatableApps[storeKey].forEach(function (value, key) {
	          var app = _appStore2.default.findAppByManifest(key);
	          apps.push(app);
	        });
	        result[storeKey] = apps;
	      });
	
	      return result;
	    }
	  }, {
	    key: 'onUpdateBtnPressed',
	    value: function onUpdateBtnPressed(type, enable) {
	      if (type === 'system' && enable && _appStore2.default.updateAllRebootNeeded) {
	        this.showRebootNeededDialog();
	      } else {
	        _appStore2.default.updateAll(type, enable);
	        this.setState({
	          isUpdatingAll: _extends({}, this.state.isUpdatingAll, _defineProperty({}, type, enable))
	        });
	      }
	    }
	  }, {
	    key: 'showRebootNeededDialog',
	    value: function showRebootNeededDialog() {
	      var dialogOptions = {
	        header: 'update-all',
	        type: 'confirm',
	        ok: 'update',
	        content: 'update-all-and-restart-dialog',
	        onOk: function onOk() {
	          _appStore2.default.updateAll('system', true);
	        }
	      };
	
	      this.setState({
	        dialog: true,
	        dialogOptions: dialogOptions
	      });
	    }
	  }, {
	    key: 'onDialogInShowState',
	    value: function onDialogInShowState() {
	      var _this2 = this;
	
	      var lastActive = document.activeElement;
	      this.refs.dialog.show();
	
	      this.refs.dialog.on('closed', function () {
	        if (_this2.state.dialog) {
	          // close by endKey
	          _this2.hideDialog();
	        }
	        lastActive.focus();
	      });
	    }
	  }, {
	    key: 'onDialogInHideState',
	    value: function onDialogInHideState() {
	      this.refs.dialog.hide();
	      this.focus();
	    }
	  }, {
	    key: '_nav',
	    value: function _nav(move, e) {
	      var navNumber = this.element.querySelectorAll(FOCUSABLE_SELECTOR).length;
	      var nextIndex = parseInt(this.state.currentNavIndex, 10) + move;
	
	      if (nextIndex < 0) {
	        this.setState({ currentNavIndex: 0 });
	      } else if (nextIndex < navNumber) {
	        nextIndex %= navNumber;
	        this.setState({ currentNavIndex: nextIndex });
	      }
	      e.stopPropagation();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var isUpdatingAll = this.state.isUpdatingAll;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'Listview update-listview',
	          tabIndex: '1',
	          ref: function ref(element) {
	            _this3.element = element;
	          },
	          onFocus: this.handleFocus,
	          onKeyDown: this.handleKeydown
	        },
	        this.updatableMeta.map(function (item) {
	          var updatableApps = _this3.state[item.stateKey];
	          if (updatableApps.length === 0) {
	            return false;
	          }
	          return _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(DividerSection, {
	              updatableApps: updatableApps,
	              l10nId: item.l10nId
	            }),
	            _react2.default.createElement(_UpdateButton2.default, {
	              l10nId: isUpdatingAll[item.storeKey] ? 'stop' : 'update-all',
	              onPress: function onPress() {
	                _this3.onUpdateBtnPressed(item.storeKey, !isUpdatingAll[item.storeKey]);
	              }
	            }),
	            _react2.default.createElement(AppList, {
	              updatableApps: updatableApps,
	              onPress: _this3.onBrickPress
	            })
	          );
	        }),
	        _react2.default.createElement(
	          'div',
	          {
	            id: 'update-dialog-root',
	            className: this.state.dialog ? '' : 'hidden'
	          },
	          _react2.default.createElement(_reactDialog2.default, _extends({
	            ref: function ref(dialog) {
	              _this3.refs['dialog'] = dialog;
	            }
	          }, this.state.dialogOptions))
	        )
	      );
	    }
	  }, {
	    key: 'updatableMeta',
	    get: function get() {
	      return [{
	        stateKey: 'updatableSystemApps',
	        l10nId: 'system-software-update',
	        storeKey: 'system'
	      }, {
	        stateKey: 'updatableRemoteApps',
	        l10nId: 'app-update',
	        storeKey: 'remote'
	      }];
	    }
	  }]);
	
	  return UpdateListview;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.handleStoreChange = function () {
	    var updatableApps = _this4.getUpdatableApps();
	    _this4.setState({
	      updatableSystemApps: updatableApps.system,
	      updatableRemoteApps: updatableApps.remote
	    });
	  };
	
	  this.onBrickPress = function (manifestURL) {
	    _userInterfaceHelper2.default.lastAppsviewIndex.appOrder = _this4.state.currentNavIndex;
	    (0, _preactRouter.route)(_constant.PATH.PAGE.URL({ manifest: manifestURL }));
	  };
	
	  this.hideDialog = function () {
	    _this4.setState({
	      dialog: false
	    });
	  };
	
	  this.handleKeydown = function (e) {
	    switch (e.key) {
	      case 'ArrowUp':
	        _this4._nav(-1, e);
	        break;
	      case 'ArrowDown':
	        _this4._nav(1, e);
	        break;
	      case 'ArrowRight':
	      case 'ArrowLeft':
	      case 'BrowserBack':
	      case 'Accept':
	      case 'Enter':
	      default:
	        // do nothing, pass to parent.
	        break;
	    }
	  };
	
	  this.handleFocus = function () {
	    _this4.focus();
	  };
	};
	
	var DividerSection = function DividerSection(props) {
	  var updatableApps = props.updatableApps,
	      l10nId = props.l10nId;
	
	  return updatableApps.length > 0 && _react2.default.createElement(_Divider2.default, { l10nId: l10nId, number: updatableApps.length });
	};
	
	var AppList = function AppList(props) {
	  var updatableApps = props.updatableApps,
	      _onPress = props.onPress;
	
	  return updatableApps.map(function (app, index) {
	    return _react2.default.createElement(_UpdateBrick2.default, {
	      localized: app.info.localized,
	      size: app.info.size,
	      icon: app.info.icon,
	      isDownloading: app.state.downloading,
	      downloadProgress: app.mozAPP.progress,
	      isPending: app.state.updatePending,
	      key: 'update-brick-' + index,
	      onPress: function onPress() {
	        _onPress && _onPress(app.manifestURL);
	      }
	    });
	  });
	};
	
	exports.default = UpdateListview;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(1);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	__webpack_require__(99);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LikeModal = function (_Component) {
	  _inherits(LikeModal, _Component);
	
	  function LikeModal(props) {
	    _classCallCheck(this, LikeModal);
	
	    return _possibleConstructorReturn(this, (LikeModal.__proto__ || Object.getPrototypeOf(LikeModal)).call(this));
	  }
	
	  _createClass(LikeModal, [{
	    key: 'render',
	    value: function render() {
	      var unlikeMsg = navigator.mozL10n.get('unliked-an-app-msg');
	      return _react2.default.createElement(
	        'div',
	        { className: 'like-modal-wrapper' },
	        this.props.liked ? _react2.default.createElement('div', { className: 'like-toast' }) : _react2.default.createElement(
	          'div',
	          { className: 'unlike-toast' },
	          _react2.default.createElement(
	            'p',
	            { className: 'unlike-msg' },
	            unlikeMsg
	          )
	        )
	      );
	    }
	  }]);
	
	  return LikeModal;
	}(_react.Component);
	
	exports.default = LikeModal;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(102);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(1);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Marquee = function (_Component) {
	  _inherits(Marquee, _Component);
	
	  function Marquee(props) {
	    _classCallCheck(this, Marquee);
	
	    var _this = _possibleConstructorReturn(this, (Marquee.__proto__ || Object.getPrototypeOf(Marquee)).call(this));
	
	    _this.state = {
	      titleInlineStyle: {}
	    };
	    return _this;
	  }
	
	  _createClass(Marquee, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var second = this.overflowTitle.scrollWidth / (6 / 90 * 1000);
	      this.setState({
	        titleInlineStyle: {
	          animation: 'marquee-animation ' + second + 's linear 1s'
	        }
	      });
	      this.element.addEventListener('animationend', function () {
	        _this2.setState({
	          titleInlineStyle: {
	            animation: 'none'
	          }
	        }, function () {
	          // use setTimeout to ensure the previous setState has rendered
	          setTimeout(function () {
	            _this2.setState({
	              titleInlineStyle: {
	                animation: 'marquee-animation ' + second + 's linear 3s'
	              }
	            });
	          }, 0);
	        });
	      }, false);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'h2',
	        {
	          className: 'marquee',
	          style: this.state.titleInlineStyle,
	          ref: function ref(element) {
	            _this3.element = element;
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          null,
	          this.props.name
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            ref: function ref(element) {
	              _this3.overflowTitle = element;
	            }
	          },
	          this.props.name
	        )
	      );
	    }
	  }]);
	
	  return Marquee;
	}(_react.Component);
	
	exports.default = Marquee;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Desc = _react2.default.memo(function Desc(props) {
	  var setRef = props.setRef;
	  var onFocus = props.onFocus;
	  var onKeyDown = props.onKeyDown;
	  return _react2.default.createElement(
	    "div",
	    {
	      className: "desc",
	      tabIndex: "1",
	      ref: setRef,
	      onKeyDown: onKeyDown,
	      onFocus: onFocus
	    },
	    _react2.default.createElement(Content, props)
	  );
	});
	
	var Content = function Content(props) {
	  if (props.isUpdatableSysApp && props.isDownloading) {
	    return _react2.default.createElement(SysAppUpdatingContent, null);
	  } else if (props.isNativeUpdated) {
	    return _react2.default.createElement(SysAppUpdateDoneContent, null);
	  } else {
	    return _react2.default.createElement(GenericAppContent, {
	      url: props.url,
	      desc: props.desc,
	      version: props.version
	    });
	  }
	};
	
	var SysAppUpdatingContent = function SysAppUpdatingContent() {
	  return _react2.default.createElement(
	    "div",
	    { className: "update-page-desc" },
	    _react2.default.createElement("h2", { "data-l10n-id": "update-page-desc-updating" }),
	    _react2.default.createElement("p", { "data-l10n-id": "update-page-desc-dont-turn-off" })
	  );
	};
	
	var SysAppUpdateDoneContent = function SysAppUpdateDoneContent() {
	  return _react2.default.createElement(
	    "div",
	    { className: "update-page-desc" },
	    _react2.default.createElement("h2", { "data-l10n-id": "update-success" })
	  );
	};
	
	var GenericAppContent = function GenericAppContent(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "Page-desc", tabIndex: "1" },
	    props.url && _react2.default.createElement(
	      "div",
	      { className: "website-info" },
	      _react2.default.createElement(
	        "small",
	        { className: "website-url" },
	        props.url
	      ),
	      _react2.default.createElement("h4", { "data-l10n-id": "website" })
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      props.desc
	    ),
	    _react2.default.createElement("br", null),
	    props.version && _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement("span", { "data-l10n-id": "version" }),
	      _react2.default.createElement(
	        "span",
	        null,
	        ": ",
	        props.version
	      )
	    )
	  );
	};
	
	exports.default = Desc;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(107);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Divider = _react2.default.memo(function Divider(props) {
	  var l10nId = props.l10nId,
	      number = props.number;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'divider' },
	    _react2.default.createElement('div', { 'data-l10n-id': l10nId, className: 'title' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'indicator' },
	      _react2.default.createElement(
	        'span',
	        null,
	        number
	      )
	    )
	  );
	});
	
	exports.default = Divider;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(105);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _progressBar = __webpack_require__(29);
	
	var _progressBar2 = _interopRequireDefault(_progressBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UpdateBrick = _react2.default.memo(function UpdateBrick(props) {
	  var _this = this;
	
	  var localized = props.localized,
	      size = props.size,
	      icon = props.icon,
	      isDownloading = props.isDownloading,
	      isPending = props.isPending,
	      downloadProgress = props.downloadProgress,
	      onPress = props.onPress;
	
	
	  var onKeyDown = function onKeyDown(evt) {
	    if (evt.key === 'Enter' && onPress) {
	      onPress(evt);
	    }
	  };
	
	  var iconWrapperStyle = icon ? {
	    backgroundImage: 'url(' + icon + ')'
	  } : {};
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'update-brick focusable', tabIndex: '1', onKeyDown: onKeyDown },
	    _react2.default.createElement('div', { className: 'icon-wrapper', style: iconWrapperStyle }),
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'name',
	          ref: function ref(element) {
	            _this.name = element;
	          }
	        },
	        localized.name
	      ),
	      isDownloading ? _react2.default.createElement(
	        'div',
	        { className: 'progress-bar-wrapper' },
	        _react2.default.createElement(_progressBar2.default, {
	          height: 0.6,
	          hasTip: true,
	          infinite: downloadProgress > 0 ? false : true,
	          percentage: downloadProgress
	        })
	      ) : _react2.default.createElement(
	        'div',
	        { className: 'size' },
	        size
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'indicator' },
	      isPending ? _react2.default.createElement('div', { className: 'pending-icon' }) : _react2.default.createElement('div', { 'data-icon': 'forward', className: 'arrow' })
	    )
	  );
	});
	
	exports.default = UpdateBrick;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(106);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UpdateButton = _react2.default.memo(function UpdateButton(props) {
	  var l10nId = props.l10nId,
	      onPress = props.onPress;
	
	  var onKeyDown = function onKeyDown(evt) {
	    if (evt.key === 'Enter' && onPress) {
	      onPress(evt);
	    }
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: 'update-btn focusable', tabIndex: '1', onKeyDown: onKeyDown },
	    _react2.default.createElement('div', { 'data-l10n-id': l10nId })
	  );
	});
	
	exports.default = UpdateButton;

/***/ },
/* 84 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var normalizedURL = exports.normalizedURL = function normalizedURL(url) {
	  return new URL(url).href;
	};
	
	var isValidURL = exports.isValidURL = function isValidURL(URL) {
	  var regexQuery = '^(https?://)?(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?$';
	  var url = new RegExp(regexQuery, 'i');
	  return url.test(URL);
	};
	
	var localeCode = exports.localeCode = function localeCode(info) {
	  var lang = navigator.mozL10n.language.code || '';
	  var defaultLocale = info.default_locale;
	  if (!info.locales.hasOwnProperty(lang)) {
	    if (info.locales.hasOwnProperty(defaultLocale)) {
	      lang = info.default_locale;
	    } else {
	      lang = 'en-US';
	    }
	  }
	  return lang;
	};
	
	var trimBgs = exports.trimBgs = function trimBgs(bgs) {
	  if (bgs && Object.keys(bgs).length > 0) {
	    return bgs[Object.keys(bgs)[0]];
	  }
	  return null;
	};
	
	var trimIcons = exports.trimIcons = function trimIcons(icons) {
	  if (!icons) {
	    return null;
	  }
	  var defaultSize = '56';
	  var sizes = Object.keys(icons);
	  if (sizes.length === 0) {
	    return null;
	  }
	
	  return icons[defaultSize] || icons[sizes[0]];
	};
	
	var trimLocales = exports.trimLocales = function trimLocales(locales, lang) {
	  if (!locales || !lang) {
	    return {};
	  }
	  return locales[lang] || {};
	};
	
	var getSize = exports.getSize = function getSize(byte) {
	  var hundredKB = 102400;
	  return byte < hundredKB ? (byte / 1024).toFixed(1) + 'KB' : (byte / 1024 / 1024).toFixed(1) + 'MB';
	};

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unPinWebsite = exports.pinWebsite = exports.openWebsite = undefined;
	
	var _commands = __webpack_require__(3);
	
	var _models = __webpack_require__(14);
	
	var _loggerHelper = __webpack_require__(32);
	
	var _webMessageHelper = __webpack_require__(5);
	
	var openWebsite = exports.openWebsite = function openWebsite(app) {
	  var url = app.info.url ? app.info.url : app.manifestURL;
	  _loggerHelper.loggerHelper.postBookmarkData(_loggerHelper.bookmarkEvent.OPEN, app.id, app.info);
	  window.open(url, '_blank', 'remote=ture');
	};
	
	var pinWebsite = exports.pinWebsite = function pinWebsite(app) {
	  var _app$info = app.info,
	      icon = _app$info.icon,
	      url = _app$info.url,
	      localized = _app$info.localized;
	
	
	  var command = new _commands.PINBookmarkCommand({
	    detail: new _models.Bookmark({
	      url: url,
	      icon: icon,
	      name: localized.name
	    })
	  });
	  _webMessageHelper.MessageSender.send(command, function (success) {
	    if (success === true) {
	      _loggerHelper.loggerHelper.postBookmarkData(_loggerHelper.bookmarkEvent.PIN, app.id, app.info);
	    }
	  });
	};
	
	var unPinWebsite = exports.unPinWebsite = function unPinWebsite(app) {
	  var command = new _commands.UnPINBookmarkCommand({
	    detail: {
	      url: app.info.url
	    }
	  });
	  _webMessageHelper.MessageSender.send(command);
	};

/***/ },
/* 86 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var loadImage = exports.loadImage = function loadImage(element) {
	  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'icon';
	
	  var imageSrc = '';
	  var image = null;
	
	  if (type === 'icon') {
	    image = element.querySelector('img.app-icon');
	    imageSrc = image.getAttribute('data-src');
	  } else if (type === 'bg') {
	    image = new Image();
	    imageSrc = element.getAttribute('data-bg-image');
	    if (imageSrc === null) {
	      return;
	    }
	  }
	
	  return new Promise(function (resolve, reject) {
	    image.onload = function () {
	      if (type === 'bg') {
	        element.style.backgroundImage = 'url(' + image.src + ')';
	        element.classList.add('bg-loaded');
	      } else if (type === 'icon') {
	        element.querySelector('.icon-wrapper').classList.remove('default');
	      }
	      resolve();
	    };
	    image.onerror = function () {
	      resolve();
	    };
	    image.src = imageSrc;
	  });
	};

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.receiveMessage = undefined;
	
	var _kaistorePostMessenger = __webpack_require__(46);
	
	var _constants = __webpack_require__(2);
	
	var _appStore = __webpack_require__(13);
	
	var _appStore2 = _interopRequireDefault(_appStore);
	
	var _mozactivityManager = __webpack_require__(34);
	
	var _account = __webpack_require__(15);
	
	var _account2 = _interopRequireDefault(_account);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var receiveMessage = exports.receiveMessage = function receiveMessage(event) {
	  var _event$detail = event.detail,
	      id = _event$detail.id,
	      action = _event$detail.action,
	      detail = _event$detail.detail,
	      source = _event$detail.source;
	
	  switch (action) {
	    case _kaistorePostMessenger.commandList.MOZAPP_UPDATE:
	      {
	        var manifestURL = detail.manifestURL,
	            mozApp = detail.mozApp,
	            mozAppEvent = detail.mozAppEvent,
	            mozAppsEvent = detail.mozAppsEvent;
	
	        var app = _appStore2.default.findAppByManifest(manifestURL);
	        if (!app) {
	          return;
	        }
	
	        app.mozAPP = mozApp;
	        _appStore2.default.publish('appstore:change');
	
	        if (mozAppsEvent === _constants.mozAppsEvents.INSTALL) {
	          app.handleInstall(mozAppEvent);
	        } else if (mozAppsEvent === _constants.mozAppsEvents.UNINSTALL) {
	          app.handleUninstall();
	        } else if (mozAppsEvent === _constants.mozAppsEvents.UPDATE) {
	          app.handleUpdate(mozAppEvent);
	          _appStore2.default.handleUpdate(manifestURL, mozAppEvent);
	        }
	        break;
	      }
	    case _kaistorePostMessenger.commandList.BOOKMARK_UPDATE:
	      {
	        var pin = detail.pin,
	            url = detail.url;
	
	        var bookmark = _appStore2.default.findBookmarkByUrl(url);
	        if (bookmark) {
	          bookmark.handleBookmarkUpdate(pin);
	        }
	        break;
	      }
	    case _kaistorePostMessenger.commandList.TASK_QUEUE_UPDATE:
	      {
	        _mozactivityManager.mozActivityManager.saveToQueue(detail);
	        break;
	      }
	    case _kaistorePostMessenger.commandList.ACCOUNT_EVENT:
	      {
	        var _event = detail.event,
	            data = detail.data;
	
	        _account2.default.handleEvent(_event, data);
	        break;
	      }
	    case _kaistorePostMessenger.commandList.REQUEST_RELOAD:
	      {
	        window.location.reload();
	        break;
	      }
	  }
	};

/***/ },
/* 88 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MozAppHelper = function () {
	  function MozAppHelper() {
	    _classCallCheck(this, MozAppHelper);
	  }
	
	  _createClass(MozAppHelper, [{
	    key: "releaseUnusedInfo",
	
	    // Delete unused description field to release strings
	    value: function releaseUnusedInfo(mozAPP) {
	      var manifest = mozAPP.manifest || mozAPP.updateManifest;
	      var locales = manifest.locales;
	
	
	      delete manifest.description;
	      if (locales) {
	        for (var locale in locales) {
	          if ({}.hasOwnProperty.call(locales, locale)) {
	            delete locales[locale].description;
	          }
	        }
	      }
	    }
	  }]);
	
	  return MozAppHelper;
	}();
	
	var mozAppHelper = exports.mozAppHelper = new MozAppHelper();

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ic_download = __webpack_require__(114);
	
	var _ic_download2 = _interopRequireDefault(_ic_download);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var IconConverter = function () {
	  function IconConverter() {
	    _classCallCheck(this, IconConverter);
	
	    // Add icon_file_path in this.iconList for setting base64 images in the Map.
	    this.iconList = {
	      download: _ic_download2.default
	    };
	    this.base64Icons = new Map();
	    this._init();
	  }
	
	  _createClass(IconConverter, [{
	    key: 'getBase64',
	    value: function getBase64(key) {
	      return this.base64Icons.get(key);
	    }
	  }, {
	    key: '_getBase64Icon',
	    value: function _getBase64Icon(filePath) {
	      return new Promise(function (resolve, reject) {
	        var img = new Image();
	        var _getBase64Image = function _getBase64Image(image) {
	          // Create an empty canvas element
	          var canvas = document.createElement('canvas');
	          canvas.width = image.width;
	          canvas.height = image.height;
	
	          // Copy the image contents to the canvas
	          var ctx = canvas.getContext('2d');
	          ctx.drawImage(image, 0, 0);
	
	          // Get the data-URL formatted image
	          return canvas.toDataURL('image/png');
	        };
	
	        img.onload = function () {
	          resolve(_getBase64Image(img));
	        };
	        img.onerror = function (evt) {
	          reject(evt);
	        };
	        img.src = filePath;
	      });
	    }
	  }, {
	    key: '_init',
	    value: function _init() {
	      var _this = this;
	
	      var list = this.iconList;
	      var keys = Object.keys(list);
	
	      var _loop = function _loop(i) {
	        if (list.hasOwnProperty(keys[i])) {
	          _this._getBase64Icon('../dist/' + list[keys[i]]).then(function (result) {
	            _this.base64Icons.set(keys[i], result);
	          }, function (error) {
	            console.warn('Failed to get base64 image "' + icon + '"', JSON.stringify(error));
	          });
	        }
	      };
	
	      for (var i = 0; i < keys.length; i++) {
	        _loop(i);
	      }
	    }
	  }]);
	
	  return IconConverter;
	}();
	
	var iconConverterInstance = new IconConverter();
	exports.default = iconConverterInstance;

/***/ },
/* 90 */
/***/ function(module, exports) {

	'use strict';
	
	var orig = console.error;
	console.error = function () {
	  var prefix = '[KaiOS-Store]';
	  Array.prototype.unshift.call(arguments, prefix);
	  orig.apply(console, arguments);
	};

/***/ },
/* 91 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var getKaiAd = function () {
	  for (var _len = arguments.length, e = Array(_len), _key = 0; _key < _len; _key++) {
	    e[_key] = arguments[_key];
	  }
	
	  var t = e[0],
	      r = e[1],
	      l = e[2],
	      n = {},
	      o = "setAttribute",
	      s = "createElement",
	      i = "contentWindow",
	      a = "appendChild",
	      f = "addEventListener",
	      d = "dataset",
	      u = "keydown",
	      p = "length",
	      c = "style",
	      y = "error",
	      m = "timeout",
	      g = "push",
	      h = "message",
	      v = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ",
	      w = v[p],
	      b = parseInt,
	      k = console[y],
	      A = {},
	      E = function E() {
	    return r.body;
	  },
	      I = function I() {
	    var e = crypto.getRandomValues(new Uint16Array(32));return [].map.call(e, function (e) {
	      return v[e % w];
	    }).join("");
	  },
	      O = I(),
	      S = function S(e) {
	    return (typeof e === "undefined" ? "undefined" : _typeof(e)) == (typeof p === "undefined" ? "undefined" : _typeof(p));
	  },
	      j = function j(e) {
	    var t = {};t[24] = e, t[5] = I(), t[16] = [], n[t[5]] = t, t[12] = [], t[25] = {}, t[15] = function (e) {
	      (t[24].onerror || k)(e), t[29]();
	    }, t[29] = function () {
	      t[18] && t[18].remove(), n[t[5]] = t = l;
	    }, t[14] = function () {
	      clearTimeout(t[22]), t[24].onready({
	        call: function call(e, r) {
	          t[11](e, r);
	        },
	        on: function on(e, r) {
	          t[25][e] || (t[25][e] = []), t[25][e][g](r);
	        }
	      });
	    }, t[11] = function (e) {
	      for (var _len2 = arguments.length, r = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        r[_key2 - 1] = arguments[_key2];
	      }
	
	      if (t[19] && t[19][i]) {
	        var _l = [];_l[5] = t[5], _l[6] = e, _l[8] = r, t[19][i].postMessage(JSON.stringify(_l, function () {
	          var e = new WeakSet();return function (t, r) {
	            if ("object" == (typeof r === "undefined" ? "undefined" : _typeof(r)) && null !== r) {
	              if (e.has(r)) return;e.add(r);
	            }return r;
	          };
	        }()), "*");
	      } else t[15](4);
	    }, t[22] = function () {
	      return t[24][m] = t[24][m] || 6e4, setTimeout(function () {
	        t[15](5);
	      }, t[24][m]);
	    }(), t[17] = function () {
	      var e = t[24].container;return e || (e = E(), t[23] = t[24][23] = 1), e;
	    }(), t[19] = function () {
	      var e = "https://ssp.kaiads.com/static/v2/frame.html?i=" + t[5] + "&s=" + O,
	          l = r[s]("iframe");l[o]("src", e);var n = r[s]("div");return n[d][O] = t[5], n[c].position = "absolute", n[c].left = "-1000%", t[18] = n, t[23] || (n[f]("focus", function (e) {
	        return t[11]("focus");
	      }), n[f]("blur", function (e) {
	        return t[11]("blur");
	      })), n[a](l), t[17][a](n), n[d][O] = t[5], l;
	    }();
	  },
	      C = function C(e, r) {
	    var n = {};n[10] = e, e[12][g](r[7]), n[7] = r[7], n[6] = r[6], n[28] = -1, n[8] = [], n[9] = [], n[1] = function (t) {
	      var r = n[26](t[1]);if (r[1]) {
	        var _e = n[27](t[3]);n[9][n[28]] = t[0] ? new (Function.prototype.bind.apply(r[1], [null].concat(_toConsumableArray(_e[0]))))() : r[1].apply(r, _toConsumableArray(_e[0])), _e[1] || n[13]();
	      } else n[10][11](n[6], y, 10, e[12][p], n[28]);
	    }, n[2] = function (t) {
	      if (t[4]) {
	        var _r = n[26](t[4]);if (_r[21]) n[10][11](n[6], y, 11, e[12][p], n[28]);else {
	          var _e2 = void 0;_e2 = _r[1] ? _r[1] : _r[7] ? _r[7] : t[4];var _o = n[26](t[2], _e2);n[9][n[28]] = l, _o[13] || n[13]();
	        }
	      } else {
	        var _r2 = n[26](t[2]);_r2[21] ? n[10][11](n[6], y, 12, e[12][p], n[28]) : (n[9][n[28]] = _r2, n[13]());
	      }
	    }, n[13] = function () {
	      for (var _len3 = arguments.length, e = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        e[_key3] = arguments[_key3];
	      }
	
	      n[28]++, n[8][n[28]] = e;var t = n[7][n[28]];t && (t[1] ? n[1](t) : t[2] ? n[2](t) : n[13]());
	    }, n[27] = function (e) {
	      var t = [[], l];if (e) for (var _r3 = 0, _l2 = e[p]; _l2 > _r3; _r3++) {
	        if (S(e[_r3])) {
	          var _l3 = n[26](e[_r3]);_l3[1] ? (t[0][g](_l3[1]), _l3[13] && (t[1] = 1)) : _l3[7] ? t[0][g](_l3[7]) : t[0][g](e[_r3]);
	        } else t[0][g](e[_r3]);
	      }return t;
	    }, n[26] = function (e, r) {
	      var o = {};if (S(e) && /^[wts]/.test(e)) {
	        var _s = e.split("."),
	            _i = _s.shift();"t" == _i ? _i = n : "w" == _i ? _i = t : "s" == _i && (_i = A);for (var _e3 = 0, _t = _s[p]; _t > _e3; _e3++) {
	          if (_t > _e3 && (o[20] = _i), _i[_s[_e3]] === l && _t > _e3) {
	            if (r) break;return o[21] = 1, o;
	          }if ((_i === l || _i[_s[_e3]] === l) && _t > _e3 && r === l) return o[21] = 1, o;_i = _i[_s[_e3]];
	        }r !== l && (o[20][_s.pop()] = r, _i = r), function (e) {
	          return (typeof e === "undefined" ? "undefined" : _typeof(e)) == (typeof b === "undefined" ? "undefined" : _typeof(b));
	        }(_i) && (o[13] = _i === n[13], o[13] ? o[1] = _i : o[1] = _i.bind(o[20])), o[7] = _i;
	      }return o;
	    }, n[13]();
	  };return t[f](h, function (e) {
	    if (!e || !e.origin || "https://ssp.kaiads.com" !== e.origin) return;var t = JSON.parse(e.data);if (n[t[5]]) {
	      var _e4 = n[t[5]];t[7] && C(_e4, t), _e4[25][t[6]] && _e4[25][t[6]].forEach(function (e) {
	        return e(t[8]);
	      });
	    }
	  }), t[f](u, function (e) {
	    var t = void 0;if (A.vfsAdId && n[A.vfsAdId]) t = n[A.vfsAdId];else {
	      var _e5 = r.activeElement,
	          _l4 = _e5[d][O];if (!_e5 || !_l4) return;t = n[_l4];
	    }t && (t[16].indexOf(e.key) > -1 || (t[11](u, e.key, e.keyCode), e.preventDefault(), e.stopPropagation()));
	  }), function (e) {
	    var t = e.onerror || k;E() ? e.onready ? j(e) : t(2) : t(1);
	  };
	}(window, document);
	exports.default = getKaiAd;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constant = __webpack_require__(9);
	
	var _mozappHelper = __webpack_require__(88);
	
	var _applicationHelper = __webpack_require__(84);
	
	var _commands = __webpack_require__(3);
	
	var _constants = __webpack_require__(2);
	
	var _models = __webpack_require__(14);
	
	var _webMessageHelper = __webpack_require__(5);
	
	var _appStore = __webpack_require__(13);
	
	var _appStore2 = _interopRequireDefault(_appStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Application = function () {
	  function Application(manifestURL) {
	    _classCallCheck(this, Application);
	
	    // trim manifest url to make sure there is no space in it.
	    this.manifestURL = encodeURI(manifestURL.trim());
	    this._remoteInfo = null;
	    this._mozAPP = null;
	    this.state = {
	      downloading: false,
	      updatable: false,
	      liked: false,
	      pinned: false,
	      updatePending: false
	    };
	    this._trimmedRemoteInfo = {};
	    this._trimmedMozAPPInfo = {};
	    this.purchased = false;
	  }
	
	  _createClass(Application, [{
	    key: 'setRemoteInfo',
	    value: function setRemoteInfo(info) {
	      if (!_constant.SUPPORTED_APP_TYPE.includes(info.type)) {
	        return false;
	      }
	
	      if (this.isRemoteInfoValid(info)) {
	        this.remoteInfo = info;
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'isRemoteInfoValid',
	    value: function isRemoteInfoValid(remoteInfo) {
	      if (remoteInfo.type === 'bookmark') {
	        var URL = remoteInfo.url;
	        return URL && (0, _applicationHelper.isValidURL)(URL);
	      }
	      return remoteInfo.id && remoteInfo.manifest_url;
	    }
	  }, {
	    key: 'trimRemoteInfo',
	    value: function trimRemoteInfo(remoteInfo) {
	      return {
	        bg: (0, _applicationHelper.trimBgs)(remoteInfo.bgs),
	        icon: (0, _applicationHelper.trimIcons)(remoteInfo.icons),
	        localized: (0, _applicationHelper.trimLocales)(remoteInfo.locales, (0, _applicationHelper.localeCode)(remoteInfo)),
	        url: remoteInfo.url ? (0, _applicationHelper.normalizedURL)(remoteInfo.url) : null,
	        type: remoteInfo.type,
	        paid: remoteInfo.paid || false,
	        productId: remoteInfo.product_id || null,
	        version: remoteInfo.version || null
	      };
	    }
	  }, {
	    key: 'trimMozAPPInfo',
	    value: function trimMozAPPInfo(updateManifest) {
	      return {
	        bg: (0, _applicationHelper.trimBgs)(updateManifest.bgs),
	        icon: (0, _applicationHelper.trimIcons)(updateManifest.icons),
	        localized: (0, _applicationHelper.trimLocales)(updateManifest.locales, (0, _applicationHelper.localeCode)(updateManifest)),
	        type: updateManifest.type,
	        version: updateManifest.version || null,
	        size: updateManifest.size
	      };
	    }
	  }, {
	    key: 'checkUpdate',
	    value: function checkUpdate() {
	      if (!this.mozAPP) {
	        return;
	      }
	      var manifestURL = this.manifestURL;
	      var command = new _commands.CheckAppUpdateCommand({
	        detail: {
	          manifestURL: manifestURL
	        }
	      });
	
	      _webMessageHelper.MessageSender.send(command);
	    }
	  }, {
	    key: 'updateState',
	    value: function updateState(detail) {
	      this.state = _extends({}, this.state, detail);
	      // auto flag updatePending to false when app starts downloading
	      if (detail.downloading === true) {
	        this.state = _extends({}, this.state, { updatePending: false });
	      }
	      var evt = new CustomEvent('appstore:change', {
	        detail: { manifestURL: this.manifestURL }
	      });
	      window.dispatchEvent(evt);
	    }
	  }, {
	    key: 'install',
	    value: function install() {
	      var jwt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      this.updateState({ downloading: true });
	
	      var command = new _commands.InstallCommand({
	        detail: {
	          isHosted: this.isHosted,
	          manifestURL: this.manifestURL,
	          jwt: jwt
	        }
	      });
	
	      return new Promise(function (resolve, reject) {
	        _webMessageHelper.MessageSender.send(command, function (success, detail) {
	          if (success === true) {
	            resolve();
	          } else {
	            reject(detail.error);
	          }
	        });
	      });
	    }
	  }, {
	    key: 'uninstall',
	    value: function uninstall() {
	      var command = new _commands.UninstallCommand({
	        detail: {
	          manifestURL: this.manifestURL
	        }
	      });
	      _webMessageHelper.MessageSender.send(command);
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      this.updateState({ downloading: true });
	
	      var command = new _commands.UpdateAppCommand({
	        detail: {
	          manifestURL: this.manifestURL
	        }
	      });
	      _webMessageHelper.MessageSender.send(command);
	    }
	  }, {
	    key: 'launch',
	    value: function launch() {
	      var command = new _commands.LaunchAppCommand({
	        detail: {
	          manifestURL: this.manifestURL
	        }
	      });
	      _webMessageHelper.MessageSender.send(command);
	    }
	  }, {
	    key: 'cancelDownload',
	    value: function cancelDownload() {
	      var command = new _commands.CancelDownloadCommand({
	        detail: {
	          manifestURL: this.manifestURL
	        }
	      });
	      _webMessageHelper.MessageSender.send(command);
	    }
	  }, {
	    key: 'handleDownload',
	    value: function handleDownload() {
	      this.updateState({
	        downloading: true
	      });
	    }
	  }, {
	    key: 'handleDownloadError',
	    value: function handleDownloadError() {
	      this.updateState({
	        downloading: false
	      });
	    }
	  }, {
	    key: 'handleDownloadSuccess',
	    value: function handleDownloadSuccess() {
	      // Remove unused info: description & locales.description
	      _mozappHelper.mozAppHelper.releaseUnusedInfo(this.mozAPP);
	      this.updateState({
	        downloading: false,
	        updatable: false
	      });
	    }
	  }, {
	    key: 'handleUpdatedSuccess',
	    value: function handleUpdatedSuccess() {
	      this.updateState({
	        downloading: false,
	        updatable: false,
	        nativeUpdated: this.isNativeApp
	      });
	      _appStore2.default.updatableApps.system.delete(this.manifestURL);
	      _appStore2.default.updatableApps.remote.delete(this.manifestURL);
	      if (nativeUpdated) {
	        _appStore2.default.shouldReboot = true;
	      }
	    }
	  }, {
	    key: 'handleInstall',
	    value: function handleInstall(mozAppEvent) {
	      if (this.isInstalled) {
	        this.handleDownloadSuccess();
	        return;
	      }
	
	      if (mozAppEvent === _constants.mozAppEvent.ON_DOWNLOAD_APPLIED) {
	        this.handleDownloadSuccess();
	      } else if (mozAppEvent === _constants.mozAppEvent.ON_DOWNLOAD_ERROR) {
	        this.handleDownloadError();
	      } else {
	        this.handleDownload();
	      }
	    }
	  }, {
	    key: 'handleUninstall',
	    value: function handleUninstall() {
	      // clear up app props.
	      this.mozAPP = null;
	      this.updateState({
	        downloading: false,
	        updatable: false
	      });
	      var messageOption = {
	        messageL10nId: 'uninstalled-msg-with-name',
	        messageL10nArgs: {
	          appName: this.info.localized.name
	        }
	      };
	
	      _webMessageHelper.MessageSender.send(new _commands.ShowToastCommand({
	        detail: new _models.Toast(messageOption)
	      }));
	    }
	  }, {
	    key: 'handleUpdate',
	    value: function handleUpdate(mozAppEvent) {
	      switch (mozAppEvent) {
	        case _constants.mozAppEvent.ON_DOWNLOAD_AVAILABLE:
	          _appStore2.default.syncUpdatableApp(this);
	          break;
	        case _constants.mozAppEvent.ON_DOWNLOAD_APPLIED:
	          this.handleUpdatedSuccess();
	          break;
	        case _constants.mozAppEvent.ON_DOWNLOAD_SUCCESS:
	          this.handleDownloadSuccess();
	          break;
	        case _constants.mozAppEvent.ON_DOWNLOAD_ERROR:
	          this.handleDownloadError();
	          break;
	      }
	    }
	  }, {
	    key: 'handleBookmarkUpdate',
	    value: function handleBookmarkUpdate(pin) {
	      this.updateState({ pinned: pin });
	      var messageL10nId = pin ? 'pin-bookmark-completely' : 'unpin-bookmark-completely';
	      _webMessageHelper.MessageSender.send(new _commands.ShowToastCommand({
	        detail: new _models.Toast({ messageL10nId: messageL10nId })
	      }));
	    }
	  }, {
	    key: 'isBookmark',
	    get: function get() {
	      return this.info.type === 'bookmark';
	    }
	  }, {
	    key: 'isHosted',
	    get: function get() {
	      return this.info.type === 'hosted';
	    }
	  }, {
	    key: 'isInternal',
	    get: function get() {
	      return _constant.INTERNAL_APP.includes(this.id);
	    }
	  }, {
	    key: 'isPreloaded',
	    get: function get() {
	      return _constant.PRELOADED_APP.includes(this.id);
	    }
	  }, {
	    key: 'isNativeApp',
	    get: function get() {
	      return this.mozAPP && this.mozAPP.manifest && this.mozAPP.manifest.isNativeApp;
	    }
	  }, {
	    key: 'isRebootNeeded',
	    get: function get() {
	      return this.mozAPP && this.mozAPP.manifest && this.mozAPP.manifest.reboot;
	    }
	  }, {
	    key: 'id',
	    get: function get() {
	      if (this.remoteInfo && this.remoteInfo.id) {
	        return this.remoteInfo.id;
	      }
	
	      var manifestInfo = this.manifestURL.split('/');
	      var lastPart = manifestInfo[manifestInfo.length - 1];
	      if (lastPart === 'manifest.webapp') {
	        return null;
	      }
	      return manifestInfo[manifestInfo.length - 1];
	    }
	  }, {
	    key: 'remoteInfo',
	    get: function get() {
	      return this._remoteInfo;
	    },
	    set: function set(info) {
	      this._remoteInfo = info;
	      this._trimmedRemoteInfo = this.trimRemoteInfo(info);
	    }
	  }, {
	    key: 'mozAPP',
	    get: function get() {
	      return this._mozAPP;
	    },
	    set: function set(mozAPP) {
	      this._mozAPP = mozAPP;
	      if (mozAPP && mozAPP.updateManifest) {
	        this._trimmedMozAPPInfo = this.trimMozAPPInfo(mozAPP.updateManifest);
	      } else {
	        this._trimmedMozAPPInfo = {};
	      }
	    }
	  }, {
	    key: 'isInRemoteList',
	    get: function get() {
	      return this._remoteInfo !== null;
	    }
	  }, {
	    key: 'isInstalled',
	    get: function get() {
	      return Boolean(this._mozAPP && this._mozAPP.installState === 'installed');
	    }
	  }, {
	    key: 'info',
	    get: function get() {
	      var remoteInfo = this._trimmedRemoteInfo;
	      var mozAPPInfo = this._trimmedMozAPPInfo;
	      return {
	        bg: remoteInfo.bg || mozAPPInfo.bg || null,
	        icon: remoteInfo.icon || mozAPPInfo.icon || null,
	        localized: remoteInfo.localized || mozAPPInfo.localized || {},
	        url: remoteInfo.url || null,
	        type: remoteInfo.type || mozAPPInfo.type,
	        paid: remoteInfo.paid || false,
	        productId: remoteInfo.productId || null,
	        version: remoteInfo.version || mozAPPInfo.version,
	        size: (0, _applicationHelper.getSize)(mozAPPInfo.size) || null
	      };
	    }
	  }, {
	    key: 'brickInfo',
	    get: function get() {
	      return {
	        id: this.id,
	        isBookmark: this.isBookmark,
	        state: this.state,
	        isInstalled: this.isInstalled,
	        purchased: this.purchased,
	        info: this.info
	      };
	    }
	  }]);
	
	  return Application;
	}();
	
	exports.default = Application;

/***/ },
/* 93 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 94 */
93,
/* 95 */
93,
/* 96 */
93,
/* 97 */
93,
/* 98 */
93,
/* 99 */
93,
/* 100 */
93,
/* 101 */
93,
/* 102 */
93,
/* 103 */
93,
/* 104 */
93,
/* 105 */
93,
/* 106 */
93,
/* 107 */
93,
/* 108 */
93,
/* 109 */
93,
/* 110 */
93,
/* 111 */
93,
/* 112 */
93,
/* 113 */
93,
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3d8b1d491a721ae4d366528c60b00133.png";

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** bundle.js
 **/